import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
// 🚀 1. EKLEME: BrowserRouter'ı import ediyoruz
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import { 
  collection, addDoc, setDoc, onSnapshot, query, 
  orderBy, doc, updateDoc, deleteDoc, getDocs, where 
} from "firebase/firestore";
import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import emailjs from '@emailjs/browser';
import { db } from './firebase';
import { Contacts } from '@capacitor-community/contacts';

const APP_NAME = "HalıPro";

const LogoGoster = ({ T, tema }) => {
  const logoSrc = tema === 'dark' 
    ? "https://firebasestorage.googleapis.com/...logon_dark_linki" 
    : "https://firebasestorage.googleapis.com/...logon_light_linki";

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <img 
        src={logoSrc} 
        alt={APP_NAME} 
        onError={(e) => { e.target.style.display = 'none'; }} 
        style={{ width: 34, height: 34, borderRadius: 8, objectFit: 'contain' }} 
      />
      <span style={{ fontWeight: 800, fontSize: 20, color: T.text }}>{APP_NAME}</span>
    </div>
  );
};
// 🔐 TÜM YETKİLER HAVUZU (Nihai & Eksiksiz Versiyon)
const TUM_YETKILER = [
  // 📄 SAYFALAR VE ANA MODÜLLER
  { id: "ana_sayfa", label: "🏠 Ana Sayfa Görebilir", grup: "Sayfalar" },
  { id: "saha_giris", label: "🚚 Saha Sayfasına Girebilir", grup: "Sayfalar" },
  { id: "sofor_modu", label: "🚐 Şoför Moduna Girebilir", grup: "Sayfalar" },
  { id: "musteri_yonetim", label: "👥 Müşteri Listesini Görebilir", grup: "Sayfalar" },
  { id: "kasa_rapor", label: "💰 Kasa ve Raporları Görebilir", grup: "Finans" },
  { id: "uygulama_ayar", label: "⚙️ Uygulama Ayarlarına Girebilir", grup: "Yönetim" },

  // 📝 İŞLEMLER VE YETKİLER
  { id: "siparis_acma", label: "📝 Yeni Sipariş Açabilir", grup: "İşlemler" },
  { id: "siparis_duzenle", label: "✏️ Mevcut Siparişi Düzenleyebilir", grup: "İşlemler" },
  { id: "buton_sil", label: "🗑️ Fiş Silme Yetkisi", grup: "İşlemler" },
  { id: "hali_al_giris", label: "📏 m² ve Halı Girişi Yapabilir", grup: "İşlemler" },
  { id: "whatsapp_mesaj", label: "💬 WhatsApp Mesajı Atabilir", grup: "İşlemler" },

  // 💰 FİNANSAL YETKİLER
  { id: "tahsilat_al", label: "💵 Tahsilat Alabilir", grup: "Finans" },
  { id: "buton_tahsilat_sil", label: "❌ Tahsilat İptal Yetkisi", grup: "Finans" },
  { id: "fiyat_liste", label: "🏷️ Fiyat Listesini Değiştirebilir", grup: "Finans" },
  { id: "gider_ekle", label: "📉 Gider Kaydı Girebilir", grup: "Finans" },
  
  // 🔥 REİS BUNLAR EKSİKTİ, EKLEDİM:
  { id: "ozel_indirim", label: "🎁 Özel İndirim Yapabilir", grup: "Finans" },
  { id: "borc_duzenle", label: "✍️ Müşteri Borcunu El ile Düzenleyebilir", grup: "Finans" },

  // ⚙️ YÖNETİM
  { id: "personel_yonetim", label: "👨‍🔧 Personel Ekleyebilir/Silebilir", grup: "Yönetim" },
  { id: "sifre_gorme", label: "🔑 Personel Şifrelerini Görebilir", grup: "Yönetim" },
  { id: "rol_duzenleme", label: "🛡️ Rol ve Yetki Düzenleyebilir", grup: "Yönetim" },
  
  // 🔥 REİS BU DA EKSİKTİ:
  { id: "veri_disa_aktar", label: "📥 Verileri Yedekle / Dışa Aktar", grup: "Yönetim" },

  // 📂 SEKMELER (İşler ve Saha içindeki görünümler)
  { id: "sekme_tumu", label: "📂 Sekme: Tümü", grup: "Sekmeler" },
  { id: "sekme_alinacak", label: "📍 Sekme: Alınacak", grup: "Sekmeler" },
  { id: "sekme_aracta", label: "🚐 Sekme: Araçta", grup: "Sekmeler" },
  { id: "sekme_yikanacak", label: "⏳ Sekme: Yıkanacak", grup: "Sekmeler" },
  { id: "sekme_yikaniyor", label: "🫧 Sekme: Yıkanıyor", grup: "Sekmeler" },
  { id: "sekme_kurutuluyor", label: "💨 Sekme: Kurutuluyor", grup: "Sekmeler" },
  { id: "sekme_fasonda", label: "🔧 Sekme: Fasonda", grup: "Sekmeler" },
  { id: "sekme_hazir", label: "📦 Sekme: Hazır", grup: "Sekmeler" },
  { id: "sekme_dagitimda", label: "🚐 Sekme: Dağıtımda", grup: "Sekmeler" },
  { id: "sekme_edildi", label: "✅ Sekme: Edildi", grup: "Sekmeler" }
];
const DILLER = {
  tr:{ad:"Türkçe",bayrak:"🇹🇷"},en:{ad:"English",bayrak:"🇬🇧"},
  de:{ad:"Deutsch",bayrak:"🇩🇪"},fr:{ad:"Français",bayrak:"🇫🇷"},
  ar:{ad:"العربية",bayrak:"🇸🇦"},ru:{ad:"Русский",bayrak:"🇷🇺"},
  es:{ad:"Español",bayrak:"🇪🇸"},it:{ad:"Italiano",bayrak:"🇮🇹"},
};

const TR = {
  girisYap: "Giriş Yap", kayitOl: "Kayıt Ol", hosGeldiniz: "Hoş Geldiniz", cikisYap: "Çıkış Yap",
  kaydet: "Kaydet", iptal: "İptal", sil: "Sil", duzenle: "Düzenle", ekle: "Ekle", ara: "Ara",
  anaSayfa: "Ana Sayfa", isler: "İşler", saha: "Saha", musteriler: "Müşteriler",
  kasa: "Kasa", ayarlar: "Ayarlar", personel: "Personel", tahsilat: "Tahsilat",
  adres_bekliyor: "Kapıdan Alınacak", beklemede: "Yıkanacak", yikaniyor: "Yıkanıyor",
  kurutuluyor: "Kurutuluyor", fason: "Fasonda", teslim_hazir: "Teslime Hazır", teslim_edildi: "Teslim Edildi",
  aracta: "Araçta (Dükkana Geliyor)", dagitimda: "Dağıtımda (Müşteriye Gidiyor)",
  k_adres_bekliyor: "Alınacak", k_beklemede: "Yıkanacak", k_yikaniyor: "Yıkanıyor",
  k_kurutuluyor: "Kurutuluyor", k_fason: "Fasonda", k_teslim_hazir: "Hazır", k_teslim_edildi: "Teslim Edildi",
  k_aracta: "Araçta ", k_dagitimda: "Dağıtımda ",
  yeniFis: "Yeni Fiş", haliAl: "Halıyı Al", teslimEt: "Teslim Et & Ödeme Al",
  tahsilatAl: "Tahsilat Al", whatsapp: "WhatsApp Gönder", yazdir: "Yazdır", acil: "ACİL", borç: "Borç", odenmemis: "Ödenmemiş",
  merhaba: "Merhaba", isletme: "İşletme Bilgileri", fiyatlar: "Birim Fiyatlar", veri: "Veri Yönetimi", log: "Arama Kayıtları"
};
const EN = {
  girisYap:"Sign In",kayitOl:"Sign Up",hosGeldiniz:"Welcome",cikisYap:"Sign Out",
  kaydet:"Save",iptal:"Cancel",sil:"Delete",duzenle:"Edit",ekle:"Add",ara:"Search",
  anaSayfa:"Home",isler:"Orders",saha:"Field",musteriler:"Customers",
  kasa:"Cash",ayarlar:"Settings",personel:"Staff",tahsilat:"Collections",
  adres_bekliyor:"Pickup Queue",beklemede:"To Wash",yikaniyor:"Washing",
  kurutuluyor:"Drying",fason:"Outsourced",teslim_hazir:"Ready",teslim_edildi:"Delivered",
  aracta:"In Vehicle (Coming)",dagitimda:"In Delivery",
  k_adres_bekliyor:"Pickup",k_beklemede:"To Wash",k_yikaniyor:"Washing",
  k_kurutuluyor:"Drying",k_fason:"Outsourced",k_teslim_hazir:"Ready",k_teslim_edildi:"Done",
  k_aracta:"In Vehicle 🚐",k_dagitimda:"Delivering 🚐",
  yeniFis:"New Order",haliAl:"Pick Up",teslimEt:"Deliver & Collect",
  tahsilatAl:"Collect Payment",whatsapp:"Send WhatsApp",yazdir:"Print",
  callerGelen:"Incoming Call",callerBilinmeyen:"Unknown Number",callerFisAc:"Open Order",
  callerSahaya:"Add to Field",callerKaydet:"Save Customer",callerGormezden:"Dismiss",
  darkMod:"Dark Mode",dil:"Language",isletme:"Business Info",
  fiyatlar:"Price List",mesajSablon:"Message Templates",veri:"Data Management",log:"Call Log",
  iade:"Return / Re-wash",acil:"URGENT",borç:"Debt",odenmemis:"Unpaid",
  kapidanAlinacak:"Pickup Queue",teslimEdilecek:"Delivery Queue",
};
const DE = {
  girisYap:"Anmelden",kayitOl:"Registrieren",hosGeldiniz:"Willkommen",cikisYap:"Abmelden",
  kaydet:"Speichern",iptal:"Abbrechen",sil:"Löschen",duzenle:"Bearbeiten",ekle:"Hinzufügen",ara:"Suchen",
  anaSayfa:"Startseite",isler:"Aufträge",saha:"Außeneinsatz",musteriler:"Kunden",
  kasa:"Kasse",ayarlar:"Einstellungen",personel:"Personal",tahsilat:"Inkasso",
  adres_bekliyor:"Abholung geplant",beklemede:"Zu waschen",yikaniyor:"Wird gewaschen",
  kurutuluyor:"Trocknet",fason:"Lohnreinigung",teslim_hazir:"Bereit",teslim_edildi:"Geliefert",
  k_adres_bekliyor:"Abholung",k_beklemede:"Waschen",k_yikaniyor:"Wäscht",
  k_kurutuluyor:"Trocknet",k_fason:"Lohn",k_teslim_hazir:"Bereit",k_teslim_edildi:"Geliefert",
  yeniFis:"Neuer Auftrag",haliAl:"Abholen",teslimEt:"Liefern & Bezahlen",
  tahsilatAl:"Zahlung erhalten",whatsapp:"WhatsApp senden",yazdir:"Drucken",
  callerGelen:"Eingehender Anruf",callerBilinmeyen:"Unbekannte Nummer",callerFisAc:"Auftrag öffnen",
  callerSahaya:"Zum Einsatz",callerKaydet:"Kunde speichern",callerGormezden:"Ignorieren",
  darkMod:"Dunkelmodus",dil:"Sprache",isletme:"Firmendaten",
  fiyatlar:"Preisliste",mesajSablon:"Nachrichtenvorlagen",veri:"Datenverwaltung",log:"Anrufprotokoll",
  iade:"Rückgabe / Neu waschen",acil:"DRINGEND",borç:"Schuld",odenmemis:"Unbezahlt",
  kapidanAlinacak:"Abholung",teslimEdilecek:"Lieferung",
};
const FR = {
  girisYap:"Se connecter",kayitOl:"S'inscrire",hosGeldiniz:"Bienvenue",cikisYap:"Déconnexion",
  kaydet:"Enregistrer",iptal:"Annuler",sil:"Supprimer",duzenle:"Modifier",ekle:"Ajouter",ara:"Rechercher",
  anaSayfa:"Accueil",isler:"Commandes",saha:"Terrain",musteriler:"Clients",
  kasa:"Caisse",ayarlar:"Paramètres",personel:"Personnel",tahsilat:"Encaissement",
  adres_bekliyor:"Collecte prévue",beklemede:"À laver",yikaniyor:"En lavage",
  kurutuluyor:"Séchage",fason:"Sous-traitance",teslim_hazir:"Prêt",teslim_edildi:"Livré",
  k_adres_bekliyor:"Collecte",k_beklemede:"À laver",k_yikaniyor:"Lavage",
  k_kurutuluyor:"Séchage",k_fason:"Sous-trait.",k_teslim_hazir:"Prêt",k_teslim_edildi:"Livré",
  yeniFis:"Nouvelle commande",haliAl:"Collecter",teslimEt:"Livrer & Encaisser",
  tahsilatAl:"Encaisser",whatsapp:"Envoyer WhatsApp",yazdir:"Imprimer",
  callerGelen:"Appel entrant",callerBilinmeyen:"Numéro inconnu",callerFisAc:"Ouvrir commande",
  callerSahaya:"Ajouter au terrain",callerKaydet:"Sauvegarder client",callerGormezden:"Ignorer",
  darkMod:"Mode sombre",dil:"Langue",isletme:"Informations entreprise",
  fiyatlar:"Liste des prix",mesajSablon:"Modèles de messages",veri:"Gestion des données",log:"Journal d'appels",
  iade:"Retour / Re-laver",acil:"URGENT",borç:"Dette",odenmemis:"Impayé",
  kapidanAlinacak:"File de collecte",teslimEdilecek:"File de livraison",
};

const DILSOZLUK = {tr:TR,en:EN,de:DE,fr:FR};
const cihazDiliBul = () => {
  const d = (navigator.language||"tr").toLowerCase().split("-")[0];
  return DILLER[d] ? d : "tr";
};
function useDil() {
  const [dil, setDil] = useState(() => localStorage.getItem("halici_dil") || cihazDiliBul());
  const t = (k) => {
    const sözlük = { tr: TR, en: EN, de: DE, fr: FR };
    return sözlük[dil]?.[k] || sözlük.tr[k] || k;
  };
  const dilDegistir = (d) => { setDil(d); localStorage.setItem("halici_dil", d); };
  return { dil, t, dilDegistir };
}

// ═══════════════════════════════════════════════════════════
// TEMA
// ═══════════════════════════════════════════════════════════
const TEMALAR = {
  light: { bg: "#F5F7FA", card: "#FFFFFF", header: "#1E3A5F", text: "#1A1A2E", textSec: "#64748B", border: "#E2E8F0", input: "#FFFFFF", inputBorder: "#CBD5E1", primary: "#2563EB", success: "#16A34A", danger: "#DC2626", warning: "#D97706", accent: "#F59E0B", navBg: "#FFFFFF", navBorder: "#E2E8F0", statCard: "#F8FAFC", badge: "#EFF6FF" },
  dark: { bg: "#080C14", card: "#0F1520", header: "#060A12", text: "#E2E8F0", textSec: "#64748B", border: "#1E293B", input: "#0F1520", inputBorder: "#1E293B", primary: "#3B82F6", success: "#22C55E", danger: "#EF4444", warning: "#F59E0B", accent: "#F59E0B", navBg: "#060A12", navBorder: "#1E293B", statCard: "#0A0E18", badge: "#0F1A2E" },
};
function useTheme() {
  const [tema,setTema] = useState(()=>localStorage.getItem("halici_tema")||"light");
  const toggleTema = () => { const y=tema==="light"?"dark":"light"; setTema(y); localStorage.setItem("halici_tema",y); };
  return {tema,T:TEMALAR[tema],toggleTema};
}

const STATÜLER_META = {
  adres_bekliyor: { icon: "📍", renk: "#F59E0B" },
  aracta: { icon: "🚐", renk: "#FB923C" },         
  beklemede: { icon: "⏳", renk: "#3B82F6" },
  yikaniyor: { icon: "🫧", renk: "#6366F1" },
  kurutuluyor: { icon: "💨", renk: "#10B981" },
  fason: { icon: "🔧", renk: "#EF4444" },
  teslim_hazir: { icon: "📦", renk: "#F97316" },
  dagitimda: { icon: "🚐", renk: "#A855F7" },
  teslim_edildi: { icon: "✅", renk: "#8B5CF6" },
};
const STATÜ_SIRASI = Object.keys(STATÜLER_META);

// ═══════════════════════════════════════════════════════════
// İZİN YÖNETİMİ (ZIRHLI, TAMİR EDİLMİŞ VE BİRLEŞTİRİLMİŞ)
// ═══════════════════════════════════════════════════════════
async function tumIzinleriAl() {
  // 🔥 REİS: ESLint hatasını bitiren asıl kilit satır burasıdır!
  const sonuclar = {
    kamera: "bekliyor",
    mikrofon: "bekliyor",
    konum: "bekliyor",
    rehber: "bekliyor",
    bildirim: "bekliyor",
    ekranKilidi: "bekliyor",
    galeri: "bekliyor"
  };

  // 1️⃣ KAMERA İZNİ
  try {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      sonuclar.kamera = "verildi";
      stream.getTracks().forEach(t => t.stop());
    } else {
      sonuclar.kamera = "desteklenmiyor";
    }
  } catch (e) { 
    sonuclar.kamera = "reddedildi"; 
  }

  // 2️⃣ MİKROFON İZNİ (ZIRHLANDI)
  try {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      sonuclar.mikrofon = "verildi";
      stream.getTracks().forEach(t => t.stop());
    } else {
      sonuclar.mikrofon = "desteklenmiyor";
    }
  } catch (e) { 
    sonuclar.mikrofon = "reddedildi"; 
  }

  // 3️⃣ KONUM İZNİ
  try {
    if (navigator.geolocation) {
      await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { timeout: 5000 }));
      sonuclar.konum = "verildi";
    } else {
      sonuclar.konum = "desteklenmiyor";
    }
  } catch (e) { 
    sonuclar.konum = "reddedildi"; 
  }

  // 4️⃣ REHBER ERİŞİMİ
  if ("contacts" in navigator && "ContactsManager" in window) {
    sonuclar.rehber = "destekleniyor";
  } else {
    sonuclar.rehber = "kısıtlı (iOS/Web)";
  }

  // 5️⃣ BİLDİRİM İZNİ
  if ("Notification" in window) {
    const izin = await Notification.requestPermission();
    sonuclar.bildirim = izin === "granted" ? "verildi" : "reddedildi";
  } else { 
    sonuclar.bildirim = "desteklenmiyor"; 
  }

  // 6️⃣ EKRAN UYANIK KALMA (WAKE LOCK)
  if ("wakeLock" in navigator) {
    try { 
      await navigator.wakeLock.request("screen"); 
      sonuclar.ekranKilidi = "verildi"; 
    } catch (e) { 
      sonuclar.ekranKilidi = "reddedildi"; 
    }
  } else { 
    sonuclar.ekranKilidi = "desteklenmiyor"; 
  }

  // 7️⃣ GALERİ/DOSYA ERİŞİMİ
  sonuclar.galeri = "aktif (Seçim bazlı)";

  return sonuclar; 
}
// ═══════════════════════════════════════════════════════════
// 🛡️ ZIRHLI SES SİSTEMİ (Android WebView & Kabuk Hatası Korumalı)
// ═══════════════════════════════════════════════════════════
function sesCal(tip = "ding", sesAcik = true) {
  if (!sesAcik || typeof window === "undefined") return;

  // 🚀 Beyin: Her seferinde yeni context oluşturup iş bitince kapatıyoruz.
  // Bu sayede Android "arka planda ses açık kaldı" diyerek uygulamayı kapatmaz.
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return;

  const context = new AudioCtx();
  
  try {
    const osc = context.createOscillator();
    const gain = context.createGain();
    
    osc.connect(gain);
    gain.connect(context.destination);
    
    const now = context.currentTime;
    let duration = 0.3;

    switch (tip) {
      case "yeniFis":
        osc.type = "sine"; 
        osc.frequency.setValueAtTime(523, now);
        osc.frequency.setValueAtTime(659, now + 0.1); 
        osc.frequency.setValueAtTime(784, now + 0.2);
        gain.gain.setValueAtTime(0.3, now); 
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
        duration = 0.5;
        break;
      case "tamamlandi":
        osc.type = "sine"; 
        osc.frequency.setValueAtTime(784, now);
        osc.frequency.setValueAtTime(1047, now + 0.15);
        gain.gain.setValueAtTime(0.2, now); 
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.4);
        duration = 0.4;
        break;
      case "uyari":
        osc.type = "square"; 
        osc.frequency.setValueAtTime(440, now);
        osc.frequency.setValueAtTime(330, now + 0.1);
        gain.gain.setValueAtTime(0.15, now); 
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
        duration = 0.3;
        break;
      default: // ding
        osc.type = "sine"; 
        osc.frequency.setValueAtTime(880, now);
        gain.gain.setValueAtTime(0.2, now); 
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
        duration = 0.3;
    }

    osc.start(now);
    osc.stop(now + duration);

    // 🔥 KRİTİK: Ses bittikten sonra kanalı tamamen yok et (Hafıza sızıntısını engeller)
    osc.onended = () => {
      context.close();
    };

  } catch (e) {
    console.log("Ses hatası:", e);
    context.close();
  }
}
// Link açma - "open external link" uyarısını bypass et
function linkAc(url) {
  if (!url) return;
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

const VARSAYILAN_URUNLER = [
  {id:"makine",ad:"Makine Halısı",birim:"m2",fiyat:30},
  {id:"yun",ad:"Yün Halı",birim:"m2",fiyat:45},
  {id:"ipek",ad:"İpek Halı",birim:"m2",fiyat:80},
  {id:"shaggy",ad:"Shaggy",birim:"m2",fiyat:55},
  {id:"kilim",ad:"Kilim",birim:"m2",fiyat:28},
  {id:"overlok",ad:"Overlok",birim:"m2",fiyat:15},
  {id:"yorgan",ad:"Yorgan",birim:"adet",fiyat:120},
  {id:"battaniye",ad:"Battaniye",birim:"adet",fiyat:90},
  {id:"perde",ad:"Perde",birim:"m2",fiyat:35},
  {id:"koltuk",ad:"Koltuk Yıkama",birim:"adet",fiyat:200},
  {id:"arabalik",ad:"Arabalık",birim:"m2",fiyat:35},
  {id:"diger",ad:"Diğer",birim:"adet",fiyat:50},
];
const KIRLILIK = [
  {id:"normal",ad:"Normal",carpan:1.0},
  {id:"kirli",ad:"Çok Kirli",carpan:1.2},
  {id:"cokkirli",ad:"Aşırı Kirli",carpan:1.4},
];
const MESAJ_SABLONLARI = {
  siparis:`HALI YIKAMA SİPARİŞİ\n\nMüşteri: {musteri_adi}\nTelefon: {telefon}\nFiş No: {fis_no}\nTahmini Teslim: {teslim_tarihi}`,
  alinacak:`Sayın {musteri_adi},\n{sirket_adi} olarak adresinizden halı/ürünlerinizi almak için planlama yapıldı.\nPlanlanan Alım: {pickup_tarihi}`,
  dagitim:`Sayın {musteri_adi},\nHalılarınız dağıtım için hazır.\nToplam: {toplam_metre} m² — {toplam_tutar} ₺`,
  tamamlandi:`Sayın {musteri_adi},\nHalılarınızın yıkama işlemi tamamlanmıştır.\nTahmini Teslim: {teslim_tarihi}`,
  borc:`Sayın {musteri_adi},\nHesabınızdaki borç: {borc_tutari} ₺`,
  teslim_notu:`Teslim edilen halıların iade süresi 1 haftadır.`,
};

// 🖼️ FOTOĞRAF SIKIŞTIRICI (Burhan Reis Özel - Cihazda çalışır)
const sikistirFoto = (base64Str) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const MAX_SIZE = 1000; 
      let width = img.width;
      let height = img.height;
      if (width > height) {
        if (width > MAX_SIZE) { height *= MAX_SIZE / width; width = MAX_SIZE; }
      } else {
        if (height > MAX_SIZE) { width *= MAX_SIZE / height; height = MAX_SIZE; }
      }
      canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.7)); // 0.7 kalite ile sıkıştırır
    };
  });
};
// 🚀 AKILLI STATÜ İLERLETME MANTIĞI (Burası kalsın)
const statuSirasiniAl = (mevcutDurum) => {
  const sira = [
    "aracta", "adres_bekliyor", "beklemede", "yikaniyor", 
    "kurutuluyor", "fason", "teslim_hazir", "dagitimda", "teslim_edildi"
  ];
  const suAnkiIdx = sira.indexOf(mevcutDurum);
  if (suAnkiIdx >= 0 && suAnkiIdx < sira.length - 1) {
    return sira[suAnkiIdx + 1];
  }
  return null;
};


// ═══════════════════════════════════════════════════════════
// YARDIMCILAR
// ═══════════════════════════════════════════════════════════
const formatAdSoyad = (v = "") => {
  if (!v) return "";
  const p = v.trim().split(/\s+/);
  if (p.length < 1) return "";
  
  // Tek isim girilirse (Örn: Burhan) -> Burhan
  if (p.length === 1) return p[0].charAt(0).toUpperCase() + p[0].slice(1).toLowerCase();

  // Çok isimli durum (Örn: burhan cengiz demirtaş karageçili)
  // En sondakini al ve hepsini BÜYÜK yap (KARAGEÇİLİ)
  const soyad = p.pop().toUpperCase(); 
  
  // Geri kalan her şeyin sadece baş harfini büyük yap (Burhan Cengiz Demirtaş)
  const isimler = p.map(isim => 
    isim.charAt(0).toUpperCase() + isim.slice(1).toLowerCase()
  ).join(" ");

  return `${isimler} ${soyad}`;
};

// 📱 Sabit +90 Ön Ekli ve Akıllı Telefon Formatlayıcı (Zırhlı Versiyon)
const formatTel = (v = "") => {
  // 🚀 REİS: Kullanıcı silmeye çalışsa bile kutu içinde +90 mühürlü kalır
  if (!v || v.length < 4) return "+90 ";

  // Rakam olmayan her şeyi temizle
  let x = v.replace(/\D/g, "");
  
  // Eğer kullanıcı 90 yazmaya başlarsa (çifte 90 olmasın diye) baştaki 90'ı temizle
  if (x.startsWith("90")) x = x.slice(2);
  
  // Maksimum 10 hane işle (5xx xxx xx xx)
  x = x.slice(0, 10);

  if (x.length === 0) return "+90 ";
  if (x.length <= 3) return `+90 ${x}`;
  if (x.length <= 6) return `+90 ${x.slice(0, 3)} ${x.slice(3)}`;
  if (x.length <= 8) return `+90 ${x.slice(0, 3)} ${x.slice(3, 6)} ${x.slice(6)}`;
  return `+90 ${x.slice(0, 3)} ${x.slice(3, 6)} ${x.slice(6, 8)} ${x.slice(8, 10)}`;
};
// 💰 (Yeni Kasa Kilidimiz)
const formatPara = (sayi) => {
  if (!sayi && sayi !== 0) return "0,00";
  return parseFloat(sayi).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
const bugun = () => new Date().toLocaleDateString("tr-TR");
const simdi = () => new Date().toLocaleTimeString("tr-TR",{hour:"2-digit",minute:"2-digit"});
const tarihEkle = (g) => { const d=new Date(); d.setDate(d.getDate()+g); return d.toLocaleDateString("tr-TR"); };
const gunFarki = (tarih="") => {
  const p=tarih.split("."); if(p.length!==3) return 0;
  return Math.floor((Date.now()-new Date(+p[2],+p[1]-1,+p[0]))/86400000);
};


let MUS_ID=100;
const hesaplaSatir = (s={}) => {
  const f=parseFloat(s.birimFiyat||s.varsayilanFiyat||0)||0;
  const m=parseFloat(s.miktar||0)||0;
  const c=KIRLILIK.find(k=>k.id===(s.kirlilik||"normal"))?.carpan||1;
  const ara=m*f; const kEk=ara*(c-1); const eEk=s.ekspres?(ara+kEk)*0.5:0;
  return {satirToplam:ara+kEk+eEk,kirlilikEk:kEk,ekspresEk:eEk};
};
const hesaplaFis = (satirlar=[],iskontoTur="yok",iskontoMiktar="",nakliye="",ambalaj="",kdv=false) => {
  const araToplam=satirlar.reduce((s,x)=>s+hesaplaSatir(x).satirToplam,0);
  let iskonto=0;
  if(iskontoTur==="yuzde") iskonto=araToplam*(parseFloat(iskontoMiktar)||0)/100;
  else if(iskontoTur==="tutar") iskonto=parseFloat(iskontoMiktar)||0;
  const nav=parseFloat(nakliye)||0, amb=parseFloat(ambalaj)||0;
  const ara2=Math.max(0,araToplam-iskonto)+nav+amb;
  const kdvVal=kdv?ara2*0.2:0;
  return {araToplam,iskonto,nakliye:nav,ambalaj:amb,kdv:kdvVal,genelToplam:ara2+kdvVal};
};
const logKey = () => `halici_log_${bugun().replace(/\./g,"_")}`;

const MOCK_M = [

];
const MOCK_P = [

];

// ═══════════════════════════════════════════════════════════
// TELEFON / REHBER ENTEGRASYONU
// ═══════════════════════════════════════════════════════════
async function rehberdenSec() {
  // Web Contacts API (Chrome Android destekler)
  if("contacts" in navigator && "ContactsManager" in window) {
    try {
      const contacts = await navigator.contacts.select(["name","tel"],{multiple:false});
      if(contacts.length>0) {
        return {
          ad:contacts[0].name?.[0]||"",
          tel:contacts[0].tel?.[0]||"",
        };
      }
    } catch(e) { console.log("Contacts API error:", e); }
  }
  return null;
}

// Son aramalar logu (uygulama kendi logunu tutar)
// Gerçek telefon aramaları: Android'de Capacitor eklentisi gerektirir
// Web'de sadece kendi kayıtlarımızı tutabiliriz

// ═══════════════════════════════════════════════════════════
// TEMEL UI
// ═══════════════════════════════════════════════════════════
function Inp({label,value,onChange,type="text",placeholder="",suffix="",T,style={},required=false}) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:4}}>
      {label && (
        <label style={{fontSize:12,fontWeight:600,color:T.textSec}}>
          {label}
          {required && <span style={{color:T.danger, marginLeft:4, fontSize:14}}>*</span>}
        </label>
      )}
      <div style={{position:"relative"}}>
        <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
          style={{width:"100%",padding:"13px 14px",paddingRight:suffix?"36px":"14px",background:T.input,
            border:`1.5px solid ${T.inputBorder}`,borderRadius:12,color:T.text,fontSize:15,outline:"none",
            boxSizing:"border-box",...style}}
          onFocus={e=>e.target.style.borderColor=T.primary}
          onBlur={e=>e.target.style.borderColor=T.inputBorder}/>
        {suffix&&<span style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",fontSize:12,color:T.textSec,pointerEvents:"none"}}>{suffix}</span>}
      </div>
    </div>
  );
}

function Toggle({value,onChange,T}) {
  return (
    <div onClick={()=>onChange(!value)} style={{width:48,height:26,borderRadius:13,background:value?T.primary:T.border,
      cursor:"pointer",position:"relative",transition:"background 0.2s",flexShrink:0}}>
      <div style={{position:"absolute",top:3,left:value?22:3,width:20,height:20,borderRadius:"50%",
        background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 4px rgba(0,0,0,0.25)"}}/>
    </div>
  );
}

function Yildiz({puan=0,onChange=null,boyut=18}) {
  return (
    <div style={{display:"flex",gap:2}}>
      {[1,2,3,4,5].map(y=>(
        <span key={y} onClick={()=>onChange?.(y)}
          style={{fontSize:boyut,cursor:onChange?"pointer":"default",color:y<=puan?"#F59E0B":"#CBD5E1",lineHeight:1}}>★</span>
      ))}
    </div>
  );
}

function Badge({children,renk="#64748B"}) {
  return <span style={{padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600,
    background:renk+"22",color:renk,border:`1px solid ${renk}33`,whiteSpace:"nowrap"}}>{children}</span>;
}

function SayiBadge({sayi,renk="#EF4444"}) {
  if(!sayi||sayi===0) return null;
  return <span style={{minWidth:18,height:18,borderRadius:9,background:renk,color:"#fff",fontSize:10,
    fontWeight:700,display:"inline-flex",alignItems:"center",justifyContent:"center",
    padding:"0 5px",flexShrink:0}}>{sayi}</span>;
}
// ═══════════════════════════════════════════════════════════
// TAKVİM
// ═══════════════════════════════════════════════════════════
const AYLAR=["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
const GUNLER_K=["Pt","Sa","Ça","Pe","Cu","Ct","Pz"];
function DatePicker({label,value,onChange,T}) {
  const [open,setOpen]=useState(false);
  const ref=useRef();
  const sel=useMemo(()=>{
    if(!value) return new Date();
    const p=value.split("—")[0].trim().split(".");
    return p.length===3?new Date(+p[2],+p[1]-1,+p[0]):new Date();
  },[value]);
  const [view,setView]=useState({y:sel.getFullYear(),m:sel.getMonth()});
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[]);
  const firstDay=new Date(view.y,view.m,1).getDay();
  const offset=firstDay===0?6:firstDay-1;
  const days=new Date(view.y,view.m+1,0).getDate();
  const pick=d=>{onChange(new Date(view.y,view.m,d).toLocaleDateString("tr-TR"));setOpen(false);};
  const today=new Date();
  // Seçili tarih metni - güzel format
  const formatGoster=()=>{
    if(!value) return "Tarih seçin...";
    const p=value.split("—")[0].trim().split(".");
    if(p.length!==3) return value;
    const d=new Date(+p[2],+p[1]-1,+p[0]);
    const gunler=["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"];
    return `${gunler[d.getDay()]}, ${p[0]} ${AYLAR[+p[1]-1]} ${p[2]}`;
  };
  return (
    <div ref={ref} style={{position:"relative"}}>
      {label&&<label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>{label}</label>}
      <div onClick={()=>setOpen(o=>!o)}
        style={{padding:"13px 14px",background:T.input,border:`1.5px solid ${open?T.primary:T.inputBorder}`,
          borderRadius:12,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",
          color:value?T.text:T.textSec,fontSize:14,transition:"border-color 0.2s"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:18}}>📅</span>
          <span style={{fontWeight:value?600:400}}>{formatGoster()}</span>
        </div>
        <span style={{fontSize:12,color:T.textSec,transform:open?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.2s"}}>▾</span>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,zIndex:999,background:T.card,
          border:`1.5px solid ${T.primary}40`,borderRadius:20,padding:16,width:"100%",minWidth:300,
          boxShadow:"0 16px 48px rgba(0,0,0,0.18)",backdropFilter:"blur(8px)"}}>
          {/* Hızlı seçim */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:6,marginBottom:14}}>
            {[["Bugün",bugun()],["Yarın",tarihEkle(1)],["+3 gün",tarihEkle(3)],["+7 gün",tarihEkle(7)]].map(([l,v])=>(
              <button key={l} onClick={()=>{onChange(v);setOpen(false);}}
                style={{padding:"8px 4px",borderRadius:10,border:`1.5px solid ${T.primary}30`,
                  background:T.primary+"10",color:T.primary,cursor:"pointer",fontSize:11,fontWeight:700,textAlign:"center"}}>
                {l}
              </button>
            ))}
          </div>
          {/* Ay başlığı */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12,
            padding:"8px 4px",background:T.primary,borderRadius:12}}>
            <button onClick={()=>setView(v=>v.m===0?{y:v.y-1,m:11}:{...v,m:v.m-1})}
              style={{background:"rgba(255,255,255,0.2)",border:"none",cursor:"pointer",fontSize:18,color:"#fff",
                borderRadius:8,width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
            <span style={{fontSize:15,fontWeight:800,color:"#fff",letterSpacing:0.5}}>{AYLAR[view.m]} {view.y}</span>
            <button onClick={()=>setView(v=>v.m===11?{y:v.y+1,m:0}:{...v,m:v.m+1})}
              style={{background:"rgba(255,255,255,0.2)",border:"none",cursor:"pointer",fontSize:18,color:"#fff",
                borderRadius:8,width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
          </div>
          {/* Gün başlıkları */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:2,marginBottom:4}}>
            {GUNLER_K.map(g=>(
              <div key={g} style={{textAlign:"center",fontSize:11,fontWeight:700,color:T.textSec,padding:"4px 0"}}>{g}</div>
            ))}
          </div>
          {/* Günler */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
            {Array(offset).fill(null).map((_,i)=><div key={"e"+i}/>)}
            {Array(days).fill(null).map((_,i)=>{
              const d=i+1;
              const isSel=sel.getDate()===d&&sel.getMonth()===view.m&&sel.getFullYear()===view.y;
              const isToday=today.getDate()===d&&today.getMonth()===view.m&&today.getFullYear()===view.y;
              const isCuma=new Date(view.y,view.m,d).getDay()===5;
              const isCumartesi=new Date(view.y,view.m,d).getDay()===6;
              const isPazar=new Date(view.y,view.m,d).getDay()===0;
              return (
                <button key={d} onClick={()=>pick(d)}
                  style={{aspectRatio:"1",borderRadius:10,border:isToday&&!isSel?`2px solid ${T.primary}`:"none",
                    cursor:"pointer",fontSize:13,fontWeight:isSel?800:isToday?700:400,
                    background:isSel?T.primary:isToday?T.primary+"15":"transparent",
                    color:isSel?"#fff":isToday?T.primary:isCuma||isCumartesi||isPazar?"#EF4444":T.text,
                    position:"relative",display:"flex",alignItems:"center",justifyContent:"center",
                    minHeight:36,transition:"all 0.15s"}}>
                  {d}
                  {isToday&&!isSel&&<div style={{position:"absolute",bottom:3,left:"50%",transform:"translateX(-50%)",
                    width:4,height:4,borderRadius:"50%",background:T.primary}}/>}
                </button>
              );
            })}
          </div>
          {/* Seçilen tarih önizleme */}
          {value&&(
            <div style={{marginTop:12,padding:"10px 14px",background:T.primary+"12",borderRadius:12,
              textAlign:"center",fontSize:13,fontWeight:600,color:T.primary}}>
              ✓ {formatGoster()}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// AUTH EKRANLARI
// ═══════════════════════════════════════════════════════════
function AuthEkrani({ onGiris, onKayit, T, t }) {
  const [tab, setTab] = useState("giris");
  const [email, setEmail] = useState("");
  const [sifre, setSifre] = useState("");
  const [sifreTekrar, setSifreTekrar] = useState("");
  const [sirket, setSirket] = useState("");
  const [adSoyad, setAdSoyad] = useState("");
  const [sifreGoster, setSifreGoster] = useState(false);
  const [hata, setHata] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);

  // 🚀 YENİ İSİM PARÇALARI (Bunları ekledik)
  const [ad_ham, setAdHam] = useState("");
  const [ad_formatli, setAdFormatli] = useState("");
  const [soyad_ham, setSoyadHam] = useState("");
  const [soyad_formatli, setSoyadFormatli] = useState("");

// ☁️ GİRİŞ TETİKLEYİCİ (AuthEkrani İçinde)
  const girisYap = async () => {
    if (!email || !sifre) { 
      setHata("E-posta ve şifre zorunlu"); 
      return; 
    }
    setYukleniyor(true); 
    setHata("");
    
    try {
      const sonuc = await onGiris(email, sifre);
      
      // 🚀 BURASI KRİTİK: Eğer sonuc false ise hatayı bas
      if (!sonuc) {
        setHata("Giriş başarısız. Lütfen açık olan diğer sekmeleri kapatın veya şifrenizi kontrol edin.");
      }
    } catch (err) {
      console.error("Giriş tetikleme hatası:", err);
      setHata("Giriş sırasında bir hata oluştu: " + err.message);
    } finally {
      // 👈 BEYİN: İşlem başarılı da olsa, hatalı da olsa asılı kalmaması için butonu ZORLA SERBEST BIRAK!
      setYukleniyor(false); 
    }
  };

// ☁️ KAYIT TETİKLEYİCİ (AuthEkrani İçinde)
  const kayitOl = async () => {
    // 🚀 BEYİN: React State gecikmelerini ezip, kutudaki anlık veriyi zorla birleştirir
    const tamIsimGaranti = `${ad_formatli || ad_ham || ""} ${soyad_formatli || soyad_ham || ""}`.trim();

    if (!tamIsimGaranti || !email || !sifre) { 
      setHata("Tüm alanları doldurun"); 
      return; 
    }
    if (sifre !== sifreTekrar) { 
      setHata("Şifreler eşleşmiyor"); 
      return; 
    }
    
    setYukleniyor(true); 
    setHata("");
    
    try {
      // 🚀 ZIRH: Adı, soyadı ve birleşmiş halini net olarak ana motora yolluyoruz
      const sonuc = await onKayit({ 
        adSoyad: tamIsimGaranti, 
        ad_sadece: ad_formatli || ad_ham || "", 
        soyad_sadece: soyad_formatli || soyad_ham || "", 
        email, 
        sifre, 
        sirket 
      });
      
      // 🚀 BURASI KRİTİK: Kayıt başarısızsa butonu serbest bırak
      if (!sonuc) {
        setHata("Kayıt sırasında bir hata oluştu veya bu e-posta zaten kullanımda.");
        setYukleniyor(false); // 👈 BUTONU SERBEST BIRAK
      }
    } catch (err) {
      console.error("Kayıt tetikleme hatası:", err);
      // 🚨 Gizli hatayı ekrana basıyoruz
      setHata("Kayıt hatası oluştu: " + err.message);
      setYukleniyor(false); // 👈 HATA OLSA BİLE BUTONU SERBEST BIRAK
    }
  };

  // 📧 ŞİFRE SIFIRLAMA FONKSİYONU (EmailJS + Hata Yakalama Birleştirilmiş)
  const sifremiUnuttum = async () => {
    if (!email) { 
      setHata("Lütfen önce e-posta adresinizi yazın."); 
      return; 
    }
    
    setYukleniyor(true);
    setHata("");

    try {
      // 1. Önce bu mailde bir kullanıcı var mı Firestore'dan kontrol edelim
      const q = query(collection(db, "kullanicilar"), where("email", "==", email.toLowerCase().trim()));
      const snap = await getDocs(q);

      if (snap.empty) {
        setHata("Bu e-posta adresi sistemde kayıtlı değil.");
        setYukleniyor(false);
        return;
      }

      const kullaniciData = snap.docs[0].data();
      const isim = kullaniciData.adSoyad || kullaniciData.ad || "Sayın Kullanıcı";
      const mevcutSifre = kullaniciData.sifre;

      // 🚀 KRİTİK: EmailJS'i anahtarla uyandır
      emailjs.init("I5OckH63W0nXISCAI");

      const templateParams = {
        to_email: email.toLowerCase().trim(),
        email: email.toLowerCase().trim(),
        to_name: isim,
        from_name: "HaliPro Destek", // 👈 Bu satırı ekle (Paneldeki {{from_name}} buraya bakar)
        message: mevcutSifre,
      };

      // 🚀 2. EmailJS ile mail gönderimi
      emailjs.send(
        'service_evp34yi',    
        'template_rnj6d3r',  
        templateParams,
        'I5OckH63W0nXISCAI' // Tedbiren Public Key'i buraya da ekledik
      )
      .then((res) => {
        console.log("BAŞARILI:", res);
        alert("✅ Şifreniz e-posta adresinize gönderildi!");
        setYukleniyor(false); // 👈 İŞLEM BİTTİ, BUTONU AÇ
      })
      .catch((err) => {
        console.error("GÖNDERİM HATASI:", err);
        // 🚨 BURASI ÇOK ÖNEMLİ: Hata verirse ekranda ne yazdığını bana söyle
        alert("EmailJS Hatası: " + (err.text || err.message || "Bilinmeyen hata"));
        setHata("Mail servisi şu an yanıt vermiyor.");
        setYukleniyor(false); // 👈 HATA OLSA BİLE BUTONU AÇ
      });

    } catch (err) {
      console.error("SİSTEM HATASI:", err);
      // 🚨 Gizli hatayı ekrana basıyoruz
      setHata("Veritabanı bağlantısında bir sorun oluştu: " + err.message);
      setYukleniyor(false); // 👈 HATA OLSA BİLE BUTONU AÇ
    }
  };
 return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20 }}>
      {/* Logo ve Başlık Bölümü */}
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          margin: "0 auto 16px",
          maxWidth: "180px", 
          maxHeight: "120px",
          overflow: "visible" 
        }}>
          <img 
            src={`${process.env.PUBLIC_URL}/logo.png`} 
            alt="HaliPro Logo" 
            style={{ 
              width: "auto", 
              height: "auto", 
              maxWidth: "100%", 
              maxHeight: "100%", 
              objectFit: "contain",
              display: "block" 
            }} 
          />
        </div>
        
        <h1 style={{ fontSize: 32, fontWeight: 900, color: T.text, margin: "0 0 16px", letterSpacing: -1 }}>Hoşgeldiniz.</h1>
        
        {/* 🚀 İNDİRME VE ERİŞİM BUTONLARI */}
        <div style={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          gap: 12,
          marginTop: 10
        }}>
          
          {/* MASAÜSTÜ GRUBU */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
            <a 
              href="https://github.com/burhancengizbc/halipro/releases/latest/download/HaliPro-mac.zip" 
              style={{
                padding: "10px 18px",
                borderRadius: "14px",
                background: T.card,
                border: `1.5px solid ${T.border}`,
                color: T.text,
                textDecoration: "none",
                fontSize: "13px",
                fontWeight: "700",
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              <i className="fab fa-apple"></i> MAC İçin İndir
            </a>

            <a 
              href="https://github.com/burhancengizbc/halipro/releases/latest/download/HaliPro.exe" 
              style={{
                padding: "10px 18px",
                borderRadius: "14px",
                background: T.card,
                border: `1.5px solid ${T.border}`,
                color: T.text,
                textDecoration: "none",
                fontSize: "13px",
                fontWeight: "700",
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              <i className="fab fa-windows"></i> Windows İçin İndir
            </a>
          </div>

          {/* MOBİL GRUBU */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center", marginTop: 5 }}>
            {/* APP STORE - ŞİMDİLİK BOŞ */}
            <a 
              href="#/" 
              onClick={(e) => e.preventDefault()}
              style={{
                padding: "10px 18px",
                borderRadius: "14px",
                background: T.card,
                border: `1.5px solid ${T.border}`,
                color: T.text,
                opacity: 0.6, // Henüz aktif olmadığını belli etmek için hafif soluk
                cursor: "not-allowed",
                textDecoration: "none",
                fontSize: "13px",
                fontWeight: "700",
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              <i className="fab fa-app-store-ios"></i> App Store
            </a>

            {/* ANDROID APK LİNKİ */}
            <a 
              href="https://github.com/burhancengizbc/halipro/releases/latest/download/HaliPro.apk" 
              style={{
                padding: "10px 18px",
                borderRadius: "14px",
                background: T.card,
                border: `1.5px solid ${T.border}`,
                color: T.text,
                textDecoration: "none",
                fontSize: "13px",
                fontWeight: "700",
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
              }}
            >
              <i className="fab fa-android"></i> Android APK İndir
            </a>
          </div>

          {/* WEB LİNKİ */}
          <a 
            href="https://burhancengiz.com/halipro" 
            style={{ 
              color: T.primary, 
              fontSize: "14px", 
              fontWeight: "800", 
              textDecoration: "underline",
              marginTop: 8
            }}
          >
            🌐 Web Olarak Kullanmak İçin Tıkla
          </a>
        </div>
      </div>

      {/* Giriş/Kayıt Form Kartı */}
      <div style={{ width: "100%", maxWidth: 420, background: T.card, borderRadius: 24, overflow: "hidden", boxShadow: "0 4px 32px rgba(0,0,0,0.1)", border: `1.1px solid ${T.border}` }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", background: T.statCard }}>
          {[["giris", t("girisYap")], ["kayit", t("kayitOl")]].map(([k, l]) => (
            <button key={k} onClick={() => { setTab(k); setHata(""); }}
              style={{ padding: "16px", border: "none", cursor: "pointer", fontSize: 15, fontWeight: tab === k ? 700 : 500, background: tab === k ? T.card : "transparent", color: tab === k ? T.primary : T.textSec, borderBottom: tab === k ? `3px solid ${T.primary}` : "3px solid transparent" }}>
              {l}
            </button>
          ))}
        </div>

        <div style={{ padding: 24 }}>
          {hata && <div style={{ padding: "12px 14px", background: "#FEE2E2", borderRadius: 10, marginBottom: 16, fontSize: 13, color: "#DC2626", border: "1px solid #FECACA" }}>{hata}</div>}

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
           {tab === "kayit" && (
              <>
                {/* 🏷️ AD VE SOYAD AYRI KUTULAR */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <Inp 
                    label="Ad(lar) *" 
                    value={ad_ham || ""} 
                    onChange={v => {
                      const f = v.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(' ');
                      setAdHam(v); 
                      setAdFormatli(f);
                      setAdSoyad(`${f} ${soyad_formatli || ""}`.trim());
                    }} 
                    T={T} 
                    placeholder="Adınız" 
                  />
                  <Inp 
                    label="Soyad *" 
                    value={soyad_ham || ""} 
                    onChange={v => {
                      // 🚀 Arka planda büyük harfe çevir
                      const f = v.toUpperCase();
                      setSoyadHam(f); 
                      setSoyadFormatli(f);
                      setAdSoyad(`${ad_formatli || ""} ${f}`.trim());
                    }} 
                    T={T} 
                    placeholder="SOYAD"
                    // 🔥 KRİTİK NOKTA: Yazarken kutu içinde de büyük görünmesi için zorla!
                    style={{ textTransform: "uppercase" }} 
                  />
                </div>
                <Inp label="Şirket Adı" value={sirket} onChange={v => setSirket(v)} placeholder="Halı Yıkama Adı" T={T} />
              </>
            )}
            
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 4 }}>E-posta *</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 18, zIndex: 2 }}>✉️</span>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="ornek@email.com"
                  onKeyDown={e => e.key === "Enter" && (tab === "giris" ? girisYap() : kayitOl())}
                  style={{ width: "100%", padding: "13px 14px 13px 44px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            {/* Şifre Alanı */}
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 4 }}>Şifre *</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 18, zIndex: 2 }}>🔒</span>
                <input type={sifreGoster ? "text" : "password"} value={sifre} onChange={e => setSifre(e.target.value)}
                  placeholder="••••••••"
                  onKeyDown={e => e.key === "Enter" && (tab === "giris" ? girisYap() : kayitOl())}
                  style={{ width: "100%", padding: "13px 44px 13px 44px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
                <button type="button" onClick={() => setSifreGoster(!sifreGoster)}
                  style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 18, color: T.textSec, zIndex: 2 }}>
                  {sifreGoster ? "🙈" : "👁️"}
                </button>
              </div>
            </div>
{/* 🚀 ŞİFREMİ UNUTTUM BURAYA GELDİ */}
            {tab === "giris" && (
              <div style={{ textAlign: "right", marginTop: -6 }}>
                <button type="button" onClick={sifremiUnuttum}
                  style={{ background: "none", border: "none", color: T.textSec, cursor: "pointer", fontSize: 12, fontWeight: 500, padding: "4px 0" }}>
                  Şifremi Unuttum?
                </button>
              </div>
            )}
            {/* Şifre Tekrar Alanı */}
            {tab === "kayit" && (
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 4 }}>Şifre Tekrar *</label>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 18, zIndex: 2 }}>🔒</span>
                  <input type={sifreGoster ? "text" : "password"} value={sifreTekrar} onChange={e => setSifreTekrar(e.target.value)}
                    placeholder="••••••••"
                    onKeyDown={e => e.key === "Enter" && kayitOl()}
                    style={{ width: "100%", padding: "13px 44px 13px 44px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
               <button type="button" onClick={() => setSifreGoster(!sifreGoster)}
                    style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 18, color: T.textSec, zIndex: 2 }}>
                    {sifreGoster ? "🙈" : "👁️"}
                  </button>
                   </div>
              </div>
            )}
          </div>

          <button onClick={tab === "giris" ? girisYap : kayitOl}
            disabled={yukleniyor}
            style={{ width: "100%", padding: "15px", background: T.primary, color: "#fff", border: "none", borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: yukleniyor ? "not-allowed" : "pointer", opacity: yukleniyor ? 0.7 : 1, marginTop: 20 }}>
            {yukleniyor ? "Lütfen bekleyin..." : (tab === "giris" ? t("girisYap") : t("kayitOl"))}
          </button>

          {tab === "giris" && (
            <p style={{ textAlign: "center", marginTop: 12, fontSize: 13, color: T.textSec }}>
              Hesabınız yok mu?{" "}
              <button onClick={() => setTab("kayit")}
                style={{ background: "none", border: "none", color: T.primary, cursor: "pointer", fontWeight: 700, fontSize: 13 }}>
                {t("kayitOl")}
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// GÜNCELLENMİŞ MODERN CALLER ID (Grup ve Borç Entegreli)
// ═══════════════════════════════════════════════════════════
function CallerIdPopup({numara, musteriler, onFisAc, onSahayaEkle, onKayitYap, onKapat, T, t}) {
  // 🚀 REİS: Telefonun son 10 hanesini eşleştiriyoruz (Hata payını siler)
  const temizNumara = (numara || "").replace(/\D/g, "").slice(-10);
  const musteri = musteriler.find(m => 
    (m.tel || "").replace(/\D/g, "").includes(temizNumara) || 
    (m.tel2 || "").replace(/\D/g, "").includes(temizNumara)
  );

  const [kapaniyor, setKapaniyor] = useState(false);

  const kapat = useCallback((aksiyon = "gormezden") => {
    setKapaniyor(true);
    setTimeout(() => onKapat(aksiyon), 280);
  }, [onKapat]);

  // 30 saniye sonra otomatik kapanma mühürü
  useEffect(() => {
    const tm = setTimeout(() => kapat(), 30000);
    return () => clearTimeout(tm);
  }, [kapat]);

  return (
    <div style={{
      position: "fixed", top: "15%", left: "5%", right: "5%", zIndex: 99999,
      background: "#fff", borderRadius: 28, padding: 24,
      boxShadow: "0 25px 70px rgba(0,0,0,0.6)", border: "1px solid #eee",
      animation: "slideUp 0.4s ease-out", color: "#1a1a1a",
      opacity: kapaniyor ? 0 : 1, transition: "opacity 0.28s"
    }}>
      {/* Kapatma Çarpısı */}
      <button onClick={() => kapat()} style={{position:"absolute", right:18, top:18, background:"#f5f5f5", border:"none", borderRadius:12, width:32, height:32, cursor:"pointer", color: "#666", fontWeight: "bold"}}>X</button>

      {/* Üst Bilgi (Murat Özer Bölümü) */}
      <div style={{display:"flex", alignItems:"center", gap:16, marginBottom:20}}>
        <div style={{width:64, height:64, borderRadius:20, background: musteri ? "#f0f7ff" : "#f5f5f5", display:"flex", alignItems:"center", justifyContent:"center", fontSize:32}}>
          {musteri ? "👤" : "❓"}
        </div>
        <div style={{flex: 1, minWidth: 0}}>
          <div style={{fontSize: 22, fontWeight: 900, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
            {musteri ? musteri.ad : "Bilinmeyen Numara"}
          </div>
          <div style={{fontSize: 14, color: "#64748b", fontWeight: 500}}>
            {musteri ? (musteri.semt || "Adres Belirtilmemiş") : "Sistemde kayıtlı değil"}
          </div>
        </div>
      </div>

      {/* 📱 Telefon Satırı */}
      <div style={{background: "#f8fafc", padding: "14px 18px", borderRadius: 16, display: "flex", alignItems: "center", gap: 12, marginBottom: 12, border: "1px solid #f1f5f9"}}>
        <span style={{fontSize: 20}}>📱</span> 
        <strong style={{fontSize: 18, letterSpacing: 0.5, color: "#334155"}}>{numara}</strong>
      </div>

      {/* 🚩 KRİTİK MÜŞTERİ NOTU (BURAYA EKLENDİ) */}
      {musteri?.notlar && (
        <div style={{
          background: "#FFF1F2", 
          border: "2px solid #FB7185", 
          padding: "14px", 
          borderRadius: 16, 
          marginBottom: 12,
          animation: "pulse 2s infinite" 
        }}>
          <div style={{fontSize: 11, fontWeight: 800, color: "#E11D48", marginBottom: 4, textTransform: "uppercase"}}>⚠️ KRİTİK MÜŞTERİ NOTU</div>
          <div style={{fontSize: 15, fontWeight: 700, color: "#9F1239", lineHeight: 1.4}}>
            {musteri.notlar}
          </div>
        </div>
      )}

      {/* 📁 GRUP BİLGİSİ */}
      {musteri && (
        <div style={{
          padding: "10px 18px", background: "#f8fafc", borderRadius: 16,
          marginBottom: 10, fontSize: 14, color: "#64748b", 
          display: "flex", justifyContent: "space-between", alignItems: "center",
          border: "1px solid #e2e8f0"
        }}>
          <span style={{fontWeight: 600}}>📁 Müşteri Grubu:</span>
          <span style={{
            fontWeight: 800, color: "#2563eb", background: "#dbeafe", 
            padding: "2px 10px", borderRadius: 8, fontSize: 12
          }}>
            {musteri.grup || "Normal"}
          </span>
        </div>
      )}

      {/* 💰 BORÇ DURUMU (Geliştirilmiş yeşil/kırmızı kutu) */}
      <div style={{
        background: (musteri?.borc > 0) ? "#fff1f2" : "#f0fdf4",
        padding: "14px 18px", borderRadius: 16, 
        color: (musteri?.borc > 0) ? "#be123c" : "#15803d",
        fontWeight: 800, marginBottom: 24, display: "flex", alignItems: "center", gap: 12,
        border: (musteri?.borc > 0) ? "1px solid #fecdd3" : "1px solid #dcfce7"
      }}>
        <span style={{fontSize: 20}}>{musteri?.borc > 0 ? "⚠️" : "✅"}</span> 
        <span style={{fontSize: 16}}>
          {(() => {
  const borc = parseFloat(musteri?.borc || 0);
  return borc > 0
    ? `Borç Durumu: ₺${borc.toFixed(2)}`
    : "Müşterinin Borcu Yok";
})()}
        </span>
      </div>

      {/* Ana Butonlar (Analizine göre tamamlandı) */}
      <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20}}>
        {musteri ? (
          <>
            <button onClick={() => { onFisAc(musteri); kapat("fis_acildi"); }} 
              style={{padding: "16px", borderRadius: 16, background: "#2563eb", color: "#fff", border: "none", fontWeight: 800, fontSize: 15, cursor: "pointer"}}>Müşteri Kartı</button>
            <button onClick={() => { onSahayaEkle(musteri); kapat("sahaya_eklendi"); }} 
              style={{padding: "16px", borderRadius: 16, background: "#f59e0b", color: "#fff", border: "none", fontWeight: 800, fontSize: 15, cursor: "pointer"}}>Yeni Sipariş</button>
          </>
        ) : (
          <button onClick={() => { onKayitYap(numara); kapat("kayit_baslatildi"); }} 
            style={{gridColumn: "span 2", padding: "16px", borderRadius: 16, background: "#10b981", color: "#fff", border: "none", fontWeight: 800, fontSize: 15, cursor: "pointer"}}>👤 Müşteri Olarak Kaydet</button>
        )}
      </div>

      {/* Alt Hızlı İkonlar */}
      <div style={{display: "flex", justifyContent: "space-around", borderTop: "1px solid #f1f5f9", paddingTop: 18}}>
        {[
          { i: "📞", l: "Ara", a: () => window.open(`tel:${numara}`) },
          { i: "💬", l: "SMS", a: () => window.open(`sms:${numara}`) },
          { i: "🟢", l: "WhatsApp", a: () => window.open(`https://wa.me/${numara.replace(/\D/g,"")}`) }
        ].map(item => (
          <div key={item.l} onClick={item.a} style={{textAlign: "center", cursor: "pointer"}}>
            <div style={{fontSize: 24, marginBottom: 4}}>{item.i}</div>
            <div style={{fontSize: 11, fontWeight: 700, color: "#64748b"}}>{item.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// TAHSILAT MODAL
// ═══════════════════════════════════════════════════════════
function TahsilatModal({fis,musteri,personeller,onKaydet,onKapat,T,t}) {
  const [nakit,setNakit]=useState("");
  const [kart,setKart]=useState("");
  const [eskiBorc,setEskiBorc]=useState("");
  const [alan,setAlan]=useState("");

  const toplam=fis?.hesaplama?.genelToplam||0;
  const mevcutBorc=musteri?.borc||0;

  // 🚀 Arka planda hesaplama için ham rakamlara çeviriyoruz
  const nakitV=parseFloat(nakit)||0;
  const kartV=parseFloat(kart)||0;
  const eskiV=parseFloat(eskiBorc)||0;

  const kalanBorc=Math.max(0,toplam-nakitV-kartV);
  const kasayaGiren=nakitV+kartV+eskiV;
  const yeniBorc=Math.max(0,mevcutBorc+kalanBorc-eskiV);

  // 💰 BİNLİK AYRAÇ İÇİN AKILLI FONKSİYONLAR
  const handleParaGirisi = (v, setter) => {
    // Sadece rakamları al (Kullanıcı harf veya sembol giremez)
    const sadeceSayi = v.replace(/[^0-9]/g, "");
    setter(sadeceSayi);
  };

  const paraFormatla = (val) => {
    if (!val) return "";
    return Number(val).toLocaleString("tr-TR"); // Ekrana 12.316.516 olarak basar
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:500,
      display:"flex",alignItems:"flex-end",justifyContent:"center"}}
      onClick={e=>{ e.stopPropagation(); }}>
      <div style={{background:T.bg,width:"100%",maxWidth:520,borderRadius:"24px 24px 0 0",
        maxHeight:"90vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
        <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"14px auto 0"}}/>
        <div style={{padding:20}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:700,color:T.success}}>💵 {t("tahsilatAl")}</h2>
            <button onClick={onKapat} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:24}}>✕</button>
          </div>
          <div style={{background:T.statCard,borderRadius:14,padding:"12px 16px",marginBottom:16}}>
            <div style={{fontSize:12,color:T.textSec}}>{fis?.fisNo?.split("—")[0]?.trim()} — {fis?.musteriAdi}</div>
            <div style={{fontSize:24,fontWeight:900,color:T.warning}}>₺{toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
          {mevcutBorc>0&&(
            <div style={{background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:14,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:700,color:"#DC2626",marginBottom:10}}>
                ⚠️ Eski Borç: ₺{mevcutBorc.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </div>
              <Inp 
                label="Eski Borçtan Tahsil Et (₺)" 
                value={paraFormatla(eskiBorc)} 
                onChange={v => handleParaGirisi(v, setEskiBorc)} 
                type="text" 
                suffix="₺" T={T}
              />
            </div>
          )}
          <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:16}}>
            <Inp 
              label="Alınan Nakit (₺)" 
              value={paraFormatla(nakit)} 
              onChange={v => handleParaGirisi(v, setNakit)} 
              type="text" 
              suffix="₺" T={T}
            />
            <Inp 
              label="Alınan Kart (₺)" 
              value={paraFormatla(kart)} 
              onChange={v => handleParaGirisi(v, setKart)} 
              type="text" 
              suffix="₺" T={T}
            />
          </div>
          
          <div style={{background:T.statCard,borderRadius:14,padding:14,marginBottom:16}}>
            {[
              ["Fiş Toplamı",`₺${toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,T.text],
              ["Nakit",`₺${nakitV.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,T.success],
              ["Kart",`₺${kartV.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,T.primary],
              ...(eskiV>0?[["Eski Borç",`₺${eskiV.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,T.warning]]:[]),
              ["---","",""],
              ["💰 Kasaya Giren",`₺${kasayaGiren.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,T.success],
              ["Kalan Borç",`₺${kalanBorc.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,kalanBorc>0?T.danger:T.success],
            ].map(([k,v,c])=>k==="---"?(
              <div key={k} style={{borderTop:`1px solid ${T.border}`,margin:"8px 0"}}/>
            ):(
              <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontSize:13}}>
                <span style={{color:T.textSec}}>{k}</span>
                <span style={{color:c,fontWeight:600}}>{v}</span>
              </div>
            ))}
          </div>

          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>Tahsil Eden</label>
            <select value={alan} onChange={e=>setAlan(e.target.value)}
              style={{width:"100%",padding:"13px 14px",background:T.input,border:`1.5px solid ${T.inputBorder}`,
                borderRadius:12,color:T.text,fontSize:15,outline:"none"}}>
              <option value="">— Seçin —</option>
              {personeller.map(p=><option key={p.id} value={p.ad}>{p.ad}</option>)}
              <option value="Patron">Patron</option>
            </select>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10}}>
            <button onClick={onKapat}
              style={{padding:"14px",borderRadius:12,background:"transparent",border:`1.5px solid ${T.border}`,
                color:T.textSec,cursor:"pointer",fontWeight:600,fontSize:15}}>
              {t("iptal")}
            </button>
            <button onClick={()=>onKaydet({nakit:nakitV,kart:kartV,eskiBorcTahsilat:eskiV,kasayaGiren,kalanBorc,yeniMusteriBorcu:yeniBorc,alan,tarih:bugun()})}
              style={{padding:"14px",borderRadius:12,background:T.success,border:"none",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:700}}>
              ✅ {t("kaydet")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// YENİ FİŞ MODAL (DÜZENLEME DESTEKLİ & AKILLI FORM)
// ═══════════════════════════════════════════════════════════
function FisModal({onKapat,onKaydet,musteriler,personeller,onYeniMusteri,T,t,showMusteriForm,setShowMusteriForm, yeniFisNo, duzenlenenFis, kullanici}) {
  const [fisNo] = useState(() => duzenlenenFis ? duzenlenenFis.fisNo : yeniFisNo());
  const [aramaStr,setAramaStr]=useState("");
  const [secili,setSecili]=useState(null);
  const [yeniMod,setYeniMod]=useState(false);
  const [yeniM, setYeniM] = useState({
    ad: "", tel: "+90 ", tel2: "+90 ", adres: "", semt: "", sehir: "", notlar: ""
  });
  const [alisTarihi,setAlis]=useState(bugun());
  const [teslimTarihi,setTeslim]=useState(tarihEkle(3));
  const [isAlan,setIsAlan]=useState("");
  const [not,setNot]=useState("");
  const [dukkanYeri,setDukkanYeri]=useState("");
  const [dukkanFotolar,setDukkanFotolar]=useState([]);
  const [acil,setAcil]=useState(false);
  const [kayd,setKayd]=useState(false);
  const dukkanFotoRef=useRef();

  // 🚀 BEYİN: Fiş Düzenlerken Formu Eski Verilerle Açan Yapı
  useEffect(() => {
    if (duzenlenenFis && isAlan === "") {
      setIsAlan(duzenlenenFis.isAlan || "");
      setAlis(duzenlenenFis.alisTarihi || bugun());
      setTeslim(duzenlenenFis.teslimTarihi || tarihEkle(3));
      setNot(duzenlenenFis.not || "");
      setAcil(duzenlenenFis.acil || false);
      setDukkanYeri(duzenlenenFis.dukkanYeri || "");
      setDukkanFotolar(duzenlenenFis.dukkanFotolar || []);
      
      // 🛡️ KORUMA: B şahsı hatasını önlemek için ID ve TELEFON'u aynı anda eşleştir!
      let m = musteriler.find(x => 
        (x.id === duzenlenenFis.musteriId || x.docId === duzenlenenFis.musteriId) &&
        x.tel === duzenlenenFis.musteriTel
      );
      if (!m) m = musteriler.find(x => x.id === duzenlenenFis.musteriId || x.docId === duzenlenenFis.musteriId);

      // 🚀 EFSANE DOKUNUŞ: Düzenlemeye basınca "Yeşil Müşteri Kutusu" yerine 
      // direkt "Açık Formu" getiriyoruz ki az önce girdiğin adresi anında gör ve düzelt!
      setYeniMod(true);
      setSecili(null); 
      
      if (m) {
        setYeniM({
          ...m, // Müşterinin mahalle, sokak, bina numarası gibi tüm verileri gelsin
          ad_ham: m.ad_ham || m.ad || duzenlenenFis.musteriAdi || "",
          soyad_ham: m.soyad_ham || "",
          tel: m.tel || duzenlenenFis.musteriTel || "+90 ",
          tel2: m.tel2 || "+90 ",
          adres: duzenlenenFis.musteriAdres || m.adres || ""
        });
      } else {
        // Eğer müşteri silinmişse bile fişin üzerindeki eski adres ekrana yansısın
        setYeniM(p => ({
          ...p,
          ad: duzenlenenFis.musteriAdi || "",
          ad_ham: duzenlenenFis.musteriAdi || "",
          tel: duzenlenenFis.musteriTel || "+90 ",
          adres: duzenlenenFis.musteriAdres || ""
        }));
      }
    }
  }, [duzenlenenFis]);

  const musteri=secili||(yeniMod&&yeniM.ad?yeniM:null);
  
  const filtreM=musteriler.filter(m=>
    (m.ad||"").toLowerCase().includes(aramaStr.toLowerCase())||(m.tel||"").includes(aramaStr)
  );

  const rehberdenAl = async () => {
    const destekleniyor = "contacts" in navigator && "ContactsManager" in window;
    if (!destekleniyor) {
      alert("⚠️ Rehber Erişimi Kısıtlı:\niPhone (iOS) cihazlarda veya bilgisayar tarayıcılarında rehber erişimi güvenlik nedeniyle kapalıdır.\n\nLütfen müşteri bilgilerini manuel giriniz.");
      return;
    }
    try {
      const contact = await rehberdenSec();
      if (contact) {
        setYeniMod(true);
        setYeniM(p => ({ ...p, ad: contact.ad || p.ad, tel: formatTel(contact.tel || p.tel) }));
      }
    } catch (e) {
      alert("Rehber açılırken bir hata oluştu.");
    }
  };

 const kaydet = async (wa = false) => {
    const ad = (secili?.ad || yeniM?.ad || "")?.trim();
    const tel = (secili?.tel || yeniM?.tel || "")?.trim();
    
    const formAdres = [yeniM?.mahalle, yeniM?.sokak, yeniM?.binaNo ? "No:"+yeniM.binaNo : "", yeniM?.daireNo ? "D:"+yeniM.daireNo : "", yeniM?.apartman, yeniM?.ilce, yeniM?.il].filter(Boolean).join(", ");
    const adres = (secili?.adres || formAdres || yeniM?.adres || "")?.trim();

    if (!ad) { alert("⚠️ Müşteri adı boş olamaz!"); return; }
    if (!tel) { alert("⚠️ Telefon numarası eksik!"); return; }
    if (!adres) { alert("⚠️ Adres bilgisi girilmemiş!"); return; }

    setKayd(true);
    let musteriId = secili?.id || (duzenlenenFis ? duzenlenenFis.musteriId : null);
    
    // Yeni müşteriyse kaydet
    if (!duzenlenenFis && !secili && yeniMod && ad) { 
      const y = await onYeniMusteri({ ...yeniM, ad: formatAdSoyad(ad), tel: formatTel(tel), adres }); 
      musteriId = y.id; 
    } 
    // 🔥 EFSANE DOKUNUŞ: Mevcut müşteri düzenleniyorsa onun profilindeki konumu da buluta mühürle!
    else if (duzenlenenFis && yeniMod && musteriId) {
      try {
        const musteriRef = doc(db, "kullanicilar", kullanici.email, "musteriler", musteriId);
        await updateDoc(musteriRef, { 
          adres: adres, 
          konum: yeniM.konum || null, 
          koordinat: yeniM.koordinat || null 
        });
      } catch (e) {}
    }

    // 🔥 BURASI DÜZELDİ: konum ve koordinat bilgisi Fişin içine de kaydediliyor!
    const fis = { 
      id: duzenlenenFis ? duzenlenenFis.id : Date.now(), 
      fisNo, 
      musteriId, 
      musteriAdi: formatAdSoyad(ad), 
      musteriTel: formatTel(tel), 
      musteriAdres: adres, 
      musteriSemt: secili?.semt || yeniM?.semt || "", 
      konum: yeniM?.konum || secili?.konum || null,         // 👈 Harita Pini için
      koordinat: yeniM?.koordinat || secili?.koordinat || null, // 👈 Harita Pini için
      alisTarihi, 
      teslimTarihi, 
      isAlan, 
      not, 
      acil, 
      dukkanYeri, 
      dukkanFotolar, 
      fotograflar: duzenlenenFis ? duzenlenenFis.fotograflar : [], 
      status: duzenlenenFis ? duzenlenenFis.status : "adres_bekliyor", 
      satirlar: duzenlenenFis ? duzenlenenFis.satirlar : [], 
      hesaplama: duzenlenenFis ? duzenlenenFis.hesaplama : { araToplam: 0, iskonto: 0, nakliye: 0, ambalaj: 0, kdv: 0, genelToplam: 0 }, 
      tahsilat: duzenlenenFis ? duzenlenenFis.tahsilat : null 
    };
    
    onKaydet(fis, wa); 
    setKayd(false); 
    onKapat();
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:300,
      display:"flex",alignItems:"flex-end",justifyContent:"center"}}
      onClick={e=>{if(e.target===e.currentTarget)onKapat();}}>
      <div style={{background:T.bg,width:"100%",maxWidth:560,borderRadius:"24px 24px 0 0",
        maxHeight:"94vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
        <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"14px auto 0"}}/>
        <div style={{padding:"12px 20px 0",display:"flex",alignItems:"center",justifyContent:"space-between",
          borderBottom:`1px solid ${T.border}`,paddingBottom:14}}>
          <div>
            <h2 style={{margin:0,fontSize:18,fontWeight:700,color:T.text}}>🧹 {duzenlenenFis ? "Fişi Düzenle" : t("yeniFis")}</h2>
            <div style={{fontSize:11,color:T.primary,marginTop:2}}>{fisNo.split("—")[0].trim()}</div>
          </div>
          <button onClick={onKapat} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:26}}>✕</button>
        </div>
        <div style={{padding:20}}>
          {!yeniMod&&!secili&&(
            <div style={{marginBottom:16}}>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <div style={{flex:1,display:"flex",alignItems:"center",gap:10,background:T.input,
                  border:`1.5px solid ${T.inputBorder}`,borderRadius:12,padding:"12px 14px"}}>
                  <span style={{color:T.textSec,fontSize:18}}>🔍</span>
                  <input 
                    value={aramaStr} 
                    onChange={e => {
                      const v = e.target.value;
                      if (v.length > 0 && /^[0-9+]/.test(v)) { setAramaStr(formatTel(v)); } else { setAramaStr(v); }
                    }}
                    placeholder="Müşteri ara (ad, telefon)..."
                    style={{background:"none", border:"none", outline:"none", color:T.text, fontSize:15, flex:1}}
                  />
                </div>
                <button onClick={()=>setYeniMod(true)}
                  style={{padding:"12px 14px",borderRadius:12,background:T.primary,border:"none",
                    color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,whiteSpace:"nowrap"}}>+ Yeni</button>
              </div>
              {aramaStr&&(
                <div style={{border:`1px solid ${T.border}`,borderRadius:14,overflow:"hidden",maxHeight:220,overflowY:"auto",background:T.card}}>
                  {filtreM.length?filtreM.map(m=>(
                    <div key={m.id} onClick={()=>{setSecili(m);setAramaStr("");}}
                      style={{padding:"14px 16px",cursor:"pointer",borderBottom:`1px solid ${T.border}`}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <div>
                          <div style={{fontSize:15,fontWeight:600,color:T.text}}>{m.ad}</div>
                          <div style={{fontSize:12,color:T.textSec}}>{formatTel(m.tel)} {m.semt?"• "+m.semt:""}</div>
                        </div>
                        {(m.borc||0)>0&&<span style={{fontSize:12,color:T.danger,fontWeight:700}}>₺{(m.borc).toFixed(0)} borç</span>}
                      </div>
                    </div>
                  )):(
                    <div style={{padding:16,color:T.textSec,fontSize:14,textAlign:"center"}}>Bulunamadı → "Yeni" ile ekleyin</div>
                  )}
                </div>
              )}
            </div>
          )}
          {secili&&(
            <div style={{background:T.success+"12",border:`1px solid ${T.success}30`,borderRadius:14,
              padding:"14px 16px",marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <div style={{fontSize:16,fontWeight:700,color:T.success}}>✓ {secili.ad}</div>
                  <div style={{fontSize:13,color:T.textSec}}>{formatTel(secili.tel)}</div>
                  <Yildiz puan={secili.yildiz||0} boyut={14}/>
                </div>
                <button onClick={()=>setSecili(null)}
                  style={{padding:"6px 12px",borderRadius:8,background:T.danger+"12",border:`1px solid ${T.danger}30`,
                    color:T.danger,cursor:"pointer",fontSize:13}}>Değiştir</button>
              </div>
              {(secili.borc||0)>0&&(
                <div style={{marginTop:8,padding:"6px 10px",background:T.danger+"12",borderRadius:8,
                  fontSize:13,color:T.danger,fontWeight:700}}>⚠️ Borç: ₺{(secili.borc).toFixed(2)}</div>
              )}
            </div>
          )}
          {yeniMod&&(
            <div style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{fontSize:14,color:T.primary,fontWeight:700}}>📝 Yeni Müşteri</span>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={rehberdenAl}
                    style={{padding:"7px 12px",borderRadius:9,background:T.primary+"15",border:`1px solid ${T.primary}30`,
                      color:T.primary,cursor:"pointer",fontSize:12,fontWeight:600}}>
                    📒 Rehberden Al
                  </button>
                  <button onClick={()=>setYeniMod(false)}
                    style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:13}}>← Geri</button>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <Inp 
                    label="Müşteri Ad(lar) *" 
                    value={yeniM.ad_ham || ""} 
                    onChange={v => {
                      const f = v.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(' ');
                      setYeniM(p => ({ ...p, ad_ham: v, ad_formatli: f, ad: `${f} ${p.soyad_formatli || ""}`.trim() }));
                    }} 
                    T={T} 
                    placeholder="Adı" 
                  />
                  <Inp 
                    label="Soyadı *" 
                    value={yeniM.soyad_ham || ""} 
                    onChange={v => {
                      const f = v.toUpperCase();
                      setYeniM(p => ({ ...p, soyad_ham: v, soyad_formatli: f, ad: `${p.ad_formatli || ""} ${f}`.trim() }));
                    }} 
                    T={T} 
                    placeholder="SOYADI" 
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <Inp label="Telefon *" value={yeniM.tel} onChange={v => setYeniM(p => ({ ...p, tel: formatTel(v) }))} placeholder="+90 5xx..." T={T} required={true} />
                  <Inp label="2. Telefon" value={yeniM.tel2} onChange={v => setYeniM(p => ({ ...p, tel2: formatTel(v) }))} placeholder="+90 5xx..." T={T} />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <Inp label="Semt" value={yeniM.semt} onChange={v => setYeniM(p => ({ ...p, semt: v }))} T={T} />
                  <Inp label="Şehir" value={yeniM.sehir} onChange={v => setYeniM(p => ({ ...p, sehir: v }))} T={T} />
                </div>

                {/* ADRES BLOĞU */}
                <div style={{ background: T.statCard, borderRadius: 14, padding: 14, border: `1px solid ${T.border}`, marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: T.textSec, marginBottom: 10 }}>📍 Müşteri Adresi</div>
                  <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 8, marginBottom: 8 }}>
                    <Inp label="Mahalle*" value={yeniM.mahalle || ""}
                      onChange={v => setYeniM(p => ({ ...p, mahalle: v, adres: [v, p.sokak, p.binaNo ? "No:"+p.binaNo : "", p.apartman, p.ilce, p.il].filter(Boolean).join(", ") }))}
                      T={T} placeholder="Atatürk Mah." />
                    <Inp label="Cadde / Sokak *" value={yeniM.sokak || ""}
                      onChange={v => setYeniM(p => ({ ...p, sokak: v, adres: [p.mahalle, v, p.binaNo ? "No:"+p.binaNo : "", p.apartman, p.ilce, p.il].filter(Boolean).join(", ") }))}
                      T={T} placeholder="Gül Sok." />
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 8 }}>
                    <Inp label="Bina No *" value={yeniM.binaNo || ""} onChange={v => setYeniM(p => ({ ...p, binaNo: v }))} T={T} placeholder="No: 12" />
                    <Inp label="Daire No" value={yeniM.daireNo || ""} onChange={v => setYeniM(p => ({ ...p, daireNo: v }))} T={T} placeholder="D: 3" />
                    <Inp label="Kat" value={yeniM.kat || ""} onChange={v => setYeniM(p => ({ ...p, kat: v }))} T={T} placeholder="3. Kat" />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Inp label="Apartman Adı (Opsiyonel)" value={yeniM.apartman || ""} onChange={v => setYeniM(p => ({ ...p, apartman: v }))} T={T} placeholder="Örn: Huzur Apt." />
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
                    <Inp label="İlçe *" value={yeniM.ilce || ""}
                      onChange={v => setYeniM(p => { const tam = [p.mahalle, p.sokak, p.binaNo ? "No:"+p.binaNo : "", p.daireNo ? "D:"+p.daireNo : "", p.apartman, v, p.il].filter(Boolean).join(", "); return { ...p, ilce: v, adres: tam }; })}
                      T={T} placeholder="Aliağa" />
                    <Inp label="İl *" value={yeniM.il || ""}
                      onChange={v => setYeniM(p => { const tam = [p.mahalle, p.sokak, p.binaNo ? "No:"+p.binaNo : "", p.daireNo ? "D:"+p.daireNo : "", p.apartman, p.ilce, v].filter(Boolean).join(", "); return { ...p, il: v, adres: tam }; })}
                      T={T} placeholder="İzmir" />
                  </div>
                 {yeniM.adres && (
                    <div style={{ padding: "8px 12px", background: T.primary+"10", borderRadius: 10, fontSize: 12, color: T.primary, border: `1px solid ${T.primary}20`, marginBottom: 8 }}>
                      🗺️ Google Maps'te aranacak: <b>{yeniM.adres}</b>
                    </div>
                  )}

                  <button type="button" onClick={async () => {
                    if (!navigator.geolocation) { alert("Konum desteklenmiyor"); return; }
                    try {
                      const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { enableHighAccuracy: true, timeout: 10000 }));
                      const lat = pos.coords.latitude, lng = pos.coords.longitude;
                      try {
                        const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&addressdetails=1`, {
                          headers: { "Accept-Language": "tr" }
                        });
                        const data = await resp.json();
                        const a = data.address || {};
                        const resSokak = a.road || a.pedestrian || "";
                        const resNo = a.house_number || "";
                        const resMah = a.neighbourhood || a.suburb || "";
                        const resIlce = a.county || a.district || a.town || "";
                        const resIl = a.province || a.state || a.city || "";
                        const tam = [resMah, resSokak, resNo ? "No:"+resNo : "", resIlce, resIl].filter(Boolean).join(", ");
                        
                        // 🔥 DÜZELTME 1: Harita pini için "konum: { lat, lng }" eklendi
                        setYeniM(p => ({ 
                          ...p, 
                          mahalle: resMah, 
                          sokak: resSokak, 
                          binaNo: resNo, 
                          ilce: resIlce, 
                          il: resIl, 
                          koordinat: `${lat},${lng}`, 
                          konum: { lat, lng }, 
                          adres: tam 
                        }));
                        alert("✅ Adres başarıyla dolduruldu!");
                      } catch {
                        const kord = `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
                        
                        // 🔥 DÜZELTME 1 (Yedek): API çökerse bile koordinatları haritaya yollar
                        setYeniM(p => ({ 
                          ...p, 
                          sokak: kord, 
                          adres: kord, 
                          koordinat: `${lat},${lng}`, 
                          konum: { lat, lng } 
                        }));
                      }
                    } catch { alert("❌ Konum alınamadı."); }
                  }} style={{ width: "100%", padding: "11px", borderRadius: 12, background: T.success+"15", border: `1.5px dashed ${T.success}`, color: T.success, cursor: "pointer", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                    📍 Konumdan Otomatik Doldur
                  </button>
                  
                  {yeniM.adres && (
                    // 🔥 DÜZELTME 2: Google Haritalar linki orijinal ve sorunsuz haline getirildi
                    <button type="button" onClick={() => linkAc(`https://maps.google.com/?q=${encodeURIComponent(yeniM.adres)}`)}
                      style={{ width: "100%", padding: "9px", borderRadius: 10, marginTop: 6, background: "#4285F415", border: "1px solid #4285F430", color: "#4285F4", cursor: "pointer", fontSize: 12, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                      🔍 Google Haritalar'da Doğrula →
                    </button>
                  )}
                </div>

                <Inp label="Notlar" value={yeniM.notlar} onChange={v => setYeniM(p => ({ ...p, notlar: v }))} T={T} placeholder="VIP, alerjisi var..." />
              </div>
            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <DatePicker label="Alınış Tarihi" value={alisTarihi} onChange={setAlis} T={T} />
            </div>
            <div style={{ flex: 1 }}>
              <DatePicker label="Teslim Tarihi" value={teslimTarihi} onChange={setTeslim} T={T} />
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 6 }}>
              İşi Alacak / Gidecek Şoför *
            </label>
            <select 
              value={isAlan} 
              onChange={e => setIsAlan(e.target.value)}
              style={{ width: "100%", padding: "13px 14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none" }}
            >
              <option value="">— Şoför Seçiniz —</option>
              <option value="Patron">👑 Bizzat Gideceğim (Yönetici)</option>
              {Object.entries(
                personeller.reduce((gruplar, p) => {
                  const rol = p.rol || "Diğer";
                  if (!gruplar[rol]) gruplar[rol] = [];
                  gruplar[rol].push(p);
                  return gruplar;
                }, {})
              ).map(([rolAdi, kisiler]) => (
                <optgroup key={rolAdi} label={rolAdi.toUpperCase()}>
                  {kisiler.map(p => (
                    <option key={p.id} value={p.ad}>{p.ad}</option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 6 }}>Not (Opsiyonel)</label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input 
                value={not} 
                onChange={e => setNot(e.target.value)} 
                placeholder="Leke, acele, özel talimat..."
                style={{ width: "100%", padding: "13px 44px 13px 14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none", boxSizing: "border-box" }}
              />
              <div style={{ position: "absolute", right: 6 }}>
                <SesliNotButonuIcon onNot={(v) => setNot(prev => prev ? (prev + " " + v) : v)} T={T} />
              </div>
            </div>
          </div>

          <div style={{background:T.statCard,border:`1px solid ${T.border}`,borderRadius:14,padding:14}}>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>📍 Dükkandaki Yeri</div>
            <Inp label="Yer Notu (Raf, kancı, bölüm...)" value={dukkanYeri} onChange={setDukkanYeri} T={T} placeholder="Örn: 5C'deki telde, A rafı 3. sıra"/>
            <div style={{marginTop:10}}>
              <input ref={dukkanFotoRef} type="file" accept="image/*" multiple 
                onChange={async (e) => { 
                  const dosyalar = Array.from(e.target.files || []);
                  for (const f of dosyalar) { 
                    const r = new FileReader();
                    const okumaSozu = new Promise((res) => {
                      r.onload = async (ev) => {
                        const kucukFoto = await sikistirFoto(ev.target.result);
                        setDukkanFotolar(p => [...p, { url: kucukFoto, tarih: Date.now() }]);
                        res();
                      };
                    });
                    r.readAsDataURL(f);
                    await okumaSozu;
                  }
                }} style={{display:"none"}} />
              <button onClick={()=>dukkanFotoRef.current?.click()} style={{width:"100%",padding:"10px",borderRadius:10,border:`2px dashed ${T.border}`,background:"transparent",color:T.textSec,cursor:"pointer",fontSize:13,fontWeight:600}}>
                📷 Yer Fotoğrafı Ekle (Akıllı Sıkıştırma Aktif)
              </button>
              {dukkanFotolar.length>0&&(
                <div style={{display:"flex",gap:6,marginTop:8,flexWrap:"wrap"}}>
                  {dukkanFotolar.map((f,i)=>(
                    <div key={i} style={{position:"relative"}}>
                      <img src={f.url} alt="" style={{width:64,height:64,objectFit:"cover",borderRadius:10}}/>
                      <button onClick={()=>setDukkanFotolar(p=>p.filter((_,idx)=>idx!==i))} style={{position:"absolute",top:-4,right:-4,width:18,height:18,borderRadius:"50%",background:T.danger,border:"none",color:"#fff",cursor:"pointer",fontSize:11}}>✕</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between", padding:"14px 16px",background:T.card,borderRadius:14,border:`1px solid ${T.border}`,margin:"14px 0"}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:20}}>❗</span>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:T.text}}>Bu müşteri {t("acil")}</div>
                <div style={{fontSize:11,color:T.textSec}}>Listede önce gösterilir</div>
              </div>
            </div>
            <Toggle value={acil} onChange={setAcil} T={T}/>
          </div>

          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <button onClick={()=>kaydet(false)} disabled={kayd}
              style={{width:"100%",padding:"15px",borderRadius:14,background:T.primary,border:"none", color:"#fff",fontSize:16,fontWeight:700,cursor:"pointer",opacity:kayd?0.7:1}}>
              ✅ {duzenlenenFis ? "Güncellemeyi Kaydet" : "Sahaya Gönder"}
            </button>
            <button onClick={()=>kaydet(true)} disabled={kayd}
              style={{width:"100%",padding:"15px",borderRadius:14,background:"#25D366",border:"none", color:"#fff",fontSize:16,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              📱 Kaydet ve WhatsApp'tan Gönder
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════
// HALİ AL MODAL (GÜVENLİ & DÜZELTİLMİŞ & BEYİNLİ)
// ═══════════════════════════════════════════════════════════
function HaliAlModal({fis,urunler,onKaydet,onKapat,T,t, kullanici}) {
  
  // 🚀 BEYİN 1: Eğer fişte daha önceden girilmiş halılar varsa onları getir, yoksa boş satır aç!
  const [satirlar, setSatirlar] = useState(() => {
    if (fis && fis.satirlar && fis.satirlar.length > 0) {
      return fis.satirlar;
    }
    return [{tipId:"makine",miktar:"",birimFiyat:"",kirlilik:"normal",ekspres:false,en:"",boy:"",not:"",adet:""}];
  });

  // 🚀 BEYİN 2: Eğer eski fişte İskonto veya Nakliye girilmişse onları da silmeden geri yükle!
  const [iskontoTur, setIskontoTur] = useState(() => (fis?.hesaplama?.iskonto > 0) ? "tutar" : "yok");
  const [iskontoMiktar, setIskontoMiktar] = useState(() => (fis?.hesaplama?.iskonto > 0) ? fis.hesaplama.iskonto : "");
  const [nakliye, setNavliye] = useState(() => (fis?.hesaplama?.nakliye > 0) ? fis.hesaplama.nakliye : "");

  const satirGunc=(i,k,v)=>setSatirlar(p=>p.map((s,idx)=>{
    if(idx!==i) return s;
    const y={...s,[k]:v};
    if(k==="en"||k==="boy"){const en_=k==="en"?v:s.en,boy_=k==="boy"?v:s.boy;if(en_&&boy_)y.miktar=(parseFloat(en_)*parseFloat(boy_)).toFixed(2);}
    return y;
  }));

  const doluSatirlar=satirlar.filter(s=>parseFloat(s.miktar||0)>0);

  const hesaplama=useMemo(()=>{
    const sH=satirlar.map(s=>({...s,varsayilanFiyat:urunler.find(u=>u.id===s.tipId)?.fiyat||0}));
    return hesaplaFis(sH,iskontoTur,iskontoMiktar,nakliye,"",false);
  }, [satirlar, iskontoTur, iskontoMiktar, nakliye, urunler]);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:400,
      display:"flex",alignItems:"flex-end",justifyContent:"center"}}
      onClick={e=>{if(e.target===e.currentTarget)onKapat();}}>
      <div style={{background:T.bg,width:"100%",maxWidth:560,borderRadius:"24px 24px 0 0",maxHeight:"95vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"14px auto 0"}}/>
        <div style={{padding:"12px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            {/* 🚀 AKILLI BAŞLIK: Yeni alımsa "Halıyı Al", düzenlemeyse "m² Düzenleme" yazar */}
            <h2 style={{margin:0,fontSize:17,fontWeight:700,color:T.text}}>
              ✓ {fis?.status === "adres_bekliyor" ? t("haliAl") : "m² Düzenleme"}
            </h2>
            <div style={{fontSize:12,color:T.textSec}}>{fis?.musteriAdi}</div>
          </div>
          <button onClick={onKapat} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:26}}>✕</button>
        </div>
        <div style={{padding:16}}>
          {satirlar.map((satir,i)=>{
            const tip=urunler.find(u=>u.id===satir.tipId)||urunler[0];
            const h=hesaplaSatir({...satir,varsayilanFiyat:tip?.fiyat||0});
            return (
              <div key={i} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:14,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                  <span style={{fontSize:13,fontWeight:600,color:T.textSec}}>Kalem #{i+1}</span>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {h.satirToplam>0&&<span style={{fontSize:15,fontWeight:800,color:T.warning}}>₺{h.satirToplam.toFixed(2)}</span>}
                    {satirlar.length>1&&<button onClick={()=>setSatirlar(p=>p.filter((_,idx)=>idx!==i))}
                      style={{background:"none",border:"none",color:T.danger,cursor:"pointer",fontSize:18}}>🗑</button>}
                  </div>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
                  {urunler.map(u=>(
                    <button key={u.id} onClick={()=>satirGunc(i,"tipId",u.id)}
                      style={{padding:"5px 10px",borderRadius:8,border:`1.5px solid ${satir.tipId===u.id?T.primary:T.border}`,
                        background:satir.tipId===u.id?T.primary+"15":"transparent",
                        color:satir.tipId===u.id?T.primary:T.textSec,cursor:"pointer",fontSize:12,fontWeight:500}}>
                      {u.ad}
                    </button>
                  ))}
                </div>
                <div style={{display:"grid",gridTemplateColumns:tip?.birim==="m2"?"1fr 1fr 1fr 1fr":"1fr 1fr 1fr",gap:8}}>
                  {tip?.birim==="m2"&&(
                    <>
                      <Inp label="En (m)" value={satir.en} onChange={v=>satirGunc(i,"en",v)} type="number" T={T} placeholder="2.5"/>
                      <Inp label="Boy (m)" value={satir.boy} onChange={v=>satirGunc(i,"boy",v)} type="number" T={T} placeholder="3.0"/>
                    </>
                  )}
                  <Inp label="m²/Adet" value={satir.miktar} onChange={v=>satirGunc(i,"miktar",v)} type="number" T={T}/>
                  {/* 🔢 ADET / PARÇA SAYISI ALANI */}
                  <Inp label="Kaç Parça (Adet)" value={satir.adet || ""} onChange={v => satirGunc(i, "adet", v)} type="number" T={T} placeholder="Örn: 3"/>
                  
                  {/* 🔓 FİYAT GÜVENLİK ZIRHI AÇILDI */}
                  <div>
                    <label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>Birim ₺</label>
                    <input type="number" value={satir.birimFiyat||""} placeholder={`${tip?.fiyat||0}`}
                      onChange={e=>satirGunc(i,"birimFiyat",e.target.value)}
                      style={{
                        width:"100%", padding:"13px 10px", background: T.input, border:`1.5px solid ${T.inputBorder}`,
                        borderRadius:12, color: T.text, fontSize:14, fontWeight: "700", outline:"none", boxSizing:"border-box", cursor: "text"
                      }}
                    />
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
                  <div>
                    <label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>Kirlilik</label>
                    <select value={satir.kirlilik} onChange={e=>satirGunc(i,"kirlilik",e.target.value)}
                      style={{width:"100%",padding:"13px",background:T.input,border:`1.5px solid ${T.inputBorder}`,borderRadius:12,color:T.text,fontSize:13,outline:"none"}}>
                      {KIRLILIK.map(k=><option key={k.id} value={k.id}>{k.ad} ×{k.carpan}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>Ekspres (+%50)</label>
                    <button onClick={()=>satirGunc(i,"ekspres",!satir.ekspres)}
                      style={{width:"100%",padding:"13px",borderRadius:12,border:`1.5px solid ${satir.ekspres?T.warning:T.border}`,
                        background:satir.ekspres?T.warning+"15":"transparent",
                        color:satir.ekspres?T.warning:T.textSec,cursor:"pointer",fontSize:13,fontWeight:600}}>
                      {satir.ekspres?"⚡ AÇIK":"Kapalı"}
                    </button>
                  </div>
                </div>
                <div style={{marginTop:8}}>
                  <Inp label="Leke / Not" value={satir.not||""} onChange={v=>satirGunc(i,"not",v)} T={T} placeholder="Sağ alt köşe mavi kalem lekesi..."/>
                </div>
              </div>
            );
          })}
          <button onClick={()=>setSatirlar(p=>[...p,{tipId:"makine",miktar:"",birimFiyat:"",kirlilik:"normal",ekspres:false,en:"",boy:"",not:"",adet:""}])}
            style={{width:"100%",padding:"12px",borderRadius:12,border:`2px dashed ${T.primary}50`,
              background:"transparent",color:T.primary,cursor:"pointer",fontSize:14,fontWeight:600,marginBottom:14}}>
            + Yeni Kalem Ekle
          </button>
          
          {/* İskonto */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{display:"flex",gap:6,marginBottom:8}}>
              {[["yok","Yok"],["yuzde","% Yüzde İndirimi"],["tutar","₺ İskonto İndirimi"]].map(([v,l])=>(
                <button key={v} onClick={()=>setIskontoTur(v)}
                  style={{flex:1,padding:"9px",borderRadius:9,border:`1.5px solid ${iskontoTur===v?T.primary:T.border}`,
                    background:iskontoTur===v?T.primary+"15":"transparent",
                    color:iskontoTur===v?T.primary:T.textSec,cursor:"pointer",fontSize:12,fontWeight:600}}>{l}</button>
              ))}
            </div>
            {iskontoTur!=="yok"&&<Inp label={iskontoTur==="yuzde"?"Yüzde İndirimi (%)":"İskonto İndirimi (₺)"} value={iskontoMiktar} onChange={setIskontoMiktar} type="number" T={T}/>}
            <div style={{marginTop:10}}><Inp label="Nakliye (₺)" value={nakliye} onChange={setNavliye} type="number" suffix="₺" T={T}/></div>
          </div>
          
          {/* Özet */}
          <div style={{background:T.warning+"12",border:`1px solid ${T.warning}30`,borderRadius:14,padding:14,marginBottom:20}}>
            {hesaplama.araToplam>0&&(
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:4,fontSize:14}}>
                <span style={{color:T.textSec}}>Ara Toplam</span>
                <span style={{color:T.text,fontWeight:600}}>₺{hesaplama.araToplam.toFixed(2)}</span>
              </div>
            )}
            <div style={{borderTop:`1px solid ${T.warning}30`,paddingTop:8,display:"flex",justifyContent:"space-between"}}>
              <span style={{fontSize:15,fontWeight:700,color:T.text}}>GENEL TOPLAM</span>
              <span style={{fontSize:20,fontWeight:900,color:T.warning}}>₺{hesaplama.genelToplam.toFixed(2)}</span>
            </div>
          </div>
          <button onClick={()=>{
            if(!doluSatirlar.length){alert("En az bir kalem girin");return;}
            const sH=doluSatirlar.map(s=>({...s,varsayilanFiyat:urunler.find(u=>u.id===s.tipId)?.fiyat||0}));
            onKaydet(fis.id,sH,hesaplama);
          }} style={{width:"100%",padding:"15px",borderRadius:14,background:T.success,border:"none",
            color:"#fff",fontSize:16,fontWeight:700,cursor:"pointer"}}>
            {/* 🚀 AKILLI BUTON: Duruma göre yazısı değişir */}
            ✓ {fis?.status === "adres_bekliyor" ? "Halıları Al → Araçta" : "Güncellemeyi Kaydet"}
          </button>
        </div>
      </div>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// İADE MODAL (GÜNCELLENMİŞ & GÜVENLİ)
// ═══════════════════════════════════════════════════════════
function IadeModal({fis, urunler, onKaydet, onKapat, T, t, kullanici}) {
  const [secilen, setSecilen] = useState([]);
  const [not, setNot] = useState("");
  const [patronOnay, setPatronOnay] = useState(false);
  const fotoRef = useRef();
  const [fotograflar, setFotograflar] = useState([]);
  
  const orijinalSatirlar = fis?.satirlar || [];
  const secilenAdet = secilen.length;
  const orijinalAdet = orijinalSatirlar.length;
  const adetUyarisi = orijinalAdet > 0 && secilenAdet > orijinalAdet;
  const paraAlindi = (fis?.tahsilat?.kasayaGiren || 0) > 0;

  // 🖼️ Fotoğraf Yükleme ve Sıkıştırma
  const fotoSec = async (e) => {
    const dosyalar = Array.from(e.target.files || []);
    for (const f of dosyalar) {
      const r = new FileReader();
      r.onload = async (ev) => {
        const kucukFoto = await sikistirFoto(ev.target.result); // Mevcut sıkıştırma fonksiyonun
        setFotograflar(p => [...p, { url: kucukFoto, tarih: Date.now() }]);
      };
      r.readAsDataURL(f);
    }
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}
         onClick={(e) => e.target === e.currentTarget && onKapat()}>
      <div style={{background:T.bg,width:"100%",maxWidth:520,borderRadius:"24px 24px 0 0",maxHeight:"92vh",overflowY:"auto", boxShadow: "0 -10px 40px rgba(0,0,0,0.3)"}}>
        <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"14px auto 0"}}/>
        
        <div style={{padding:"12px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <h2 style={{margin:0,fontSize:17,fontWeight:700,color:T.danger}}>🔄 {t("iade")} / Tekrar Yıkama</h2>
            <div style={{fontSize:12,color:T.textSec}}>{fis?.musteriAdi} — {fis?.fisNo?.split("—")[0]}</div>
          </div>
          <button onClick={onKapat} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:26}}>✕</button>
        </div>

        <div style={{padding:16}}>
          {paraAlindi && (
            <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:700,color:"#D97706"}}>⚠️ Tahsilat Yapılmış Fiş</div>
              <div style={{fontSize:12,color:"#92400E",marginTop:4}}>Ödeme alındığı için bu iade ciro raporlarında "mahsup" olarak görünecektir.</div>
            </div>
          )}

          <div style={{marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:8}}>İade Alınacak Halıları Seçin ({secilenAdet}/{orijinalAdet})</div>
            {orijinalSatirlar.length > 0 ? orijinalSatirlar.map((satir, idx) => {
              const urunTip = urunler?.find(u => u.id === satir.tipId);
              const isSelected = secilen.includes(idx);
              
              return (
                <div key={idx} onClick={() => setSecilen(p => isSelected ? p.filter(i => i !== idx) : [...p, idx])}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",borderRadius:12,
                    border:`1.5px solid ${isSelected ? T.danger : T.border}`,
                    background: isSelected ? T.danger + "08" : T.card, marginBottom: 6, cursor: "pointer", transition: "0.2s"}}>
                  <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${isSelected ? T.danger : T.border}`,
                    background: isSelected ? T.danger : "transparent",display:"flex",alignItems:"center",
                    justifyContent:"center",color:"#fff",fontSize:13,flexShrink:0}}>
                    {isSelected && "✓"}
                  </div>
                  <div style={{flex: 1}}>
                    <div style={{fontSize:14,fontWeight:600,color:T.text}}>{urunTip?.ad || satir.tipId}</div>
                    <div style={{fontSize:12,color:T.textSec}}>{satir.miktar} {urunTip?.birim || "birim"}</div>
                  </div>
                </div>
              );
            }) : (
              <div style={{padding:20, textAlign:"center", color:T.textSec, background:T.card, borderRadius:12, border:`1px dashed ${T.border}`}}>
                Kayıtlı halı bulunamadı. Tüm sipariş iade olarak işlenecek.
              </div>
            )}
          </div>

          {adetUyarisi && (
            <div style={{background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
              <div style={{fontSize:14,fontWeight:700,color:T.danger}}>🚨 Sayı Uyuşmazlığı!</div>
              <div style={{fontSize:12,color:"#7F1D1D",marginTop:4}}>Seçilen halı sayısı orijinal fişten fazla.</div>
              
              {/* 🛡️ Sadece patron onay kutusunu görebilir veya işaretleyebilir */}
              <div style={{display:"flex",alignItems:"center",gap:8,marginTop:10, opacity: kullanici?.rol === 'patron' ? 1 : 0.6}}>
                <input 
                  type="checkbox" 
                  disabled={kullanici?.rol !== 'patron'} 
                  checked={patronOnay} 
                  onChange={e => setPatronOnay(e.target.checked)} 
                  id="po" style={{width:18,height:18}}
                />
                <label htmlFor="po" style={{fontSize:13,color:T.danger,fontWeight:600,cursor:"pointer"}}>
                  {kullanici?.rol === 'patron' ? "Patron olarak onaylıyorum" : "Yetkili (Patron) Onayı Bekleniyor"}
                </label>
              </div>
            </div>
          )}

          <div style={{marginBottom:14}}>
            <label style={{fontSize:13,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>İade Sebebi & Leke Notu</label>
            <textarea value={not} onChange={e=>setNot(e.target.value)}
              placeholder="Örn: Kenarlarda çıkmayan lekeler var, tekrar yıkansın..." rows={3}
              style={{width:"100%",padding:"12px 14px",background:T.input,border:`1.5px solid ${T.inputBorder}`,
                borderRadius:12,color:T.text,fontSize:14,outline:"none",resize:"none",boxSizing:"border-box"}}/>
          </div>

          <input ref={fotoRef} type="file" accept="image/*" multiple onChange={fotoSec} style={{display:"none"}}/>
          <button onClick={()=>fotoRef.current?.click()}
            style={{width:"100%",padding:"12px",borderRadius:12,border:`2px dashed ${T.border}`,
              background:"transparent",color:T.textSec,cursor:"pointer",fontSize:14,marginBottom:fotograflar.length>0?8:14}}>
            📷 Sorunlu Bölge Fotoğrafları Ekle
          </button>

          {fotograflar.length > 0 && (
            <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
              {fotograflar.map((f,i)=>(
                <div key={i} style={{position:"relative"}}>
                  <img src={f.url} alt="" style={{width:70,height:70,objectFit:"cover",borderRadius:12, border:`1px solid ${T.border}`}}/>
                  <button onClick={()=>setFotograflar(p=>p.filter((_,idx)=>idx!==i))}
                    style={{position:"absolute",top:-6,right:-6,width:22,height:22,borderRadius:"50%",
                      background:T.danger,border:`2px solid ${T.bg}`,color:"#fff",cursor:"pointer",fontSize:12, fontWeight: "bold"}}>✕</button>
                </div>
              ))}
            </div>
          )}

          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10, marginTop: 10}}>
            <button onClick={onKapat}
              style={{padding:"14px",borderRadius:12,background:"transparent",border:`1.5px solid ${T.border}`,
                color:T.textSec,cursor:"pointer",fontWeight:600,fontSize:15}}>{t("iptal")}</button>
            <button onClick={()=>{
              if(adetUyarisi && !patronOnay && kullanici?.rol !== 'patron'){
                alert("Halı sayısı uyuşmadığı için Patron onayı gerekiyor!");
                return;
              }
              onKaydet({
                fisId: fis.id,
                secilenSatirlar: secilen.map(i => orijinalSatirlar[i]).filter(Boolean),
                not,
                fotograflar,
                paraAlindi,
                tarih: new Date().toISOString()
              });
              onKapat();
            }} style={{padding:"14px",borderRadius:12,background:T.danger,border:"none",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:700}}>
              🔄 İadeyi Başlat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}// ═══════════════════════════════════════════════════════════
// GARANTİ KAREKOD OLUŞTURUCU (Hızlı & Kesintisiz)
// ═══════════════════════════════════════════════════════════
function QRKodSVG({ metin, boyut = 200 }) {
  // Daha hızlı ve SSL sertifikalı QR API
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${boyut}x${boyut}&data=${encodeURIComponent(metin)}&bgcolor=ffffff`;

  return (
    <div style={{ 
      background: "#fff", 
      padding: "12px", 
      borderRadius: "24px", 
      display: "inline-flex",
      boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
      border: "1px solid #f0f0f0"
    }}>
      <img 
        src={qrUrl} 
        alt="Fiş Karekod" 
        style={{ width: boyut, height: boyut, display: "block", borderRadius: "12px" }} 
        onError={(e) => {
          e.target.src = `https://chart.googleapis.com/chart?cht=qr&chs=${boyut}x${boyut}&chl=${encodeURIComponent(metin)}`;
        }}
      />
    </div>
  );
}

// 🚀 QR GÖSTERME VE YAZDIRMA MOTORU (Modal İçeriği)
// 🚀 QR GÖSTERME VE YAZDIRMA MOTORU (GÜNCELLENDİ)
const QRModalIcerik = ({ showQRGoster, setShowQRGoster, T }) => {
  if (!showQRGoster) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => setShowQRGoster(null)}>
      <div style={{ background: T.card, borderRadius: 24, padding: 28, textAlign: "center", maxWidth: 350, boxShadow: "0 20px 60px rgba(0,0,0,0.5)" }}
        onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 4px", fontSize: 17, fontWeight: 700, color: T.text }}>QR Fiş Kodu</h2>
        <div style={{ fontSize: 12, color: T.textSec, marginBottom: 16 }}>{showQRGoster.fisNo?.split("—")[0]?.trim()}</div>
        
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
          <QRKodSVG metin={showQRGoster.fisNo || showQRGoster.id} boyut={180} />
        </div>
        
        <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginBottom: 4 }}>{showQRGoster.musteriAdi}</div>
        <div style={{ fontSize: 12, color: T.textSec, marginBottom: 16 }}>{showQRGoster.alisTarihi}</div>
        
        <div style={{ fontSize: 11, color: T.textSec, padding: "8px 12px", background: T.statCard, borderRadius: 10, marginBottom: 16 }}>
          💡 Bu kodu halı etiketine yapıştırın.
        </div>

        {/* 🖨️ YAZDIRMA BUTONU (İŞTE BURADA!) */}
        <button onClick={() => {
          const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(showQRGoster.fisNo || showQRGoster.id)}&bgcolor=ffffff`;
          const w = window.open("", "_blank");
          w.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
          <style>
            body { font-family: Arial, sans-serif; text-align: center; padding: 20px; }
            img { width: 220px; height: 220px; border: 1px solid #eee; border-radius: 12px; }
            h2 { font-size: 20px; margin: 10px 0; }
            .fis-no { font-size: 26px; font-weight: bold; border: 2px solid #000; display: inline-block; padding: 5px 15px; margin: 10px 0; }
            @media print { .no-print { display: none } }
          </style></head>
          <body>
            <div class="no-print"><button onclick="window.print()" style="padding:10px 20px; margin-bottom:20px; border-radius:8px; cursor:pointer;">🖨️ Yazdır</button></div>
            <img src="${qrUrl}" />
            <br><div class="fis-no">${showQRGoster.fisNo?.split("—")[0]?.trim() || showQRGoster.id}</div>
            <h2>${showQRGoster.musteriAdi || ""}</h2>
            <p>${showQRGoster.alisTarihi || ""} • ${showQRGoster.musteriTel || ""}</p>
          </body></html>`);
          w.document.close();
          setTimeout(() => { if(!w.closed) w.print(); }, 700);
        }} style={{
          width: "100%", padding: "14px", borderRadius: 12, background: "#1E3A5F15", 
          border: "1px solid #1E3A5F30", color: "#1E3A5F", cursor: "pointer", 
          fontSize: 14, fontWeight: 700, marginBottom: 10, display: "flex", 
          alignItems: "center", justifyContent: "center", gap: 8
        }}>
          🖨️ QR Etiketini Yazdır
        </button>

        <button onClick={() => setShowQRGoster(null)} 
          style={{ width: "100%", padding: "12px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>
          Kapat
        </button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════
// QR TARAMA MODAL (AKILLI ODAKLAMA & UYUMLULUK MODU)
// ═══════════════════════════════════════════════════════════
function QRTaraModal({ onBul, onKapat, T }) {
  const videoRef = useRef();
  const [hata, setHata] = useState("");
  const [manuelGiris, setManuelGiris] = useState("");
  const [taraniyor, setTaraniyor] = useState(true);

  useEffect(() => {
    let stream = null;
    let aktif = true;
    let animasyonId = null;

    const baslat = async () => {
      try {
        // En iyi kamera performansını zorla (Arka kamera + Yüksek çözünürlük)
        stream = await navigator.mediaDevices.getUserMedia({ 
          video: { 
            facingMode: "environment", 
            width: { ideal: 1920 }, 
            height: { ideal: 1080 },
            frameRate: { ideal: 60 } 
          } 
        });
        
        if (videoRef.current && aktif) {
          videoRef.current.srcObject = stream;
          videoRef.current.setAttribute("playsinline", true); // iOS Safari için zorunlu
          videoRef.current.play();
        }

        // 🔍 GELİŞMİŞ TARAMA MANTIĞI (Polyfill destekli kontrol)
        if (aktif && "BarcodeDetector" in window) {
          const detector = new window.BarcodeDetector({ formats: ["qr_code", "code_128"] });
          
          const tara = async () => {
            if (!videoRef.current || videoRef.current.paused || !aktif || !taraniyor) return;

            try {
              const barkodlar = await detector.detect(videoRef.current);
              if (barkodlar.length > 0 && taraniyor) {
                const kod = barkodlar[0].rawValue;
                setTaraniyor(false);
                
                // 🔊 Başarılı tarama sesi (Ding)
                const ctx = new (window.AudioContext || window.webkitAudioContext)();
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                osc.connect(gain); gain.connect(ctx.destination);
                osc.frequency.setValueAtTime(880, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.2);
                osc.start(); osc.stop(ctx.currentTime + 0.2);

                onBul(kod);
                if (stream) stream.getTracks().forEach(t => t.stop());
                return;
              }
            } catch (err) { /* Tarama hatalarını sessizce geç */ }

            if (aktif && taraniyor) animasyonId = requestAnimationFrame(tara);
          };
          tara();
        } else {
          // iOS veya eski Android kullanıcıları için uyarı
          setHata("Cihazınız otomatik taramayı desteklemiyor. Lütfen fiş numarasını elle girin.");
        }
      } catch (e) {
        if (aktif) setHata("Kamera erişimi engellendi. Lütfen Ayarlar > İzinler kısmından kamerayı açın.");
      }
    };

    baslat();

    return () => {
      aktif = false;
      setTaraniyor(false);
      if (animasyonId) cancelAnimationFrame(animasyonId);
      if (stream) stream.getTracks().forEach(t => t.stop());
    };
  }, [taraniyor, onBul]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.98)", zIndex: 999, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: 450, padding: "20px" }}>
        
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <div style={{color: "#fff"}}>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Kamerayı Odaklayın</h2>
            <div style={{fontSize: 12, opacity: 0.6, marginTop: 4}}>Barkodu karenin ortasına getirin</div>
          </div>
          <button onClick={onKapat} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: "14px", padding: "12px 20px", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>✕ Vazgeç</button>
        </div>

        {hata ? (
          <div style={{ background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: "20px", padding: "24px", marginBottom: 24, color: "#FCA5A5", textAlign: "center", lineHeight: 1.5 }}>
            <div style={{fontSize: 32, marginBottom: 12}}>⚠️</div>
            {hata}
          </div>
        ) : (
          <div style={{ position: "relative", borderRadius: "32px", overflow: "hidden", boxShadow: "0 0 60px rgba(0,0,0,0.8)", background: "#000", border: "2px solid #333", aspectRatio: "1" }}>
            <video ref={videoRef} style={{ width: "100%", height: "100%", objectFit: "cover" }} muted playsInline />
            
            {/* Tarama Çerçevesi */}
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
              <div style={{ width: "70%", height: "70%", border: "2px solid rgba(255,255,255,0.2)", borderRadius: "40px", position: "relative" }}>
                {/* Köşe Çizgileri */}
                <div style={{ position: "absolute", top: -2, left: -2, width: 40, height: 40, borderTop: "5px solid #F59E0B", borderLeft: "5px solid #F59E0B", borderRadius: "40px 0 0 0" }} />
                <div style={{ position: "absolute", top: -2, right: -2, width: 40, height: 40, borderTop: "5px solid #F59E0B", borderRight: "5px solid #F59E0B", borderRadius: "0 40px 0 0" }} />
                <div style={{ position: "absolute", bottom: -2, left: -2, width: 40, height: 40, borderBottom: "5px solid #F59E0B", borderLeft: "5px solid #F59E0B", borderRadius: "0 0 0 40px" }} />
                <div style={{ position: "absolute", bottom: -2, right: -2, width: 40, height: 40, borderBottom: "5px solid #F59E0B", borderRight: "5px solid #F59E0B", borderRadius: "0 0 40px 0" }} />
                
                {/* Tarama Çizgisi */}
                <div style={{ position: "absolute", top: "10%", left: "5%", right: "5%", height: "3px", background: "#F59E0B", boxShadow: "0 0 20px #F59E0B", animation: "scanAnim 2.5s infinite linear" }} />
              </div>
            </div>
          </div>
        )}

        <div style={{ marginTop: 24, background: "rgba(255,255,255,0.05)", borderRadius: "24px", padding: "20px", border: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 12, textAlign: "center" }}>Veya fiş numarasını elinizle girin</div>
          <div style={{ display: "flex", gap: 10 }}>
            <input 
              value={manuelGiris} 
              onChange={e => setManuelGiris(e.target.value.toUpperCase())} 
              placeholder="Örn: A3F7K" 
              style={{ flex: 1, padding: "16px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "14px", color: "#fff", fontSize: 18, fontWeight: 700, outline: "none", textAlign: "center" }} 
            />
            <button 
              onClick={() => manuelGiris && onBul(manuelGiris)} 
              style={{ padding: "0 28px", borderRadius: "14px", background: "#F59E0B", border: "none", color: "#000", cursor: "pointer", fontSize: 16, fontWeight: 800 }}
            >
              AÇ
            </button>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes scanAnim {
          0% { top: 10%; opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { top: 90%; opacity: 0; }
        }
      `}</style>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════
// SESLI NOT (Zırhlı ve Android Uyumlu Versiyon - GÜNCELLENDİ)
// ═══════════════════════════════════════════════════════════
function SesliNotButonuIcon({ onNot, T }) {
  const [kayitYapiliyor, setKayitYapiliyor] = useState(false);
  const recognitionRef = useRef(null);

  const baslat = async () => {
    // 🎤 1. ADIM: Tarayıcı desteği kontrolü
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Cihaz sesli dikteyi desteklemiyor.");
      return;
    }

   // 🎤 2. ADIM: Mikrofonu Gerçek Zamanlı Uyandır (ZIRHLI VERSİYON)
    try {
      if (navigator.mediaDevices?.getUserMedia) {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
      }
    } catch (e) {
      console.error("Mikrofon uyandırma hatası yakalandı (Crash Engellendi):", e);
    }

    const rec = new SpeechRecognition();
    rec.lang = "tr-TR";
    rec.continuous = false;
    rec.interimResults = false;

    rec.onstart = () => {
      setKayitYapiliyor(true);
    };

    rec.onend = () => {
      setKayitYapiliyor(false);
    };

    rec.onresult = (event) => {
      const metin = event.results[0][0].transcript;
      if (metin) {
        onNot(metin);
      }
    };

    rec.onerror = (event) => {
      console.error("Ses tanıma hatası:", event.error);
      setKayitYapiliyor(false);
      
      if (event.error === "not-allowed") {
        alert("Mikrofon izni kapalı! Lütfen:\n1. Ayarlar > Uygulamalar > HaliPro > İzinler kısmından mikrofonu kapatıp açın.\n2. Google uygulamasının mikrofon iznini kontrol edin.");
      } else if (event.error === "network") {
        alert("Sesli dikte için internet bağlantısı gerekiyor.");
      }
    };

    recognitionRef.current = rec;
    
    // 🚀 3. ADIM: Motoru Ateşle
    try {
      rec.start();
    } catch (err) {
      console.error("Başlatma hatası:", err);
      setKayitYapiliyor(false);
    }
  };

  return (
    <button
      type="button"
      onClick={kayitYapiliyor ? () => recognitionRef.current?.stop() : baslat}
      style={{
        background: kayitYapiliyor ? "#EF4444" : "transparent",
        border: "none",
        width: 40,
        height: 40,
        borderRadius: 12,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 20,
        transition: "all 0.2s",
        boxShadow: kayitYapiliyor ? "0 0 15px rgba(239, 68, 68, 0.5)" : "none",
        zIndex: 999
      }}
    >
      {kayitYapiliyor ? "🛑" : "🎤"}
    </button>
  );
}
// ═══════════════════════════════════════════════════════════
// FATURA / RESMİ MAKBUZ HTML (Gerçek Resmi Format)
// ═══════════════════════════════════════════════════════════
function faturaHTML(fis, isletme, urunler, kullanici) {
  const h = fis?.hesaplama || {};
  const faturaNo = `SERI-A-${String(Date.now()).slice(-6)}`;
  
  const genelToplam = h.genelToplam || 0;
  const kdvMatrahi = genelToplam / 1.20; 
  const kdvTutari = genelToplam - kdvMatrahi;

  const satirHTML = (fis?.satirlar || []).map(s => {
    const tip = urunler.find(u => u.id === s?.tipId) || { ad: "?", birim: "adet", fiyat: 0 };
    const sh = hesaplaSatir({ ...s, varsayilanFiyat: tip.fiyat });
    if (!parseFloat(s?.miktar || 0)) return "";
    
    const sMatrah = sh.satirToplam / 1.20;
    const sKdv = sh.satirToplam - sMatrah;

    return `<tr>
      <td style="text-align:left; border: 1px solid #000; padding: 5px;">${tip.ad}</td>
      <td style="border: 1px solid #000; padding: 5px;">${s.miktar} ${tip.birim}</td>
      <td style="text-align:right; border: 1px solid #000; padding: 5px;">${(parseFloat(s.birimFiyat || tip.fiyat) / 1.20).toFixed(2)}₺</td>
      <td style="text-align:right; border: 1px solid #000; padding: 5px;">${sMatrah.toFixed(2)}₺</td>
      <td style="border: 1px solid #000; padding: 5px; text-align:center;">%20</td>
      <td style="text-align:right; border: 1px solid #000; padding: 5px;">${sKdv.toFixed(2)}₺</td>
      <td style="text-align:right; border: 1px solid #000; padding: 5px;"><b>${sh.satirToplam.toFixed(2)}₺</b></td>
    </tr>`;
  }).join("");

  return `<!DOCTYPE html><html><head><meta charset="UTF-8">
<style>
  body{font-family: 'Courier New', Courier, monospace; max-width:800px; margin:0 auto; padding:20px; color:#000; font-size:11px;}
  .resmi-baslik{text-align:center; font-size:16px; font-weight:bold; text-decoration:underline; margin-bottom:20px;}
  .ust-tablo{width:100%; margin-bottom:20px; border-collapse: collapse;}
  .taraf-kutu{border: 1px solid #000; padding:10px; width:48%; vertical-align:top; min-height:100px;}
  table.ana-liste{width:100%; border-collapse:collapse; margin-top:10px;}
  th{border: 1px solid #000; padding:5px; background:#f2f2f2;}
  .alt-bilgi{margin-top:20px;}
  .sag-tutar{float:right; width:250px; margin-top:10px;}
  .sag-tutar table{width:100%; border-collapse:collapse;}
  .sag-tutar td{padding:4px; border-bottom: 1px solid #eee;}
  .imza-alan{margin-top:70px; display:flex; justify-content:space-between; text-align:center;}
  @media print{.no-print{display:none}}
</style></head>
<body onafterprint="window.close();">
<div class="resmi-baslik">HİZMET TESLİM VE TAHSİLAT MAKBUZU</div>
<table style="width:100%">
  <tr>
    <td class="taraf-kutu">
      <strong>HİZMETİ VEREN</strong><br>
      <b>${isletme.ad || kullanici.sirket || "HALI YIKAMA İŞLETMESİ"}</b><br>
      ${isletme.adres || ""}<br>
      V.D. / NO: ${isletme.vergiNo || "—"}<br>
      IBAN: ${isletme.iban || "—"}
    </td>
    <td style="width:4%"></td>
    <td class="taraf-kutu">
      <strong>HİZMETİ ALAN</strong><br>
      <b>${fis?.musteriAdi || ""}</b><br>
      ${fis?.musteriAdres || ""}<br>
      ${fis?.musteriTel || ""}
    </td>
  </tr>
</table>

<div style="margin-top:15px; margin-bottom:10px;">
  <strong>MAKBUZ NO:</strong> ${faturaNo} | <strong>TARİH:</strong> ${bugun()}
</div>

<table class="ana-liste">
  <thead>
    <tr>
      <th>HİZMET ADI</th>
      <th>MİKTAR</th>
      <th>BİRİM FİYAT</th>
      <th>MATRAH</th>
      <th>KDV</th>
      <th>KDV TUTARI</th>
      <th>TOPLAM</th>
    </tr>
  </thead>
  <tbody>${satirHTML}</tbody>
</table>

<div class="sag-tutar">
  <table>
    <tr><td>TOPLAM MATRAH</td><td style="text-align:right">${kdvMatrahi.toFixed(2)}₺</td></tr>
    ${(h.iskonto || 0) > 0 ? `<tr><td>İSKONTO (-)</td><td style="text-align:right">-${(h.iskonto || 0).toFixed(2)}₺</td></tr>` : ""}
    <tr><td>HESAPLANAN KDV (%20)</td><td style="text-align:right">${kdvTutari.toFixed(2)}₺</td></tr>
    <tr style="font-weight:bold; font-size:13px; border-top: 1px solid #000;">
      <td>GENEL TOPLAM</td><td style="text-align:right">${genelToplam.toFixed(2)}₺</td></tr>
  </table>
</div>
<div style="clear:both"></div>

<div class="alt-bilgi">
  <p><strong>YALNIZ:</strong> ${genelToplam.toFixed(2)} Türk Lirası tahsil edilmiştir.</p>
  <p>Referans Fiş No: ${fis?.fisNo?.split("—")[0]?.trim() || ""}</p>
</div>

<div class="imza-alan">
  <div>
    <hr style="width:180px">
    DÜZENLEYEN / TESLİM EDEN<br>
    <strong>${isletme.ad || kullanici.sirket || "İŞLETME YETKİLİSİ"}</strong>
  </div>
  <div>
    <hr style="width:180px">
    MÜŞTERİ / TESLİM ALAN<br>
    <small>(İmza / İsim Soyisim)</small>
  </div>
</div>
</body></html>`;
}
// ═══════════════════════════════════════════════════════════
// 🛡️ İZİN BUTONU (PUSH-FREE VE ESLINT ZIRHLI SÜRÜM)
// ═══════════════════════════════════════════════════════════
function IzinButonu({ T }) {
  const [izinDurum, setIzinDurum] = useState({
    bildirim: "kontrol",
    kamera: "kontrol",
    mikrofon: "kontrol",
    konum: "kontrol",
    rehber: "kontrol"
  });

  const durumKontrol = async () => {
    // 🧹 ESLint uyarısı veren boş 'sonuclar' değişkeni kaldırıldı.
    setIzinDurum({ 
      bildirim: "kontrol", 
      kamera: "kontrol", 
      mikrofon: "kontrol", 
      konum: "kontrol", 
      rehber: "kontrol" 
    });
    
    try {
      if (!Capacitor.isNativePlatform()) {
        // Tarayıcı modunda her şeyi aktif veya varsayılan göster
        setIzinDurum({ 
          bildirim: "granted", 
          kamera: "granted", 
          mikrofon: "granted", 
          konum: "granted", 
          rehber: "granted" 
        });
        return;
      }

      let kameraDurum = "denied";
      let konumDurum = "denied";
      let mikrofonDurum = "denied";
      let rehberDurum = "denied";

      // 1️⃣ KAMERA KONTROL
      try {
        const kPerm = await Camera.checkPermissions();
        kameraDurum = kPerm.camera === "granted" ? "granted" : "denied";
      } catch(e) { console.log("Kamera izin kontrolü pas geçildi."); }

      // 2️⃣ KONUM KONTROL
      try {
        const lPerm = await Geolocation.checkPermissions();
        konumDurum = (lPerm.location === "granted" || lPerm.coarseLocation === "granted") ? "granted" : "denied";
      } catch(e) { console.log("Konum izin kontrolü pas geçildi."); }

      // 3️⃣ 🎤 MİKROFON KONTROL (ZIRHLI)
      try {
        if (navigator.mediaDevices?.getUserMedia) {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          mikrofonDurum = "granted";
          stream.getTracks().forEach(track => track.stop());
        }
      } catch(e) {
        mikrofonDurum = "denied";
      }

    // 4️⃣ 📒 REHBER KONTROL (ESLint ve Tanımsızlık Korumalı)
      try {
        if (typeof Contacts !== "undefined" && Contacts.getPermissions) {
          const cPerm = await Contacts.getPermissions();
          rehberDurum = cPerm.granted ? "granted" : "denied";
        } else {
          rehberDurum = "granted"; // Eklenti yoksa varsayılan aktif geç
        }
      } catch(e) {
        console.log("Rehber izin kontrolü yapılamadı.");
        rehberDurum = "granted";
      }

      setIzinDurum({
        // 🚀 BEYİN: Push eklentisini sildiğimiz için uygulama içi (In-App) bildirimleri 
        // varsayılan olarak aktif (granted) kabul ediyoruz.
        bildirim: "granted", 
        kamera: kameraDurum,
        konum: konumDurum,
        mikrofon: mikrofonDurum,
        rehber: rehberDurum
      });

    } catch (e) { 
      console.error("Genel izin kontrol hatası:", e);
    }
  };

  useEffect(() => {
    durumKontrol();
  }, []);

  const eksikIzinVarMi = Object.entries(izinDurum).some(([k, v]) => v === "denied");
  
  const labels = {
    bildirim: "🔔 Uygulama İçi Bildirimler",
    kamera: "📷 Kamera Erişimi",
    mikrofon: "🎤 Mikrofon Erişimi",
    konum: "📍 Konum Servisi",
    rehber: "📒 Rehber / Caller ID"
  };

  return (
    <div className="izin-paneli">
      {eksikIzinVarMi && (
        <div style={{ 
          background: T.danger + "15", 
          padding: "14px", 
          borderRadius: 14, 
          marginBottom: 12, 
          border: `1.2px solid ${T.danger}40` 
        }}>
          <p style={{ fontSize: 13, color: T.text, margin: 0, lineHeight: 1.5 }}>
            <strong style={{ color: "#DC2626" }}>⚠️ Bazı İzinler Eksik!</strong><br />
            Özelliklerin tam çalışması için Ayarlar › HaliPro › İzinler kısmından her şeye izin vermeniz önerilir.
          </p>
        </div>
      )}

      <button onClick={durumKontrol}
        style={{ 
          width: "100%", 
          padding: "14px", 
          borderRadius: 12, 
          background: "#2563EB", 
          border: "none", 
          color: "#fff", 
          cursor: "pointer", 
          fontSize: 14, 
          fontWeight: 800, 
          marginBottom: 12,
          boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)"
        }}>
        🔄 İzinleri Yeniden Tara
      </button>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {Object.entries(labels).map(([key, label]) => {
          const v = izinDurum[key];
          const basarili = v === "granted";
          const bekliyor = v === "kontrol";
          
          return (
            <div key={key} style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              padding: "12px", 
              borderRadius: 10, 
              fontSize: 13, 
              background: T.bg, 
              border: `1.1px solid ${T.border}` 
            }}>
              <span style={{ fontWeight: 600, color: T.text }}>{label}</span>
              <span style={{ 
                fontWeight: 800, 
                fontSize: 11,
                color: bekliyor ? T.textSec : (basarili ? "#16A34A" : "#DC2626"),
                background: bekliyor ? "#F3F4F6" : (basarili ? "#DCFCE7" : "#FEE2E2"),
                padding: "4px 8px",
                borderRadius: 6
              }}>
                {bekliyor ? "KONTROL..." : (basarili ? "AKTİF" : "KAPALI")}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
  // ═══════════════════════════════════════════════════════════
// GİDER EKLEME MODALI (Dinamik Kategori Destekli)
// ═══════════════════════════════════════════════════════════
function GiderFormModal({ T, onKapat, onKaydet, kategoriler, setKategoriler }) {
  // 📝 Formun kendi iç hafızası
  const [form, setForm] = useState({
    kategori: "Deterjan / Kimyasal",
    aciklama: "",
    tutar: "",
    tarih: bugun()
  });

  // 📂 Yukarıdan gelen kategorileri kullan, gelmezse varsayılanları göster
  const GIDER_KATEGORILERI = kategoriler || ["Deterjan / Kimyasal", "Su / Elektrik", "Diğer"];

  return (
    <div 
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 500, 
        display: "flex", alignItems: "flex-end", justifyContent: "center"
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onKapat(); }}
    >
      <div 
        style={{
          background: T.bg, width: "100%", maxWidth: 520, borderRadius: "24px 24px 0 0", 
          padding: 20, maxHeight: "88vh", overflowY: "auto", boxShadow: "0 -8px 40px rgba(0,0,0,0.3)"
        }}
        onClick={(e) => e.stopPropagation()} // Modal içine tıklandığında kapanmasın
      >
        <div style={{ width: 40, height: 4, borderRadius: 2, background: T.border, margin: "0 auto 16px" }} />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: T.danger }}>📤 Gider Ekle</h2>
          <button onClick={onKapat} style={{ background: "none", border: "none", color: T.textSec, cursor: "pointer", fontSize: 24 }}>✕</button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {/* 📂 KATEGORİ SEÇİMİ VE YENİ EKLEME */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 6 }}>Kategori</label>
            <select 
              value={form.kategori} 
              onChange={(e) => setForm(p => ({ ...p, kategori: e.target.value }))}
              style={{
                width: "100%", padding: "13px 14px", background: T.input, 
                border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, 
                color: T.text, fontSize: 15, outline: "none"
              }}
            >
              {GIDER_KATEGORILERI.map(k => <option key={k} value={k}>{k}</option>)}
            </select>

            {/* 🚀 Yeni Kategori Ekleme Satırı */}
            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <input
                placeholder="Yeni kategori adı..."
                id="yeniKategoriInput"
                style={{
                  flex: 1, padding: "10px 12px", background: T.input, 
                  border: `1px solid ${T.inputBorder}`, borderRadius: 10, 
                  color: T.text, fontSize: 13, outline: "none"
                }}
              />
              <button 
                type="button" 
                onClick={() => {
                  const inp = document.getElementById("yeniKategoriInput");
                  const yeni = inp?.value?.trim();
                  if (yeni && !GIDER_KATEGORILERI.includes(yeni)) {
                    setKategoriler(p => [...p, yeni]); // Ana listedeki kategorilere ekle
                    setForm(p => ({ ...p, kategori: yeni })); // Formda otomatik seç
                    if (inp) inp.value = ""; // Kutuyu temizle
                    alert("✅ Kategori eklendi: " + yeni);
                  }
                }} 
                style={{
                  padding: "10px 14px", borderRadius: 10, background: T.primary, 
                  border: "none", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 700
                }}
              >
                + Ekle
              </button>
            </div>
          </div>

          <Inp label="Açıklama" value={form.aciklama} onChange={v => setForm(p => ({ ...p, aciklama: v }))} T={T} placeholder="Örn: 20lt Deterjan alımı" />
          <Inp 
  label="Tutar (₺) *" 
  value={form.tutar ? formatPara(form.tutar) : ""} 
  onChange={v => {
    const temizDeger = v.replace(/[^0-9]/g, ""); 
    setForm(p => ({ ...p, tutar: temizDeger ? parseInt(temizDeger, 10) : "" }));
  }} 
  type="text" 
  suffix="₺" 
  T={T} 
/>
          <DatePicker label="Tarih" value={form.tarih} onChange={v => setForm(p => ({ ...p, tarih: v }))} T={T} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10, marginTop: 20 }}>
          <button 
            onClick={onKapat} 
            style={{
              padding: "14px", borderRadius: 12, background: "transparent", 
              border: `1.5px solid ${T.border}`, color: T.textSec, 
              cursor: "pointer", fontWeight: 600, fontSize: 15
            }}
          >
            İptal
          </button>
          <button 
            onClick={() => {
              if (!form.tutar || !form.kategori) { alert("Tutar ve kategori zorunlu!"); return; }
              onKaydet({ ...form, id: "g" + Date.now(), tutar: parseFloat(form.tutar) || 0 });
              onKapat();
            }} 
            style={{
              padding: "14px", borderRadius: 12, background: T.danger, 
              border: "none", color: "#fff", cursor: "pointer", fontSize: 15, fontWeight: 700
            }}
          >
            ✅ Gider Kaydet
          </button>
        </div>
      </div>
    </div>
  );
}

// 🛡️ YETKİSİZ GİRİŞ ENGEL EKRANI
function YetkiYokEkrani({ setAltSayfa, T, setSayfa }) {
  return (
    <div style={{ padding: 40, textAlign: "center", height: "100%", background: T.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <div style={{ fontSize: 64, marginBottom: 20 }}>🛑</div>
      <h2 style={{ color: T.danger, fontWeight: 800 }}>Yetki Sınırı</h2>
      <p style={{ color: T.textSec, maxWidth: 280, marginTop: 10 }}>Bu alanı görüntüleme yetkiniz bulunmamaktadır. Lütfen yöneticinizden yetki isteyin.</p>
      <button onClick={() => { setAltSayfa ? setAltSayfa(null) : setSayfa("anaSayfa") }} 
        style={{ marginTop: 24, padding: "14px 28px", borderRadius: 12, background: T.primary, color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>
        Geri Dön
      </button>
    </div>
  );
}

function SahaHaritaModal({ baslangicModu, isler, musteriler, onKapat, T }) {
  const [gosterAlim, setGosterAlim] = useState(baslangicModu === "alinacak" || baslangicModu === "ikisi");
  const [gosterTeslim, setGosterTeslim] = useState(baslangicModu === "teslim" || baslangicModu === "ikisi");
  const [kendiKonum, setKendiKonum] = useState({ lat: 38.4237, lng: 27.1428 }); // Varsayılan İzmir

  // 🛰️ Şoförün o anki konumunu al
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => setKendiKonum({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => console.warn("GPS alınamadı"),
      { enableHighAccuracy: true }
    );
  }, []);

  // 📍 Koordinatları Taramaya Başla
  const pinVerileri = useMemo(() => {
    const liste = [];
    isler.forEach(is => {
      const m = musteriler.find(x => x.id === is.musteriId || x.docId === is.musteriId) || {};
      
      // Enlem ve Boylamı Bul
      let lat = is.konum?.lat || is.lat || m.konum?.lat || m.lat;
      let lng = is.konum?.lng || is.lng || m.konum?.lng || m.lng;

      if (lat && lng) {
        const payLoad = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
          isim: is.musteriAdi || m.ad || "İsimsiz",
          fis: is.fisNo?.split("—")[0] || "Yeni",
          adres: is.musteriAdres || is.adres || m.adres || "Adres Yok",
          adet: is.hesaplama?.toplamAdet || 0,
          m2: is.hesaplama?.toplamM2 || 0,
          fiyat: is.hesaplama?.genelToplam || 0
        };

        // 📍 ALIM
        if (gosterAlim && (is.status === "adres_bekliyor" || is.status === "siparis_alindi")) {
          liste.push({ ...payLoad, tip: "alim" });
        } 
        // 🚚 TESLİM
        else if (gosterTeslim && (is.status === "teslim_hazir" || is.status === "dagitimda")) {
          liste.push({ ...payLoad, tip: "teslim" });
        }
      }
    });
    return liste;
  }, [isler, musteriler, gosterAlim, gosterTeslim]);

  // 🌍 BİREBİR İSTEDİĞİN GOOGLE MAPS TASARIMI VE HTML İÇERİĞİ
  const htmlIcerik = `
    <!DOCTYPE html><html><head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"/>
    <script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
    <style>
      body{margin:0;padding:0;} 
      #map{width:100vw;height:100vh;background:#e5e5e5;}
      .p-alim{font-size:38px; text-align:center; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));}
      .p-teslim{font-size:38px; text-align:center; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));}
      .p-ben{width:18px; height:18px; background:#2563EB; border:3px solid #fff; border-radius:50%; box-shadow:0 0 10px rgba(0,0,0,0.5);}
      
      /* REİS: ATTIĞIN SS'TEKİ POPUP TASARIMI */
      .leaflet-popup-content-wrapper { border-radius: 8px; box-shadow: 0 4px 15px rgba(0,0,0,0.3); }
      .popup-card{min-width:200px; font-family: sans-serif; text-align:center;}
      .popup-title { font-size: 16px; font-weight: bold; color: #000; margin-bottom: 6px; }
      .popup-red-text { color: #D32F2F; font-size: 14px; font-weight: bold; margin-bottom: 3px; line-height: 1.3; text-transform: uppercase;}
      .popup-btn{
        background:#4285F4; color:#fff; border:none; padding:12px; border-radius:8px; width:100%;
        margin-top:12px; font-weight:bold; font-size:14px; cursor:pointer;
      }
      .popup-btn:active { background: #3367D6; }
    </style>
    </head><body><div id="map"></div>
    <script>
      var map = L.map('map', { zoomControl: false }).setView([${kendiKonum.lat}, ${kendiKonum.lng}], 14);
      
      // 🚀 GERÇEK GOOGLE MAPS GÖRÜNÜMÜ
      L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
      }).addTo(map);
      
      // 🔵 ŞOFÖRÜN KENDİ KONUMU
      L.marker([${kendiKonum.lat}, ${kendiKonum.lng}], {
        icon: L.divIcon({ className: 'p-ben', html: '' })
      }).addTo(map).bindPopup("<b>Buradasınız</b>");

      var markers = ${JSON.stringify(pinVerileri)};
      var bounds = [];
      
      markers.forEach(function(m){
        var icon = L.divIcon({
          html: m.tip==='alim' ? '📍' : '🚚', 
          className: m.tip==='alim' ? 'p-alim' : 'p-teslim',
          iconSize: [44, 44],
          iconAnchor: [22, 44]
        });
        
        var marker = L.marker([m.lat, m.lng], {icon: icon}).addTo(map);
        var googleUrl = "https://www.google.com/maps/dir/?api=1&destination=" + m.lat + "," + m.lng;

        // İSTEDİĞİN BİREBİR POPUP (Kırmızı Yazılı)
        marker.bindPopup(
          "<div class='popup-card'>" +
          "<div class='popup-title'>(S " + m.fis + ") " + m.isim + "</div>" +
          "<div class='popup-red-text'>ADRES : " + m.adres.substring(0,35) + "...</div>" +
          "<div class='popup-red-text'>" + m.adet + " ADET / " + m.m2 + " M2 / " + m.fiyat + " TL</div>" +
          "<div class='popup-red-text'>BORCU : YOK</div>" +
          "<button class='popup-btn' onclick='window.open(\\"" + googleUrl + "\\", \\"_system\\")'>🚀 GİT</button>" +
          "</div>"
        );
          
        bounds.push([m.lat, m.lng]);
      });
      
      // Pin varsa onlara odaklan
      if(bounds.length > 0) {
        map.fitBounds(bounds, {padding:[60,60]});
      }
    </script></body></html>`;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: T.bg, display: "flex", flexDirection: "column", animation: "slideUp 0.3s ease-out" }}>
      {/* Üst Başlık */}
      <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
        <h2 style={{ margin: 0, fontSize: 18, color: "#fff", fontWeight: 700 }}>📍 Saha Haritası ({pinVerileri.length} Adres)</h2>
        <button onClick={onKapat} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 16px", fontWeight: "bold", cursor: "pointer" }}>✕ Kapat</button>
      </div>

      {/* Filtre Butonları */}
      <div style={{ padding: 12, display: "flex", gap: 10, background: T.card, borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
        <button onClick={() => setGosterAlim(!gosterAlim)} 
          style={{ flex: 1, padding: "12px", borderRadius: 12, border: "none", background: gosterAlim ? "#EF4444" : "#ccc", color: "#fff", fontWeight: 800, fontSize: 13, cursor: "pointer" }}>
          📍Alınacaklar
        </button>
        <button onClick={() => setGosterTeslim(!gosterTeslim)} 
          style={{ flex: 1, padding: "12px", borderRadius: 12, border: "none", background: gosterTeslim ? "#3B82F6" : "#ccc", color: "#fff", fontWeight: 800, fontSize: 13, cursor: "pointer" }}>
          🚚 Teslimatlar
        </button>
      </div>

      {/* 🗺️ HARİTA ALANI */}
      <div style={{ flex: 1, position: "relative", background: "#e5e5e5" }}>
        <iframe srcDoc={htmlIcerik} style={{ width: "100%", height: "100%", border: "none" }} title="Saha Haritasi" />
      </div>
    </div>
  );
}
// 🌍 ADRESTEN KOORDİNAT BULMA MOTORU (Arka planda sessiz çalışır)
const adresdenKonumBul = async (tamAdres) => {
  try {
    if (!tamAdres || tamAdres.trim() === "") return null;
    const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&q=${encodeURIComponent(tamAdres)}&limit=1`;
    const resp = await fetch(url, { headers: { "Accept-Language": "tr" } });
    const data = await resp.json();
    if (data && data.length > 0) {
      return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    }
    return null;
  } catch (err) {
    console.error("Adres çevirme hatası:", err);
    return null;
  }
};
function HaliCi() { 
  // 🚀 1. TEMA VE DİL HOOKLARI (En üstte)
  const { tema, T, toggleTema } = useTheme();
  const { dil, t, dilDegistir } = useDil();

  // 🚀 2. KULLANICI STATE (Her şey buna bağlı, en yukarıda olmalı)
  const [kullanici, setKullanici] = useState(() => {
    try { const s = localStorage.getItem("halici_k"); return s ? JSON.parse(s) : null; } catch { return null; }
  });

  const logEkle = (numara, aksiyon) => {
    const log = { saat: simdi(), numara, eslesti: musteriler.some(m => m.tel === numara || m.tel2 === numara), aksiyon };
    setAramaLog(prev => {
      const y = [...prev, log];
      try { localStorage.setItem(logKey(), JSON.stringify(y)); } catch { }
      return y;
    });
  };
  // 🛡️ PATRON KONTROLÜ
  const isPatron = kullanici?.rol === "patron";

  // 🚀 3. BİLDİRİM VE GÖRÜNÜM AYARLARI
  const [icBildirimAcik, setIcBildirimAcik] = useState(() => localStorage.getItem("ic_bildirim") !== "kapali");
  const [aktifBildirimler, setAktifBildirimler] = useState([]);
  const [giderKategorileri, setGiderKategorileri] = useState(() => {
    try {
      const k = localStorage.getItem("halici_gider_kategorileri");
      return k ? JSON.parse(k) : ["Deterjan / Kimyasal","Su / Elektrik","Kira","Personel Maaşı","Araç Yakıt","Araç Bakım","Ekipman","Vergi / Sigorta","Diğer"];
    } catch { return ["Deterjan / Kimyasal","Su / Elektrik","Kira","Personel Maaşı","Araç Yakıt","Araç Bakım","Ekipman","Vergi / Sigorta","Diğer"]; }
  });

  // 🔔 BİLDİRİM KURALLARI (Dükkan hafızası)
  const [bildirimKurallari, setBildirimKurallari] = useState(() => {
    try {
      const kayitli = localStorage.getItem("halici_bildirim_kurallari");
      return kayitli ? JSON.parse(kayitli) : {
        adres_bekliyor: ["sofor"],
        aracta: ["patron", "yikamaci"],
        beklemede: ["yikamaci"],
        yikaniyor: ["patron"],
        kurutuluyor: ["patron"],
        fason: ["patron"],
        teslim_hazir: ["sofor"],
        dagitimda: ["patron"],
        teslim_edildi: ["patron"],
      };
    } catch (e) { return {}; }
  });

  // 🏢 İŞLETME AYARLARI
  const [isletme, setIsletme] = useState(() => {
    try {
      const kString = localStorage.getItem("halici_k");
      const k = kString ? JSON.parse(kString) : {};
      return {
        ad: k.isletmeAyarlari?.ad || k.sirket || "HalıPro İşletmesi",
        sahip: k.isletmeAyarlari?.sahip || k.ad || "",
        tel: k.isletmeAyarlari?.tel || "",
        teslimGun: k.isletmeAyarlari?.teslimGun || 7
      };
    } catch (e) { return { ad: "HaliPro", sahip: "", teslimGun: 7 }; }
  });

  // 🚀 4. SAYAÇLAR VE NAVİGASYON (kullanici'dan sonra gelmeli)
  const [fisIdSayac, setFisIdSayac] = useState(() => parseInt(localStorage.getItem("halici_fis_id")) || 1248);
  const [musIdSayac, setMusIdSayac] = useState(() => parseInt(localStorage.getItem("halici_mus_id")) || 100);
  const [sayfa, setSayfa] = useState(() => kullanici?.rol === "sofor" ? "saha" : "anaSayfa");
  const [altSayfa, setAltSayfa] = useState(null);
  const [haritaModu, setHaritaModu] = useState(null);

  // 🚀 5. ANA VERİ STATE'LERİ
  const [isler, setIsler] = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [personeller, setPersoneller] = useState(() => {
    try {
      const kayitli = localStorage.getItem("halici_personeller");
      return kayitli ? JSON.parse(kayitli) : [];
    } catch { return []; }
  });
  const [urunler, setUrunler] = useState(VARSAYILAN_URUNLER);
  const [donem, setDonem] = useState("bugun");
  const [aramaLog, setAramaLog] = useState(() => {
    try { const saved = localStorage.getItem(logKey()); return saved ? JSON.parse(saved) : []; } catch (e) { return []; }
  });

  // 🚀 6. MODAL VE FORM KONTROLLERİ
  const [personelSecimModal, setPersonelSecimModal] = useState(null);
  const [yuklemeDosyası, setYuklemeDosyası] = useState(null);
  const [durumFiltre, setDurumFiltre] = useState("hepsi");
  const [aramaMetni, setAramaMetni] = useState("");
  const [musteriGrupFiltre, setMusteriGrupFiltre] = useState("hepsi");
  const [sablonlar, setSablonlar] = useState(MESAJ_SABLONLARI);
  const [showQRTara, setShowQRTara] = useState(false);
  const [showQRGoster, setShowQRGoster] = useState(null);
  const [showBorcHatirla, setShowBorcHatirla] = useState(false);
  const [giderler, setGiderler] = useState([]);
  const [showGiderForm, setShowGiderForm] = useState(false);
  const [showSoforModu, setShowSoforModu] = useState(false);
  const [personelForm, setPersonelForm] = useState(null);
  const [showRolSecim, setShowRolSecim] = useState(false);
  const [showFis, setShowFis] = useState(false);
  const [duzenlenenFis, setDuzenlenenFis] = useState(null);
  const [showTahsilat, setShowTahsilat] = useState(null);
  const [showHaliAl, setShowHaliAl] = useState(null);
  const [showIade, setShowIade] = useState(null);
  const [showMusteriForm, setShowMusteriForm] = useState(null);
  const [showMusteriProfil, setShowMusteriProfil] = useState(null);
  const [showBorcTahsilatForm, setShowBorcTahsilatForm] = useState(false);
  const [borcTahsilatMiktar, setBorcTahsilatMiktar] = useState("");
  const [yedekSecimler, setYedekSecimler] = useState({
  musteriler: true, isler: true, personeller: true,
  urunler: true, ayarlar: true, giderler: true
});
  const [callerNumara, setCallerNumara] = useState(null);
  const [bekleyenUser, setBekleyenUser] = useState(null);
  const [sifreSecenekModal, setSifreSecenekModal] = useState(null);

 // 🚀 7. EFFECT'LER (Kayıt ve Başlık)

  // 1. Gider Kategorilerini Kaydet
  useEffect(() => {
    localStorage.setItem("halici_gider_kategorileri", JSON.stringify(giderKategorileri));
  }, [giderKategorileri]);

  // 2. Sayfa Başlığı
  useEffect(() => {
    document.title = "HaliPro Yönetim Paneli";
  }, []);

  // ══════════════════════════════════════════════════════════
  // MÜŞTERİ HAFIZA KÖPRÜSÜ (CALLER ID İÇİN)
  // ══════════════════════════════════════════════════════════
  useEffect(() => {
    if (!musteriler || musteriler.length === 0) return;

    const overlayVerisi = musteriler.map(m => ({
      tel:    (m.tel  || "").replace(/\D/g, "").slice(-10),
      tel2:   (m.tel2 || "").replace(/\D/g, "").slice(-10),
      ad:     m.ad     || "",
      grup:   m.grup   || "Normal",
      borc:   parseFloat(m.borc || 0),
      notlar: m.notlar || ""
    }));

    const jsonStr = JSON.stringify(overlayVerisi);
    try { localStorage.setItem("halici_overlay_data", jsonStr); } catch(e) {}

    if (Capacitor.isNativePlatform()) {
      import('@capacitor/preferences').then(({ Preferences }) => {
        Preferences.set({ key: 'halici_overlay_data', value: jsonStr })
          .catch(e => console.log("Preferences kayıt hatası:", e));
      }).catch(() => {});
    }
  }, [musteriler]);

  useEffect(() => {
    console.log("✅ Sistem hazır, dükkan açık.");
  }, []);

  const yeniFisNo = () => {
    const yeniNo = (Number(fisIdSayac) || 0) + 1;
    setFisIdSayac(yeniNo);
    localStorage.setItem("halici_fis_id", yeniNo.toString());
    const harfler = "ABCDEFGHJKLMNPRSTUVYZ";
    const rakamlar = "23456789";
    const alfaKod = harfler[yeniNo % harfler.length] + rakamlar[Math.floor(yeniNo / harfler.length) % rakamlar.length] + harfler[(yeniNo * 3) % harfler.length];
    return `${alfaKod} — ${bugun()} — ${simdi()}`;
  };

  // 🚀 NATIVE ZIRH: CALLER ID VE SONSUZ DÖNGÜ KIRICI BİLDİRİM MOTORU
  useEffect(() => {
    if (!kullanici?.email || !kullanici?.rol) return;

    let unsubBildirim = () => { };

    // 📞 1. CALLER ID: Telefon çalınca dükkanı uyandırır
    const aramaListener = (event) => {
      const numara = event.detail.number;
      if (numara) {
        const formatliNum = formatTel(numara);
        setCallerNumara(formatliNum);
        if (typeof logEkle === "function") logEkle(formatliNum, "bekliyor");
      }
    };

    if (Capacitor.isNativePlatform()) {
      window.addEventListener('aramaGeldi', aramaListener);
    }

    // 🔔 2. UYGULAMA İÇİ BİLDİRİM (DÖNGÜ KIRICILI)
    // Sadece 'okundu: false' olanları dinleterek donmayı kökten çözüyoruz.
    const qBildirim = query(
      collection(db, "bildirimler"), 
      where("aliciRol", "==", kullanici.rol),
      where("okundu", "==", false) 
    );

    unsubBildirim = onSnapshot(qBildirim, (snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        if (change.type === "added") {
          const data = change.doc.data();
          const docRef = doc(db, "bildirimler", change.doc.id);

          // Ekrana bildirim kutusunu fırlat
          if (icBildirimAcik) {
            const yeniId = Date.now();
            setAktifBildirimler(p => [...p, { 
              id: yeniId, 
              baslik: data.baslik || "🔔 Yeni İş", 
              mesaj: data.mesaj || "" 
            }]);
            try { 
              const sesAyari = localStorage.getItem("halici_ses") !== "kapali";
              sesCal("yeniFis", sesAyari); 
            } catch(e) {}
            setTimeout(() => setAktifBildirimler(p => p.filter(b => b.id !== yeniId)), 8000);
          }

          // 🚀 KRİTİK: Hemen okundu yapıp listeden düşürüyoruz. 
          // Liste 'false' olanlara baktığı için bu döküman hafızadan silinir ve donma YAPMAZ.
          try { await updateDoc(docRef, { okundu: true }); } catch (e) { }
        }
      });
    }, (err) => console.log("Bildirim dinleme pasif."));

    // 🔙 SÜPÜRGE: Sayfa veya rol değişince muslukları kapat
    return () => {
      window.removeEventListener('aramaGeldi', aramaListener);
      unsubBildirim();
    };
  }, [kullanici?.email, kullanici?.rol, icBildirimAcik, logEkle]);

  // ☁️ 2. BÖLÜM: FIREBASE VERİ DİNLEYİCİLERİ
  useEffect(() => {
    if (!kullanici?.email) return;
    const uid = kullanici.email;
    let unsubIsler = () => { };
    let unsubMusteri = () => { };
    let unsubAyarlar = () => { };
    try {
      unsubIsler = onSnapshot(query(collection(db, "kullanicilar", uid, "isler"), orderBy("id", "desc")), (snap) => {
        setIsler(snap.docs.map(d => ({ docId: d.id, ...d.data() })));
      });

      unsubMusteri = onSnapshot(query(collection(db, "kullanicilar", uid, "musteriler")), (snap) => {
        setMusteriler(snap.docs.map(d => ({ ...d.data(), docId: d.id })));
      });

      unsubAyarlar = onSnapshot(doc(db, "kullanicilar", uid), (d) => {
        if (d.exists()) {
          const veri = d.data();
          if (veri.isletmeAyarlari) setIsletme(veri.isletmeAyarlari);
          if (veri.urunler) setUrunler(veri.urunler);
          if (veri.musteriGruplari) setMusteriGruplari(veri.musteriGruplari);
          if (veri.personelRolleri) setPersonelRolleri(veri.personelRolleri);
          if (veri.personeller) setPersoneller(veri.personeller);
          if (veri.bildirimKurallari) {
            setBildirimKurallari(veri.bildirimKurallari);
            localStorage.setItem("halici_bildirim_kurallari", JSON.stringify(veri.bildirimKurallari));
          }
        }
      });
    } catch (e) { console.error("Bulut Okuma Hatası:", e); }

    return () => { unsubIsler(); unsubMusteri(); unsubAyarlar(); };
  }, [kullanici?.email]);

  // 📝 3. BÖLÜM: LOG VE ARŞİV ROBOTU
  useEffect(() => {
    const simdikiGun = bugun();
    if (localStorage.getItem("halici_log_tarih") !== simdikiGun) {
      setAramaLog([]);
      localStorage.setItem(logKey(), "[]");
    }
    localStorage.setItem("halici_log_tarih", simdikiGun);
  }, []);

  useEffect(() => {
    const fotograflariTemizle = async () => {
      if (!kullanici?.email || kullanici?.rol !== "patron" || isler.length === 0) return;
      if (localStorage.getItem("halici_bakim_tarih") === bugun()) return;

      const otuzGunOnce = Date.now() - (30 * 24 * 60 * 60 * 1000);
      const eskiIsler = isler.filter(is => 
        is.status === "teslim_edildi" && 
        (Number(is.id) || 0) < otuzGunOnce && 
        ((is.dukkanFotolar?.length > 0) || (is.fotograflar?.length > 0))
      );

      for (const is of eskiIsler) {
        try {
          const isRef = doc(db, "kullanicilar", kullanici.email, "isler", is.docId);
          await updateDoc(isRef, { dukkanFotolar: [], fotograflar: [], arsivlendi: true });
        } catch (err) { console.log("Robot hatası:", err); }
      }
      localStorage.setItem("halici_bakim_tarih", bugun());
    };
    fotograflariTemizle();
  }, [isler, kullanici]);

  useEffect(() => {
    localStorage.setItem("halici_personeller", JSON.stringify(personeller));
  }, [personeller]);

  // 🔙 4. BÖLÜM: GERİ TUŞU KONTROL MERKEZİ (SÜPÜRGE SİSTEMİ)
  useEffect(() => {
    const geriBasildi = (e) => {
      e.preventDefault();
      
      // Modalları sırayla kapat
      if (showFis) { setShowFis(false); return; }
      if (showHaliAl) { setShowHaliAl(null); return; }
      if (showTahsilat) { setShowTahsilat(null); return; }
      if (showIade) { setShowIade(null); return; }
      if (showMusteriForm) { setShowMusteriForm(null); return; }
      if (showMusteriProfil) { setShowMusteriProfil(null); return; }
      if (showBorcHatirla) { setShowBorcHatirla(false); return; }
      if (showQRTara) { setShowQRTara(false); return; }
      if (showQRGoster) { setShowQRGoster(null); return; }
      if (showGiderForm) { setShowGiderForm(false); return; }
      if (showRolSecim) { setShowRolSecim(false); return; }
      if (sifreSecenekModal) { setSifreSecenekModal(null); return; }
      
      if (altSayfa) { setAltSayfa(null); return; }
      
      if (["raporlar", "fason", "personel", "isler", "musteriler", "kasa", "ayarlar", "saha"].includes(sayfa)) {
        setSayfa("anaSayfa"); 
        return;
      }
      
      if (sayfa === "anaSayfa") {
        if (Capacitor.isNativePlatform()) {
          import('@capacitor/app').then(({ App }) => App.exitApp());
        }
        return;
      }
      setSayfa("anaSayfa");
    };

    document.addEventListener("backbutton", geriBasildi, false);
    window.addEventListener("popstate", geriBasildi);
    
    return () => {
      document.removeEventListener("backbutton", geriBasildi, false);
      window.removeEventListener("popstate", geriBasildi);
    };
  }, [showFis, showHaliAl, showTahsilat, showIade, showMusteriForm, showMusteriProfil,
      showBorcHatirla, showQRTara, showQRGoster, showGiderForm, showRolSecim,
      sifreSecenekModal, altSayfa, sayfa]);

 // 4️⃣ ANA GİRİŞ & KAYIT MANTIĞI (Zırhlı ve Alert'siz Versiyon)
  const handleGiris = async (emailInp, sifreInp) => {
    try {
      const temizEmail = emailInp.toLowerCase().trim();
      
      const q = query(
        collection(db, "kullanicilar"), 
        where("email", "==", temizEmail), 
        where("sifre", "==", sifreInp)
      );

      // 🚀 ZIRHLI ZAMAN AŞIMI
      const fetchWithTimeout = () => {
        return new Promise((resolve, reject) => {
          const timer = setTimeout(() => {
            reject(new Error("Sunucu yanıt vermedi. İnternet bağlantınızı veya Firebase ayarlarını kontrol edin."));
          }, 20000);

          getDocs(q).then(res => {
            clearTimeout(timer);
            resolve(res);
          }).catch(err => {
            clearTimeout(timer);
            reject(err);
          });
        });
      };

      const snap = await fetchWithTimeout();

      if (!snap.empty) {
        const uData = { docId: snap.docs[0].id, ...snap.docs[0].data() };
        
        if (uData.isletmeAyarlari) setIsletme(uData.isletmeAyarlari);
        if (uData.urunler) setUrunler(uData.urunler);
        if (uData.personeller) setPersoneller(uData.personeller);
        if (uData.musteriGruplari) setMusteriGruplari(uData.musteriGruplari);
        if (uData.personelRolleri) setPersonelRolleri(uData.personelRolleri);
        
        if (uData.bildirimKurallari) {
          setBildirimKurallari(uData.bildirimKurallari);
          localStorage.setItem("halici_bildirim_kurallari", JSON.stringify(uData.bildirimKurallari));
        }
        
        setBekleyenUser(uData); 
        setShowRolSecim(true); 
        // 🚀 BEYİN: Artık true/false yerine obje dönüyoruz ki hatayı ekrana basabilelim!
        return { success: true }; 
      } else {
        return { success: false, message: "E-posta veya şifre hatalı!" }; 
      }
    } catch (err) { 
      console.error("Giriş Hatası:", err); 
      return { success: false, message: "Sistem hatası: " + err.message }; 
    }
  };

  const handleKayit = async (data) => {
    try {
      const temizEmail = data.email.toLowerCase().trim();
      const formatliIsim = formatAdSoyad(data.adSoyad);
      const yeni = { 
        email: temizEmail, 
        sifre: data.sifre, 
        ad: formatliIsim, 
        sirket: data.sirket || "HaliPro İşletmesi", 
        lisans_onay: "deneme", 
        kayitTarihi: new Date().toISOString(), 
        isletmeAyarlari: { ad: data.sirket, sahip: formatliIsim, teslimGun: 7 },
        urunler: VARSAYILAN_URUNLER,
        personeller: [],
        musteriGruplari: [
          { id: "Normal", ad: "Normal", icon: "👤", renk: "#64748B" },
          { id: "VIP", ad: "VIP", icon: "⭐", renk: "#F59E0B" },
          { id: "Kurumsal", ad: "Kurumsal", icon: "🏢", renk: "#2563EB" }
        ],
        personelRolleri: [
  { 
    id: "patron", 
    ad: "Yönetici", 
    icon: "👑", 
    renk: "#f59e0b", 
    yetkiler: TUM_YETKILER.reduce((acc, y) => ({ ...acc, [y.id]: true }), {}) // Patron'a her şey TRUE
  },
  { 
    id: "sofor", 
    ad: "Şoför / Sevkiyat", 
    icon: "🚐", 
    renk: "#3b82f6", 
    yetkiler: { saha_giris: true, sofor_modu: true, sekme_alinacak: true, sekme_dagitimda: true } // Sadece gerekenler TRUE
  },
  { 
    id: "yikamaci", 
    ad: "Yıkama Personeli", 
    icon: "🧼", 
    renk: "#10b981", 
    yetkiler: { sekme_yikanacak: true, sekme_yikaniyor: true, sekme_kurutuluyor: true } 
  }
]
      };
      await setDoc(doc(db, "kullanicilar", temizEmail), yeni);
      setIsletme(yeni.isletmeAyarlari);
      setBekleyenUser({ docId: temizEmail, ...yeni });
      setShowRolSecim(true);
      return true;
    } catch (err) { 
      console.error("Kayıt hatası:", err); 
      alert("Kayıt hatası: " + err.message);
      return false;
    }
  };

  const [musteriGruplari, setMusteriGruplari] = useState([
    { id: "Normal", ad: "Normal", icon: "👤", renk: "#64748B" },
    { id: "VIP", ad: "VIP", icon: "⭐", renk: "#F59E0B" },
    { id: "Kurumsal", ad: "Kurumsal", icon: "🏢", renk: "#2563EB" }
  ]);

  const [editGrup, setEditGrup] = useState(null);

  const [personelRolleri, setPersonelRolleri] = useState([
    { id: "patron", ad: "Yönetici", icon: "👑", renk: "#f59e0b", yetkiler: { anaSayfa: true, musteriler: true, siparisEkle: true, kasa: true, fiyatlar: true, ayarlar: true, personelSifre: true } },
    { id: "sofor", ad: "Şoför / Sevkiyat", icon: "🚐", renk: "#3b82f6", yetkiler: { anaSayfa: true, musteriler: true, siparisEkle: true, kasa: false, fiyatlar: false, ayarlar: false, personelSifre: false } },
    { id: "yikamaci", ad: "Yıkama Personeli", icon: "🧼", renk: "#10b981", yetkiler: { anaSayfa: true, musteriler: false, siparisEkle: false, kasa: false, fiyatlar: false, ayarlar: false, personelSifre: false } },
    { id: "muhasebe", ad: "Ofis / Muhasebe", icon: "🏢", renk: "#8b5cf6", yetkiler: { anaSayfa: true, musteriler: true, siparisEkle: true, kasa: true, fiyatlar: true, ayarlar: false, personelSifre: false } }
  ]);

  // 🛡️ YETKİ KONTROL MOTORU (Mühürlendi!)
  const yetkiVarMi = (yetkiId) => {
    // Patron ise her kapı açılır
    if (kullanici?.rol === "patron") return true;

    // Kullanıcının mevcut rolünü bul
    const suAnkiRol = personelRolleri.find(r => r.id === kullanici?.rol);

    // Rolün içinde o yetki 'true' ise geçiş ver
    return suAnkiRol?.yetkiler?.[yetkiId] === true;
  };

  // 🗑️BİLDİRİM MOTORU EMEKLİ EDİLDİ (Sadece Caller ID çalışacak)
// Bu fonksiyon boş bırakıldı çünkü artık uygulama içi bildirim bombardımanı istenmiyor.
const bildirimGonder = async () => {
  // Veritabanına yazma işlemi tamamen durduruldu.
  // Diğer kodlarda çağrıldığı için hata vermemesi adına boş return dönüyoruz.
  return; 
};

// 🔐 1. ÖNCE FONKSİYONU TANIMLIYORUZ (Aşağıdan buraya taşıdık)
  const lisansKontrol = () => {
    if (kullanici?.lisans_onay === "pasif") return { durum: "suresi_doldu", kalanGun: 0 }; 

    if (kullanici?.lisans_bitis) {
      const bitis = new Date(kullanici.lisans_bitis).getTime();
      const simdi = new Date().getTime();
      const kalanGun = Math.ceil((bitis - simdi) / 86400000);
      return kalanGun > 0 ? { durum: "aktif", kalanGun } : { durum: "suresi_doldu", kalanGun: 0 };
    }
    
    if (kullanici?.lisans_onay === "aktif") return { durum: "aktif", kalanGun: 999 };

    const kayit = kullanici?.kayitTarihi || localStorage.getItem("halici_kayit_tarihi");
    const gecenGun = Math.floor((Date.now() - new Date(kayit).getTime()) / 86400000);
    const denemeKalan = Math.max(0, 15 - gecenGun);
    return { durum: denemeKalan > 0 ? "deneme" : "suresi_doldu", kalanGun: denemeKalan };
  };

  // 🔐 2. SONRA ÇAĞIRIYORUZ
  const lisans = lisansKontrol();
  const lisansKilitli = lisans.durum === "suresi_doldu";



  const callerKapat = (aksiyon) => {
    setAramaLog(prev => {
      const y = [...prev];
      if (y.length > 0) y[y.length - 1].aksiyon = aksiyon;
      try { localStorage.setItem(logKey(), JSON.stringify(y)); } catch { }
      return y;
    });
    setCallerNumara(null);
  };

  // 👥 MÜŞTERİ YÖNETİMİ
  const musteriEkle = async (data) => {
    // 🚀 ADRES ÇÖZÜCÜ DEVREDE: Eğer konum yoksa ama adres yazılmışsa bul!
    let guncelKonum = data.konum;
    if (!guncelKonum && data.adres) {
      const bulunan = await adresdenKonumBul(data.adres);
      if (bulunan) guncelKonum = bulunan;
    }

    const yeni = { 
      ...data, 
      id: "m" + (++MUS_ID), 
      ad: formatAdSoyad(data.ad || ""), 
      borc: 0, 
      yildiz: 0, 
      grup: "Normal",
      konum: guncelKonum // 📍 Zırhlandı!
    };
    
    try {
      await addDoc(collection(db, "kullanicilar", kullanici.email, "musteriler"), yeni);
      return yeni;
    } catch (e) {
      console.error("Müşteri buluta eklenemedi:", e);
    }
  };

  const musteriGunc = async (id, data) => {
    setMusteriler(prev => prev.map(m =>
      (m.id === id || m.docId === id)
        ? { ...m, ...data, ad: formatAdSoyad(data.ad || m.ad) }
        : m
    ));

    const hedef = musteriler.find(m => m.id === id || m.docId === id);
    const firebaseId = hedef?.docId;

    if (firebaseId && kullanici?.email) {
      try {
        const temizData = { ...data };
        delete temizData.docId;
        const musteriRef = doc(db, "kullanicilar", kullanici.email, "musteriler", firebaseId);
        await updateDoc(musteriRef, {
          ...temizData,
          ad: formatAdSoyad(data.ad || hedef.ad)
        });
        console.log("✅ Müşteri buluta başarıyla mühürlendi.");
      } catch (e) {
        console.error("❌ Müşteri Firebase güncelleme hatası:", e);
      }
    }
  };
  const musteriSil = async (id, docId) => {
    if (kullanici.rol !== "patron") {
      alert("⚠️ Yetki Hatası: Sadece patron silebilir.");
      return;
    }

    if (!window.confirm("Bu müşteriyi veritabanından KALICI olarak siliyorum?")) return;

    try {
      const silinecekID = docId || id;
      await deleteDoc(doc(db, "kullanicilar", kullanici.email, "musteriler", silinecekID));
      setMusteriler(prev => prev.filter(m => (m.docId || m.id) !== silinecekID));
      sesCal("ding", true);
      alert("✅ Kayıt buluttan tamamen temizlendi.");
    } catch (err) {
      console.error("Silme hatası:", err);
      alert("❌ Hata: Firebase dökümanı silemedi. " + err.message);
    }
  };

  const yildizGunc = (id, y) => setMusteriler(p => p.map(m => m.id === id ? { ...m, yildiz: y } : m));

  // ✏️ Fiş Düzenleme Başlatıcı
  const fisDuzenleBas = (fis) => {
    setDuzenlenenFis(fis);
    setShowFis(true);
  };

  // 🚀 GÜNCELLENMİŞ GÜVENLİ İŞ EKLEME VE DÜZENLEME (Update & Add Birleşik)
  const isEkle = async (fis, wa = false) => {
    // 🚨 1. AKILLI EKSİK KONTROLÜ...
    if (!fis?.musteriId) { alert("⚠️ Müşteri seçilmedi!"); return; }
    if (!fis?.musteriAdi || fis.musteriAdi.trim() === "") { alert("⚠️ Müşteri adı boş olamaz!"); return; }
    if (!fis?.musteriTel || fis.musteriTel.trim() === "") { alert("⚠️ Müşteri telefonu eksik!"); return; }
    if (!fis?.musteriAdres || fis.musteriAdres.trim() === "") { alert("⚠️ Adres bilgisi eksik!"); return; }

    // 🌍 2. ADRES ÇÖZÜCÜ DEVREDE: Eğer fişte konum yoksa ama adres yazılmışsa arka planda bul!
    if (!fis.konum && fis.musteriAdres) {
      const bulunanKonum = await adresdenKonumBul(fis.musteriAdres);
      if (bulunanKonum) {
        fis.konum = bulunanKonum; // 📍 Koordinatı fişe mühürle, haritada kesin çıksın!
      }
    }

    try {
      if (duzenlenenFis) {
        // ✏️ MOD 1: GÜNCELLEME (Update)
        const isRef = doc(db, "kullanicilar", kullanici.email, "isler", duzenlenenFis.docId || duzenlenenFis.id);
        await updateDoc(isRef, {
          ...fis,
          guncellemeTarihi: new Date().toISOString()
        });
        setDuzenlenenFis(null); // İşlem bitince hafızayı boşalt
        console.log("✅ Fiş güncellendi");
      } else {
        // ✨ MOD 2: YENİ KAYIT (Add)
        await addDoc(collection(db, "kullanicilar", kullanici.email, "isler"), fis);

        // 🚀 Şoförlere Yeni İş Bildirimi (Akıllı Motor ile tek satırda!)
        bildirimGonder("sofor", "🚚 Yeni İş Geldi!", `${fis.musteriAdi} için yeni alım fişi açıldı. Sahaya bak!`, "yeni_fis")
          .catch(e => console.log("Şoför bildirimi atlandı."));
      }

      // 🔊 Dükkan içi ses çal
      try {
        const sesAyari = localStorage.getItem("halici_ses") !== "kapali";
        if (typeof sesCal === "function") {
          sesCal("ding", sesAyari);
        }
      } catch (e) {
        console.log("Statü değişim sesi hatası engellendi.");
      }

      // 📱 WhatsApp Gönderimi (Eğer seçiliyse)
      if (wa && fis.musteriTel) {
        const tel = fis.musteriTel.replace(/\D/g, "");
        const waNumara = tel.startsWith("0") ? "90" + tel.slice(1) : tel;
        const sablon = sablonlar?.siparis || MESAJ_SABLONLARI.siparis;
        const mesaj = sablon.replace("{musteri_adi}", fis.musteriAdi)
                        .replace("{sirket_adi}", isletme?.ad || kullanici?.sirket || "Halı Yıkama")
                        .replace("{fis_no}", fis.fisNo?.split("—")[0]?.trim() || "")
                        .replace("{telefon}", fis.musteriTel)
                        .replace("{teslim_tarihi}", fis.teslimTarihi || "");
        linkAc(`https://wa.me/${waNumara}?text=${encodeURIComponent(mesaj)}`);
      }

      // ✅ İşlem başarılı: Sayfayı yönlendir ve modalı kapat
      setSayfa("saha");
      setShowFis(false); 

    } catch (e) {
      console.error("Firebase İşlem Hatası:", e);
      alert("❌ İşlem yapılamadı: " + e.message);
    }
  };

  const isSil = async (id, docId) => {
    // 🛡️ DİNAMİK GÜVENLİK DUVARI
    const patronMu = kullanici?.rol === "patron";
    const aktifRol = personelRolleri.find(r => r.id === kullanici?.rol) || {};

    // Eğer patron değilse VE rolünde silme yetkisi yoksa engelle
    if (!patronMu && !aktifRol.yetkiler?.yetki_silme) {
      alert("❌ Yetki Engellendi: Fiş silme yetkiniz bulunmamaktadır.");
      return;
    }

    // 🛡️ ONAY KONTROLÜ
    if (!window.confirm("⚠️ Bu fiş kalıcı olarak silinecek! Emin misiniz?")) return;

    try {
      if (docId) {
        // ☁️ Firebase'den kalıcı olarak sil
        await deleteDoc(doc(db, "kullanicilar", kullanici.email, "isler", docId));
      } else {
        // Yerel state yedeği
        setIsler(p => p.filter(is => is.id !== id));
      }
      
      // Ses ve Bildirim işlemleri
      const sesAcik = localStorage.getItem("halici_ses") !== "kapali";
      if (typeof sesCal === "function") sesCal("uyari", sesAcik); 
      // 🔥 EKSİK OLAN 4. PARAMETREYİ EKLEDİK
      await bildirimGonder("patron", "🗑️ Fiş Silindi", "Sistemden bir fiş kalıcı olarak silindi.", "bilgi");
    } catch (e) {
      alert("Silme hatası: " + e.message);
    }
  };
// 🚀 GÜNCELLENMİŞ HALİ AL / m2 DÜZENLE KAYIT MOTORU
const haliAlKaydet = async (fisId, satirlar, hesaplama) => {
  const hedefFis = isler.find(is => String(is.id) === String(fisId) || is.docId === fisId);

  if (hedefFis && hedefFis.docId) {
    try {
      const isRef = doc(db, "kullanicilar", kullanici.email, "isler", hedefFis.docId);
      
      // 🛡️ REİS: Burası kritik! Eğer statü zaten "adres_bekliyor" ise "aracta" yap.
      // Ama eğer fiş zaten yıkanıyorsa veya hazırdaysa (Düzenleme yapılıyorsa) statüyü elleme!
      const yeniDurum = hedefFis.status === "adres_bekliyor" ? "aracta" : hedefFis.status;

      await updateDoc(isRef, { 
        status: yeniDurum,
        satirlar: satirlar, 
        hesaplama: hesaplama,
        // Toplam parça sayısını da kalemlerin içindeki 'adet'lerden toplayarak mühürleyelim
        originalHaliSayisi: satirlar.reduce((s, x) => s + (parseInt(x.adet) || 0), 0)
      });

      // 🔔 Bildirimleri sadece ilk alımda gönder (Dükkanın kafası karışmasın)
      if (hedefFis.status === "adres_bekliyor") {
        // 🔥 EKSİK OLAN 4 PARAMETRE DÜZENİ BURADA DA KURULDU
        bildirimGonder(
  "patron", 
  "Halılar Alındı", 
  `🚛 Şoför ${hedefFis.musteriAdi} halılarını aldı, yola çıktı.`, 
  "is_alindi"
).catch(() => console.log("Patrona bildirim atılamadı, ama işlem devam ediyor."));

bildirimGonder(
  "yikamaci", 
  "Yeni İş Yolda", 
  `🧼 Yeni iş yolda: ${hedefFis.musteriAdi}. Hazırlık yapabilirsin.`, 
  "hazirlik"
).catch(() => console.log("Yıkamacıya bildirim atılamadı, ama işlem devam ediyor."));
      }

      const sesAcik = localStorage.getItem("halici_ses") !== "kapali";
      sesCal("ding", sesAcik);
      setShowHaliAl(null);
    } catch (e) {
      alert("Güncelleme hatası: " + e.message);
    }
  } else {
    // Eğer docId bulunamazsa yerel güncelleme
    setIsler(p => p.map(is => is.id === fisId ? { ...is, status: is.status === "adres_bekliyor" ? "aracta" : is.status, satirlar, hesaplama } : is));
    setShowHaliAl(null);
  }
};

// 🚀 STATÜ GÜNCELLEME MOTORU (ZIRHLI & ÇÖKMEYİ ENGELLER)
  const durumGunc = async (id, durum) => {
    const hedefFis = isler.find(is => is.id === id || is.docId === id);
    if (!hedefFis?.docId) {
      // Eğer henüz buluta yüklenmemişse sadece yerel state güncelle
      setIsler(p => p.map(is => is.id === id ? { ...is, status: durum } : is));
      return;
    }

    try {
      // 1️⃣ Önce bulutu güncelle
      const isRef = doc(db, "kullanicilar", kullanici.email, "isler", hedefFis.docId);
      await updateDoc(isRef, { 
        status: durum,
        sonIslemYapan: kullanici.ad || "Bilinmiyor" 
      });
      
      // 2️⃣ Bildirim tetikleyiciyi "Sessiz Mod"da çalıştır (Refused hatası dükkanı kapatmasın)
      const gidecekRoller = bildirimKurallari[durum] || [];
      if (gidecekRoller.length > 0) {
        const asamaAdi = t("k_" + durum);
        bildirimGonder(
          gidecekRoller, 
          `🔔 Sipariş Durumu Değişti`, 
          `Müşteri: ${hedefFis.musteriAdi}\nYeni Durum: ${asamaAdi}`, 
          "statu_guncelleme"
        ).catch(() => console.log("Bildirim atlanıldı."));
      }

      // 3️⃣ Sesi zırhlı şekilde çal
      try {
        const sesAcik = localStorage.getItem("halici_ses") !== "kapali";
        if (typeof sesCal === "function") sesCal("ding", sesAcik);
      } catch (e) { console.log("Ses hatası bypass edildi."); }

    } catch (e) {
      console.error("Güncelleme hatası:", e);
      alert("⚠️ Bağlantı hatası: İşlem yapılamadı.");
    }
  };

  const tahsilatKaydet=(fisId,tahsilat)=>{
    setIsler(p=>p.map(is=>{
      if(is.id!==fisId) return is;
      if(is.musteriId) setMusteriler(prev=>prev.map(m=>m.id!==is.musteriId?m:{...m,borc:Math.max(0,(m.borc||0)+tahsilat.kalanBorc-tahsilat.eskiBorcTahsilat)}));
      return {...is,tahsilat};
    }));
    setShowTahsilat(null);
  };

  const iadeKaydet=(data)=>{
    const orgFis=isler.find(is=>is.id===data.fisId);
    if(!orgFis) return;
    const iadeFis={
      id:Date.now(),fisNo:`${orgFis.fisNo?.split("—")[0]?.trim()}-R`,
      musteriId:orgFis.musteriId,musteriAdi:orgFis.musteriAdi,
      musteriTel:orgFis.musteriTel,musteriAdres:orgFis.musteriAdres,
      musteriSemt:orgFis.musteriSemt,alisTarihi:bugun(),teslimTarihi:tarihEkle(3),
      not:`İADE: ${data.not}`,fotograflar:data.fotograflar||[],
      status:"beklemede",satirlar:data.secilenSatirlar||[],
      hesaplama:{araToplam:0,iskonto:0,nakliye:0,ambalaj:0,kdv:0,genelToplam:0},
      tahsilat:null,isIade:true,originalFisId:data.fisId,paraAlindi:data.paraAlindi,
    };
    setIsler(p=>[iadeFis,...p]);
  };

  const whatsappGonder=(is_,ozelSablon="")=>{
    const tel=(is_?.musteriTel||"").replace(/\D/g,"");
    const waTel=tel.startsWith("0")?"90"+tel.slice(1):tel;
    const st=STATÜLER_META[is_?.status||"beklemede"]||STATÜLER_META.beklemede;
    const mesaj=ozelSablon||`Sayın ${is_?.musteriAdi||""} 🧹\nFiş: *${is_?.fisNo?.split("—")[0]?.trim()}*\nDurum: ${st.icon} *${t(is_?.status||"beklemede")}*\nTeslim: ${is_?.teslimTarihi||""}`;
    linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent(mesaj)}`);
  };

  const smsGonder=(tel,mesaj)=>{
    const temizTel=tel.replace(/\D/g,"");
    linkAc(`sms:${temizTel}?body=${encodeURIComponent(mesaj)}`);
  };
// 🗺️ Rota optimizasyonu - TAM DÜZELTİLMİŞ HALİ
  const rotaOptimize = (tip = "alinacak") => {
    // 🎯 Filtre Mantığı: Alınacaksa 'adres_bekliyor', Teslimat ise 'teslim_hazir' VEYA 'dagitimda' olanlar
    const filtreFn = tip === "alinacak" 
      ? (is => is.status === "adres_bekliyor")
      : (is => is.status === "teslim_hazir" || is.status === "dagitimda");

    // 📍 Adresleri topla ve temizle (Boş veya çok kısa adresleri ele)
    const hedefler = isler
      .filter(filtreFn)
      .map(is => (is.musteriAdres || "") + (is.musteriSemt ? " " + is.musteriSemt : ""))
      .filter(s => s && s.trim().length > 5);

    // 🚨 Adres yoksa uyar
    if (!hedefler.length) {
      alert(tip === "alinacak" ? "📍 Alınacak adres bulunamadı!" : "🚐 Teslim edilecek adres bulunamadı!");
      return;
    }

    // 🗺️ TEK ADRES VARSA: Direkt navigasyonu aç
    if (hedefler.length === 1) {
      linkAc(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(hedefler[0])}`);
      return;
    }

    // 🛣️ ÇOKLU ADRES VARSA: Rota oluştur
    const origin = isletme.adres || ""; // Dükkan adresi
    const destination = hedefler[hedefler.length - 1]; // Son durak
    const waypoints = hedefler.slice(0, -1).map(a => encodeURIComponent(a)).join("|"); // Ara duraklar

    // Google Maps Rota URL'si (Zırhlı Syntax)
    const url = `https://www.google.com/maps/dir/?api=1${origin ? `&origin=${encodeURIComponent(origin)}` : ""}&waypoints=${waypoints}&destination=${encodeURIComponent(destination)}&travelmode=driving`;

    linkAc(url);
  };

  // 🔍 QR ile fiş bul - TAM DÜZELTİLMİŞ HALİ
  const qrIleFisBul = (deger) => {
    if (!deger) return;

    const aranan = deger.toString().replace(/FŞ-/i, "").trim().toUpperCase();
const bulunan = isler.find(is => {
  const fisNoStr = (is.fisNo || "").toString().toUpperCase();
  const idStr = (is.id || "").toString();
  const kisaKod = fisNoStr.split(" — ")[0].trim();
  return kisaKod === aranan || fisNoStr.includes(aranan) || idStr === aranan;
});

    if (bulunan) {
      setShowQRTara(false);
      setAramaMetni(aranan);
      setSayfa("isler");
      setDurumFiltre("hepsi");

      const durum = bulunan.status;
      // Statü kontrolü senin TR sözlüğündeki isimlerle eşitlendi
      if (durum === "alinacak" || durum === "adres_bekliyor") {
        setShowHaliAl(bulunan); 
      } else if (durum === "hazir" || durum === "aracta" || durum === "dagitimda" || durum === "teslim_hazir") {
        setShowTahsilat(bulunan); 
      } else {
        setShowMusteriProfil(bulunan);
      }

      const sesAcik = localStorage.getItem("halici_ses") !== "kapali";
      sesCal("tamamlandi", sesAcik);
    } else {
      setAramaMetni(aranan);
      setShowQRTara(false);
      alert(`❌ "${aranan}" sistemde bulunamadı.`);
    }
  };
  // 📊 1. SAYAC VE HESAP MOTORU (Zırhlı ve useMemo içine alındı)
  const sayac = useMemo(() => {
    const s = {
      toplamCiro: 0, toplamBorc: 0,
      adres_bekliyor: 0, aracta: 0, beklemede: 0, yikaniyor: 0, 
      kurutuluyor: 0, fason: 0, teslim_hazir: 0, dagitimda: 0, teslim_edildi: 0
    };
    if (!isler || !Array.isArray(isler)) return s;

    isler.forEach(is => {
      if (!is) return; 
      // Statü Sayacı
      if (is.status && s[is.status] !== undefined) {
        s[is.status]++;
      }
      // Para Hesapları
      const gToplam = parseFloat(is.hesaplama?.genelToplam || 0);
      const kGiren = parseFloat(is.tahsilat?.kasayaGiren || 0);
      
      s.toplamCiro += kGiren;
      if (is.status !== "teslim_edildi" && is.status !== "adres_bekliyor") {
        s.toplamBorc += (gToplam - kGiren);
      }
    });
    return s;
  }, [isler]);

  // 🔍 2. FİLTRELEME MOTORU (Crash Korumalı)
  const filtrelenmisIsler = useMemo(() => {
    return (isler || []).filter(is => {
      if (!is) return false;
      const aranan = (aramaMetni || "").toLowerCase();
      const ms = (
        (is.musteriAdi || "").toLowerCase().includes(aranan) || 
        (is.fisNo || "").toLowerCase().includes(aranan)
      );
      const mf = (durumFiltre === "hepsi") || (is.status === durumFiltre);
      return ms && mf;
    });
  }, [isler, aramaMetni, durumFiltre]);

// 📈 3. İSTATİSTİK MOTORU (Güncel ve Hızlı)
  const istat = useMemo(() => ({
    sicakPara: isler.reduce((s, is) => s + (parseFloat(is.tahsilat?.kasayaGiren || 0)), 0),
    odenmemis: isler.filter(is => !is.tahsilat && (is.hesaplama?.genelToplam || 0) > 0 && is.status !== "adres_bekliyor").reduce((s, is) => s + (parseFloat(is.hesaplama?.genelToplam || 0)), 0),
    aktif: isler.filter(is => is.status !== "teslim_edildi").length,
    borclu: musteriler.filter(m => (parseFloat(m.borc || 0)) > 0).length,
  }), [isler, musteriler]);

  // ─── FİŞ PRINT HTML (Gereksiz Değişkenlerden Arındırılmış Versiyon) ───
  const fisPrintHTML = (fis) => {
    // 🛡️ REİS: dar ve genislik uyarısı veren satırlar silindi, kod sadeleşti.
    const h = fis?.hesaplama || {};
    
    // 🚚 Teslim eden bilgisini akıllıca belirle
    const teslimEdenIsim = (fis?.isAlan === "Patron" || !fis?.isAlan) 
      ? (isletme.ad || "İşletme Yetkilisi") 
      : fis.isAlan;

  const satirHTML = (fis?.satirlar || []).map(s => {
    const tip = urunler.find(u => u.id === s?.tipId) || { ad: "?", birim: "adet", fiyat: 0 };
    const sh = hesaplaSatir({ ...s, varsayilanFiyat: tip.fiyat });
    if (!parseFloat(s?.miktar || 0)) return "";
    return `<tr>
      <td style="text-align:left">
        <strong>${tip.ad}</strong>
        ${s.not ? `<div style="font-size:10px; color:#555;">📋 Not: ${s.not}</div>` : ""}
        ${s.kirlilik !== "normal" ? `<div style="font-size:10px; color:#d9480f;">⚠ Durum: ${KIRLILIK.find(k=>k.id===s.kirlilik).ad}</div>` : ""}
      </td>
      <td>${s.miktar} ${tip.birim}</td>
      <td>${s.birimFiyat || tip.fiyat}₺</td>
      <td>${s.ekspres ? "⚡" : "-"}</td>
      <td style="text-align:right; font-weight:bold;">${sh.satirToplam.toFixed(2)}₺</td>
    </tr>`;
  }).join("");

  return `<!DOCTYPE html><html><head><meta charset="UTF-8">
<style>
  body{font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width:800px; margin:0 auto; padding:20px; color:#333; line-height:1.2;}
  .header-box{text-align:center; padding:15px; border: 2px solid #1E3A5F; border-radius:15px; margin-bottom:20px;}
  .info-grid{display:grid; grid-template-columns:1fr 1fr; gap:15px; margin-bottom:20px;}
  .info-card{background:#f8f9fa; padding:12px; border-radius:10px; border:1px solid #e9ecef;}
  .info-card h4{margin:0 0 5px 0; font-size:11px; color:#1E3A5F; text-transform:uppercase;}
  table{width:100%; border-collapse:collapse;}
  th{border-bottom:2px solid #1E3A5F; padding:10px; text-align:center; font-size:12px;}
  td{padding:10px; border-bottom:1px dotted #ccc; text-align:center; font-size:13px;}
  .totals{margin-top:15px; text-align:right;}
  .grand-total{font-size:22px; color:#1E3A5F; font-weight:900; margin-top:5px;}
  .rule-box{margin-top:25px; padding:15px; background:#fff3cd; border: 1px solid #ffeeba; border-radius:10px; font-size:11px;}
  .imza-row{margin-top:60px; display:flex; justify-content:space-between; text-align:center; font-size:12px;}
  @media print{.no-print{display:none}}
</style></head>
<body onload="window.print()">
  <div class="header-box">
   <h2 style="margin:0;">${isletme.ad || kullanici.sirket || "Halı Yıkama"}</h2>
    <div style="font-size:13px; font-weight:600; color:#1E3A5F; margin-top:5px;">MÜŞTERİ BİLGİLENDİRME VE TESLİM FİŞİ</div>
  </div>

  <div class="info-grid">
    <div class="info-card">
      <h4>Müşteri Bilgileri</h4>
      <strong>${fis?.musteriAdi}</strong><br>${fis?.musteriTel}<br>${fis?.musteriAdres}
    </div>
    <div class="info-card">
      <h4>İşlem Bilgileri</h4>
      <strong>Fiş No:</strong> ${fis?.fisNo?.split("—")[0]?.trim()}<br>
      <strong>Tarih:</strong> ${fis?.alisTarihi}<br>
      <strong>Teslim:</strong> ${fis?.teslimTarihi || "Planlanıyor"}
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th style="text-align:left">Hizmet / Ürün</th>
        <th>Miktar</th>
        <th>Birim Fiyat</th>
        <th>Hızlı</th>
        <th style="text-align:right">Tutar</th>
      </tr>
    </thead>
    <tbody>${satirHTML}</tbody>
  </table>

  <div class="totals">
    <div style="font-size:13px;">Ara Toplam: ${h.araToplam?.toFixed(2)}₺</div>
    ${(h.iskonto > 0) ? `<div style="color:red;">İndirim: -${h.iskonto?.toFixed(2)}₺</div>` : ""}
    ${(h.nakliye > 0) ? `<div>Servis Bedeli: ${h.nakliye?.toFixed(2)}₺</div>` : ""}
    <div class="grand-total">ÖDENECEK TOPLAM: ${h.genelToplam?.toFixed(2)}₺</div>
  </div>

  <div class="rule-box">
    <strong>🛡 HİZMET ŞARTLARI & GARANTİ BİLGİSİ</strong><br>
    • Halılarınızı teslim aldıktan sonra <strong>mutlaka ambalajından çıkarınız.</strong> Kapalı kalan halı rutubet ve koku yapabilir.<br>
    • Temizlikten memnun kalmazsanız lütfen <strong>2 iş günü</strong> içinde bize bildiriniz.<br>
    • Ürünlerimiz teslim tarihinden itibaren <strong>1 hafta</strong> süresince yıkama garantimiz altındadır.
  </div>

  <div class="imza-row">
    <div>
      <hr style="width:180px">
      TESLİM EDEN<br>
      <strong>${teslimEdenIsim}</strong>
    </div>
    <div>
      <hr style="width:180px">
      MÜŞTERİ / TESLİM ALAN<br>
      <small>(İmza / İsim Soyisim)</small>
    </div>
  </div>
</body></html>`;
};
  // ─── SAYFA İÇERİKLERİ ───
  const StatüKart=({k,onClick})=>{
    const meta=STATÜLER_META[k];
    const count=sayac[k]||0;
    return (
      <button onClick={onClick} style={{padding:"16px",borderRadius:16,background:T.card,
        border:`1.5px solid ${durumFiltre===k?meta.renk:T.border}`,cursor:"pointer",textAlign:"left",
        display:"flex",alignItems:"center",gap:12,width:"100%",transition:"all 0.2s"}}
        onMouseEnter={e=>e.currentTarget.style.borderColor=meta.renk}
        onMouseLeave={e=>e.currentTarget.style.borderColor=durumFiltre===k?meta.renk:T.border}>
        <div style={{width:44,height:44,borderRadius:12,background:meta.renk+"18",display:"flex",
          alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{meta.icon}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:14,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
            {t(k)}
          </div>
          <div style={{fontSize:13,color:meta.renk,fontWeight:700}}>{count} iş</div>
        </div>
        <span style={{fontSize:18,color:T.textSec}}>›</span>
      </button>
    );
  };
  if (!kullanici && !showRolSecim) {
    return <AuthEkrani onGiris={handleGiris} onKayit={handleKayit} T={T} t={t} />;
  }

  const renderAnaSayfa = () => {
    return (
      <>
        <div style={{ padding: 16, overflowY: "auto", height: "100%" }}>
          {/* 👋 DİNAMİK SELAMLAMA KARTI */}
          <div style={{ background: T.header, borderRadius: 20, padding: 20, marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>{t("merhaba")},</div>
              
              {/* 👤 Giriş yapan aktif personelin tam adını (Ad Soyad) gösterir */}
        <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>
          {kullanici?.aktifPersonel ? kullanici.aktifPersonel.ad : (kullanici?.ad || isletme.sahip || "Yönetici")}
        </div>

              {/* 🏢 REİS BURASI DÜZELDİ: Ayarlardaki "Şirket Adı"nı çeker */}
              <div style={{ 
                fontSize: 12, 
                color: "rgba(255,255,255,0.6)", 
                marginTop: 4,
                background: "rgba(255,255,255,0.1)",
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: "8px"
              }}>
                {isletme.ad || kullanici.sirket || "HaliPro İşletmesi"}
              </div>
            </div>

            {/* Günün raporu */}
            <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
              {[
                { l: t("k_adres_bekliyor"), v: sayac.adres_bekliyor },
                { l: t("k_beklemede") + " / " + t("k_yikaniyor"), v: sayac.beklemede + sayac.yikaniyor },
                { l: t("k_teslim_hazir"), v: sayac.teslim_hazir }
              ].map(s => (
                <div key={s.l} style={{ textAlign: "center", background: "rgba(255,255,255,0.12)", borderRadius: 12, padding: "10px 6px" }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: "#fff" }}>{s.v}</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.7)" }}>{s.l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Hızlı erişim */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
            {[
              { icon: "👤", label: "Müşteri Ekle", renk: T.primary, action: () => setShowMusteriForm({}) },
              { icon: "📊", label: "Raporlar & Analiz", renk: "#8B5CF6", action: () => setSayfa("raporlar") },
            ].map((btn, i) => (
              <button key={i} onClick={btn.action}
                style={{
                  padding: "16px", borderRadius: 16, background: T.card, border: `1px solid ${T.border}`,
                  cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 12,
                  transition: "background 0.15s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = btn.renk + "12"}
                onMouseLeave={e => e.currentTarget.style.background = T.card}>
                <div style={{
                  width: 40, height: 40, borderRadius: 11, background: btn.renk + "20", display: "flex",
                  alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0
                }}>{btn.icon}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{btn.label}</div>
                  {btn.badge > 0 && <div style={{ fontSize: 12, color: btn.renk, fontWeight: 700 }}>{btn.badge} iş var</div>}
                </div>
              </button>
            ))}
          </div>

          {/* 📊 TÜM STATÜ ÖZETİ */}
<div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 14, marginBottom: 16 }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
    <div style={{ fontSize: 12, fontWeight: 700, color: T.textSec }}>
      📊 Günlük İş Durumu
    </div>
    <div style={{ fontSize: 10, color: T.textSec, fontStyle: "italic" }}>
      (Günlük Sıfırlanır)
    </div>
  </div>
  
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
    {STATÜ_SIRASI.map(k => {
      const meta = STATÜLER_META[k];
      // sayac[k] değeri yukarıdaki useEffect içinde isler.filter ile hesaplanıyor olmalı
      const count = sayac[k] || 0; 
      
      return (
        <button 
          key={k} 
          onClick={() => { 
            setSayfa("isler"); 
            setDurumFiltre(k); 
          }}
          style={{
            padding: "10px 6px", 
            borderRadius: 12,
            background: count > 0 ? meta.renk + "15" : T.statCard,
            border: `1px solid ${count > 0 ? meta.renk + "40" : T.border}`,
            cursor: "pointer", 
            textAlign: "center", 
            transition: "all 0.2s",
            outline: "none"
          }}
        >
          <div style={{ fontSize: 18 }}>{meta.icon}</div>
          <div style={{ 
            fontSize: 18, 
            fontWeight: 900, 
            color: count > 0 ? meta.renk : T.textSec 
          }}>
            {count}
          </div>
          <div style={{ 
            fontSize: 9, 
            color: T.textSec, 
            marginTop: 1, 
            whiteSpace: "nowrap", 
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}>
            {t("k_" + k)}
          </div>
        </button>
      );
    })}
  </div>
</div>

          {/* Kasa özeti */}
          <div 
  onClick={() => setSayfa("kasa")}
  style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 16, cursor: "pointer" }}>
  <div style={{ fontSize: 13, fontWeight: 700, color: T.textSec, marginBottom: 10 }}>💰 Kasa Özeti →</div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, fontSize: 15 }}>
              <span style={{ color: T.textSec }}>Sıcak Para</span>
              <span style={{ color: T.success, fontWeight: 700 }}>₺{istat.sicakPara.toFixed(2)}</span>
            </div>
            {istat.odenmemis > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
                <span style={{ color: T.textSec }}>{t("odenmemis")}</span>
                <span style={{ color: T.danger, fontWeight: 700 }}>₺{istat.odenmemis.toFixed(2)}</span>
              </div>
            )}
          </div>

          {/* Hızlı araçlar */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
            <button onClick={() => setShowQRTara(true)} style={{ padding: "12px", borderRadius: 14, background: T.card, border: `1px solid ${T.border}`, cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 10 }}
              onMouseEnter={e => e.currentTarget.style.background = T.primary + "12"}
              onMouseLeave={e => e.currentTarget.style.background = T.card}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: T.primary + "20", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>📷</div>
              <div><div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>QR Tara</div><div style={{ fontSize: 11, color: T.textSec }}>Fiş bul</div></div>
            </button>
            <button onClick={() => setShowBorcHatirla(true)} style={{ padding: "12px", borderRadius: 14, background: T.card, border: `1px solid ${T.border}`, cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 10 }}
              onMouseEnter={e => e.currentTarget.style.background = T.danger + "12"}
              onMouseLeave={e => e.currentTarget.style.background = T.card}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: T.danger + "20", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>💳</div>
              <div><div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>Borç Hatırlat</div><div style={{ fontSize: 11, color: T.textSec }}>{istat.borclu} borçlu müşteri</div></div>
            </button>
          </div>
{/* 📞 SON ARAMALAR (BİRLEŞTİRİLMİŞ & FİLTRESİZ YENİ VERSİYON) */}
          <div style={{ marginTop: 20, background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: T.textSec, letterSpacing: 0.5 }}>
                📞 SON ARAMALAR {aramaLog.length > 0 && `(${aramaLog.length})`}
              </div>
              <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                {aramaLog.length > 0 && <div style={{ fontSize: 11, color: T.textSec, opacity: 0.7, fontWeight: 600 }}>Kaydırın ↕</div>}
                <button onClick={() => setAramaLog([])} style={{ background: "none", border: "none", color: T.danger, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Temizle</button>
              </div>
            </div>

            {aramaLog.length === 0 ? (
              <div style={{ padding: 24, textAlign: "center", borderRadius: 12, border: `1px dashed ${T.border}`, color: T.textSec, fontSize: 12 }}>
                Bugün henüz bir arama gelmedi.
              </div>
            ) : (
              /* 📱 Kaydırılabilir Liste Konteyner — iPhone Tarzı Akıcı */
              <div style={{ 
                maxHeight: 240, // Yaklaşık 3.5 kayıt yüksekliği
                overflowY: "auto", 
                scrollSnapType: "y mandatory",
                paddingRight: 4,
                scrollbarWidth: "none",
                display: "flex",
                flexDirection: "column",
                gap: 8
              }}>
                {[...aramaLog].reverse().map((log, index) => {
                  // 🚀 AKILLI EŞLEŞTİRME (Filtre yok, sadece numarayı düzeltip arar)
                  const temizLogNum = (log.numara || "").replace(/\D/g, "").slice(-10);
                  const kayitliMusteri = musteriler.find(m =>
                    (m.tel || "").replace(/\D/g, "").slice(-10) === temizLogNum ||
                    (m.tel2 || "").replace(/\D/g, "").slice(-10) === temizLogNum
                  );

                  return (
                    <div key={index} style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "12px",
                      background: T.bg, // İç kart rengi
                      borderRadius: 12,
                      border: `1px solid ${T.border}`,
                      scrollSnapAlign: "start"
                    }}>
                      
                      {/* Sol Taraf: Tıklayınca Profil veya Hızlı Kayıt Formu */}
                      <div onClick={() => {
                        if (kayitliMusteri) {
                          setShowMusteriProfil(kayitliMusteri);
                        } else {
                          setShowMusteriForm({ ad: "", tel: log.numara, grup: "Normal" });
                        }
                      }} style={{ flex: 1, cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}>
                        
                        <div style={{ 
                          width: 36, height: 36, borderRadius: 10, 
                          background: kayitliMusteri ? T.success + "15" : T.warning + "15", 
                          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 
                        }}>
                          {kayitliMusteri ? "👤" : "❓"}
                        </div>

                        <div>
                          <div style={{ fontSize: 13, color: T.text, fontWeight: kayitliMusteri ? 800 : 600 }}>
                            {kayitliMusteri ? kayitliMusteri.ad : log.numara}
                          </div>
                          <div style={{ fontSize: 11, color: T.textSec, marginTop: 2 }}>
                            {log.saat} • {kayitliMusteri ? "Kayıtlı Müşteri" : "Bilinmeyen Numara"}
                          </div>
                        </div>
                      </div>

                      {/* Sağ Taraf: Hızlı Aksiyon Butonları (+ Fiş / + Kaydet) */}
                      <div style={{ display: "flex", alignItems: "center", paddingLeft: 10 }}>
                        <button onClick={() => {
                          if (kayitliMusteri) {
                            setShowFis(true);
                            setTimeout(() => setCallerNumara(log.numara), 50);
                          } else {
                            setShowMusteriForm({ tel: log.numara, ad: "", grup: "Normal" });
                          }
                        }} style={{
                          padding: "8px 14px", borderRadius: 10, 
                          background: kayitliMusteri ? (T.primary + "15") : (T.success + "15"),
                          border: `1px solid ${kayitliMusteri ? T.primary : T.success}40`, 
                          color: kayitliMusteri ? T.primary : T.success,
                          cursor: "pointer", fontSize: 11, fontWeight: 800
                        }}>
                          {kayitliMusteri ? "+ Fiş" : "+ Kaydet"}
                        </button>
                      </div>

                    </div>
                  );
                })}
              </div>
            )}

            {/* Tümünü Gör Butonu */}
            {aramaLog.length > 5 && (
              <button onClick={() => setAltSayfa("log")} 
                style={{ width: "100%", marginTop: 12, padding: 12, borderRadius: 12, background: T.bg, border: `1px dashed ${T.border}`, color: T.primary, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                Tüm Aramaları Gör ({aramaLog.length})
              </button>
            )}
          </div>
        </div>
      </>
    ); 
  }; 

  const renderIsler = () => {
    return (
      <>
        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Arama + filtre */}
          <div style={{ padding: "12px 16px", background: T.bg, borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 10, background: T.card, border: `1.5px solid ${T.inputBorder}`,
              borderRadius: 14, padding: "11px 14px", marginBottom: 10
            }}>
              <span style={{ color: T.textSec, fontSize: 18 }}>🔍</span>
              <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
                placeholder="Fiş no, müşteri adı..."
                style={{ background: "none", border: "none", outline: "none", color: T.text, fontSize: 15, flex: 1 }} />
            </div>
            <div style={{ display: "flex", gap: 6, overflowX: "auto", paddingBottom: 2 }}>
              <button onClick={() => setDurumFiltre("hepsi")}
                style={{
                  padding: "7px 14px", borderRadius: 9, border: `1.5px solid ${durumFiltre === "hepsi" ? T.primary : T.border}`,
                  background: durumFiltre === "hepsi" ? T.primary : "transparent", color: durumFiltre === "hepsi" ? "#fff" : T.textSec,
                  cursor: "pointer", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0
                }}>
                Tümü ({isler.length})
              </button>
              {STATÜ_SIRASI.map(k => {
                const meta = STATÜLER_META[k];
                return (
                  <button key={k} onClick={() => setDurumFiltre(k)}
                    style={{
                      padding: "7px 12px", borderRadius: 9,
                      border: `1.5px solid ${durumFiltre === k ? meta.renk : T.border}`,
                      background: durumFiltre === k ? meta.renk + "20" : "transparent",
                      color: durumFiltre === k ? meta.renk : T.textSec,
                      cursor: "pointer", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0,
                      display: "flex", alignItems: "center", gap: 4
                    }}>
                    {meta.icon} {t("k_" + k)} {sayac[k] > 0 ? `(${sayac[k]})` : ""}
                  </button>
                );
              })}
            </div>
          </div>
          {/* Liste */}
          <div style={{ flex: 1, overflowY: "auto", padding: "12px 16px" }}>
            {filtrelenmisIsler.length === 0 ? (
              <div style={{ textAlign: "center", padding: 48, color: T.textSec }}>
                <div style={{ fontSize: 48, marginBottom: 8 }}>🧹</div>
                <div style={{ fontSize: 15 }}>Henüz iş kaydı yok</div>
                <div style={{ fontSize: 13, marginTop: 4 }}>Üstten "+ Fiş" ekleyin</div>
              </div>
            ) : filtrelenmisIsler.map(is => {
              const meta = STATÜLER_META[is?.status || "beklemede"];
              return (
                <div key={is.id} style={{
                  background: T.card, border: `1px solid ${is.acil ? T.danger : is.isIade ? "#7C3AED" : T.border}`,
                  borderRadius: 16, padding: 14, marginBottom: 10
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", marginBottom: 2 }}>
                        {is.acil && <span style={{ fontSize: 10, background: T.danger, color: "#fff", borderRadius: 5, padding: "1px 6px", fontWeight: 700 }}>{t("acil")}</span>}
                        {is.isIade && <span style={{ fontSize: 10, background: "#7C3AED", color: "#fff", borderRadius: 5, padding: "1px 6px", fontWeight: 700 }}>İADE</span>}
                        <button onClick={() => { const m = musteriler.find(m => m.id === is.musteriId); if (m) setShowMusteriProfil(m); }}
                          style={{
                            fontSize: 16, fontWeight: 700, background: "none", border: "none", color: T.primary,
                            cursor: "pointer", padding: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 200
                          }}>
                          {is.musteriAdi}
                        </button>
                      </div>
                      <div style={{ fontSize: 12, color: T.textSec }}>{is.fisNo?.split("—")[0]?.trim()} • {is.alisTarihi}</div>
                    </div>
                    <div style={{ textAlign: "right", flexShrink: 0 }}>
                      <div style={{ fontSize: 12, color: meta?.renk, fontWeight: 600 }}>{meta?.icon} {t("k_" + (is.status || "beklemede"))}</div>
                      <div style={{ fontSize: 17, fontWeight: 900, color: T.warning }}>
                        {is.status === "adres_bekliyor" ? "m² bekleniyor" : `₺${(is.hesaplama?.genelToplam || 0).toFixed(2)}`}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: 10, fontSize: 13 }}>
                    {is.tahsilat?.kasayaGiren > 0 ? (
                      <span style={{ color: T.success }}>✅ ₺{is.tahsilat.kasayaGiren.toFixed(2)} tahsil — {is.tahsilat.alan || ""}</span>
                    ) : is.isIade && is.paraAlindi ? (
                      <span style={{ color: T.warning }}>⚠️ Para alınmış, iade bekliyor</span>
                    ) : is.status !== "adres_bekliyor" && (is.hesaplama?.genelToplam || 0) > 0 ? (
                      <button onClick={() => setShowTahsilat(is)}
                        style={{
                          padding: "5px 12px", borderRadius: 8, background: T.danger + "12", border: `1px solid ${T.danger}30`,
                          color: T.danger, cursor: "pointer", fontSize: 13, fontWeight: 600
                        }}>⏳ Ödeme Al</button>
                    ) : null}
                  </div>
                 <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                    
                    {/* 🚀 AKILLI "SIRADAKİ AŞAMA" BUTONU (Kibar Versiyon) */}
                    {(() => {
                      const sonraki = statuSirasiniAl(is.status);
                      if (!sonraki) return null;
                      const sMeta = STATÜLER_META[sonraki];
                      return (
                        <button 
                          onClick={() => durumGunc(is.id, sonraki)}
                          style={{
                            padding: "7px 12px",
                            borderRadius: 9,
                            background: sMeta.renk,
                            color: "#fff",
                            border: "none",
                            fontWeight: 700,
                            fontSize: 12,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            boxShadow: `0 2px 8px ${sMeta.renk}33`,
                            transition: "all 0.2s"
                          }}
                        >
                          <span>{sMeta.icon}</span>
                          <span>{t("k_" + sonraki)} →</span>
                        </button>
                      );
                    })()}

                    {/* ⚙️ MANUEL SEÇİM (Zaten kodunda var) */}
                    <select value={is.status || "beklemede"} onChange={e => durumGunc(is.id, e.target.value)}
                      style={{
                        padding: "6px 8px", borderRadius: 9, border: `1.5px solid ${meta?.renk}40`,
                        background: T.bg, color: meta?.renk, fontSize: 11, cursor: "pointer", outline: "none", fontWeight: 600,
                        height: "31px"
                      }}>
                      {STATÜ_SIRASI.map(k => <option key={k} value={k}>{STATÜLER_META[k].icon} {t("k_" + k)}</option>)}
                    </select>

                    {/* 🚀 BURAYI YAPIŞTIRIYORSUN (DÜZENLEME TUŞLARI) */}
                    <div style={{ display: "flex", gap: 4 }}>
                      {/* 1. Müşteri/Adres Düzenle */}
                      <button onClick={() => fisDuzenleBas(is)}
                        style={{ 
                          padding: "7px 8px", borderRadius: 9, background: T.primary + "15", 
                          border: `1.5px solid ${T.primary}30`, color: T.primary, cursor: "pointer", 
                          fontSize: 11, fontWeight: 700 
                        }}>
                        ✏️ Fiş/Ad Dzlt.
                      </button>

                      {/* 2. Halı m²/Adet Düzenle */}
                      <button onClick={() => setShowHaliAl(is)}
                        style={{ 
                          padding: "7px 8px", borderRadius: 9, background: T.success + "15", 
                          border: `1.5px solid ${T.success}30`, color: T.success, cursor: "pointer", 
                          fontSize: 11, fontWeight: 700 
                        }}>
                        📐 m² Düzelt
                      </button>
                    </div>
                    
                    <button onClick={() => whatsappGonder(is)}
                      style={{ padding: "7px 10px", borderRadius: 9, background: "#25D36618", border: "1px solid #25D36630", color: "#25D366", cursor: "pointer", fontSize: 13 }}>📱 WA</button>
  
  <button onClick={() => {
    const st = STATÜLER_META[is?.status || "beklemede"];
    smsGonder(is.musteriTel, `Sayın ${is.musteriAdi}, halınızın durumu: ${st.icon} ${t("k_" + (is.status || "beklemede"))}. ${isletme.ad || kullanici.sirket || "Halı Yıkama"}`);
  }} style={{ padding: "7px 10px", borderRadius: 9, background: T.primary + "15", border: `1.5px solid ${T.primary}30`, color: T.primary, cursor: "pointer", fontSize: 13 }}>✉️ SMS</button>
  
<button onClick={() => { 
    const htmlIcerik = fisPrintHTML(is); 
    const win = window.open("", "_blank");
    win.document.write(htmlIcerik);
    win.document.close();
    // 🚀 ZIRHLI YAZDIRMA VE DÖNÜŞ MOTORU
    win.onafterprint = function() { win.close(); };
    setTimeout(() => { try { win.print(); } catch(e) {} }, 400);
  }} style={{ padding: "7px 10px", borderRadius: 9, background: T.border, border: `1px solid ${T.border}`, color: T.textSec, cursor: "pointer", fontSize: 13 }}>
    🖨️ Bilgi Fişi
  </button>
  
  <button onClick={() => { 
    const w = window.open("", "_blank"); 
    w.document.write(faturaHTML(is, isletme, urunler, kullanici)); 
    w.document.close(); 
    // 🚀 ZIRHLI YAZDIRMA VE DÖNÜŞ MOTORU
    w.onafterprint = function() { w.close(); };
    setTimeout(() => { try { w.print(); } catch(e) {} }, 400);
  }} style={{ padding: "7px 10px", borderRadius: 9, background: T.warning + "15", border: `1.5px solid ${T.warning}30`, color: T.warning, cursor: "pointer", fontSize: 11, fontWeight: 600 }}>
    📄 Fatura
  </button>
  
  <button onClick={() => setShowQRGoster(is)}
    style={{ padding: "7px 10px", borderRadius: 9, background: T.statCard, border: `1px solid ${T.border}`, color: T.textSec, cursor: "pointer", fontSize: 13 }}>
    QR
  </button>

  {/* 🗑️ SİLME TUŞU */}
  <button onClick={() => isSil(is.id, is.docId)} 
    style={{ 
      padding: "7px 10px", borderRadius: 9, background: T.danger + "15", 
      border: `1px solid ${T.danger}30`, color: T.danger, cursor: "pointer", fontSize: 13 
    }}>
    🗑️
  </button>

  {is.status === "teslim_edildi" && (
    <>
      <button onClick={() => setShowIade(is)}
        style={{ padding: "7px 10px", borderRadius: 9, background: "#7C3AED15", border: "1px solid #7C3AED30", color: "#7C3AED", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>🔄 {t("iade")}</button>
      <button onClick={() => {
        const tel = (is.musteriTel || "").replace(/\D/g, "");
        const waTel = tel.startsWith("0") ? "90" + tel.slice(1) : tel;
        const mesaj = `Sayın ${is.musteriAdi} 🧹\nHalılarınız teslim edildi. Hizmetimizden memnun kaldınız mı?\nTeşekkürler! — ${isletme.ad || kullanici.sirket || "Halı Yıkama Fabrikası"}`;
        linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent(mesaj)}`);
      }} style={{ padding: "7px 10px", borderRadius: 9, background: T.success + "15", border: `1.2px solid ${T.success}30`, color: T.success, cursor: "pointer", fontSize: 11, fontWeight: 600 }}>⭐ Puan</button>
    </>
  )}
</div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };
const renderSaha = () => {
  const patronMu = kullanici?.rol === "patron";
  const kullanıcıRolId = kullanici?.rol; 
  const aktifRol = personelRolleri.find(r => r.id === kullanıcıRolId) || {};
  const ayarlar = bildirimKurallari || {}; 

  // 1. Yetki Kontrolü
  const yetkiVarmi = (statusKey) => {
    if (patronMu) return true;
    const salterAcikMi = aktifRol.yetkiler?.[statusKey] === true || 
                        aktifRol.yetkiler?.[`yetki_${statusKey}`] === true ||
                        aktifRol.yetkiler?.[`stat_${statusKey}`] === true;
    if (salterAcikMi) return true;
    const izinliRoller = ayarlar[statusKey] || [];
    return izinliRoller.includes(kullanıcıRolId);
  };

  const sahaAnaYetkisi = patronMu || aktifRol.yetkiler?.yetki_saha === true;

  if (!sahaAnaYetkisi) {
    return (
      <div style={{ padding: 20, textAlign: "center", color: T.danger, marginTop: 50 }}>
        <div style={{ fontSize: 40, marginBottom: 10 }}>🛑</div>
        <h3>Saha Yetkisi Kapalı</h3>
        <button onClick={() => setSayfa("anaSayfa")} style={{marginTop:20, padding:"10px 20px", borderRadius:12, background:T.primary, color:"#fff", border:"none"}}>Geri Dön</button>
      </div>
    );
  }

  // 🚀 HARİTA VE ROTA MANTIĞI (BEYİN)
  const haritaIkonuGetir = (is) => {
    if (haritaModu === "alinacak") return "📍"; 
    if (haritaModu === "teslim") return "🚚";   
    return "📍";
  };

  const haritaVerisi = isler.filter(is => {
    // Statü isimlerinin senin Firebase yapınla uyumlu olduğundan emin ol (adres_bekliyor veya alinacak)
    if (haritaModu === "alinacak") return is.status === "alinacak" || is.status === "adres_bekliyor";
    if (haritaModu === "teslim") return is.status === "teslim_hazir" || is.status === "dagitimda";
    return false;
  });

  // 🔥 YETKİ KONTROLLERİ YENİ SİSTEME GÖRE MÜHÜRLENDİ
  const gosterAlimRotasi = yetkiVarMi("sekme_alinacak");
  const gosterTeslimRotasi = yetkiVarMi("sekme_dagitimda") || yetkiVarMi("sekme_hazir");

  return (
    <div style={{ height: "100%", overflowY: "auto", padding: 16 }}>
      
      {/* 🗺️ HIZLI ARAÇLAR (3 SÜTUNLU SADE TASARIM) */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
        
        {/* 1. Alım Haritası */}
        {gosterAlimRotasi && (
          <button onClick={() => setHaritaModu(haritaModu === "alinacak" ? null : "alinacak")}
            style={{ 
              padding: "14px 8px", borderRadius: 16, 
              background: haritaModu === "alinacak" ? T.warning : T.warning + "15", 
              border: `1.5px solid ${T.warning}`, 
              color: haritaModu === "alinacak" ? "#fff" : T.warning, 
              cursor: "pointer", fontSize: 13, fontWeight: 800, textAlign: "center" 
            }}>
            📍 Alım
          </button>
        )}

        {/* 2. Teslim Haritası */}
        {gosterTeslimRotasi && (
          <button onClick={() => setHaritaModu(haritaModu === "teslim" ? null : "teslim")}
            style={{ 
              padding: "14px 8px", borderRadius: 16, 
              background: haritaModu === "teslim" ? T.primary : T.primary + "15", 
              border: `1.5px solid ${T.primary}`, 
              color: haritaModu === "teslim" ? "#fff" : T.primary, 
              cursor: "pointer", fontSize: 13, fontWeight: 800, textAlign: "center" 
            }}>
            🚚 Teslim
          </button>
        )}

        {/* 3. QR Tara (Hata Giderildi: setShowQRTara kullanıldı) */}
        <button onClick={() => setShowQRTara(true)}
          style={{ 
            padding: "14px 8px", borderRadius: 16, 
            background: T.card, border: `1.2px solid ${T.border}`, 
            color: T.text, cursor: "pointer", fontSize: 13, 
            fontWeight: 800, textAlign: "center" 
          }}>
          📷 QR Tara
        </button>
      </div>

      {/* 📍 DİNAMİK ROTA / HARİTA LİSTESİ */}
      {haritaModu && (
        <div style={{ marginBottom: 20, borderRadius: 18, overflow: "hidden", border: `2px solid ${haritaModu === "alinacak" ? T.warning : T.primary}`, background: T.card, boxShadow: "0 6px 15px rgba(0,0,0,0.15)" }}>
          <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: haritaModu === "alinacak" ? T.warning + "10" : T.primary + "10" }}>
            <span style={{ fontWeight: 800, fontSize: 13, color: T.text }}>
              {haritaModu === "alinacak" ? "📍 Alınacak Adresler" : "🚚 Dağıtılacak Paketler"}
            </span>
            <button onClick={() => setHaritaModu(null)} style={{ background: T.danger, border: "none", color: "#fff", fontWeight: 800, padding: "5px 12px", borderRadius: 10, fontSize: 11, cursor: "pointer" }}>KAPAT</button>
          </div>
          
          <div style={{ maxHeight: 350, overflowY: "auto", padding: 12, background: "#f1f5f9" }}>
            {haritaVerisi.length > 0 ? (
              haritaVerisi.map(is => (
                <div key={is.id} 
                  onClick={() => {
                    const adres = is.musteriAdres || is.adres;
                    if(adres) window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(adres)}`, '_blank');
                  }} 
                  style={{ padding: "14px", background: "#fff", marginBottom: 10, borderRadius: 14, border: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 12, boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                  <div style={{ fontSize: 24 }}>{haritaIkonuGetir(is)}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 800, fontSize: 15, color: T.text }}>{is.musteriAdi}</div>
                    <div style={{ fontSize: 12, color: T.textSec, marginTop: 2 }}>{is.musteriAdres || is.adres || "Adres bilgisi yok"}</div>
                  </div>
                  <div style={{ background: T.success + "15", padding: "8px", borderRadius: 10, color: T.success, fontSize: 18 }}>🧭</div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "40px 20px", color: T.textSec, fontSize: 14 }}>
                📭 Bu rotada bekleyen iş bulunmuyor.
              </div>
            )}
          </div>
          <div style={{ padding: "8px", textAlign: "center", fontSize: 10, color: T.textSec, background: "#fff" }}>
            * Adrese tıklayarak navigasyonu başlatabilirsiniz.
          </div>
        </div>
      )}
{/* 📋 DİNAMİK STATÜ LİSTELERİ (YETKİ KONTROLLÜ & SIRALI) */}
      {["adres_bekliyor", "aracta", "beklemede", "yikaniyor", "kurutuluyor", "fason", "teslim_hazir", "dagitimda"].map(sKey => {
        
        // 🛡️ Statü anahtarlarını Yetki ID'leri ile eşleştiriyoruz
        const yetkiMap = {
          "adres_bekliyor": "stat_alinacak",
          "aracta": "stat_aracta",
          "beklemede": "stat_yikanacak",
          "yikaniyor": "stat_yikaniyor",
          "kurutuluyor": "stat_kurutuluyor",
          "fason": "stat_fason",
          "teslim_hazir": "stat_hazir",
          "dagitimda": "stat_dagitimda"
        };

        // Eğer bu statü için yetki yoksa bu bölümü hiç render etme
        if (!yetkiVarMi(yetkiMap[sKey])) return null;

        const liste = isler.filter(is => is.status === sKey);
        const meta = STATÜLER_META[sKey];
        if (!meta) return null;

        return (
          <div key={sKey} style={{ marginBottom: 24 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
              <span style={{ fontSize: 20 }}>{meta.icon}</span>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: meta.renk }}>{t("k_" + sKey)}</h3>
              <div style={{ background: meta.renk, color: "#fff", borderRadius: 10, padding: "2px 10px", fontSize: 12, fontWeight: 800 }}>
                {liste.length}
              </div>
            </div>

            {liste.length === 0 ? (
              <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 20, textAlign: "center", color: T.textSec, fontSize: 13 }}>
                {meta.icon} Bu aşamada bekleyen iş yok.
              </div>
            ) : (
              liste.map(is => (
                <div key={is.id} style={{ background: T.card, border: `1.5px solid ${meta.renk}40`, borderRadius: 16, padding: 14, marginBottom: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 700, color: T.text }}>{is.musteriAdi}</div>
                      <div style={{ fontSize: 13, color: T.textSec, marginTop: 2 }}>{is.musteriTel}</div>
                      <div style={{ fontSize: 15, fontWeight: 800, color: meta.renk, marginTop: 4 }}>
                        ₺{formatPara(is.hesaplama?.genelToplam || 0)}
                      </div>
                    </div>
                    <div style={{ fontSize: 22, opacity: 0.5 }}>{meta.icon}</div>
                  </div>

                  {/* 🛠️ DURUM AKSİYON BUTONLARI */}
                  <div style={{ marginTop: 12 }}>
                    {sKey === "adres_bekliyor" && <button onClick={() => setShowHaliAl(is)} style={{ width: "100%", padding: "13px", borderRadius: 12, background: T.success, color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>✓ Halı Al → m² Gir</button>}
                    
                    {sKey === "aracta" && <button onClick={() => durumGunc(is.id, "beklemede")} style={{ width: "100%", padding: "13px", borderRadius: 12, background: T.primary, color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>🏭 Dükkana Geldi</button>}
                    
                    {sKey === "beklemede" && <button onClick={() => durumGunc(is.id, "yikaniyor")} style={{ width: "100%", padding: "13px", borderRadius: 12, background: "#3B82F6", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>🫧 Yıkamaya Al</button>}

                    {sKey === "yikaniyor" && <button onClick={() => durumGunc(is.id, "kurutuluyor")} style={{ width: "100%", padding: "13px", borderRadius: 12, background: "#F59E0B", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>💨 Kurutmaya Al</button>}

                    {sKey === "kurutuluyor" && <button onClick={() => durumGunc(is.id, "teslim_hazir")} style={{ width: "100%", padding: "13px", borderRadius: 12, background: "#22C55E", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>📦 Paketlendi / Hazır</button>}
                    
                    {sKey === "teslim_hazir" && <button onClick={() => durumGunc(is.id, "dagitimda")} style={{ width: "100%", padding: "13px", borderRadius: 12, background: "#A855F7", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>🚐 Dağıtıma Çıkar</button>}
                    
                    {sKey === "dagitimda" && <button onClick={() => { durumGunc(is.id, "teslim_edildi"); setShowTahsilat(is); }} style={{ width: "100%", padding: "13px", borderRadius: 12, background: T.primary, color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>💵 Teslim Et / Tahsilat</button>}
                  </div>
                </div>
              ))
            )}
          </div>
        );
      })}

      {/* 🏭 GENEL ÖZET */}
      {(patronMu || kullanıcıRolId === "yikamaci") && (
        <div style={{ marginTop: 10, padding: 12, background: T.statCard, borderRadius: 16 }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, color: T.textSec, margin: "0 0 10px" }}>🏭 Dükkan Genel Durumu</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6 }}>
            {["aracta", "beklemede", "yikaniyor", "kurutuluyor"].map(k => (
              <div key={k} style={{ textAlign: "center" }}>
                <div style={{ fontSize: 16 }}>{STATÜLER_META[k]?.icon}</div>
                <div style={{ fontSize: 18, fontWeight: 900 }}>{sayac[k] || 0}</div>
                <div style={{ fontSize: 9, color: T.textSec }}>{t("k_" + k)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
const renderMusteriler = () => {
  return (
    <div style={{height:"100%",display:"flex",flexDirection:"column"}}>
      <div style={{padding:"12px 16px",background:T.bg,borderBottom:`1px solid ${T.border}`,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:10,background:T.card,border:`1.5px solid ${T.inputBorder}`,
          borderRadius:14,padding:"11px 14px",marginBottom:10}}>
          <span style={{color:T.textSec,fontSize:18}}>🔍</span>
          <input value={aramaMetni} onChange={e=>setAramaMetni(e.target.value)} placeholder="Ad, telefon, semt..."
            style={{background:"none",border:"none",outline:"none",color:T.text,fontSize:15,flex:1}}/>
        </div>
        
        {/* 🚀 DİNAMİK GRUP FİLTRELERİ BAŞLADI */}
        <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:2}}>
          <button onClick={()=>setMusteriGrupFiltre("hepsi")}
            style={{padding:"7px 12px",borderRadius:9,border:`1.5px solid ${musteriGrupFiltre==="hepsi"?T.primary:T.border}`,
              background:musteriGrupFiltre==="hepsi"?T.primary:"transparent",color:musteriGrupFiltre==="hepsi"?"#fff":T.textSec,
              cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",flexShrink:0}}>Tümü</button>
          
          {/* Senin oluşturduğun özel gruplar buraya otomatik dizilir */}
          {musteriGruplari.map(g => (
            <button key={g.id} onClick={()=>setMusteriGrupFiltre(g.id)}
              style={{padding:"7px 12px",borderRadius:9,border:`1.5px solid ${musteriGrupFiltre===g.id?g.renk:T.border}`,
                background:musteriGrupFiltre===g.id?g.renk:"transparent",color:musteriGrupFiltre===g.id?"#fff":T.textSec,
                cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",flexShrink:0}}>
              {g.icon} {g.ad}
            </button>
          ))}
          
          {/* Teknik Filtreler */}
          <button onClick={()=>setMusteriGrupFiltre("borclu")}
            style={{padding:"7px 12px",borderRadius:9,border:`1.5px solid ${musteriGrupFiltre==="borclu"?T.danger:T.border}`,
              background:musteriGrupFiltre==="borclu"?T.danger:"transparent",color:musteriGrupFiltre==="borclu"?"#fff":T.textSec,
              cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",flexShrink:0}}>⚠️ Borçlu</button>
          <button onClick={()=>setMusteriGrupFiltre("6ay")}
            style={{padding:"7px 12px",borderRadius:9,border:`1.5px solid ${musteriGrupFiltre==="6ay"?T.warning:T.border}`,
              background:musteriGrupFiltre==="6ay"?T.warning:"transparent",color:musteriGrupFiltre==="6ay"?"#fff":T.textSec,
              cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",flexShrink:0}}>⏰ 6+ Ay</button>
        </div>
        {/* 🚀 DİNAMİK GRUP FİLTRELERİ BİTTİ */}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"12px 16px"}}>
        {musteriler.filter(m=>{
          const metinEslesti = (m.ad||"").toLowerCase().includes(aramaMetni.toLowerCase()) || 
                               (m.tel||"").includes(aramaMetni) || 
                               (m.semt||"").toLowerCase().includes(aramaMetni.toLowerCase());
          
          if(!metinEslesti) return false;

      if(musteriGrupFiltre === "hepsi") return true;
      if(musteriGrupFiltre === "borclu") return (m.borc||0) > 0;
      
      if(musteriGrupFiltre === "6ay"){
        const mKimlik = m.id || m.docId;
        const mIs = isler.filter(is => 
          is.musteriId === mKimlik || 
          (m.id && is.musteriId === m.id) || 
          (m.docId && is.musteriId === m.docId)
        );

        // Hiç işi yoksa bu müşteriyi "kayıp" kabul et ve listele
        if (!mIs.length) return true;

        // En son yapılan işi bul
        const sonIs = mIs.reduce((son, is) => {
          if (!son) return is;
          return (new Date(is.alisTarihi) > new Date(son.alisTarihi)) ? is : son;
        }, null);

        // Son işin üzerinden 180 gün geçmiş mi?
        return sonIs && gunFarki(sonIs.alisTarihi) > 180;
      }

      // 🚀 Dinamik gruplar (VIP, Kurumsal, Otel vb.) için ana kontrol
      return String(m.grup).trim() === String(musteriGrupFiltre).trim();

        }).map(m=>{
          const mIs=isler.filter(is=>is.musteriId===m.id);
          const ciro=mIs.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
          
          // 🏷️ Aktif grubu bul (ikonu göstermek için)
          const aktifGrup = musteriGruplari.find(gx => gx.id === m.grup);

          return (
            <div key={m.id} style={{background:T.card,border:`1.5px solid ${T.border}`,borderRadius:16,padding:14,marginBottom:10}}>
              <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                <div style={{width:48,height:48,borderRadius:14,background:aktifGrup?.renk || T.primary,display:"flex",alignItems:"center",
                  justifyContent:"center",fontSize:20,fontWeight:800,color:"#fff",flexShrink:0}}>{aktifGrup?.icon || (m.ad||"?")[0]}</div>
                <div style={{flex:1,minWidth:0}}>
                  <button onClick={()=>setShowMusteriProfil(m)}
                    style={{fontSize:16,fontWeight:700,background:"none",border:"none",color:T.primary,cursor:"pointer",
                      padding:0,textAlign:"left",width:"100%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    {m.ad}
                  </button>
                  <div style={{fontSize:13,color:T.textSec}}>{m.tel}{m.tel2?" / "+m.tel2:""}</div>
                  <div style={{display:"flex",gap:6,alignItems:"center",marginTop:3}}>
                    <Yildiz puan={m.yildiz||0} boyut={13}/>
                    <span style={{fontSize:11,color:T.textSec}}>{mIs.length} iş • ₺{ciro.toFixed(0)}</span>
                    {m.grup&&m.grup!=="Normal"&&aktifGrup && <Badge renk={aktifGrup.renk}>{aktifGrup.ad}</Badge>}
                  </div>
                  
                  {/* 🚀 EKLENEN KISIM BURASI */}
                  {m.notlar && (
                    <div style={{
                      marginTop: 8, 
                      fontSize: 12, 
                      color: T.textSec, 
                      whiteSpace: "pre-wrap", 
                      background: T.warning + "10", 
                      padding: "6px", 
                      borderRadius: 6, 
                      border: `1px solid ${T.warning}30`
                    }}>
                      {m.notlar}
                    </div>
                  )}

                </div>
                <div style={{display:"flex",gap:4,flexShrink:0}}>
                  <button onClick={()=>setShowMusteriForm({...m, ekBorc: "", ekBorcTarih: "", ekBorcNot: ""})} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:18}} title="Düzenle">✏️</button>
                  {/* PATRON İÇİN SİLME BUTONU */}
                  {kullanici?.rol === "patron" && (
                    <button 
                      onClick={(e) => {
                        e.stopPropagation(); // Yanlışlıkla profili açmasını engeller
                        musteriSil(m.id, m.docId);
                      }} 
                      style={{background:"none", border:"none", color:T.danger, cursor:"pointer", fontSize:18}}
                      title="Müşteriyi Sil"
                    >
                      🗑️
                    </button>
                  )}
                </div>
              </div>
              {(m.borc||0)>0&&(
                <div style={{marginTop:10,padding:"7px 12px",background:T.danger+"12",borderRadius:9,
                  fontSize:13,color:T.danger,fontWeight:700,display:"flex",justifyContent:"space-between"}}>
                  <span>⚠️ {t("borç")}</span><span>₺{(m.borc).toFixed(2)}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
  };

  const renderKasa = () => {
    const donemFiltre = (is) => {
      const tarih = is.tahsilat?.tarih || "";
      if (donem === "bugun") return tarih === bugun();
      if (donem === "hafta") { const p = tarih.split("."); if (p.length !== 3) return false; return (Date.now() - new Date(+p[2], +p[1] - 1, +p[0]).getTime()) / 86400000 <= 7; }
      if (donem === "ay") { const p = tarih.split("."); if (p.length !== 3) return false; return +p[1] === new Date().getMonth() + 1 && +p[2] === new Date().getFullYear(); }
      return true;
    };

    // 💰 1. NORMAL TAHSİLATLAR
    const donemIsler = isler.filter(is => is.tahsilat && donemFiltre(is));
    const nakit = donemIsler.reduce((s, is) => s + (is.tahsilat?.nakit || 0), 0);
    const kart = donemIsler.reduce((s, is) => s + (is.tahsilat?.kart || 0), 0);
    
    // 💰 2. ESKİ BORÇ TAHSİLATLARI (Fişten ve Kişi Profilinden Gelenler)
    const eskiIsTahsilat = donemIsler.reduce((s, is) => s + (is.tahsilat?.eskiBorcTahsilat || 0), 0);
    const hariciBorcTahsilat = giderler.filter(g => g.tutar < 0).reduce((s, g) => s + Math.abs(g.tutar), 0); 
    const eski = eskiIsTahsilat + hariciBorcTahsilat; 
    
    // 💰 3. KASA ÖZETİ VE KÂR
    const toplamGelir = nakit + kart + eski;
    const toplamGider = giderler.filter(g => g.tutar > 0).reduce((s, g) => s + g.tutar, 0);
    const netKar = toplamGelir - toplamGider;

    // 🚀 BEYİN: DÜKKANIN DIŞARIDAKİ PARASI (Tüm Müşterilerin Toplam Borcu)
    const gercekToplamBorc = musteriler.reduce((s, m) => s + (m.borc || 0), 0);

    return (
      <div style={{ height: "100%", overflowY: "auto", padding: 16 }}>

        {/* 👑 PATRON ÖZEL: ANLIK DURUM ÖZETİ (En Tepede) */}
        {kullanici?.rol === "patron" && (
          <div style={{
            background: `linear-gradient(135deg, ${T.primary}, #4f46e5)`,
            padding: "20px",
            borderRadius: 24,
            marginBottom: 20,
            color: "#fff",
            boxShadow: "0 10px 25px rgba(79, 70, 229, 0.2)"
          }}>
            <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 4 }}>Dükkan Genel Sağlık Özeti</div>
            <div style={{ fontSize: 24, fontWeight: 900, marginBottom: 16 }}>
              ₺{formatPara(sayac.toplamCiro || 0)} <span style={{ fontSize: 14, fontWeight: 400, opacity: 0.7 }}>Tahsil Edilen</span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div style={{ background: "rgba(255,255,255,0.15)", padding: "12px", borderRadius: 16 }}>
                <div style={{ fontSize: 11, opacity: 0.9 }}>Dışarıdaki Para</div>
                {/* 🚀 BEYİN: Gerçek Dışarıdaki Parayı Buraya Bastık */}
                <div style={{ fontSize: 16, fontWeight: 700 }}>₺{formatPara(gercekToplamBorc)}</div>
              </div>
              <div style={{ background: "rgba(255,255,255,0.15)", padding: "12px", borderRadius: 16 }}>
                <div style={{ fontSize: 11, opacity: 0.9 }}>Bekleyen İş Yükü</div>
                <div style={{ fontSize: 16, fontWeight: 700 }}>{sayac.adres_bekliyor + sayac.teslim_hazir} Adet</div>
              </div>
            </div>
          </div>
        )}

        {/* 📅 DÖNEM FİLTRE BUTONLARI */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6, marginBottom: 16 }}>
          {[["bugun", "Bugün"], ["hafta", "Hafta"], ["ay", "Ay"], ["tumu", "Tümü"]].map(([v, l]) => (
            <button key={v} onClick={() => setDonem(v)}
              style={{
                padding: "9px", borderRadius: 10, border: `1.5px solid ${donem === v ? T.primary : T.border}`,
                background: donem === v ? T.primary : "transparent", color: donem === v ? "#fff" : T.textSec,
                cursor: "pointer", fontSize: 12, fontWeight: 600
              }}>{l}</button>
          ))}
        </div>

       {/* 💰 KASA VE BORÇ ÖZET KARTLARI */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          {[
            { l: "💵 Nakit", v: nakit, c: T.success }, 
            { l: "💳 Kart", v: kart, c: T.primary },
            { l: "🔄 Tahsil Edilen Borç", v: eski, c: T.warning }, 
            { l: "⚠️ Müşteri Borçları", v: gercekToplamBorc, c: T.danger }
          ].map((k, i) => (
            <div key={i} style={{ background: T.card, border: `1px solid ${k.c}30`, borderRadius: 14, padding: "14px 16px" }}>
              <div style={{ fontSize: 12, color: k.c, fontWeight: 600, marginBottom: 4 }}>{k.l}</div>
              <div style={{ fontSize: 18, fontWeight: 900, color: k.c }}>₺{formatPara(k.v)}</div>
            </div>
          ))}
          
          {/* 💰 TOPLAM KASA (Giren Para - Boydan Boya) */}
          <div style={{ gridColumn: "1 / -1", background: T.card, border: `1.5px solid ${T.text}30`, borderRadius: 14, padding: "14px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 14, color: T.text, fontWeight: 700 }}>💰 Toplam Kasa (Giren)</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: T.text }}>₺{formatPara(toplamGelir)}</div>
          </div>
        </div>

        {/* ⚙️ DURUM DAĞILIMI */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 14, marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 12 }}>⚙️ Durum Dağılımı</div>
          {STATÜ_SIRASI.map(k => {
            const meta = STATÜLER_META[k];
            const count = isler.filter(is => is.status === k).length;
            const top = isler.filter(is => is.status === k).reduce((s, is) => s + (is.hesaplama?.genelToplam || 0), 0);
            if (!count) return null;
            return (
              <div key={k} style={{
                display: "flex", alignItems: "center", justifyItems: "center", justifyContent: "space-between",
                marginBottom: 8, padding: "9px 12px", background: T.statCard, borderRadius: 10
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 16 }}>{meta.icon}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: meta.renk }}>{t("k_" + k)}</div>
                    <div style={{ fontSize: 11, color: T.textSec }}>{count} iş</div>
                  </div>
                </div>
                <span style={{ fontSize: 14, fontWeight: 700, color: meta.renk }}>₺{formatPara(top)}</span>
              </div>
            );
          }).filter(Boolean)}
        </div>

       {/* 🏆 NET KÂR KARTI */}
        {giderler.length > 0 && (
          <div style={{ background: T.card, border: `1.5px solid ${T.success}30`, borderRadius: 14, padding: 14, marginBottom: 14 }}>
            <div style={{ fontSize: 12, color: T.textSec, marginBottom: 4 }}>🏆 Net Kâr (Gelir - Gider)</div>
            
            <div style={{ fontSize: 22, fontWeight: 900, color: netKar >= 0 ? T.success : T.danger }}>
              ₺{formatPara(netKar)}
            </div>
            
            <div style={{ fontSize: 11, color: T.textSec, marginTop: 2 }}>
              Toplam Gider: ₺{formatPara(toplamGider)}
            </div>
          </div>
        )}
        
        {/* 📤 SON GİDERLER ÖZETİ */}
        {giderler.length > 0 && (
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 14, marginBottom: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: T.text }}>📤 Son Giderler</div>
              <button onClick={() => setSayfa("raporlar")} style={{ padding: "5px 10px", borderRadius: 8, background: T.primary + "12", border: `1.5px solid ${T.primary}30`, color: T.primary, cursor: "pointer", fontSize: 11, fontWeight: 600 }}>Tümü →</button>
            </div>
            {giderler.slice(-4).reverse().map(g => (
              <div key={g.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px", background: T.statCard, borderRadius: 10, marginBottom: 6 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: T.text }}>{g.kategori}</div>
                  <div style={{ fontSize: 11, color: T.textSec }}>{g.tarih}{g.aciklama ? " — " + g.aciklama : ""}</div>
                </div>
                <span style={{ fontSize: 13, fontWeight: 700, color: T.danger }}>₺{formatPara(g.tutar)}</span>
              </div>
            ))}
          </div>
        )}

        {/* 📊 RAPORLARA GİT BUTONU */}
        <button onClick={() => setSayfa("raporlar")} style={{ width: "100%", padding: "13px", borderRadius: 14, background: T.primary + "15", border: `1.5px solid ${T.primary}30`, color: T.primary, cursor: "pointer", fontSize: 14, fontWeight: 700, marginBottom: 14, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          📊 Detaylı Raporlar & Analiz →
        </button>

        {/* 👑 EN İYİ MÜŞTERİLER */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 12 }}>👑 En İyi Müşteriler</div>
          {[...musteriler].sort((a, b) => {
            const aC = isler.filter(i => i.musteriId === a.id).reduce((s, i) => s + (i.tahsilat?.kasayaGiren || 0), 0);
            const bC = isler.filter(i => i.musteriId === b.id).reduce((s, i) => s + (i.tahsilat?.kasayaGiren || 0), 0);
            return bC - aC;
          }).slice(0, 5).map((m, i) => {
            const mCiro = isler.filter(is => is.musteriId === m.id).reduce((s, is) => s + (is.tahsilat?.kasayaGiren || 0), 0);
            if (!mCiro) return null;
            return (
              <div key={m.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{
                    width: 26, height: 26, borderRadius: "50%", background: T.primary, color: "#fff", fontSize: 12, fontWeight: 700,
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                  }}>{i + 1}</div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: T.text }}>{m.ad}</div>
                    <div style={{ fontSize: 11, color: T.textSec }}>{m.semt}</div>
                  </div>
                </div>
                <span style={{ fontSize: 14, fontWeight: 700, color: T.success }}>₺{formatPara(mCiro)}</span>
              </div>
            );
          }).filter(Boolean)}
        </div>
      </div>
    );
  };

const renderAyarlar = () => {
  // 🛡️ GENEL YETKİ KONTROLÜ (Tüm alt sayfalar için geçerli bekçiler)

    const patronMu = kullanici?.rol === "patron"; 
    const aktifRol = personelRolleri.find(r => r.id === kullanici?.rol) || {};

  // 1. 🏢 İŞLETME BİLGİLERİ SAYFASI
  if (altSayfa === "isletme") {
    // Şalter kontrolü: Patron değilse ve 'isletme' yetkisi kapalıysa engelle
    if (!patronMu && !aktifRol.yetkiler?.isletme) {
      return <YetkiYokEkrani setAltSayfa={setAltSayfa} T={T} />;
    }

    return (
      <div style={{ height: "100%", overflowY: "auto" }}>
        <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 16 }}>←</button>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>{t("isletme")}</h2>
        </div>
        <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12 }}>
          {[
            ["Şirket Adı", "ad"], 
            ["Yönetici (Sahip)", "sahip"], 
            ["Vergi No", "vergiNo"], 
            ["Dükkan Adresi", "adres"], 
            ["IBAN", "iban"], 
            ["IBAN Adı", "ibanAd"], 
            ["Telefon 1", "tel"], 
            ["Telefon 2", "tel2"], 
            ["Telefon 3", "tel3"]
          ].map(([l, k]) => (
            <Inp 
              key={k} 
              label={l} 
              value={(k === "tel" || k === "tel2" || k === "tel3") ? (isletme[k] || "+90 ") : (isletme[k] || "")} 
              onChange={v => {
                const yeniDeger = (k === "tel" || k === "tel2" || k === "tel3") ? formatTel(v) : v;
                setIsletme(p => ({ ...p, [k]: yeniDeger }));
              }} 
              T={T} 
              placeholder={(k === "tel" || k === "tel2" || k === "tel3") ? "+90 5XX XXX XX XX" : l}
            />
          ))}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 6 }}>Ortalama Teslim Süresi (Gün)</label>
            <input type="number" value={isletme.teslimGun || 7} onChange={e => setIsletme(p => ({ ...p, teslimGun: +e.target.value || 7 }))}
              style={{ width: "100%", padding: "13px 14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
          </div>
          <button onClick={async () => {
            try {
              const userRef = doc(db, "kullanicilar", kullanici.email);
              await updateDoc(userRef, { isletmeAyarlari: isletme });
              const guncelK = { ...kullanici, isletmeAyarlari: isletme };
              setKullanici(guncelK);
              localStorage.setItem("halici_k", JSON.stringify(guncelK));
              setAltSayfa(null);
              alert("✅ Bilgiler buluta mühürlendi!");
            } catch (err) { alert("❌ Hata: " + err.message); }
          }} style={{ padding: "14px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", cursor: "pointer", fontSize: 15, fontWeight: 700 }}>✅ {t("kaydet")}</button>
        </div>
      </div>
    );
  }

  // 2. 🔔 BİLDİRİM YÖNETİMİ SAYFASI
  if (altSayfa === "bildirimAyarlari") {
    // Şalter kontrolü: Bildirim/Ayarlar yetkisi yoksa engelle
    if (!patronMu && !aktifRol.yetkiler?.ayarlar) {
      return <YetkiYokEkrani setAltSayfa={setAltSayfa} T={T} />;
    }

    const rolToggle = (durum, rolId) => {
      setBildirimKurallari(prev => {
        const mevcutRoller = prev[durum] || [];
        const yeni = mevcutRoller.includes(rolId) ? mevcutRoller.filter(r => r !== rolId) : [...mevcutRoller, rolId];
        const guncellenmis = { ...prev, [durum]: yeni };
        localStorage.setItem("halici_bildirim_kurallari", JSON.stringify(guncellenmis));
        updateDoc(doc(db, "kullanicilar", kullanici.email), { bildirimKurallari: guncellenmis });
        return guncellenmis;
      });
    };

    return (
      <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
        <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer" }}>←</button>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>🔔 Bildirim Yönetimi</h2>
        </div>
        <div style={{ padding: 16 }}>
          <div style={{ padding: "12px 14px", background: T.primary + "12", borderRadius: 12, marginBottom: 16, fontSize: 13, color: T.primary, lineHeight: 1.4 }}>
            💡 Her statü değişiminde hangi role bildirim gideceğini seçin. Seçimler anında buluta mühürlenir.
          </div>
          {STATÜ_SIRASI.map(durum => {
            const meta = STATÜLER_META[durum];
            const aktifRoller = bildirimKurallari[durum] || [];
            return (
              <div key={durum} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 14, marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                  <span style={{ fontSize: 20 }}>{meta.icon}</span>
                  <span style={{ fontSize: 14, fontWeight: 700, color: meta.renk }}>{t("k_" + durum)}</span>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {personelRolleri.map(rol => (
                    <button key={rol.id} onClick={() => rolToggle(durum, rol.id)}
                      style={{
                        padding: "8px 14px", borderRadius: 10,
                        background: aktifRoller.includes(rol.id) ? (rol.renk || T.primary) + "20" : T.bg,
                        border: `1.5px solid ${aktifRoller.includes(rol.id) ? (rol.renk || T.primary) : T.border}`,
                        color: aktifRoller.includes(rol.id) ? (rol.renk || T.primary) : T.textSec,
                        cursor: "pointer", fontSize: 13, fontWeight: aktifRoller.includes(rol.id) ? 700 : 500,
                        display: "flex", alignItems: "center", gap: 6
                      }}>
                      {rol.icon} {rol.ad}
                      {aktifRoller.includes(rol.id) && <span style={{ fontSize: 16, marginLeft: 4 }}>✓</span>}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
// 2. 💰 BİRİM FİYAT LİSTESİ (GÜNCELLENDİ)
    if (altSayfa === "fiyatlar") {
      // 🛡️ PATRON KONTROLÜ (Stratejik Kilit)
      if (kullanici?.rol !== "patron") return <YetkiYokEkrani setAltSayfa={setAltSayfa} T={T} />;

      return (
        <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
          <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12, position: "sticky", top: 0, zIndex: 10 }}>
            <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 16 }}>←</button>
            <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>{t("fiyatlar")}</h2>
            <button onClick={() => setUrunler(p => [...p, { id: "u" + Date.now() + Math.random(), ad: "Yeni Halı Çeşidi", birim: "m2", fiyat: 0 }])}
              style={{ marginLeft: "auto", background: T.success, border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>+ Yeni Çeşit</button>
          </div>

          <div style={{ padding: 16 }}>
            <div style={{ padding: "12px", background: T.primary + "12", borderRadius: 14, marginBottom: 16, fontSize: 13, color: T.primary }}>
              💡 Fiyatları ve isimleri kutucuklara tıklayarak anında güncelleyebilirsiniz.
            </div>

            {urunler.map((u, i) => (
              <div key={u.id} style={{ background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 12 }}>
                {/* Çeşit Adı Düzenleme */}
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: T.textSec, display: "block", marginBottom: 6 }}>Halı Çeşidi / Ürün Adı</label>
                  <input 
                    value={u.ad} 
                    onChange={e => {
                      const yeniAd = e.target.value;
                      setUrunler(p => p.map(item => item.id === u.id ? { ...item, ad: yeniAd } : item));
                    }}
                    style={{ width: "100%", padding: "12px 14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, fontWeight: 600, outline: "none", boxSizing: "border-box" }}
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                  {/* Fiyat Düzenleme */}
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: T.textSec, display: "block", marginBottom: 6 }}>Birim Fiyat (₺)</label>
                    <div style={{ position: "relative" }}>
                      <input 
                        type="number" 
                        value={u.fiyat} 
                        onChange={e => {
                          const yeniFiyat = parseFloat(e.target.value) || 0;
                          setUrunler(p => p.map(item => item.id === u.id ? { ...item, fiyat: yeniFiyat } : item));
                        }}
                        style={{ width: "100%", padding: "12px 30px 12px 14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.warning, fontSize: 16, fontWeight: 800, outline: "none", boxSizing: "border-box" }}
                      />
                      <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: T.textSec, fontWeight: 700 }}>₺</span>
                    </div>
                  </div>

                  {/* Birim Seçimi */}
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: T.textSec, display: "block", marginBottom: 6 }}>Hesap Birimi</label>
                    <select 
                      value={u.birim} 
                      onChange={e => {
                        const yeniBirim = e.target.value;
                        setUrunler(p => p.map(item => item.id === u.id ? { ...item, birim: yeniBirim } : item));
                      }}
                      style={{ width: "100%", padding: "12px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 14, fontWeight: 600, outline: "none" }}>
                      <option value="m2">m² (Metrekare)</option>
                      <option value="adet">Adet (Parça)</option>
                    </select>
                  </div>
                </div>

                {/* Aksiyonlar */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${T.border}`, paddingTop: 12 }}>
                  <span style={{ fontSize: 12, color: T.success, fontWeight: 600 }}>Örn: 10 {u.birim} = ₺{ (10 * u.fiyat).toFixed(0) }</span>
                  <button 
                    onClick={() => {
                      if (urunler.length <= 1) return alert("En az bir fiyat çeşidi kalmalıdır.");
                      if (window.confirm(`"${u.ad}" silinsin mi?`)) {
                        setUrunler(p => p.filter(item => item.id !== u.id));
                      }
                    }} 
                    style={{ background: T.danger + "15", border: "none", color: T.danger, padding: "8px 12px", borderRadius: 10, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                    🗑 Sil
                  </button>
                </div>
              </div>
            ))}
            
            <div style={{ height: 40 }} />
          </div>
        </div>
      );
    }
// 👥 PERSONEL, YETKİ VE ROL YÖNETİMİ (Zarif, Estetik & Tam Fonksiyonel Sürüm)
    else if (altSayfa === "personel") {
      const isPatron = kullanici?.rol === "patron";
      const girisIsmi = (kullanici.ad || "").toLowerCase().trim();

      return (
        <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
          {/* 📌 Header */}
          <div style={{ background: T.header, padding: "14px 18px", display: "flex", alignItems: "center", gap: 12, position: "sticky", top: 0, zIndex: 10 }}>
            <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", borderRadius: 8, width: 34, height: 34, cursor: "pointer", fontSize: 16 }}>←</button>
            <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#fff" }}>Personel & Roller</h2>
          </div>

          <div style={{ padding: 16 }}>
            
            {/* 🔄 BÖLÜM 1: HIZLI ROL DEĞİŞTİR (iPhone Tarzı Kompakt) */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12 }}>
                <h3 style={{ margin: 0, fontSize: 11, fontWeight: 800, color: T.textSec, letterSpacing: 0.8, textTransform: "uppercase" }}>Hızlı Geçiş</h3>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {personelRolleri.map((rol) => {
                  const mevcutPin = kullanici[`pin_${rol.id}`];
                  const suAnkiRol = kullanici.rol === rol.id;

                  return (
                    <button key={rol.id} 
                      onClick={() => {
                        if (suAnkiRol) return;

                        const buRoldekiPersoneller = personeller.filter(p => p.rol === rol.ad && p.aktif !== false);

                        // Eğer rolde 1'den fazla kişi varsa, seçim ekranını aç ve işlemi burada durdur
                        if (buRoldekiPersoneller.length > 1) {
                          setPersonelSecimModal({ rol: rol, kisiler: buRoldekiPersoneller, genelPin: mevcutPin });
                          return; 
                        }

                        let yeniPersonel = null;
                        if (buRoldekiPersoneller.length === 1) {
                          yeniPersonel = { ad: buRoldekiPersoneller[0].ad, id: buRoldekiPersoneller[0].id, pin: buRoldekiPersoneller[0].pin };
                        }

                        // Şifre Kontrolü: Önce personelin kendi şifresine bakar, yoksa rolün genel şifresine bakar
                        const sorulacakPin = yeniPersonel?.pin || mevcutPin;
                        if (sorulacakPin) {
                          const girilen = prompt(`🔒 ${yeniPersonel ? yeniPersonel.ad : rol.ad} Şifresi:`);
                          if (girilen !== sorulacakPin) return alert("❌ Hatalı Şifre!");
                        }

                        const guncelUser = { 
                          ...kullanici, 
                          rol: rol.id,
                          aktifPersonel: yeniPersonel ? { ad: yeniPersonel.ad, id: yeniPersonel.id } : null
                        };
                        setKullanici(guncelUser);
                        localStorage.setItem("halici_k", JSON.stringify(guncelUser));
                      }}
                      style={{ 
                        padding: "12px 10px", borderRadius: 14, 
                        background: suAnkiRol ? (rol.renk || T.primary) : T.card,
                        border: `1.2px solid ${suAnkiRol ? (rol.renk || T.primary) : T.border}`, 
                        cursor: "pointer", display: "flex", alignItems: "center", gap: 10, transition: "all 0.2s"
                      }}>
                      <div style={{ fontSize: 20, width: 34, height: 34, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", background: suAnkiRol ? "rgba(255,255,255,0.2)" : (rol.renk || T.primary) + "15" }}>
                        {rol.icon}
                      </div>
                      <div style={{textAlign: "left"}}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: suAnkiRol ? "#fff" : T.text }}>{rol.ad}</div>
                        {suAnkiRol && <div style={{fontSize: 9, color:"#fff", opacity: 0.8}}>Aktif</div>}
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* 👷 BÖLÜM 2: PERSONEL LİSTESİ (Tam Fonksiyonel) */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <h3 style={{ margin: 0, fontSize: 11, fontWeight: 800, color: T.textSec, letterSpacing: 0.8, textTransform: "uppercase" }}>{isPatron ? "Çalışanlar" : "Profilim"}</h3>
                {isPatron && (
                  <button onClick={() => setPersonelForm({ ad: "", rol: "", tel: "", maas: "", notlar: "" })}
                    style={{ background: T.primary, color: "#fff", border: "none", padding: "6px 12px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Müşteri Ekle</button>
                )}
              </div>
              
              {personeller
                .filter(p => isPatron ? true : (p.ad || "").toLowerCase().includes(girisIsmi))
                .map((p) => (
                <div key={p.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: "12px", marginBottom: 8, display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: T.primary + "12", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: T.primary, fontWeight: 800 }}>{p.ad[0]}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, color: T.text, fontSize: 13 }}>{p.ad}</div>
                    <div style={{ fontSize: 11, color: T.textSec }}>{p.rol}</div>
                  </div>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button onClick={() => setPersonelForm({...p})} style={{ background: T.primary + "10", border: "none", color: T.primary, width: 32, height: 32, borderRadius: 8, cursor: "pointer" }}>✏️</button>
                    {isPatron && (
                      <button onClick={() => { if(window.confirm(`${p.ad} silinsin mi?`)) setPersoneller(prev => prev.filter(x => x.id !== p.id)) }} 
                        style={{ background: T.danger + "10", border: "none", color: T.danger, width: 32, height: 32, borderRadius: 8, cursor: "pointer" }}>🗑️</button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* 🔐 BÖLÜM 3: ROL TANIMLARI */}
            {isPatron && (
              <div style={{ marginBottom: 32 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                  <h3 style={{ margin: 0, fontSize: 11, fontWeight: 800, color: T.textSec, letterSpacing: 0.8, textTransform: "uppercase" }}>Roller & Yetkiler</h3>
                  <button onClick={() => setEditGrup({ id: "yeni_" + Date.now(), ad: "", icon: "👤", renk: T.primary, yetkiler: {} })}
                    style={{ background: "transparent", color: T.primary, border: `1px solid ${T.primary}`, padding: "5px 10px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Yeni Rol</button>
                </div>

                {personelRolleri.map((rol) => {
  const mevcutPin = kullanici[`pin_${rol.id}`];
  return (
    <div key={rol.id} style={{ position: "relative", marginBottom: 8 }}>
      <div onClick={() => setEditGrup({...rol})} 
        style={{ 
          width: "100%", 
          background: T.card, 
          border: `1.1px solid ${T.border}`, 
          borderRadius: 16, 
          padding: "12px", 
          display: "flex", 
          alignItems: "center", 
          gap: 10, 
          cursor: "pointer" 
        }}>
        
        {/* Rol İkonu */}
        <div style={{ 
          width: 36, height: 36, borderRadius: 10, 
          background: (rol.renk || T.primary) + "12", 
          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 
        }}>
          {rol.icon}
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, color: T.text, fontSize: 13 }}>{rol.ad}</div>
          
          {/* 🛡️ ZIRHLI YETKİ SAYACI (Hayalet 49 sayısını bitiren kod) */}
          <div style={{ fontSize: 10, color: T.textSec }}>
            {Object.keys(rol.yetkiler || {}).filter(k => 
              rol.yetkiler[k] === true && TUM_YETKILER.some(y => y.id === k)
            ).length} yetki aktif
          </div>
        </div>
      </div>

      {/* Şifre / PIN Butonu */}
      <button onClick={(e) => { e.stopPropagation(); setSifreSecenekModal(rol); }}
        style={{ 
          position: "absolute", 
          right: 10, 
          top: "50%", 
          transform: "translateY(-50%)", 
          padding: "6px 10px", 
          borderRadius: 8, 
          background: mevcutPin ? T.success + "12" : T.primary + "12", 
          color: mevcutPin ? T.success : T.primary, 
          border: "none", 
          fontSize: 10, 
          fontWeight: 800, 
          cursor: "pointer" 
        }}>
        {mevcutPin ? "PIN" : "+PIN"}
      </button>
    </div>
  );
})}
              </div>
            )}
          </div>
{/* 👷 MODAL: PERSONEL EKLEME FORMU (Tam Fonksiyonel & İki Kutulu) */}
          {personelForm !== null && (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 2000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
                 onClick={() => setPersonelForm(null)}>
              <div style={{ background: T.bg, width: "100%", maxWidth: 500, borderRadius: "24px 24px 0 0", padding: "24px", animation: "slideUp 0.3s ease-out", maxHeight: "85vh", overflowY: "auto" }}
                   onClick={e => e.stopPropagation()}>
                
                <div style={{ width: 40, height: 4, background: T.border, borderRadius: 2, margin: "0 auto 20px" }} />
                
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                  <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: T.text }}>
                    {personelForm.id ? "✏️ Personel Düzenle" : "👷 Yeni Personel"}
                  </h2>
                  <button onClick={() => setPersonelForm(null)} style={{ background: "none", border: "none", color: T.textSec, cursor: "pointer", fontSize: 24 }}>✕</button>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  
                  {/* 🏷️ AD VE SOYAD AYRI KUTULAR */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <Inp 
                      label="Ad(lar) *" 
                      value={personelForm.ad_ham || ""} 
                      onChange={v => {
                        const formatliAd = v.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(' ');
                        setPersonelForm(p => ({ ...p, ad_ham: v, ad_formatli: formatliAd }));
                      }} 
                      T={T} 
                      placeholder="İsimler" 
                    />
                    <Inp 
                      label="Soyad *" 
                      value={personelForm.soyad_ham || ""} 
                      onChange={v => {
                        setPersonelForm(p => ({ ...p, soyad_ham: v, soyad_formatli: v.toUpperCase() }));
                      }} 
                      T={T} 
                      placeholder="SOYİSİM" 
                    />
                  </div>

                  <div>
                    <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 6 }}>Dükkan Rolü *</label>
                    <select value={personelForm.rol || ""} onChange={e => setPersonelForm(p => ({ ...p, rol: e.target.value }))}
                      style={{ width: "100%", padding: "14px", background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, fontSize: 15, outline: "none" }}>
                      <option value="">— Rol Seçin —</option>
                      {personelRolleri.map(rol => (<option key={rol.id} value={rol.ad}>{rol.icon} {rol.ad}</option>))}
                    </select>
                  </div>

                  <Inp 
  label="Telefon" 
  value={personelForm.tel || "+90 "} // 🚀 Burası kritik
  onChange={v => setPersonelForm(p => ({ ...p, tel: formatTel(v) }))} 
  T={T} 
  placeholder="+90 5XX XXX XX XX"
/>

                  {/* MAAŞ FORMATLI KISIM */}
                  <Inp 
                    label="Maaş (₺/ay)" 
                    value={personelForm.maas_gosterim || personelForm.maas || ""} 
                    onChange={v => {
                      const sadeceSayi = v.replace(/[^0-9]/g, ""); 
                      if (!sadeceSayi) {
                        setPersonelForm(p => ({ ...p, maas_gosterim: "", maas: "" }));
                        return;
                      }
                      const gosterim = Number(sadeceSayi).toLocaleString("tr-TR"); 
                      setPersonelForm(p => ({ ...p, maas_gosterim: gosterim, maas: sadeceSayi }));
                    }} 
                    T={T} 
                    placeholder="10.000"
                  />
                  
                  <Inp label="Notlar" value={personelForm.notlar || ""} onChange={v => setPersonelForm(p => ({ ...p, notlar: v }))} T={T} />

                  {/* ŞİFRE ALANI BURAYA EKLENDİ */}
                  <Inp 
                    label="Kişisel Şifre / PIN (Opsiyonel)" 
                    value={personelForm.pin || ""} 
                    onChange={v => setPersonelForm(p => ({...p, pin: v}))} 
                    type="password" 
                    T={T} 
                    placeholder="Sadece ona özel şifre (Örn: 1234)"
                  />

                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12, marginTop: 24 }}>
                  <button onClick={() => setPersonelForm(null)} style={{ padding: "14px", borderRadius: 12, background: "transparent", border: `1.5px solid ${T.border}`, color: T.textSec, fontWeight: 600, cursor: "pointer" }}>İptal</button>
                  <button onClick={async () => {
                    const tamIsim = `${personelForm.ad_formatli || personelForm.ad_ham || ""} ${personelForm.soyad_formatli || personelForm.soyad_ham || ""}`.trim();
                    
                    if (!tamIsim || !personelForm.rol) return alert("Ad, Soyad ve Rol zorunludur!");

                    const guncelVeri = { 
                      ...personelForm, 
                      ad: tamIsim, 
                      tel: formatTel(personelForm.tel),
                      maas: personelForm.maas
                    };

                    let yeniListe;
                    if (personelForm.id) {
                      yeniListe = personeller.map(p => p.id === personelForm.id ? guncelVeri : p);
                    } else {
                      yeniListe = [...personeller, { ...guncelVeri, id: "p" + Date.now(), aktif: true }];
                    }
                    
                    setPersoneller(yeniListe);
                    
                    try {
                      await updateDoc(doc(db, "kullanicilar", kullanici.email), { personeller: yeniListe });
                    } catch(e) { console.error("Personel kayıt hatası:", e); }

                    setPersonelForm(null);
                  }} style={{ padding: "14px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
                    {personelForm.id ? "Güncelle" : "Dükkana Kaydet"}
                  </button>
                </div>
              </div>
            </div>
          )}
         {/* 🛠️ MODAL: ROL DÜZENLEME PANELİ (YETKİLER) */}
{editGrup && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", display: "flex", alignItems: "flex-end", zIndex: 1000 }}>
    <div style={{ 
      background: T.bg, width: "100%", borderTopLeftRadius: 28, borderTopRightRadius: 28, 
      padding: "24px 24px 40px 24px", animation: "slideUp 0.3s ease-out", 
      maxHeight: "92vh", display: "flex", flexDirection: "column" 
    }}>
      
      {/* 🔝 Başlık Bölümü */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <h3 style={{ margin: 0, color: T.text, fontSize: 18, fontWeight: 800 }}>
            {editGrup.id.toString().includes("yeni") ? "✨ Yeni Rol Oluştur" : "🛡️ Rol Yetkilerini Düzenle"}
          </h3>
          <p style={{ margin: 0, fontSize: 12, color: T.textSec, marginTop: 4 }}>Personelin erişebileceği alanları belirleyin.</p>
        </div>
        <button onClick={() => setEditGrup(null)} style={{ background: T.card, border: "none", fontSize: 20, color: T.text, cursor:"pointer", width: 40, height: 40, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
      </div>

      {/* 📝 Rol Temel Bilgileri */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: T.textSec, display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.5 }}>Rol Adı</label>
          <input autoFocus value={editGrup.ad} onChange={e => setEditGrup({ ...editGrup, ad: e.target.value })} placeholder="Örn: Sevkiyatçı" style={{ width: "100%", padding: 14, background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 14, color: T.text, outline: "none", fontSize:15, fontWeight: 600 }} />
        </div>
        <div style={{ width: 85 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: T.textSec, display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.5 }}>İkon</label>
          <input value={editGrup.icon} onChange={e => setEditGrup({ ...editGrup, icon: e.target.value })} style={{ width: "100%", padding: 14, background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 14, textAlign: "center", fontSize: 22 }} />
        </div>
      </div>

      {/* 🔐 YETKİ LİSTESİ (Kaydırılabilir Alan) */}
      <div style={{ flex: 1, overflowY: "auto", paddingRight: 4, marginBottom: 20 }}>
        <label style={{ fontSize: 11, fontWeight: 800, color: T.primary, marginBottom: 12, display: "block", textTransform: "uppercase", letterSpacing: 1 }}>🛡️ YETKİ VE ERİŞİM TANIMLARI</label>
        
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 8 }}>
          {TUM_YETKILER.map((yetki) => {
            const aktif = editGrup.yetkiler ? editGrup.yetkiler[yetki.id] : false;
            return (
              <div 
                key={yetki.id} 
                onClick={() => setEditGrup({ 
                  ...editGrup, 
                  yetkiler: { ...(editGrup.yetkiler || {}), [yetki.id]: !aktif } 
                })} 
                style={{ 
                  display: "flex", alignItems: "center", justifyContent: "space-between", 
                  padding: "14px 16px", borderRadius: 16, background: aktif ? T.primary + "08" : T.input, 
                  cursor: "pointer", border: aktif ? `2px solid ${T.primary}` : `1.5px solid ${T.inputBorder}`,
                  transition: "all 0.2s ease"
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: 14, color: T.text, fontWeight: aktif ? 700 : 500 }}>{yetki.label}</span>
                  <span style={{ fontSize: 10, color: T.textSec, fontWeight: 600, textTransform: "uppercase" }}>{yetki.grup}</span>
                </div>
                
                {/* iPhone Style Switch */}
                <div style={{ 
                  width: 40, height: 22, borderRadius: 20, position: "relative", 
                  background: aktif ? T.primary : "#A0AEC0", transition: "0.3s" 
                }}>
                  <div style={{ 
                    width: 16, height: 16, borderRadius: "50%", background: "#fff", 
                    position: "absolute", top: 3, left: aktif ? 21 : 3, transition: "0.2s",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                  }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 💾 Kaydet Butonu */}
      <button 
        onClick={async () => {
          if (!editGrup.ad) return alert("Lütfen rol adı giriniz!");
          
          let yeniRoller;
          const rolId = editGrup.id.toString().includes("yeni") 
            ? editGrup.ad.toLowerCase().trim().replace(/\s/g, "_") + "_" + Date.now() 
            : editGrup.id;

          const guncelGrup = { ...editGrup, id: rolId };

          if (editGrup.id.toString().includes("yeni")) {
            yeniRoller = [...personelRolleri, guncelGrup];
          } else {
            yeniRoller = personelRolleri.map(x => x.id === editGrup.id ? guncelGrup : x);
          }
          
          setPersonelRolleri(yeniRoller);
          
          try {
            await updateDoc(doc(db, "kullanicilar", kullanici.email), { personelRolleri: yeniRoller });
            setEditGrup(null);
            // Opsiyonel: Başarı bildirimi
          } catch(e) { 
            console.error("Kayıt hatası:", e); 
            alert("❌ Hata: Yetkiler kaydedilemedi!");
          }
        }} 
        style={{ 
          width: "100%", padding: "18px", borderRadius: 16, background: T.primary, 
          color: "#fff", border: "none", fontWeight: 800, fontSize: 16, 
          cursor: "pointer", boxShadow: "0 6px 20px " + T.primary + "40"
        }}
      >
        {editGrup.id.toString().includes("yeni") ? "🚀 Rolü Oluştur ve Kaydet" : "✅ Değişiklikleri Uygula"}
      </button>
    </div>
  </div>
)}
{/* ⚡ YENİ: OTOMATİK GÖREV AKIŞI (PERSONEL SAYFASININ EN ALTI) */}
          {isPatron && (
            <div style={{ marginTop: 32, paddingTop: 24, borderTop: `2px dashed ${T.border}`, paddingBottom: 60 }}>
              <div style={{ marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: 13, fontWeight: 800, color: T.text, letterSpacing: 0.5 }}>⚡ OTOMATİK GÖREV AKIŞI</h3>
                <p style={{ margin: "4px 0 0", fontSize: 11, color: T.textSec }}>Aşamaya göre hangi telefonlara bildirim gideceğini seçin.</p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {STATÜ_SIRASI.map(durum => {
                  const meta = STATÜLER_META[durum];
                  const aktifRoller = bildirimKurallari[durum] || [];
                  return (
                    <div key={durum} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 18, padding: 14 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                        <span style={{ fontSize: 18 }}>{meta.icon}</span>
                        <span style={{ fontSize: 13, fontWeight: 700, color: meta.renk }}>{t("k_" + durum)} Bildirimi</span>
                      </div>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {personelRolleri.map(rol => {
                          const aktif = aktifRoller.includes(rol.id);
                          return (
                            <button key={rol.id} 
                              onClick={() => {
                                const yeniListe = aktif ? aktifRoller.filter(r => r !== rol.id) : [...aktifRoller, rol.id];
                                const güncelKural = { ...bildirimKurallari, [durum]: yeniListe };
                                setBildirimKurallari(güncelKural);
                                // 🔥 Buluta Mühürle
                                updateDoc(doc(db, "kullanicilar", kullanici.email), { bildirimKurallari: güncelKural });
                                localStorage.setItem("halici_bildirim_kurallari", JSON.stringify(güncelKural));
                              }}
                              style={{ 
                                padding: "6px 12px", borderRadius: 10, fontSize: 11, fontWeight: 700, cursor: "pointer", 
                                background: aktif ? (rol.renk || T.primary) + "15" : T.bg, 
                                border: `1.5px solid ${aktif ? (rol.renk || T.primary) : T.border}`, 
                                color: aktif ? (rol.renk || T.primary) : T.textSec 
                              }}>
                              {rol.ad} {aktif && "✓"}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <style>{`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}</style>
        </div>
      );
    }

// 📂 GİDER KATEGORİLERİ YÖNETİM SAYFASI
else if (altSayfa === "giderKategorileri") {
      // ☁️ Buluta Kaydetme Fonksiyonu
      const bulutaKaydet = async (yeniListe) => {
        try {
          await updateDoc(doc(db, "kullanicilar", kullanici.email), {
            giderKategorileri: yeniListe
          });
          console.log("✅ Kategoriler mühürlendi");
        } catch (e) {
          console.error("Bulut hatası:", e);
          alert("❌ Ayarlar kaydedilemedi!");
        }
      };

      return (
        <div style={{ height: "100%", background: T.bg, display: "flex", flexDirection: "column" }}>
          {/* Üst Bar */}
          <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12 }}>
            <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer" }}>←</button>
            <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: "#fff" }}>Gider Kategorileri</h2>
          </div>

          <div style={{ padding: 16, flex: 1, overflowY: "auto" }}>
            <p style={{ fontSize: 13, color: T.textSec, marginBottom: 16 }}>Mevcut kategorileri düzenleyebilir veya silebilirsiniz.</p>
            
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {giderKategorileri.map((kat, index) => (
                <div key={index} style={{ 
                  display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", 
                  background: T.card, border: `1px solid ${T.border}`, borderRadius: 16 
                }}>
                  <div style={{ flex: 1, fontSize: 15, fontWeight: 600, color: T.text }}>{kat}</div>
                  
                  <button onClick={() => {
                    const yeniAd = prompt(`${kat} kategorisinin yeni adını yazın:`, kat);
                    if (yeniAd && yeniAd.trim() !== "" && yeniAd !== kat) {
                      const yeniListe = [...giderKategorileri];
                      yeniListe[index] = yeniAd.trim();
                      setGiderKategorileri(yeniListe);
                      bulutaKaydet(yeniListe);
                    }
                  }} style={{ background: T.primary + "15", border: "none", color: T.primary, padding: "8px 12px", borderRadius: 8, fontSize: 12, fontWeight: 700 }}>
                    Düzenle
                  </button>

                  <button onClick={() => {
                    if (window.confirm(`"${kat}" kategorisini silmek istediğinize emin misiniz?`)) {
                      const yeniListe = giderKategorileri.filter((_, i) => i !== index);
                      setGiderKategorileri(yeniListe);
                      bulutaKaydet(yeniListe);
                    }
                  }} style={{ background: T.danger + "15", border: "none", color: T.danger, padding: "8px 12px", borderRadius: 8, fontSize: 12, fontWeight: 700 }}>
                    Sil
                  </button>
                </div>
              ))}
            </div>
          </div>
          
          <div style={{ padding: 16, background: T.bg, borderTop: `1px solid ${T.border}` }}>
            <button onClick={() => {
              const yeni = prompt("Yeni kategori adını yazın:");
              if (yeni && yeni.trim() !== "") {
                if (giderKategorileri.includes(yeni.trim())) {
                  alert("Bu kategori zaten mevcut!");
                } else {
                  const yeniListe = [...giderKategorileri, yeni.trim()];
                  setGiderKategorileri(yeniListe);
                  bulutaKaydet(yeniListe);
                }
              }
            }} style={{ width: "100%", padding: "16px", borderRadius: 14, background: T.primary, color: "#fff", border: "none", fontWeight: 800, fontSize: 16, boxShadow: "0 4px 12px " + T.primary + "40" }}>
              + Yeni Kategori Ekle
            </button>
          </div>
        </div>
      );
    }

  // 🏷️ MÜŞTERİ GRUPLARI (FİŞLEME) MODERN YÖNETİM
    else if (altSayfa === "gruplar") {
      // 🛡️ PATRON KONTROLÜ
      if (kullanici?.rol !== "patron") return <YetkiYokEkrani setAltSayfa={setAltSayfa} T={T} />;

      return (
        <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
          {/* Header */}
          <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12, position: "sticky", top: 0, zIndex: 10 }}>
            <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 16 }}>←</button>
            <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>🏷️ Grup Yönetimi</h2>
            <button onClick={() => setEditGrup({ id: "yeni_" + Date.now(), ad: "", icon: "🏷️", renk: T.primary })} 
              style={{ marginLeft: "auto", background: T.success, border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>+ Yeni Ekle</button>
          </div>

          <div style={{ padding: 16 }}>
            <div style={{ padding: "12px", background: T.primary + "12", borderRadius: 14, marginBottom: 16, fontSize: 13, color: T.primary }}>
              💡 Müşterileri VIP, Otel, Kurumsal gibi gruplara ayırarak kolayca filtreleyin.
            </div>

            {/* 🚀 Grup Listesi */}
            {musteriGruplari.map((g) => (
              <div key={g.id} 
                style={{ background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 20, padding: "14px 16px", marginBottom: 10, display: "flex", alignItems: "center", gap: 14 }}>
                
                {/* Sol İkon (Düzenleme Tetikler) */}
                <div onClick={() => setEditGrup(g)} style={{ width: 48, height: 48, borderRadius: 14, background: g.renk + "15", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, cursor: "pointer" }}>
                  {g.icon}
                </div>
                
                {/* Bilgi Alanı (Düzenleme Tetikler) */}
                <div onClick={() => setEditGrup(g)} style={{ flex: 1, cursor: "pointer" }}>
                  <div style={{ fontWeight: 700, color: T.text, fontSize: 15 }}>{g.ad}</div>
                  <div style={{ fontSize: 12, color: T.textSec }}>Düzenlemek için dokun</div>
                </div>

                {/* 🗑️ SİLME BUTONU (Firebase Entegreli) */}
                <button onClick={async (e) => {
                  e.stopPropagation(); // 🚀 Düzenleme panelinin açılmasını engeller
                  
                  if (g.id === "Normal") return alert("Varsayılan grup silinemez.");
                  
                  if (window.confirm(`${g.ad} grubu silinsin mi?`)) {
                    const yeniListe = musteriGruplari.filter(x => x.id !== g.id);
                    
                    // 1️⃣ Önce ekranda hemen temizle
                    setMusteriGruplari(yeniListe);
                    
                    // 2️⃣ Buluttan (Firebase) de sök at
                    try {
                      const userRef = doc(db, "kullanicilar", kullanici.email);
                      await updateDoc(userRef, { musteriGruplari: yeniListe });
                      console.log("✅ Grup buluttan silindi.");
                    } catch (err) {
                      console.error("Firebase Silme Hatası:", err);
                      alert("Hata: Grup buluttan silinemedi.");
                    }
                  }
                }} 
                style={{ 
                  background: T.danger + "15", 
                  border: "none", 
                  color: T.danger, 
                  padding: "10px", 
                  borderRadius: 12, 
                  cursor: "pointer", 
                  fontSize: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 44,
                  height: 44
                }}>
                  🗑️
                </button>
              </div>
            ))}
          </div>

          {/* 🛠️ Modern Düzenleme Paneli (Bottom Sheet Tarzı) */}
          {((editGrup && editGrup.id.toString().includes("yeni")) || (editGrup && !editGrup.yetkiler)) ? (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "flex-end", zIndex: 100 }}>
              <div style={{ background: T.bg, width: "100%", borderTopLeftRadius: 32, borderTopRightRadius: 32, padding: "24px 24px 40px 24px", animation: "slideUp 0.3s ease-out" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
                  <h3 style={{ margin: 0, color: T.text }}>{editGrup.id.toString().includes("yeni") ? "Yeni Grup Ekle" : "Grubu Düzenle"}</h3>
                  <button onClick={() => setEditGrup(null)} style={{ background: "none", border: "none", fontSize: 24, color: T.textSec, cursor:"pointer" }}>✕</button>
                </div>

                <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 12, color: T.textSec, display: "block", marginBottom: 6 }}>Grup Adı</label>
                    <input autoFocus value={editGrup.ad} onChange={e => setEditGrup({ ...editGrup, ad: e.target.value })}
                      placeholder="Örn: Oteller"
                      style={{ width: "100%", padding: 14, background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, color: T.text, outline: "none", fontSize:16 }} />
                  </div>
                  <div style={{ width: 80 }}>
                    <label style={{ fontSize: 12, color: T.textSec, display: "block", marginBottom: 6 }}>Emoji</label>
                    <input value={editGrup.icon} onChange={e => setEditGrup({ ...editGrup, icon: e.target.value })}
                      style={{ width: "100%", padding: 14, background: T.input, border: `1.5px solid ${T.inputBorder}`, borderRadius: 12, textAlign: "center", fontSize: 22 }} />
                  </div>
                </div>

               <button onClick={async () => { // 👈 REİS: async BURADA ŞART!
  if (!editGrup.ad) return alert("İsim boş olamaz.");
  
  let yeniListe;
  
  // 1️⃣ Önce listenin son halini hazırla (Ekleme mi Düzenleme mi kontrol et)
  if (editGrup.id.toString().includes("yeni")) {
    // YENİ EKLEME
    yeniListe = [...musteriGruplari, { ...editGrup, id: editGrup.ad + Date.now() }];
  } else {
    // ESKİSİNİ GÜNCELLEME
    yeniListe = musteriGruplari.map(x => x.id === editGrup.id ? editGrup : x);
  }

  // 2️⃣ Ekrana bas (Hız için önce state)
  setMusteriGruplari(yeniListe);

  // 3️⃣ Buluta mühürle (Firebase Kaydı)
  try {
    const userRef = doc(db, "kullanicilar", kullanici.email);
    await updateDoc(userRef, { musteriGruplari: yeniListe });
    console.log("✅ Gruplar buluta işlendi.");
  } catch(e) {
    console.error("❌ Firebase hatası:", e);
    alert("Kayıt sırasında bir hata oluştu.");
  }

  // 4️⃣ Paneli kapat
  setEditGrup(null);
}} 
style={{ width: "100%", padding: 16, borderRadius: 14, background: T.primary, color: "#fff", border: "none", fontWeight: 700, fontSize: 16, cursor:"pointer" }}>
  Kaydet ve Kapat
</button>
              </div>
            </div>
          ) : null}
         
          <style>{`
            @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
          `}</style>
        </div>
      );
    }

    if(altSayfa==="gorunum") {
      const sesAcik=localStorage.getItem("halici_ses")!=="kapali";
      return (
      <div style={{height:"100%",overflowY:"auto"}}>
        <div style={{background:T.header,padding:"16px 20px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setAltSayfa(null)} style={{background:"rgba(255,255,255,0.2)",border:"none",color:"#fff",
            borderRadius:10,padding:"8px 14px",cursor:"pointer",fontSize:16}}>←</button>
          <h2 style={{margin:0,fontSize:16,fontWeight:700,color:"#fff"}}>🎨 Görünüm & Ayarlar</h2>
        </div>
        <div style={{padding:16,display:"flex",flexDirection:"column",gap:12}}>
          {/* Başlık: Görünüm */}
          <div style={{fontSize:12,fontWeight:700,color:T.textSec,letterSpacing:1,paddingLeft:4}}>GÖRÜNÜM</div>
          {/* Dark Mod */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px",
            background:T.card,borderRadius:14,border:`1px solid ${T.border}`}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <span style={{fontSize:24}}>{tema==="dark"?"🌙":"☀️"}</span>
              <div>
                <div style={{fontSize:15,fontWeight:600,color:T.text}}>{t("Kanlık Mod")}</div>
                <div style={{fontSize:12,color:T.textSec}}>Karanlık / Aydınlık</div>
              </div>
            </div>
            <Toggle value={tema==="dark"} onChange={toggleTema} T={T}/>
          </div>
        
          {/* Ses */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px",background:T.card,borderRadius:14,border:`1px solid ${T.border}`}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <span style={{fontSize:24}}>{sesAcik?"🔊":"🔇"}</span>
              <div>
                <div style={{fontSize:15,fontWeight:600,color:T.text}}>Ses Efektleri</div>
                <div style={{fontSize:12,color:T.textSec}}>Ses aç-kapat tuşu</div>
              </div>
            </div>
            <Toggle value={sesAcik} onChange={v=>{localStorage.setItem("halici_ses",v?"acik":"kapali");sesCal("ding",v);window.location.reload();}} T={T}/>
          </div>
         
          {/* 🌍 Dil Seçimi (iPhone Tarzı Kaydırmalı) */}
          <div style={{background:T.card, border:`1px solid ${T.border}`, borderRadius:16, padding:16, marginBottom:12}}>
            <div style={{fontSize:14, fontWeight:700, color:T.text, marginBottom:12}}>🌍 {t("Diller")}</div>
            
            <div style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "160px", // iPhone picker yüksekliği
              overflowY: "auto",
              background: T.bg + "60",
              borderRadius: 14,
              border: `1px solid ${T.border}80`,
              scrollSnapType: "y mandatory"
            }}>
              {Object.entries(DILLER).map(([kod, info]) => {
                const aktif = dil === kod;
                return (
                  <div 
                    key={kod} 
                    onClick={() => dilDegistir(kod)}
                    style={{
                      padding: "14px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: aktif ? T.primary + "15" : "transparent",
                      borderBottom: `1px solid ${T.border}30`,
                      scrollSnapAlign: "start",
                      transition: "all 0.2s"
                    }}
                  >
                    <div style={{display:"flex", alignItems:"center", gap:12}}>
                      <span style={{fontSize: 22}}>{info.bayrak}</span>
                      <span style={{
                        fontSize: 15, 
                        fontWeight: aktif ? 700 : 500, 
                        color: aktif ? T.primary : T.text 
                      }}>
                        {info.ad}
                      </span>
                    </div>
                    {aktif && <span style={{color: T.primary, fontWeight: 900, fontSize: 18}}>✓</span>}
                  </div>
                );
              })}
            </div>
          </div>
        {/* Başlık: Uygulama */}
          <div style={{fontSize:12,fontWeight:700,color:T.textSec,letterSpacing:1,paddingLeft:4,marginTop:4}}>UYGULAMA</div>
          
          {/* 🔐 Birleştirilmiş İzin ve Güvenlik Paneli */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
              <span style={{fontSize:20}}>🔐</span>
              <div style={{fontSize:14,fontWeight:700,color:T.text}}>Sistem İzinleri</div>
            </div>
            <p style={{fontSize:12,color:T.textSec,marginBottom:12,lineHeight:1.5}}>
              Uygulamanın tam performanslı çalışması için; <b>Bildirim, Kamera, Konum, Rehber ve Mikrofon</b> izinlerini buradan yönetebilirsiniz.
            </p>
            <IzinButonu T={T}/>
          </div>

          {/* Ses testi */}
          <div style={{marginTop:12}}>
            <button onClick={()=>sesCal("yeniFis",true)} 
              style={{width:"100%",padding:"12px",borderRadius:12,background:T.statCard,border:`1px solid ${T.border}`,color:T.textSec,cursor:"pointer",fontSize:14,fontWeight:600}}>
              🔊 Ses Testi Çal
            </button>
          </div>
        </div>
      </div>
      );
    }
    if(altSayfa==="log") return (
      <div style={{height:"100%",overflowY:"auto"}}>
        <div style={{background:T.header,padding:"16px 20px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setAltSayfa(null)} style={{background:"rgba(255,255,255,0.2)",border:"none",color:"#fff",
            borderRadius:10,padding:"8px 14px",cursor:"pointer",fontSize:16}}>←</button>
          <h2 style={{margin:0,fontSize:16,fontWeight:700,color:"#fff"}}>{t("log")}</h2>
        </div>
        <div style={{padding:16}}>
          <div style={{padding:"10px 14px",background:T.primary+"12",borderRadius:10,marginBottom:12,fontSize:13,color:T.primary}}>
            Her gece sıfırlanır. Bugün: {aramaLog.length} arama
          </div>
          {/* Rehberden arama kaydı ekle */}
          <button onClick={async()=>{
            const contact=await rehberdenSec();
            if(contact&&contact.tel){setCallerNumara(contact.tel.trim());logEkle(contact.tel.trim(),"bekliyor");}
            else{const num=prompt("Telefon numarası:");if(num){setCallerNumara(num.trim());logEkle(num.trim(),"bekliyor");}}
          }} style={{width:"100%",padding:"12px",borderRadius:12,background:T.primary,border:"none",
            color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,marginBottom:12}}>
            📒 Rehberden / Manuel Arama Simüle Et
          </button>
          {aramaLog.length===0?(
            <div style={{textAlign:"center",padding:32,color:T.textSec}}>Arama logu yok</div>
          ):[...aramaLog].reverse().map((l,i)=>(
            <div key={i} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,
              padding:"12px 14px",marginBottom:6,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <span style={{color:l.eslesti?T.success:T.warning,fontSize:14,fontWeight:600}}>{l.eslesti?"✓ Kayıtlı":"❓ Bilinmeyen"}</span>
                  <span style={{fontSize:14,color:T.text}}>{l.numara}</span>
                </div>
                <div style={{fontSize:12,color:T.textSec,marginTop:2}}>{l.saat}</div>
              </div>
              <span style={{fontSize:12,color:l.aksiyon==="fis_acildi"?T.success:l.aksiyon==="gormezden"?T.textSec:T.primary,fontWeight:500}}>
                {l.aksiyon==="fis_acildi"?"Fiş Açıldı":l.aksiyon==="sahaya_eklendi"?"Sahaya":l.aksiyon==="kayit_baslatildi"?"Kayıt":"Görmezden"}
              </span>
            </div>
          ))}
        </div>
      </div>
    );

    if (altSayfa === "hakkinda") return (
      <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
        <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12, position: "sticky", top: 0, zIndex: 10 }}>
          <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer" }}>←</button>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>📖 Kullanım Rehberi</h2>
        </div>
        <div style={{ padding: 16 }}>
          
   {/* Sürüm & Logo */}
          <div style={{ background: T.header, borderRadius: 20, padding: 24, marginBottom: 16, textAlign: "center" }}>
            <img 
              src="logo.png" 
              alt="HaliPro" 
              style={{ 
                width: 80, 
                height: 80, 
                objectFit: "contain", 
                marginBottom: 10,
                borderRadius: 16 // Logo kare ise köşeleri yumuşatır
              }} 
            />
            
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>Halı Yıkama Yönetim Sistemi — v1.0</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginTop: 4 }}>Firebase Bulut Tabanlı • Çok Kullanıcılı • Gerçek Zamanlı</div>
          </div>

          {/* Bölümler */}
          {[
            {
              baslik: "🏠 Ana Sayfa",
              icerik: "Günlük iş özetinizi tek bakışta görürsünüz. Üstte 'Alınacak', 'Yıkanacak/Yıkanıyor' ve 'Hazır' sayaçları bulunur. Altında hızlı erişim butonları, kasa özeti ve son aramalar yer alır. Kasa özeti kutusuna tıklayınca doğrudan Kasa sayfasına geçersiniz."
            },
            {
              baslik: "📋 İşler Sayfası",
              icerik: "Tüm fişlerin listelendiği yerdir. Üstteki renk butonlarıyla statüye göre filtreleyin (Alınacak, Araçta, Yıkanıyor...). Arama kutusuna müşteri adı veya fiş no yazın. Her fişte 'Sıradaki Aşama' butonu ilerletir. Üç nokta menüsünden WA, SMS, Fiş Yazdır, Fatura, QR ve Sil işlemleri yapılır."
            },
            {
              baslik: "🚗 Saha Sayfası",
              icerik: "Şoförlerin ana ekranıdır. 'Kapıdan Alınacaklar' bölümünde müşteri adresi gösterilir, 'Adrese Git' butonuyla doğrudan Google Maps açılır. 'Kapıdayım, Konumu Kaydet' butonu bulunduğunuz yeri müşterinin adresine işler. 'Teslim Edilecekler' bölümünde ödeme alarak teslim işlemi yapılır. Alım ve Teslim Rotası butonları birden fazla adresi Google Maps'te sıralı şekilde açar."
            },
            {
              baslik: "👥 Müşteriler Sayfası",
              icerik: "Tüm müşteri kayıtlarına ulaşırsınız. Üstte VIP, Kurumsal gibi grup filtreleri ve borçlu/6 ay görülmeyenler filtreleri bulunur. Müşteri adına tıklayınca sağdan profil paneli açılır — tüm iş geçmişi, istatistikler ve WhatsApp/SMS butonları burada. ✏️ ikonu ile düzenleme, 🗑️ ile silme yapılır (silme sadece Yönetici'ye açıktır)."
            },
            {
              baslik: "💰 Kasa Sayfası",
              icerik: "Bugün, Hafta, Ay veya Tüm zamanlar için nakit/kart tahsilat özetini gösterir. Durum dağılımı bölümünde her statüdeki iş sayısı ve tutarları listelenir. En altta en çok ciro yapan müşteriler sıralanır. Raporlar butonuyla detaylı analiz ve PDF rapor alınabilir."
            },
            {
              baslik: "➕ Yeni Fiş Açmak",
              icerik: "Üstteki '+ Fiş' veya '+ Yeni Fiş' butonuna basın. Arama kutusuna müşteri adı/telefonu yazarak mevcut müşteriyi seçin; yoksa '+ Yeni' butonuyla anında oluşturun. Alınış ve teslim tarihi seçin. İşi götürecek şoförü atayın. Not alanında sesli not (🎤) kullanabilirsiniz. Dükkandaki yeri ve fotoğraf ekleyebilirsiniz."
            },
            {
              baslik: "✅ Halı Alma (m² Girişi)",
              icerik: "Saha sayfasında 'Halıyı Al → m² Gir' butonuna basın. Halı çeşidini seçin (Makine, Yün, İpek...). En × Boy yazarsanız m² otomatik hesaplanır. Kirlilik seviyesi ve ekspres seçeneği eklenir. Birim fiyat sadece Yönetici tarafından değiştirilebilir. Fiş tamamlanınca durum 'Araçta' olarak güncellenir."
            },
            {
              baslik: "💵 Tahsilat Almak",
              icerik: "Fiş listesinde '⏳ Ödeme Al' butonuna veya teslim ekranında 'Teslim Et ve Ödeme Al' butonuna basın. Nakit ve kart ayrı ayrı girilebilir. Eski borç varsa tahsilat eklenebilir. Kasa özeti anında hesaplanır. Tahsil eden personeli seçin."
            },
            {
              baslik: "📷 QR Kod Sistemi",
              icerik: "Her fiş otomatik benzersiz QR koda sahiptir. Fiş listesinde 'QR' butonuna basın → '🖨️ QR Etiketini Yazdır' ile halıya yapıştırılacak etiketi yazdırın. Teslimde QR tarayıcıyla (Ana Sayfa veya Saha'daki '📷 QR Tara' butonu) fişi anında bulun. iOS/eski Android'de manuel fiş no girişi yapılabilir."
            },
            {
              baslik: "📞 Gelen Arama (Caller ID)",
              icerik: "Telefon çaldığında ekranın altında HaliPro popup'ı açılır. Kayıtlı müşteriyse adı, semti, kritik notu ve borç durumu görünür. 'Müşteri Kartı' ile profile, 'Yeni Sipariş' ile fiş oluşturmaya geçilir. Bilinmeyen numara ise 'Müşteri Olarak Kaydet' butonu gösterilir. 'Göz Ardı Et' ile popup kapatılır. Uygulama arka plandayken de çalışır."
            },
            {
              baslik: "🔧 Statü Sırası",
              icerik: "📍 Kapıdan Alınacak → 🚐 Araçta (Dükkana Geliyor) → ⏳ Yıkanacak → 🫧 Yıkanıyor → 💨 Kurutuluyor → 🔧 Fasonda → 📦 Teslime Hazır → 🚐 Dağıtımda → ✅ Teslim Edildi. Her aşamada ilgili personele otomatik bildirim gönderilir (Bildirim Yönetimi ayarından özelleştirilebilir)."
            },
            {
              baslik: "⚙️ Ayarlar",
              icerik: "Personel Yönetimi: Çalışan ekle, rollerini ve şifrelerini belirle. Uygulama Ayarları: Karanlık mod, ses, dil ve izinler. İşletme Bilgileri: Firma adı, adres, IBAN. Fiyat Listesi: Ürün tipleri ve birim fiyatlar. Müşteri Grupları: VIP, Kurumsal gibi kategoriler — kalıcı, buluttan yüklenir. Bildirim Yönetimi: Hangi statü kime bildirim gitsin. Veri Yönetimi: JSON/CSV/PDF yedek al, yedek yükle."
            },
            
          ].map((b, i) => (
            <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 10 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: T.primary, marginBottom: 8 }}>{b.baslik}</div>
              <div style={{ fontSize: 13, color: T.textSec, lineHeight: 1.7 }}>{b.icerik}</div>
            </div>
          ))}
{/* 👨‍💻 GELİŞTİRİCİ İLETİŞİM */}
<div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 10 }}>
  <div style={{ fontSize: 15, fontWeight: 800, color: T.primary, marginBottom: 12 }}>👨‍💻 Geliştirici İletişim</div>
  
  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    <div style={{ fontSize: 13, color: T.textSec }}>
  ✉️ E-posta: 
  <button 
    onClick={() => linkAc("mailto:cengizburhanbc@gmail.com")}
    style={{
      background: "none",
      border: "none",
      padding: 0,
      marginLeft: 4,
      fontSize: 13,
      fontWeight: 800,
      color: T.text,
      cursor: "pointer",
      textDecoration: "underline" // Tıklanabilir olduğu belli olsun diye altı çizili yaptık
    }}
  >
    cengizburhanbc@gmail.com
  </button>
</div>
    
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
      <button onClick={() => linkAc("tel:+905375166664")}
        style={{ padding: "10px 6px", borderRadius: 12, background: T.success+"15", border: `1px solid ${T.success}30`, color: T.success, cursor: "pointer", fontSize: 12, fontWeight: 700, textAlign: "center" }}>
        📞 Ara
      </button>
      <button onClick={() => linkAc("sms:+905375166664")}
        style={{ padding: "10px 6px", borderRadius: 12, background: T.primary+"15", border: `1px solid ${T.primary}30`, color: T.primary, cursor: "pointer", fontSize: 12, fontWeight: 700, textAlign: "center" }}>
        💬 SMS
      </button>
      <button onClick={() => linkAc("https://wa.me/905375166664")}
        style={{ padding: "10px 6px", borderRadius: 12, background: "#25D36615", border: "1px solid #25D36630", color: "#25D366", cursor: "pointer", fontSize: 12, fontWeight: 700, textAlign: "center" }}>
        🟢 WA
      </button>
    </div>
    
    <button onClick={() => linkAc("https://burhancengiz.com/halipro")}
      style={{ width: "100%", padding: "10px", borderRadius: 12, background: T.statCard, border: `1px solid ${T.border}`, color: T.primary, cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
     Web Üzerinden Açmak İçin: 🌐 burhancengiz.com/halipro
    </button>
  </div>
</div>
        </div>
      </div>
    );
    
// 💾 VERİ YÖNETİMİ (PATRONA ÖZEL)
if (altSayfa === "veri") {
 
  // 🛡️ PATRON KONTROLÜ
  if (kullanici?.rol !== "patron") return <YetkiYokEkrani setAltSayfa={setAltSayfa} T={T} />;

  return (
    <div style={{ height: "100%", overflowY: "auto" }}>
      <div style={{ background: T.header, padding: "16px 20px", display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={() => setAltSayfa(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: 16 }}>←</button>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" }}>{t("veri")}</h2>
      </div>

      <div style={{ padding: 16 }}>

        
        {/* 📤 YEDEK AL BÖLÜMÜ */}
        <div style={{ background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 14, padding: 16, marginBottom: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 12 }}>📤 Yedek Al</div>
          
          <div style={{marginBottom:14}}>
            <div style={{fontSize:13, fontWeight:700, color:T.text, marginBottom:10}}>📦 Yedeklenecek İçerikler:</div>
            {[
              ["musteriler","👥 Müşteriler"],
              ["isler","📋 İş Fişleri"],
              ["personeller","👷 Personeller"],
              ["urunler","💰 Fiyat Listesi"],
              ["ayarlar","🏢 İşletme Ayarları"],
              ["giderler","📤 Gider Kayıtları"]
            ].map(([key, label]) => (
              <div key={key} onClick={() => setYedekSecimler(p => ({...p, [key]: !p[key]}))}
                style={{display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:10,
                  background: yedekSecimler[key] ? T.primary+"12" : T.bg,
                  border:`1px solid ${yedekSecimler[key] ? T.primary : T.border}`,
                  cursor:"pointer", marginBottom:6}}>
                <div style={{width:20, height:20, borderRadius:5, background: yedekSecimler[key] ? T.primary : "transparent",
                  border:`2px solid ${yedekSecimler[key] ? T.primary : T.border}`,
                  display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:12}}>
                  {yedekSecimler[key] && "✓"}
                </div>
                <span style={{fontSize:14, color:T.text}}>{label}</span>
              </div>
            ))}
          </div>

          {[["json", "🗄️ JSON (Geri Yüklenebilir)"], ["csv", "📊 CSV/Excel"], ["pdf", "📑 PDF"]].map(([fmt, lbl]) => (
            <button key={fmt} onClick={async () => {
              
              // 🚀 AKILLI YEDEKLEME MOTORU: ES6 Spread ile dinamik veri paketi
              const veri = {
                ...(yedekSecimler.musteriler && { musteriler }),
                ...(yedekSecimler.isler && { isler }),
                ...(yedekSecimler.personeller && { personeller }),
                ...(yedekSecimler.urunler && { urunler }),
                ...(yedekSecimler.ayarlar && { ayarlar: isletme }),
                ...(yedekSecimler.giderler && { giderler }),
                meta: { tarih: new Date().toISOString(), uygulama: "HaliPro" }
              };

              const tarihStr = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
              const dosyaAdi = `HaliCi_Yedek_${tarihStr}.${fmt}`;

              if (fmt === "json") {
                const jsonStr = JSON.stringify(veri, null, 2);
                
                if (window.Capacitor?.isNativePlatform?.()) {
                  // 📱 ANDROID TARAFI: Filesystem ile gerçek kayıt
                  try {
                    const { Filesystem, Directory, Encoding } = await import('@capacitor/filesystem');
                    await Filesystem.writeFile({
                      path: dosyaAdi,
                      data: jsonStr,
                      directory: Directory.Documents,
                      encoding: Encoding.UTF8,
                    });
                    alert(`✅ Yedek Cihaza Kaydedildi!\nKonum: Belgeler/${dosyaAdi}`);
                  } catch (e) {
                    // Hata olursa B planı: Panoya kopyala
                    await navigator.clipboard.writeText(jsonStr);
                    alert("⚠️ Dosya izni alınamadı. Yedek içeriği panoya kopyalandı! Bir nota yapıştırıp saklayın.");
                  }
                } else {
                  // 💻 WEB TARAFI: Normal indirme
                  const blob = new Blob([jsonStr], { type: "application/json" });
                  const a = document.createElement("a");
                  a.href = URL.createObjectURL(blob);
                  a.download = dosyaAdi;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(a.href);
                }
              } 
         else if (fmt === "csv") {
                // 📊 CSV/EXCEL İÇİN GENİŞLETİLMİŞ VERİ SETİ
                const satirlar = [
                  ["Ad Soyad", "Telefon 1", "Telefon 2", "Semt", "Sehir", "Tam Adres", "Borc", "Notlar"], 
                  ...musteriler.map(m => [
                    m.ad, 
                    m.tel || "", 
                    m.tel2 || "", 
                    m.semt || "", 
                    m.sehir || "", 
                    `"${(m.adres || "").replace(/"/g, '""')}"`, // Adres içindeki virgüller sütun kaydırmasın diye tırnak içine alındı
                    (m.borc || 0).toFixed(2),
                    `"${(m.notlar || "").replace(/"/g, '""')}"`
                  ])
                ];
                const csv = satirlar.map(s => s.join(",")).join("\n");
                const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = `HaliCi_Musteri_Listesi_${tarihStr}.csv`;
                a.click();
              } 
              else {
                // 📑 PDF / YAZDIRMA İÇİN DETAYLI TABLO TASARIMI
                const w = window.open("", "_blank");
                const tabloSatirlari = musteriler.map(m => `
                  <tr>
                    <td style="border:1px solid #ddd; padding:8px;"><b>${m.ad}</b></td>
                    <td style="border:1px solid #ddd; padding:8px;">${m.tel}${m.tel2 ? "<br>"+m.tel2 : ""}</td>
                    <td style="border:1px solid #ddd; padding:8px;">${m.semt || ""} / ${m.sehir || ""}</td>
                    <td style="border:1px solid #ddd; padding:8px; font-size:10px; max-width:200px;">${m.adres || ""}</td>
                    <td style="border:1px solid #ddd; padding:8px; text-align:right; font-weight:bold; color:#DC2626;">₺${formatPara(m.borc || 0)}</td>
                  </tr>`).join("");

                w.document.write(`
                  <!DOCTYPE html><html><head><meta charset="UTF-8">
                  <style>
                    body{font-family:'Segoe UI', Arial, sans-serif; padding:20px; color:#333;}
                    table{width:100%; border-collapse:collapse; margin-top:20px;}
                    th{background:#1E3A5F; color:#fff; padding:12px 8px; text-align:left; font-size:12px; text-transform:uppercase;}
                    h1{color:#1E3A5F; font-size:22px; margin-bottom:5px;}
                    .footer{margin-top:20px; font-size:11px; color:#666; text-align:center; border-top:1px solid #eee; padding-top:10px;}
                  </style></head>
                  <body>
                    <h1>HaliPro Detaylı Müşteri Listesi</h1>
                    <div style="font-size:13px; color:#666;">Yedekleme Tarihi: ${bugun()}</div>
                    <table>
                      <thead>
                        <tr>
                          <th>Müşteri Adı</th>
                          <th>Telefonlar</th>
                          <th>Bölge</th>
                          <th>Tam Adres</th>
                          <th>Bakiye</th>
                        </tr>
                      </thead>
                      <tbody>${tabloSatirlari}</tbody>
                    </table>
                    <div class="footer">HaliPro Yönetim Sistemi tarafından oluşturulmuştur.</div>
                  </body></html>`);
                w.document.close();
                setTimeout(() => w.print(), 500);
              }
            }} style={{ width: "100%", padding: "13px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 600, marginBottom: 8, textAlign: "left" }}>
              {lbl}
            </button>
          ))}
        </div>
       {/* 📥 YEDEK YÜKLE BÖLÜMÜ (Modern, Butonlu & Akıllı Birleştirme) */}
        <div style={{ background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 14, padding: 16, marginBottom: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 8 }}>📥 Yedek Yükle</div>
          
          {!yuklemeDosyası ? (
            /* 📂 ADIM 1: Dosya Seçme Alanı */
            <label style={{ display: "block", padding: "14px", borderRadius: 12, border: `2px dashed ${T.border}`, color: T.textSec, cursor: "pointer", textAlign: "center", fontSize: 14, fontWeight: 600 }}>
              📂 JSON Yedek Dosyası Seç
              <input type="file" accept=".json" onChange={e => {
                const f = e.target.files?.[0];
                if (!f) return;
                const r = new FileReader();
                r.onload = ev => {
                  try {
                    const d = JSON.parse(ev.target.result);
                    if (d.meta?.uygulama !== "HaliPro") { alert("❌ Bu dosya geçerli bir HaliPro yedeği değil!"); return; }
                    setYuklemeDosyası(d); // Dosyayı hafızaya al, butonları göster
                  } catch { alert("❌ Dosya okunamadı!"); }
                };
                r.readAsText(f);
              }} style={{ display: "none" }} />
            </label>
          ) : (
            /* 📊 ADIM 2: Seçenek Paneli (Dosya Seçildikten Sonra) */
            <div style={{ animation: "fadeIn 0.3s" }}>
              <div style={{ background: T.primary + "15", padding: 12, borderRadius: 12, marginBottom: 12, fontSize: 13, color: T.text }}>
                ✅ <b>{yuklemeDosyası.musteriler?.length || 0}</b> Müşteri bulundu. Lütfen yöntemi seçin:
              </div>
              
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {/* ➕ AKILLI BİRLEŞTİRME BUTONU */}
                <button onClick={() => {
                  const mevcutMusteriler = [...musteriler];
                  let yeniSayi = 0;
                  (yuklemeDosyası.musteriler || []).forEach(yM => {
                    const yedekTel = (yM.tel || "").replace(/\D/g, "");
                    const yedekIsim = (yM.ad || "").toLowerCase().trim();
                    const varMi = mevcutMusteriler.find(mM => 
                      (mM.ad || "").toLowerCase().trim() === yedekIsim && 
                      (mM.tel || "").replace(/\D/g, "") === yedekTel
                    );
                    if (!varMi) { mevcutMusteriler.push(yM); yeniSayi++; }
                  });

                  const mevcutIsler = [...isler];
                  (yuklemeDosyası.isler || []).forEach(yI => {
                    if (!mevcutIsler.find(mI => mI.id === yI.id)) mevcutIsler.push(yI);
                  });

                  setMusteriler(mevcutMusteriler);
                  setIsler(mevcutIsler);
                  if (yuklemeDosyası.personeller) setPersoneller(yuklemeDosyası.personeller);
                  
                  alert(`✅ İşlem Başarılı!\n${yeniSayi} yeni müşteri mevcut listeye eklendi.`);
                  setYuklemeDosyası(null);
                  setAltSayfa(null);
                }} style={{ padding: "14px", borderRadius: 12, background: T.primary, color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>
                  ➕ Üzerine Ekle (Kayıtlarımı Koru)
                </button>

                {/* 🗑️ SIFIRDAN YÜKLE BUTONU */}
                <button onClick={() => {
                  if (window.confirm("⚠️ DİKKAT: Mevcut dükkan verileriniz tamamen SİLİNECEK! Emin misiniz?")) {
                    setMusteriler(yuklemeDosyası.musteriler || []);
                    setIsler(yuklemeDosyası.isler || []);
                    if (yuklemeDosyası.urunler) setUrunler(yuklemeDosyası.urunler);
                    if (yuklemeDosyası.ayarlar) setIsletme(yuklemeDosyası.ayarlar);
                    if (yuklemeDosyası.personeller) setPersoneller(yuklemeDosyası.personeller);
                    alert("✅ Dükkan sıfırlandı ve yedek yüklendi!");
                    setYuklemeDosyası(null);
                    setAltSayfa(null);
                  }
                }} style={{ padding: "14px", borderRadius: 12, background: T.danger + "20", color: T.danger, border: `1.5px solid ${T.danger}`, fontWeight: 700, cursor: "pointer" }}>
                  🧹 Mevcutları Sil ve Bunu Yükle
                </button>

                {/* ❌ VAZGEÇ BUTONU */}
                <button onClick={() => setYuklemeDosyası(null)} style={{ padding: "10px", color: T.textSec, background: "none", border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
                  ❌ Vazgeç / Dosyayı Kapat
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ⚠️ TEHLİKELİ İŞLEMLER */}
        <div style={{ background: T.danger + "10", border: `1px solid ${T.danger}30`, borderRadius: 14, padding: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: T.danger, marginBottom: 8 }}>⚠️ Tehlikeli İşlemler</div>
          <button onClick={async () => {
            const patronPini = kullanici?.pin_patron;
            if (patronPini) {
              const girilen = prompt("Dükkan verilerini SIFIRLAMAK için Patron PIN kodunu girin:");
              if (girilen !== patronPini) { alert("❌ Hatalı şifre!"); return; }
            } else {
              const onay = prompt("Dükkanı tamamen sıfırlamak üzeresiniz. Onaylamak için 'SİL' yazın:");
              if (onay !== "SİL") return;
            }

            if (window.confirm("⚠️ DİKKAT: Tüm müşteri kayıtları, işler ve personeller KALICI olarak silinecek. Emin misiniz?")) {
              setIsler([]); 
              setMusteriler([]); 
              setPersoneller([]); 
              alert("✅ Dükkan tertemiz edildi.");
            }
          }}
          style={{ padding: "12px 16px", borderRadius: 12, background: T.danger, border: "none", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>
          🗑 Tüm Verileri Sil (PIN Korumalı)
          </button>
        </div>
      </div>
    </div>
  );
}
   // Ana ayarlar listesi - YENİ VE BİRLEŞİK SIRALAMA
  const BOLUMLER = [
  { id: "personel", icon: "👥", baslik: "Personel Yönetimi", aciklama: "Çalışanlar, yetkiler ve görev akışı" }, // Açıklamayı güncelledim
  { id: "gorunum", icon: "🎨", baslik: "Uygulama Ayarları", aciklama: "Dark mod, ses, dil, izinler" },
  { id: "isletme", icon: "🏢", baslik: t("isletme"), aciklama: "Firma adı, telefon, adres, IBAN" },
  { id: "giderKategorileri", icon: "📂", baslik: "Gider Kategorileri", aciklama: "Gider türlerini yönetin veya silin" },
  { id: "fiyatlar", icon: "💰", baslik: t("fiyatlar"), aciklama: "Ürün tipleri ve birim fiyatları" },
  { id: "gruplar", icon: "🏷️", baslik: "Müşteri Grupları", aciklama: "VIP, Kurumsal vb. etiketleri yönet" },
  { id: "veri", icon: "💾", baslik: t("veri"), aciklama: "Yedekleme ve geri yükleme" },
  { id: "hakkinda", icon: "ℹ️", baslik: "Uygulama Hakkında", aciklama: "Kullanım rehberi ve sürüm" },
];

  // 🏠 AYARLAR ANA MENÜ GÖRÜNÜMÜ
  if (altSayfa === null) {
    return (
      <div style={{ height: "100%", overflowY: "auto", background: T.bg }}>
        {/* Üstteki mükerrer başlık divi (T.header olan kısım) tamamen kaldırıldı */}
        
        <div style={{ padding: 16 }}>
          
       {/* 🛡️ DİNAMİK AKTİF ROL VE PERSONEL KARTI */}
          {(() => {
            const aktifRolObj = personelRolleri.find(r => r.id === kullanici?.rol) || { ad: "Bilinmeyen Rol", icon: "👤", renk: T.primary };
            return (
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: 14, 
                padding: "16px", 
                background: aktifRolObj.renk + "10", 
                borderRadius: 16, 
                border: `1px solid ${aktifRolObj.renk}30`, 
                marginBottom: 12 
              }}>
                <div style={{ 
                  width: 48, 
                  height: 48, 
                  borderRadius: 14, 
                  background: aktifRolObj.renk + "20", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  fontSize: 24, 
                  flexShrink: 0 
                }}>
                  {aktifRolObj.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: aktifRolObj.renk }}>
                    Rol: {aktifRolObj.ad}
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginTop: 2 }}>
                    👤 {kullanici?.aktifPersonel ? kullanici.aktifPersonel.ad : (kullanici?.ad || "Yönetici")}
                  </div>
                </div>
              </div>
            );
          })()}

          {/* 📋 2. AYARLAR LİSTESİ (BOLUMLER dizisindeki sırayla dizilir) */}
          {BOLUMLER.map(b=>(
            <button key={b.id} onClick={()=>setAltSayfa(b.id)}
              style={{display:"flex", alignItems:"center", gap:14, padding:"16px", background:T.card,
                borderRadius:16, marginBottom:10, cursor:"pointer", border:`1px solid ${T.border}`, width:"100%", textAlign:"left"}}
              onMouseEnter={e=>e.currentTarget.style.background=T.primary+"08"}
              onMouseLeave={e=>e.currentTarget.style.background=T.card}>
              <div style={{width:48, height:48, borderRadius:14, background:T.primary+"18", display:"flex",
                alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0}}>{b.icon}</div>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:15, fontWeight:600, color:T.text}}>{b.baslik}</div>
                {b.aciklama && <div style={{fontSize:12, color:T.textSec, marginTop:1}}>{b.aciklama}</div>}
              </div>
              <span style={{color:T.textSec, fontSize:20}}>›</span>
            </button>
          ))}
     

          {/* 🚪 3. ÇIKIŞ YAP (En altta kırmızı buton) */}
          <button 
            onClick={() => {
              if (window.confirm("Hesaptan çıkış yapılsın mı? Tüm yerel veriler temizlenecektir.")) {
                setKullanici(null);
                localStorage.removeItem("halici_k");
                localStorage.removeItem("halici_isler");
                localStorage.removeItem("halici_musteriler");
                localStorage.removeItem("halici_giderler");
                localStorage.removeItem("halici_fis_id");
                localStorage.removeItem("halici_mus_id");
                window.location.reload(); 
              }
            }}
            style={{
              display: "flex", alignItems: "center", gap: 14, padding: "16px", background: T.danger + "10",
              borderRadius: 16, cursor: "pointer", border: `1.1px solid ${T.danger}30`, width: "100%", textAlign: "left", marginTop: 16
            }}
          >
            <div style={{ width: 48, height: 48, borderRadius: 14, background: T.danger + "20", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>🚪</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: T.danger }}>{t("cikisYap")}</div>
          </button>
       
        </div>
      </div>
    );
  }
}; // ← renderAyarlar kapandı

const renderPersonel=()=>(
    <div style={{height:"100%",overflowY:"auto",padding:16}}>
      {/* Personel form modal */}
      {personelForm!==null&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:500,
          display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={e=>{if(e.target===e.currentTarget)setPersonelForm(null);}}>
          <div style={{background:T.bg,width:"100%",maxWidth:500,borderRadius:"24px 24px 0 0",
            padding:20,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
            <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"0 auto 16px"}}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <h2 style={{margin:0,fontSize:17,fontWeight:700,color:T.text}}>
                {personelForm.id?"✏️ Personel Düzenle":"👷 Yeni Personel Ekle"}
              </h2>
              <button onClick={()=>setPersonelForm(null)}
                style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:24}}>✕</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <Inp label="Ad Soyad *" value={personelForm.ad||""} onChange={v=>setPersonelForm(p=>({...p,ad:v}))} T={T} placeholder="Ad Soyad Giriniz"/>
              
              <div>
                <label style={{fontSize:12,fontWeight:600,color:T.textSec,display:"block",marginBottom:6}}>Rolü *</label>
                <select 
                  value={personelForm.rol||""} 
                  onChange={e=>setPersonelForm(p=>({...p,rol:e.target.value}))}
                  style={{width:"100%",padding:"13px 14px",background:T.input,border:`1.5px solid ${T.inputBorder}`,
                    borderRadius:12,color:T.text,fontSize:15,outline:"none"}}>
                  <option value="">— Rol Seçin —</option>
                  {/* 🚀 ARTIK AYARLARDAKİ LİSTEDEN ÇEKİYORUZ: */}
                  {personelRolleri.map(rol => (
                    <option key={rol.id} value={rol.ad}>
                      {rol.icon} {rol.ad}
                    </option>
                  ))}
                </select>
              </div>

              <Inp 
                    label="Telefon" 
                    value={personelForm.tel || "+90 "} 
                    onChange={v => setPersonelForm(p => ({ ...p, tel: formatTel(v) }))} 
                    T={T} 
                    placeholder="+90 5XX XXX XX XX"
                  />

                  {/* 💵 MAAŞ FORMATLANDI: 12.345,00 TL gibi görünür ama arka planda düz sayı tutulur */}
                  <div style={{ marginBottom: 10 }}>
                    <Inp 
                      label="Maaş (₺/ay)" 
                      value={personelForm.maas_gosterim || personelForm.maas || ""} 
                      onChange={v => {
                        const sadeceSayi = v.replace(/[^0-9]/g, ""); // Sadece rakamları al
                        if (!sadeceSayi) {
                          setPersonelForm(p => ({ ...p, maas_gosterim: "", maas: "" }));
                          return;
                        }
                        const gosterim = Number(sadeceSayi).toLocaleString("tr-TR"); // Noktalı formatla
                        setPersonelForm(p => ({ ...p, maas_gosterim: gosterim, maas: sadeceSayi }));
                      }} 
                      T={T} 
                      placeholder="10.000"
                    />
                  </div>
                  
                  <Inp label="Notlar" value={personelForm.notlar || ""} onChange={v => setPersonelForm(p => ({ ...p, notlar: v }))} T={T} />
                  
                  {/* 🔒 YENİ EKLENEN ŞİFRE ALANI */}
                  <Inp 
                    label="Kişisel Şifre / PIN (Opsiyonel)" 
                    value={personelForm.pin || ""} 
                    onChange={v => setPersonelForm(p => ({...p, pin: v}))} 
                    type="password" 
                    T={T} 
                    placeholder="Sadece ona özel şifre (Örn: 1234)"
                  />

                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12, marginTop: 24 }}>
                  <button onClick={() => setPersonelForm(null)} style={{ padding: "14px", borderRadius: 12, background: "transparent", border: `1.5px solid ${T.border}`, color: T.textSec, fontWeight: 600, cursor: "pointer" }}>İptal</button>
                  <button onClick={async () => {
                    const tamIsim = `${personelForm.ad_formatli || personelForm.ad_ham || ""} ${personelForm.soyad_formatli || personelForm.soyad_ham || ""}`.trim();
                    
                    if (!tamIsim || !personelForm.rol) return alert("Ad, Soyad ve Rol zorunludur!");

                    const guncelVeri = { 
                      ...personelForm, 
                      ad: tamIsim, 
                      tel: formatTel(personelForm.tel),
                      maas: personelForm.maas // Arka planda düz sayı olarak kaydedilir
                    };

                    let yeniListe;
                    if (personelForm.id) {
                      yeniListe = personeller.map(p => p.id === personelForm.id ? guncelVeri : p);
                    } else {
                      yeniListe = [...personeller, { ...guncelVeri, id: "p" + Date.now(), aktif: true }];
                    }
                    
                    setPersoneller(yeniListe);
                    
                    // ☁️ BULUTA KAYDETME EKLENDİ (Kapanıp açılınca silinmemesi için)
                    try {
                      await updateDoc(doc(db, "kullanicilar", kullanici.email), { personeller: yeniListe });
                    } catch(e) { console.error("Personel kayıt hatası:", e); }

                    setPersonelForm(null);
                  }} style={{ padding: "14px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
                    {personelForm.id ? "Güncelle" : "Dükkana Kaydet"}
                  </button>
            </div>
          </div>
        </div>
      )}

      {/* ... Listenin geri kalanı aynı kalıyor ... */}
      {personeller.map(p=>{
        const pIs=isler.filter(is=>is.isAlan===p.ad||is.atanUsta===p.ad).length;
        const pTah=isler.filter(is=>is.tahsilat?.alan===p.ad).reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
        return (
          <div key={p.id} style={{background:T.card,border:`1px solid ${p.aktif?T.border:T.danger+"30"}`,borderRadius:16,padding:14,marginBottom:10,opacity:p.aktif?1:0.7}}>
            <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
              <div style={{width:48,height:48,borderRadius:14,background:p.aktif?T.primary:T.textSec,display:"flex",alignItems:"center",
                justifyContent:"center",fontSize:20,fontWeight:800,color:"#fff",flexShrink:0}}>{(p.ad||"?")[0]}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:16,fontWeight:700,color:T.text}}>{p.ad}</div>
                <div style={{fontSize:13,color:T.textSec}}>{p.rol}{p.tel?" • "+p.tel:""}</div>
                {p.maas&&<div style={{fontSize:12,color:T.warning}}>💰 ₺{p.maas}/ay</div>}
                <div style={{fontSize:12,color:T.textSec,marginTop:2}}>{pIs} iş • ₺{pTah.toFixed(0)} tahsilat</div>
                {p.notlar&&<div style={{fontSize:11,color:T.textSec,marginTop:2}}>📝 {p.notlar}</div>}
              </div>
            </div>
            {/* Aksiyon butonları */}
            <div style={{display:"flex",gap:6,marginTop:10,flexWrap:"wrap"}}>
              <button onClick={()=>setPersonelForm({...p})}
                style={{padding:"8px 14px",borderRadius:9,background:T.primary+"12",border:`1px solid ${T.primary}30`,
                  color:T.primary,cursor:"pointer",fontSize:13,fontWeight:600}}>✏️ Düzenle</button>
              <button onClick={async ()=>{
                const yeniListe = personeller.map(pp=>pp.id===p.id?{...pp,aktif:!pp.aktif}:pp);
                setPersoneller(yeniListe);
                await updateDoc(doc(db, "kullanicilar", kullanici.email), { personeller: yeniListe });
              }}
                style={{padding:"8px 14px",borderRadius:9,
                  border:`1.5px solid ${p.aktif?T.success:T.danger}`,
                  background:p.aktif?T.success+"15":T.danger+"15",
                  color:p.aktif?T.success:T.danger,cursor:"pointer",fontSize:13,fontWeight:600}}>
                {p.aktif?"✓ Aktif":"✗ Pasif"}
              </button>
              <button onClick={async ()=>{
                if(!window.confirm(`"${p.ad}" personel listesinden silinsin mi?`)) return;
                const yeniListe = personeller.filter(pp=>pp.id!==p.id);
                setPersoneller(yeniListe);
                await updateDoc(doc(db, "kullanicilar", kullanici.email), { personeller: yeniListe });
        }} style={{padding:"8px 14px",borderRadius:9,background:T.danger+"12",border:`1px solid ${T.danger}30`,
                color:T.danger,cursor:"pointer",fontSize:13,fontWeight:600}}>🗑 Sil</button>
            </div>
          </div>
        );
     })}

      <button onClick={() => setPersonelForm({ ad: "", rol: "", tel: "", maas: "", notlar: "" })}
        style={{ width: "100%", padding: "15px", borderRadius: 14, background: T.primary, border: "none", color: "#fff", cursor: "pointer", fontSize: 15, fontWeight: 700, marginTop: 4 }}>
        + Yeni Personel Ekle
      </button>

    </div>
  ); // 🚀 renderPersonel fonksiyonu burada güvenle bitti

  const renderTahsilat=()=>(
    <div style={{height:"100%",overflowY:"auto",padding:16}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
        {[{l:"Toplam Alacak",v:`₺${istat.odenmemis.toFixed(2)}`,c:T.danger},{l:"Borçlu Müşteri",v:istat.borclu,c:T.warning}].map((k,i)=>(
          <div key={i} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14}}>
            <div style={{fontSize:12,color:T.textSec,marginBottom:4}}>{k.l}</div>
            <div style={{fontSize:22,fontWeight:900,color:k.c}}>{k.v}</div>
          </div>
        ))}
      </div>
      {isler.filter(is=>!is.tahsilat&&(is.hesaplama?.genelToplam||0)>0&&is.status!=="adres_bekliyor").map(is=>(
        <div key={is.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:10,
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <div style={{fontSize:15,fontWeight:600,color:T.text}}>{is.musteriAdi}</div>
            <div style={{fontSize:12,color:T.textSec}}>{is.fisNo?.split("—")[0]?.trim()}</div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:17,fontWeight:800,color:T.danger}}>₺{formatPara(is.hesaplama?.genelToplam || 0)}</span>
            <button onClick={()=>setShowTahsilat(is)} style={{padding:"9px 14px",borderRadius:10,background:T.success,
              border:"none",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700}}>💵 Al</button>
          </div>
        </div>
      ))}
      {musteriler.filter(m=>(m.borc||0)>0).length>0&&(
        <>
          <h3 style={{fontSize:14,fontWeight:700,color:T.textSec,margin:"16px 0 10px"}}>⚠️ Borçlu Müşteriler</h3>
          {musteriler.filter(m=>(m.borc||0)>0).map(m=>(
            <div key={m.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:8,
              display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{fontSize:15,fontWeight:600,color:T.text}}>{m.ad}</div>
                <div style={{fontSize:12,color:T.textSec}}>{m.tel}</div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:17,fontWeight:800,color:T.danger}}>₺{(m.borc||0).toFixed(2)}</span>
                <button onClick={()=>setShowMusteriProfil(m)} style={{padding:"9px 12px",borderRadius:10,background:T.primary,
                  border:"none",color:"#fff",cursor:"pointer",fontSize:13}}>Profil</button>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );

  // ─── ŞOFÖR MODU MODAL ───
  const SoforModuModal=()=>{
    const bugunAlinacak=isler.filter(is=>is.status==="adres_bekliyor");
    const bugunTeslim=isler.filter(is=>is.status==="teslim_hazir");
    return (
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:800,display:"flex",flexDirection:"column"}}>
        <div style={{background:"#1a2744",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontSize:18,fontWeight:900,color:"#F59E0B"}}>🚗 Şoför Modu</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.6)"}}>{bugun()}</div>
          </div>
          <button onClick={()=>setShowSoforModu(false)} style={{background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",borderRadius:10,padding:"8px 14px",cursor:"pointer",fontSize:16}}>✕ Kapat</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:16}}>
          {/* Alınacaklar */}
          <div style={{marginBottom:20}}>
            <div style={{fontSize:16,fontWeight:700,color:"#F59E0B",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
              📍 Alınacaklar <span style={{background:"#F59E0B",color:"#000",borderRadius:10,padding:"2px 10px",fontSize:13}}>{bugunAlinacak.length}</span>
            </div>
            {bugunAlinacak.length===0?(
              <div style={{background:"rgba(255,255,255,0.05)",borderRadius:14,padding:24,textAlign:"center",color:"rgba(255,255,255,0.4)"}}>Alınacak iş yok</div>
            ):bugunAlinacak.map(is=>(
              <div key={is.id} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(245,158,11,0.25)",borderRadius:16,padding:16,marginBottom:10}}>
                <div style={{fontSize:18,fontWeight:700,color:"#fff",marginBottom:4}}>{is.musteriAdi}</div>
                <div style={{fontSize:14,color:"rgba(255,255,255,0.6)",marginBottom:8}}>{is.musteriTel}</div>
        {is.musteriAdres && (
  <button 
    onClick={() => linkAc(`https://maps.google.com/?q={encodeURIComponent(is.musteriAdres + " " + (is.musteriSemt || ""))}`)}
    style={{
      width: "100%",
      padding: "13px",
      borderRadius: 12,
      background: "rgba(96,165,250,0.2)",
      border: "1px solid rgba(96,165,250,0.3)",
      color: "#60A5FA",
      cursor: "pointer",
      fontSize: 15,
      fontWeight: 700,
      marginBottom: 10,
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      gap: 8
    }}
  >
    📍 {is.musteriAdres} →
  </button>
)}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <button onClick={()=>{const tel=is.musteriTel.replace(/\D/g,"");linkAc(`tel:${tel}`);}}
                    style={{padding:"12px",borderRadius:12,background:"rgba(34,197,94,0.2)",border:"1px solid rgba(34,197,94,0.3)",color:"#4ADE80",cursor:"pointer",fontSize:14,fontWeight:700}}>
                    📞 Ara
                  </button>
                  <button onClick={()=>{setShowHaliAl(is);setShowSoforModu(false);}}
                    style={{padding:"12px",borderRadius:12,background:"#22C55E",border:"none",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700}}>
                    ✓ Halıyı Al
                  </button>
                </div>
              </div>
            ))}
          </div>
          {/* Teslim edilecekler */}
          <div>
            <div style={{fontSize:16,fontWeight:700,color:"#F97316",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
              📦 Teslim Edilecekler <span style={{background:"#F97316",color:"#fff",borderRadius:10,padding:"2px 10px",fontSize:13}}>{bugunTeslim.length}</span>
            </div>
            {bugunTeslim.length===0?(
              <div style={{background:"rgba(255,255,255,0.05)",borderRadius:14,padding:24,textAlign:"center",color:"rgba(255,255,255,0.4)"}}>Teslim edilecek iş yok</div>
            ):bugunTeslim.map(is=>(
              <div key={is.id} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(249,115,22,0.25)",borderRadius:16,padding:16,marginBottom:10}}>
                <div style={{fontSize:18,fontWeight:700,color:"#fff",marginBottom:2}}>{is.musteriAdi}</div>
                <div style={{fontSize:16,fontWeight:800,color:"#F59E0B",marginBottom:4}}>₺{formatPara(is.hesaplama?.genelToplam || 0)}</div>
                <div style={{fontSize:14,color:"rgba(255,255,255,0.6)",marginBottom:8}}>{is.musteriTel}</div>
          {is.musteriAdres && (
  <button 
    onClick={() => linkAc(`https://www.google.com/search?q=https://www.google.com/maps/dir/%3Fapi%3D1${encodeURIComponent(is.musteriAdres)}`)}
    style={{
      width: "100%",
      padding: "13px",
      borderRadius: 12,
      background: "rgba(96,165,250,0.2)",
      border: "1px solid rgba(96,165,250,0.3)",
      color: "#60A5FA",
      cursor: "pointer",
      fontSize: 15,
      fontWeight: 700,
      marginBottom: 10,
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      gap: 8
    }}
  >
    📍 {is.musteriAdres} →
  </button>
)}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <button onClick={()=>{const tel=is.musteriTel.replace(/\D/g,"");linkAc(`tel:${tel}`);}}
                    style={{padding:"12px",borderRadius:12,background:"rgba(34,197,94,0.2)",border:"1px solid rgba(34,197,94,0.3)",color:"#4ADE80",cursor:"pointer",fontSize:14,fontWeight:700}}>
                    📞 Ara
                  </button>
                  <button onClick={()=>{durumGunc(is.id,"teslim_edildi");setShowTahsilat(is);setShowSoforModu(false);}}
                    style={{padding:"12px",borderRadius:12,background:"#3B82F6",border:"none",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700}}>
                    💵 Teslim & Tahsilat
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // ─── RAPORLAR SAYFASI ───
  const renderRaporlar=()=>{
    const toplamGelir=isler.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
    const toplamGider=giderler.reduce((s,g)=>s+g.tutar,0);
    const netKar=toplamGelir-toplamGider;
    const toplamM2=isler.reduce((s,is)=>s+(is.satirlar||[]).reduce((ss,satir)=>{
      const u=urunler.find(u=>u.id===satir?.tipId);
      return ss+(u?.birim==="m2"?parseFloat(satir?.miktar||0)||0:0);
    },0),0);

    // Müşteri döngü analizi
    const dongüAnalizi=musteriler.map(m=>{
      const mIs=[...isler.filter(is=>is.musteriId===m.id)].sort((a,b)=>{
        const pa=a.alisTarihi?.split("."); const pb=b.alisTarihi?.split(".");
        if(!pa||!pb) return 0;
        return new Date(+pa[2],+pa[1]-1,+pa[0])-new Date(+pb[2],+pb[1]-1,+pb[0]);
      });
      if(mIs.length<2) return null;
      const araliklar=[];
      for(let i=1;i<mIs.length;i++){
        const p1=mIs[i-1].alisTarihi?.split(".");
        const p2=mIs[i].alisTarihi?.split(".");
        if(!p1||!p2) continue;
        const fark=Math.floor((new Date(+p2[2],+p2[1]-1,+p2[0])-new Date(+p1[2],+p1[1]-1,+p1[0]))/86400000);
        araliklar.push(fark);
      }
      if(!araliklar.length) return null;
      const ortGun=Math.round(araliklar.reduce((s,x)=>s+x,0)/araliklar.length);
      const sonIs=mIs[mIs.length-1];
      const gecenGun=gunFarki(sonIs.alisTarihi||bugun());
      const tahminiKalanGun=ortGun-gecenGun;
      return {musteri:m,ortGun,gecenGun,tahminiKalanGun,sonIs,ciro:mIs.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0)};
    }).filter(Boolean).sort((a,b)=>a.tahminiKalanGun-b.tahminiKalanGun);

    // Mevsim karşılaştırması
    const buAy=new Date().getMonth();
    const buYil=new Date().getFullYear();
    const buAyIs=isler.filter(is=>{const p=is.alisTarihi?.split(".");return p&&+p[1]-1===buAy&&+p[2]===buYil;}).length;
    const gecenYilAyIs=isler.filter(is=>{const p=is.alisTarihi?.split(".");return p&&+p[1]-1===buAy&&+p[2]===buYil-1;}).length;

    // Ürün analizi
    const urunAnalizi=urunler.map(u=>{
      const satislar=isler.flatMap(is=>(is.satirlar||[]).filter(s=>s?.tipId===u.id));
      const m2=satislar.reduce((s,satir)=>s+(parseFloat(satir?.miktar||0)||0),0);
      const gelir=satislar.reduce((s,satir)=>s+hesaplaSatir({...satir,varsayilanFiyat:u.fiyat}).satirToplam,0);
      return {...u,satisAdet:satislar.length,m2,gelir};
    }).filter(u=>u.satisAdet>0).sort((a,b)=>b.gelir-a.gelir);

    return (
      <div style={{height:"100%",overflowY:"auto",padding:16}}>
        {/* Genel özet */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          {[
            {l:"💰 Toplam Gelir",v:`₺${toplamGelir.toFixed(2)}`,c:T.success},
            {l:"📤 Toplam Gider",v:`₺${toplamGider.toFixed(2)}`,c:T.danger},
            {l:"🏆 Net Kâr",v:`₺${netKar.toFixed(2)}`,c:netKar>=0?T.success:T.danger},
            {l:"📐 Toplam m²",v:`${toplamM2.toFixed(1)} m²`,c:T.primary},
          ].map((k,i)=>(
            <div key={i} style={{background:T.card,border:`1.5px solid ${k.c}30`,borderRadius:14,padding:"14px 16px"}}>
              <div style={{fontSize:12,color:T.textSec,marginBottom:4}}>{k.l}</div>
              <div style={{fontSize:18,fontWeight:900,color:k.c}}>{k.v}</div>
            </div>
          ))}
        </div>

        {/* Mevsim karşılaştırması */}
        {(buAyIs>0||gecenYilAyIs>0)&&(
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:10}}>📅 Bu Ay vs Geçen Yıl Aynı Ay</div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:28,fontWeight:900,color:T.primary}}>{buAyIs}</div>
                <div style={{fontSize:12,color:T.textSec}}>{buYil} {["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"][buAy]}</div>
              </div>
              <div style={{fontSize:24,color:buAyIs>=gecenYilAyIs?T.success:T.danger}}>
                {buAyIs>gecenYilAyIs?"📈":buAyIs===gecenYilAyIs?"➡️":"📉"}
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:28,fontWeight:900,color:T.textSec}}>{gecenYilAyIs}</div>
                <div style={{fontSize:12,color:T.textSec}}>{buYil-1} {["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"][buAy]}</div>
              </div>
            </div>
            {buAyIs<gecenYilAyIs&&(
              <div style={{marginTop:10,padding:"8px 12px",background:T.warning+"15",borderRadius:10,fontSize:13,color:T.warning,fontWeight:600}}>
                ⚠️ Geçen yıla göre {gecenYilAyIs-buAyIs} iş az. Kampanya zamanı!
              </div>
            )}
          </div>
        )}

        {/* Müşteri döngü analizi */}
        {dongüAnalizi.length>0&&(
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:10}}>🔄 Müşteri Döngü Analizi</div>
            <div style={{fontSize:12,color:T.textSec,marginBottom:10}}>Ort. gelme süresine göre yakında beklenenler:</div>
            {dongüAnalizi.slice(0,8).map(({musteri:m,ortGun,gecenGun,tahminiKalanGun,ciro})=>{
              const durum=tahminiKalanGun<=0?"gecikmis":tahminiKalanGun<=7?"yaklasan":"bekliyor";
              const renk=durum==="gecikmis"?T.danger:durum==="yaklasan"?T.warning:T.success;
              return (
                <div key={m.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"10px 12px",background:T.statCard,borderRadius:10,marginBottom:6}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.ad}</div>
                    <div style={{fontSize:11,color:T.textSec}}>Ort. {ortGun} günde bir • {gecenGun} gün geçti</div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontSize:12,fontWeight:700,color:renk}}>
                        {durum==="gecikmis"?`${Math.abs(tahminiKalanGun)} gün geçti!`:durum==="yaklasan"?`${tahminiKalanGun} gün kaldı`:`${tahminiKalanGun} gün sonra`}
                      </div>
                      <div style={{fontSize:10,color:T.textSec}}>₺{ciro.toFixed(0)} ciro</div>
                    </div>
                    <button onClick={()=>{
                      const tel=(m.tel||"").replace(/\D/g,"");
                      const waTel=tel.startsWith("0")?"90"+tel.slice(1):tel;
                      linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent("Sayın "+m.ad+" 🧹 Ortalama "+ortGun+" günde bir halılarınızı yıkatıyorsunuz. Sizi bekliyoruz!")}`);
                    }} style={{padding:"6px 10px",borderRadius:8,background:"#25D36615",border:"1px solid #25D36630",color:"#25D366",cursor:"pointer",fontSize:13}}>📱</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Ürün analizi */}
        {urunAnalizi.length>0&&(
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:12}}>📊 Ürün / Hizmet Analizi</div>
            {urunAnalizi.map((u,i)=>{
              const maxGelir=urunAnalizi[0].gelir||1;
              return (
                <div key={u.id} style={{marginBottom:12}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{width:22,height:22,borderRadius:"50%",background:T.primary,color:"#fff",fontSize:10,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{i+1}</span>
                      <span style={{fontSize:13,fontWeight:600,color:T.text}}>{u.ad}</span>
                    </div>
                    <span style={{fontSize:13,fontWeight:700,color:T.success}}>₺{u.gelir.toFixed(0)}</span>
                  </div>
                  <div style={{height:6,background:T.border,borderRadius:3,overflow:"hidden"}}>
                    <div style={{height:"100%",width:`${(u.gelir/maxGelir)*100}%`,background:T.primary,borderRadius:3,transition:"width 0.5s"}}/>
                  </div>
                  <div style={{fontSize:11,color:T.textSec,marginTop:2}}>{u.satisAdet} iş{u.birim==="m2"?` • ${u.m2.toFixed(1)} m²`:""}</div>
                </div>
              );
            })}
          </div>
        )}

        {/* Akıllı fiyat önerisi */}
        {musteriler.length>0&&isler.length>0&&(
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}}>🤖 Akıllı Fiyat Önerisi</div>
            <div style={{fontSize:12,color:T.textSec,marginBottom:12}}>Geçmiş fişlere göre müşteri bazlı ortalama m² fiyatları:</div>
            {[...musteriler].map(m=>{
              const mIs=isler.filter(is=>is.musteriId===m.id&&(is.hesaplama?.genelToplam||0)>0&&(is.satirlar||[]).length>0);
              if(!mIs.length) return null;
              const topM2=mIs.reduce((s,is)=>s+(is.satirlar||[]).reduce((ss,satir)=>{const u=urunler.find(u=>u.id===satir?.tipId);return ss+(u?.birim==="m2"?parseFloat(satir?.miktar||0)||0:0);},0),0);
              const topGelir=mIs.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
              if(!topM2) return null;
              const ortFiyat=topGelir/topM2;
              return {m,ortFiyat,isCount:mIs.length,topM2};
            }).filter(Boolean).sort((a,b)=>b.topM2-a.topM2).slice(0,5).map(({m,ortFiyat,isCount,topM2})=>(
              <div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 12px",background:T.statCard,borderRadius:10,marginBottom:6}}>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:T.text}}>{m.ad}</div>
                  <div style={{fontSize:11,color:T.textSec}}>{isCount} fiş • {topM2.toFixed(1)} m² toplam</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:14,fontWeight:700,color:T.warning}}>₺{ortFiyat.toFixed(1)}/m²</div>
                  <div style={{fontSize:10,color:T.textSec}}>önerilen fiyat</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Gider listesi */}
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text}}>📤 Giderler</div>
            <button onClick={()=>setShowGiderForm(true)} style={{padding:"6px 12px",borderRadius:9,background:T.danger,border:"none",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:600}}>+ Gider Ekle</button>
          </div>
          {giderler.length===0?(
            <div style={{textAlign:"center",padding:20,color:T.textSec,fontSize:13}}>Henüz gider kaydı yok</div>
          ):Object.entries(giderler.reduce((acc,g)=>{if(!acc[g.kategori])acc[g.kategori]=0;acc[g.kategori]+=g.tutar;return acc;},{})).map(([kat,toplam])=>(
            <div key={kat} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:T.statCard,borderRadius:10,marginBottom:6}}>
              <span style={{fontSize:13,color:T.text}}>{kat}</span>
              <span style={{fontSize:14,fontWeight:700,color:T.danger}}>₺{toplam.toFixed(2)}</span>
            </div>
          ))}
          {giderler.slice(-5).reverse().map(g=>(
            <div key={g.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",marginBottom:4,fontSize:12}}>
              <div style={{color:T.textSec}}>{g.tarih} — {g.aciklama||g.kategori}</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{color:T.danger,fontWeight:600}}>₺{g.tutar.toFixed(2)}</span>
                <button onClick={()=>{if(window.confirm("Bu gider silinsin mi?"))setGiderler(prev=>prev.filter(gg=>gg.id!==g.id));}}
                  style={{background:"none",border:"none",color:T.danger,cursor:"pointer",fontSize:14}}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ─── FASON DETAY SAYFASI ───
  const renderFasonDetay=()=>{
    const fasonIsler=isler.filter(is=>is.status==="fason");
    const toplamFason=fasonIsler.length;
    return (
      <div style={{height:"100%",overflowY:"auto",padding:16}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div style={{background:T.card,border:`1px solid ${T.danger}30`,borderRadius:14,padding:14}}>
            <div style={{fontSize:12,color:T.textSec,marginBottom:4}}>🔧 Fasonda Bekleyen</div>
            <div style={{fontSize:22,fontWeight:900,color:T.danger}}>{toplamFason} iş</div>
          </div>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14}}>
            <div style={{fontSize:12,color:T.textSec,marginBottom:4}}>💰 Tahmini Değer</div>
            <div style={{fontSize:22,fontWeight:900,color:T.warning}}>₺{fasonIsler.reduce((s,is)=>s+(is.hesaplama?.genelToplam||0),0).toFixed(0)}</div>
          </div>
        </div>
        {fasonIsler.length===0?(
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:40,textAlign:"center"}}>
            <div style={{fontSize:36,marginBottom:8}}>🔧</div>
            <div style={{fontSize:15,color:T.textSec}}>Fasonda iş yok</div>
          </div>
        ):fasonIsler.map(is=>{
          const fasonGun=gunFarki(is.fasonTarihi||is.alisTarihi||bugun());
          return (
            <div key={is.id} style={{background:T.card,border:`1.5px solid ${fasonGun>7?T.danger:T.border}`,borderRadius:16,padding:14,marginBottom:10}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <div style={{fontSize:16,fontWeight:700,color:T.text}}>{is.musteriAdi}</div>
                  <div style={{fontSize:12,color:T.textSec}}>{is.fisNo?.split("—")[0]?.trim()} • {is.alisTarihi}</div>
                  {is.fasonFirma&&<div style={{fontSize:12,color:T.primary,marginTop:2}}>🏭 {is.fasonFirma}</div>}
                  {is.fasonFiyat&&<div style={{fontSize:12,color:T.danger,marginTop:2}}>Fason maliyeti: ₺{is.fasonFiyat}</div>}
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:13,fontWeight:700,color:fasonGun>7?T.danger:T.textSec}}>{fasonGun} gündür fasonda</div>
                  <div style={{fontSize:15,fontWeight:800,color:T.warning}}>₺{formatPara(is.hesaplama?.genelToplam || 0)}</div>
                </div>
              </div>
              {fasonGun>7&&(
                <div style={{padding:"7px 12px",background:T.danger+"12",borderRadius:10,marginBottom:10,fontSize:12,color:T.danger,fontWeight:600}}>
                  ⚠️ {fasonGun} gündür fasonda — takip edin!
                </div>
              )}
              {/* Fason firması ve maliyet gir */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
                <Inp label="Fason Firması" value={is.fasonFirma||""} onChange={v=>setIsler(p=>p.map(ii=>ii.id===is.id?{...ii,fasonFirma:v}:ii))} T={T} placeholder="Ahmet Usta"/>
                <Inp label="Fason Maliyeti ₺" value={is.fasonFiyat||""} onChange={v=>setIsler(p=>p.map(ii=>ii.id===is.id?{...ii,fasonFiyat:v}:ii))} type="number" T={T}/>
              </div>
              {is.fasonFiyat&&is.hesaplama?.genelToplam&&(
                <div style={{padding:"7px 12px",background:T.success+"12",borderRadius:10,marginBottom:10,fontSize:12,color:T.success}}>
                  Kâr Marjı: ₺{((is.hesaplama.genelToplam)-(parseFloat(is.fasonFiyat)||0)).toFixed(2)}
                  {" "}(%{(((is.hesaplama.genelToplam-(parseFloat(is.fasonFiyat)||0))/is.hesaplama.genelToplam)*100).toFixed(0)})
                </div>
              )}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <button onClick={()=>durumGunc(is.id,"kurutuluyor")} style={{padding:"11px",borderRadius:11,background:T.success,border:"none",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700}}>✓ Döndü</button>
                <button onClick={()=>{const tel=(is.musteriTel||"").replace(/\D/g,"");const waTel=tel.startsWith("0")?"90"+tel.slice(1):tel;linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent("Sayın "+is.musteriAdi+" 🧹 Fason işleminiz tamamlandı, en kısa sürede teslim edeceğiz.")}`);}}
                  style={{padding:"11px",borderRadius:11,background:"#25D36615",border:"1px solid #25D36630",color:"#25D366",cursor:"pointer",fontSize:14,fontWeight:700}}>📱 WA</button>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const sayfaIcerigi=()=>{
    if(sayfa==="anaSayfa") return renderAnaSayfa();
    if(sayfa==="isler") return renderIsler();
    if(sayfa==="saha") return renderSaha();
    if(sayfa==="musteriler") return renderMusteriler();
    if(sayfa==="kasa") return renderKasa();
    if(sayfa==="tahsilat") return renderTahsilat();
    if(sayfa==="personel") return renderPersonel();
    if(sayfa==="ayarlar") return renderAyarlar();
    if(sayfa==="raporlar") return renderRaporlar();
    if(sayfa==="fason") return renderFasonDetay();
    return null;
  };

  // 1. EĞER KULLANICI YOKSA VE ROL SEÇİMİ AÇIK DEĞİLSE -> GİRİŞ EKRANI
  if (!kullanici && !showRolSecim) {
    return <AuthEkrani onGiris={handleGiris} onKayit={handleKayit} T={T} t={t} />;
  }

  if (!kullanici && showRolSecim) {
    return (
      <RolSecimEkrani 
        bekleyenUser={bekleyenUser} 
        personelRolleri={personelRolleri} 
        personeller={personeller} // 🚀 BURASI KRİTİK: Listeyi buraya paslamalıyız
        onRolSec={(secilenRolId, secilenPersonel) => {
          // Giriş yapanın rolünü ve seçtiği ismi son kullanıcı objesine mühürle
          const sonUser = { 
            ...bekleyenUser, 
            rol: secilenRolId,
            aktifPersonel: secilenPersonel ? { ad: secilenPersonel.ad, id: secilenPersonel.id } : null
          };
          setKullanici(sonUser);
          localStorage.setItem("halici_k", JSON.stringify(sonUser));
          setShowRolSecim(false); 
        }}
        T={T}
      />
    );
  }

  // 🔒 Lisans süresi dolmuş ekranı - Tamamen senin onayına bağlı
  if (lisansKilitli) return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <div style={{ fontSize: 64, marginBottom: 12 }}>🔒</div>
        <h1 style={{ fontSize: 24, fontWeight: 900, color: T.text, margin: "0 0 8px" }}>Deneme Süresi Sona Erdi</h1>
        <p style={{ color: T.textSec, fontSize: 15, margin: 0 }}>15 günlük ücretsiz deneme süreniz doldu.</p>
      </div>

      <div style={{ width: "100%", maxWidth: 400, background: T.card, borderRadius: 24, padding: 24, border: `1px solid ${T.border}`, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 14 }}>✅ Verileriniz Güvende</div>
        <div style={{ fontSize: 13, color: T.textSec, lineHeight: 1.6, marginBottom: 16 }}>
          Tüm müşteri kayıtlarınız ve iş fişleriniz saklanmaktadır. 
          Üyeliğiniz dükkan sahibi tarafından onaylandıktan sonra kullanıma devam edebilirsiniz.
        </div>

        <div style={{ background: T.primary + "12", border: `1px solid ${T.primary}30`, borderRadius: 14, padding: 16, marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: T.primary, marginBottom: 4, textTransform: "uppercase" }}>Kullanıcı Hesabı</div>
          <div style={{ fontSize: 16, fontWeight: 800, color: T.text }}>
  {[kullanici?.adSoyad || kullanici?.ad, kullanici?.soyad].filter(Boolean).join(" ").trim()}
</div>
          <div style={{ fontSize: 12, color: T.textSec }}>{kullanici?.email}</div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {/* Müşteri sana WhatsApp'tan "Onayla" mesajı atar */}
          <a href={`https://wa.me/905375166664?text=${encodeURIComponent(`Selam Burhan, HaliPro üyeliğimi aktif eder misin?\n\nKullanıcı: ${kullanici?.ad}\nE-posta: ${kullanici?.email}`)}`}
            target="_blank" rel="noopener noreferrer"
            style={{ display: "block", padding: "16px", borderRadius: 12, background: "#25D366", color: "#fff", textAlign: "center", fontSize: 16, fontWeight: 800, textDecoration: "none", boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)" }}>
            🚀 Şimdi Onay Al
          </a>

          <button onClick={() => { setKullanici(null); localStorage.removeItem("halici_k"); }}
            style={{ padding: "12px", borderRadius: 10, background: "transparent", border: "none", color: T.textSec, cursor: "pointer", fontSize: 14 }}>
            Farklı Hesapla Giriş Yap
          </button>
        </div>
      </div>
      
      <p style={{ fontSize: 12, color: T.textSec }}>Hesap: {kullanici?.email || "Bilinmiyor"}</p>
    </div>
  );

// ─── NAVIGASYON (YETKİ MOTORUNA BAĞLI DİNAMİK LİSTE) ───
  const TUM_MENULER = [
    { id: "anaSayfa", icon: "🏠", label: t("anaSayfa"), badge: 0, yetki: "ana_sayfa" },
    { id: "isler", icon: "📋", label: t("isler"), badge: istat.aktif, yetki: "sekme_tumu" }, 
    { id: "saha", icon: "🚗", label: t("saha"), badge: sayac.adres_bekliyor || 0, yetki: "saha_giris" },
    { id: "musteriler", icon: "👥", label: t("musteriler"), badge: istat.borclu || 0, yetki: "musteri_yonetim" },
    { id: "kasa", icon: "💰", label: t("kasa"), badge: 0, yetki: "kasa_rapor" },
    { id: "ayarlar", icon: "⚙️", label: t("ayarlar"), badge: 0, yetki: null } // 👈 KİLİT SÖKÜLDÜ (Herkese Açık)
  ];

  // 🚀 BEYİN: Patron ise tüm butonlar dizilir. 
  // Değilse, sadece Patronun 'Açık' bıraktığı şalterlere (yetkilere) göre menü otomatik çizilir!
  const NAV = TUM_MENULER.filter(menu => {
    // 1️⃣ Patron her şeyi görür
    if (kullanici?.rol === "patron") return true;
    
    // 2️⃣ ⚙️ AYARLAR SEKME KİLİDİ AÇILDI: Herkes (şoför, yıkamacı vb.) Ayarlar sekmesini görebilir.
    // İçindeki hassas yerler (İşletme, Personel, Veri) zaten kendi içinde korunuyor.
    if (menu.id === "ayarlar") return true;

    // 3️⃣ İŞLER SAYFASI: Herhangi bir sekmeyi görme yetkisi varsa ana menüde görünsün
    if (menu.id === "isler") {
      return yetkiVarMi("sekme_tumu") || 
             yetkiVarMi("sekme_alinacak") || 
             yetkiVarMi("sekme_aracta") || 
             yetkiVarMi("sekme_yikanacak") || 
             yetkiVarMi("sekme_yikaniyor") || 
             yetkiVarMi("sekme_kurutuluyor") || 
             yetkiVarMi("sekme_hazir") || 
             yetkiVarMi("sekme_dagitimda");
    }
    
    // 4️⃣ Diğer butonlar patron panelindeki şalterlere bakar
    return yetkiVarMi(menu.yetki);
  });

  const sayfaBaslik=()=>{
    if(sayfa==="saha") return t("saha");
    if(sayfa==="isler") return t("isler");
    if(sayfa==="musteriler") return t("musteriler");
    if(sayfa==="kasa") return t("kasa");
    if(sayfa==="tahsilat") return t("tahsilat");
    if(sayfa==="personel") return t("personel");
    if(sayfa==="ayarlar") return altSayfa?null:t("ayarlar");
    if(sayfa==="raporlar") return "📊 Raporlar & Analiz";
    if(sayfa==="fason") return "🔧 Fason Takibi";
    return "HaliPro";
  };

  return (
    <div style={{height:"100vh",display:"flex",flexDirection:"column",background:T.bg,
      fontFamily:"'Segoe UI','SF Pro Display','DM Sans',system-ui,sans-serif",color:T.text,overflow:"hidden",
      maxWidth:"100vw"}}>
      <style>{`
        *{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}
        select option{background:${T.card};color:${T.text};}
        ::-webkit-scrollbar{width:2px;height:2px;}
        ::-webkit-scrollbar-thumb{background:${T.border};border-radius:2px;}
        @keyframes callerSlide{from{opacity:0;transform:translateX(50px)}to{opacity:1;transform:translateX(0)}}
        @keyframes callerPulse{0%,100%{box-shadow:0 0 0 0 rgba(34,197,94,0.4)}50%{box-shadow:0 0 0 12px rgba(34,197,94,0)}}
        @keyframes slideInRight{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}
        @keyframes sesliPulse{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,0.5)}50%{box-shadow:0 0 0 8px rgba(239,68,68,0)}}
        input,select,textarea,button{font-family:inherit;}
        input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;}
        button:active{opacity:0.85 !important;transform:scale(0.98);}
      `}</style>

      {/* CallerID */}
      {callerNumara&&<CallerIdPopup numara={callerNumara} musteriler={musteriler}
        onFisAc={(m)=>{setShowFis(true);}}
        onSahayaEkle={(m)=>{
          const fis={id:Date.now(),fisNo:yeniFisNo(),musteriId:m.id,musteriAdi:m.ad,musteriTel:m.tel,
            musteriAdres:m.adres,musteriSemt:m.semt,alisTarihi:bugun(),teslimTarihi:tarihEkle(isletme.teslimGun||7),
            status:"adres_bekliyor",satirlar:[],hesaplama:{araToplam:0,iskonto:0,nakliye:0,ambalaj:0,kdv:0,genelToplam:0},tahsilat:null};
          setIsler(p=>[fis,...p]);setSayfa("saha");
        }}
        onKayitYap={(num)=>setShowMusteriForm({tel:num})}
        onKapat={callerKapat} T={T} t={t}/>}

      {/* Header */}
      {!(sayfa==="ayarlar"&&altSayfa)&&(
        <div style={{background:T.header,padding:"12px 16px",display:"flex",alignItems:"center",
          justifyContent:"space-between",flexShrink:0,minHeight:56}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {(sayfa==="personel"||sayfa==="raporlar"||sayfa==="fason")&&(
              <button onClick={()=>setSayfa(sayfa==="personel"?"ayarlar":"anaSayfa")} style={{background:"rgba(255,255,255,0.15)",border:"none",
                color:"#fff",borderRadius:10,padding:"7px 12px",cursor:"pointer",fontSize:16}}>←</button>
            )}
            {sayfa!=="personel"&&sayfa!=="raporlar"&&sayfa!=="fason"&&(
  <img 
    src={`${process.env.PUBLIC_URL}/logo.png`} 
    alt="HalıPro Logo" 
    style={{ 
      height: 40, 
      width: "auto", 
      objectFit: "contain",
      borderRadius: 8 // Şekline göre köşeleri hafif yumuşatır
    }} 
  />
)}
            <div>
              <div style={{fontSize:16,fontWeight:700,color:"#fff"}}>{sayfaBaslik()||"HaliPro"}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.6)"}}>{new Date().toLocaleDateString("tr-TR",{weekday:"long",day:"numeric",month:"long"})}</div>
            </div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            {/* 🚀 BEYİN: Yeni fişe basınca önce eski hafızayı (duzenlenenFis) sıfırlar! */}
            {sayfa==="isler"&&<button onClick={()=>{ setDuzenlenenFis(null); setShowFis(true); }} style={{padding:"8px 16px",borderRadius:11,background:T.accent,border:"none",color:"#000",cursor:"pointer",fontSize:13,fontWeight:700}}>+ {t("yeniFis")}</button>}
            
            {sayfa==="musteriler"&&<button onClick={()=>setShowMusteriForm({})} style={{padding:"8px 16px",borderRadius:11,background:T.accent,border:"none",color:"#000",cursor:"pointer",fontSize:13,fontWeight:700}}>+ {t("ekle")}</button>}
            
            {/* 🚀 BEYİN: Saha sayfasındaki Yeni Fiş butonu */}
            {sayfa === "saha" && (
              <button 
                onClick={() => { setDuzenlenenFis(null); setShowFis(true); }} 
                style={{ padding: "8px 16px", borderRadius: 11, background: T.accent, border: "none", color: "#000", cursor: "pointer", fontSize: 13, fontWeight: 700 }}
              >
                + {t("yeniFis")}
              </button>
            )}
            
            {sayfa==="kasa"&&<button onClick={()=>setShowGiderForm(true)} style={{padding:"8px 14px",borderRadius:11,background:T.danger+"20",border:`1px solid ${T.danger}40`,color:T.danger,cursor:"pointer",fontSize:13,fontWeight:700}}>+ Gider</button>}
            
            {sayfa==="raporlar"&&<button onClick={()=>{
              const w=window.open("","_blank");
              const toplamGelir=isler.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
              const toplamGider=giderler.reduce((s,g)=>s+(g.tutar||0),0);
              w.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>HaliPro Raporu</title><style>body{font-family:Arial;padding:24px;max-width:800px;margin:0 auto}h1{color:#1E3A5F}table{width:100%;border-collapse:collapse;margin:12px 0}th{background:#1E3A5F;color:#fff;padding:8px}td{padding:6px 8px;border-bottom:1px solid #eee}@media print{.noprint{display:none}}</style></head><body><div class="noprint" style="margin-bottom:12px"><button onclick="window.print()" style="padding:8px 18px;background:#1E3A5F;color:#fff;border:none;border-radius:6px;cursor:pointer">🖨️ Yazdır / PDF</button></div><h1>HaliPro Raporu — ${new Date().toLocaleDateString("tr-TR")}</h1><h2>Özet</h2><table><tr><th>Kalem</th><th>Değer</th></tr><tr><td>Toplam Gelir</td><td>₺${toplamGelir.toFixed(2)}</td></tr><tr><td>Toplam Gider</td><td>₺${toplamGider.toFixed(2)}</td></tr><tr><td>Net Kâr</td><td>₺${(toplamGelir-toplamGider).toFixed(2)}</td></tr><tr><td>Toplam İş</td><td>${isler.length}</td></tr><tr><td>Toplam Müşteri</td><td>${musteriler.length}</td></tr></table><h2>Giderler</h2><table><tr><th>Tarih</th><th>Kategori</th><th>Açıklama</th><th>Tutar</th></tr>${giderler.map(g=>`<tr><td>${g.tarih}</td><td>${g.kategori}</td><td>${g.aciklama}</td><td>₺${(g.tutar||0).toFixed(2)}</td></tr>`).join("")}</table></body></html>`);
              w.document.close();
            }} style={{padding:"8px 14px",borderRadius:11,background:T.primary+"20",border:`1px solid ${T.primary}40`,color:T.primary,cursor:"pointer",fontSize:13,fontWeight:700}}>📄 PDF Rapor</button>}
          </div>
        </div>
      )}

{/* İçerik */}
<div style={{flex:1,overflow:"hidden"}} key={sayfa}>
  {sayfaIcerigi()}
</div>

      {/* 📱 ALT NAVİGASYON (SÜPÜRGE SİSTEMLİ) */}
      <div style={{
        background: T.navBg, 
        borderTop: `1px solid ${T.navBorder}`, 
        display: "flex",
        justifyContent: "space-around", 
        padding: "6px 0", 
        paddingBottom: "max(6px, env(safe-area-inset-bottom))",
        flexShrink: 0, 
        boxShadow: "0 -4px 20px rgba(0,0,0,0.08)"
      }}>
        {NAV.map(n => (
          <button key={n.id} onClick={() => {
            // 1️⃣ Sayfayı Değiştir
            setSayfa(n.id);
            setAltSayfa(null);
            
            // 2️⃣ Aramayı ve Filtreleri Temizle
            setDurumFiltre("hepsi");
            setAramaMetni("");

            // 3️⃣ 🔥 EKRANI SÜPÜR (Açık kalan tüm yan panelleri zorla kapatır)
            setShowMusteriProfil(null); // Müşteriler sayfasından kalan profil panelini kapatır
            setShowMusteriForm(null);   // Müşteri ekleme/düzenleme formunu kapatır
            setShowFis(false);          // Yeni fiş ekranını kapatır
            setShowTahsilat(null);      // Tahsilat ekranını kapatır
            setShowHaliAl(null);        // Halı ölçü girme ekranını kapatır
            setShowIade(null);          // İade ekranını kapatır
            setShowRolSecim(false);     // Rol seçim ekranını kapatır
            setSifreSecenekModal(null); // Şifre modalını kapatır
            setEditGrup(null);          // Grup/Rol düzenleme modalını kapatır
          }}
          style={{
            display: "flex", flexDirection: "column", alignItems: "center", gap: 2, padding: "4px 8px",
            background: "none", border: "none", cursor: "pointer", minWidth: 52, position: "relative", flex: 1
          }}>
            {n.badge > 0 && (
              <span style={{
                position: "absolute", top: 0, right: "50%", marginRight: -22,
                background: T.danger, color: "#fff", borderRadius: 9, fontSize: 9, padding: "1px 5px", fontWeight: 700
              }}>
                {n.badge}
              </span>
            )}
            <span style={{ fontSize: 22, lineHeight: 1.2 }}>{n.icon}</span>
            <span style={{
              fontSize: 10, 
              fontWeight: sayfa === n.id ? 700 : 500, 
              color: sayfa === n.id ? T.primary : T.textSec
            }}>
              {n.label}
            </span>
            {sayfa === n.id && (
              <div style={{ width: 20, height: 2.5, borderRadius: 2, background: T.primary, marginTop: 2 }} />
            )}
          </button>
        ))}
      </div>


      {/* 🚀 MODERN ŞİFRE YÖNETİM PANELİ BAŞLADI */}
      {sifreSecenekModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)", zIndex: 2000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
             onClick={() => setSifreSecenekModal(null)}>
          <div style={{ background: T.bg, width: "100%", maxWidth: 500, borderRadius: "32px 32px 0 0", padding: "24px 24px 40px 24px", animation: "slideUp 0.3s ease-out", boxShadow: "0 -10px 40px rgba(0,0,0,0.5)" }}
               onClick={e => e.stopPropagation()}>
            <div style={{ width: 40, height: 5, background: T.border, borderRadius: 10, margin: "0 auto 24px" }} />
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <div style={{ fontSize: 44, marginBottom: 12 }}>{sifreSecenekModal.icon}</div>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: T.text }}>{sifreSecenekModal.ad}</h2>
              <p style={{ color: T.textSec, fontSize: 14, marginTop: 4 }}>Güvenlik & Şifre Yönetimi</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <button onClick={async () => {
                const yeni = prompt(`${sifreSecenekModal.ad} için yeni şifre girin:`);
                if (yeni !== null && yeni.trim() !== "") {
                   try {
                     const userRef = doc(db, "kullanicilar", kullanici.email);
                     const pinAlani = `pin_${sifreSecenekModal.id}`;
                     await updateDoc(userRef, { [pinAlani]: yeni.trim() });
                     const guncelK = { ...kullanici, [pinAlani]: yeni.trim() };
                     setKullanici(guncelK);
                     localStorage.setItem("halici_k", JSON.stringify(guncelK));
                     setSifreSecenekModal(null);
                     alert("✅ Şifre mühürlendi.");
                   } catch (err) { alert("❌ Hata: " + err.message); }
                }
              }} style={{ width: "100%", padding: "18px", borderRadius: 20, background: T.primary, color: "#fff", border: "none", fontSize: 16, fontWeight: 700, cursor: "pointer" }}>
                {kullanici[`pin_${sifreSecenekModal.id}`] ? "🔒 Şifreyi Değiştir" : "🔑 Yeni Şifre Belirle"}
              </button>
              {kullanici[`pin_${sifreSecenekModal.id}`] && (
                <button onClick={async () => {
                  if (window.confirm("Bu rolün şifresini tamamen kaldırmak istiyor musunuz?")) {
                    try {
                      const userRef = doc(db, "kullanicilar", kullanici.email);
                      const pinAlani = `pin_${sifreSecenekModal.id}`;
                      await updateDoc(userRef, { [pinAlani]: "" });
                      const guncelK = { ...kullanici, [pinAlani]: "" };
                      setKullanici(guncelK);
                      localStorage.setItem("halici_k", JSON.stringify(guncelK));
                      setSifreSecenekModal(null);
                      alert("🔓 Şifre silindi.");
                    } catch (err) { alert("❌ Hata!"); }
                  }
                }} style={{ width: "100%", padding: "16px", borderRadius: 20, background: "transparent", color: T.danger, border: `2px solid ${T.danger}30`, fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
                  🗑️ Şifreyi Kaldır
                </button>
              )}
              <button onClick={() => setSifreSecenekModal(null)} 
                      style={{ width: "100%", padding: "16px", borderRadius: 20, background: "transparent", color: T.textSec, border: "none", fontSize: 15, fontWeight: 600, cursor: "pointer", marginTop: 8 }}>
                Vazgeç
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Şoför Modu */}
      {showSoforModu&&<SoforModuModal/>}

      {/* Gider Modal */}
      {showGiderForm&&<GiderFormModal 
  T={T} 
  onKapat={()=>setShowGiderForm(false)} 
  onKaydet={g=>setGiderler(prev=>[...prev,g])}
  kategoriler={giderKategorileri}
  setKategoriler={setGiderKategorileri}
/>}
{/* YENİ HARİTA MODALIMIZ */}
      {haritaModu && (
        <SahaHaritaModal 
          baslangicModu={haritaModu} 
          isler={isler} 
          musteriler={musteriler} 
          onKapat={() => setHaritaModu(null)} 
          T={T} 
        />
      )}
      {/* QR Tara */}
      {showQRTara&&<QRTaraModal onBul={qrIleFisBul} onKapat={()=>setShowQRTara(false)} T={T}/>}

    {/* QR Göster (Akıllı Kalem Bazlı Özet Sistemi) */}
      {showQRGoster && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
          onClick={() => setShowQRGoster(null)}>
          <div style={{ background: T.card, borderRadius: 24, padding: 28, textAlign: "center", maxWidth: 350, boxShadow: "0 20px 60px rgba(0,0,0,0.5)" }}
            onClick={e => e.stopPropagation()}>
            <h2 style={{ margin: "0 0 4px", fontSize: 17, fontWeight: 700, color: T.text }}>QR Fiş Kodu</h2>
            <div style={{ fontSize: 12, color: T.textSec, marginBottom: 12 }}>{showQRGoster.fisNo?.split("—")[0]?.trim()}</div>
            
            {/* 🔢 EKRANDAKİ ÖZET PANELİ */}
            {(() => {
              const kalemler = showQRGoster.satirlar || [];
              if (kalemler.length === 0) return null;
              
              // Kalemleri grupla (Örn: Makine Halısı: 5, Perde: 3)
              const ozet = kalemler.reduce((acc, s) => {
                const ad = urunler.find(u => u.id === s.tipId)?.ad || "Ürün";
                acc[ad] = (acc[ad] || 0) + (parseInt(s.adet) || 0);
                return acc;
              }, {});

              return (
                <div style={{ background: T.warning + "20", padding: "10px", borderRadius: 12, marginBottom: 12, border: `1px solid ${T.warning}40` }}>
                  {Object.entries(ozet).map(([ad, adet]) => (
                    <div key={ad} style={{ fontSize: 12, fontWeight: 800, color: T.warning, textTransform: "uppercase" }}>
                      📦 {ad}: {adet} ADET
                    </div>
                  ))}
                </div>
              );
            })()}

            <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
              <QRKodSVG metin={showQRGoster.fisNo || showQRGoster.id} boyut={180} />
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginBottom: 4 }}>{showQRGoster.musteriAdi}</div>
            <div style={{ fontSize: 12, color: T.textSec, marginBottom: 16 }}>{showQRGoster.alisTarihi}</div>
            {/* 🖨️ YAZDIRMA BUTONU (REFUSED HATASINI KÖKTEN ÇÖZEN ZIRHLI VERSİYON) */}
        <button onClick={() => {
          const dukkanIsmi = isletme.ad || kullanici.sirket || "Halı Yıkama";
          
          // 🚀 1. KRİTİK HAMLE: Dış dünyaya gitmiyoruz. 
          // Ekranda modalda zaten açık olan QR kodun görüntüsünü (Base64 verisini) yakalıyoruz.
          const modalQrImg = document.querySelector("img[alt='Fiş Karekod']");
          const qrDataUrl = modalQrImg ? modalQrImg.src : "";

          const kalemler = showQRGoster.satirlar || [];
          const ozet = kalemler.reduce((acc, s) => {
            const ad = urunler.find(u => u.id === s.tipId)?.ad || "Ürün";
            acc[ad] = (acc[ad] || 0) + (parseInt(s.adet) || 0);
            return acc;
          }, {});

          const ozetHTML = Object.entries(ozet)
            .map(([ad, adet]) => `<div class="adet-box">${ad}: ${adet}</div>`)
            .join("");

          const w = window.open("", "_blank");
          w.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <style>
            body { font-family: Arial, sans-serif; text-align: center; padding: 20px; color: #000; background: #fff; }
            .label-container { 
              background: #fff; 
              border: 2px solid #000; 
              padding: 10px; 
              border-radius: 10px; 
              display: inline-block; 
              width: 280px; 
            }
            @media print {
              @page { size: auto; margin: 0mm; }
              body { padding: 0; margin: 0; }
              .no-print { display: none !important; }
              .label-container { border: none; width: 100%; }
            }
            img { width: 160px; height: 160px; margin-bottom: 5px; }
            h2 { font-size: 24px; margin: 5px 0; font-weight: 900; border-bottom: 3px solid #000; text-transform: uppercase; }
            .adet-box { font-size: 22px; font-weight: 900; background: #000; color: #fff; display: block; padding: 6px; margin: 6px 0; border-radius: 6px; }
            .fis-no { font-size: 18px; font-weight: bold; }
            p { font-size: 12px; margin: 3px 0; font-weight: 800; }
            .btn-group { margin-bottom: 20px; display: flex; flex-direction: column; gap: 10px; align-items: center; }
            .print-btn { padding: 15px 30px; background: #1E3A5F; color: #fff; border: none; border-radius: 10px; font-weight: bold; font-size: 18px; width: 280px; cursor: pointer; }
          </style></head>
          <body>
            <div class="no-print btn-group">
              <button class="print-btn" onclick="window.print()">🖨️ ETİKETİ BAS</button>
              <button class="close-btn" onclick="window.close()" style="padding:10px; background:#eee; border:none; border-radius:8px;">KAPAT</button>
            </div>
            <div class="label-container">
              <h2>${showQRGoster.musteriAdi?.split(" ")[0] || ""}</h2>
              <div class="fis-no">#${showQRGoster.fisNo?.split("—")[0]?.trim()}</div>
              <img src="${qrDataUrl}" />
              ${ozetHTML}
              <p>📅 ${showQRGoster.alisTarihi}</p>
              <p>${dukkanIsmi.toUpperCase()}</p> 
            </div>
          </body></html>`);
          
          w.document.close();
          
          // 🚀 ZIRHLI YAZDIRMA VE DÖNÜŞ MOTORU (Android WebView Uyumu)
          w.onafterprint = function() { w.close(); };
          setTimeout(() => { try { w.print(); } catch(e) {} }, 400);
          
        }} style={{
          width: "100%", padding: "14px", borderRadius: 12, background: "#1E3A5F", 
          border: "none", color: "#fff", cursor: "pointer", 
          fontSize: 14, fontWeight: 800, marginBottom: 10, display: "flex", 
          alignItems: "center", justifyContent: "center", gap: 8
        }}>
          🖨️ QR Etiketini Yazdır
        </button>

            <button onClick={() => setShowQRGoster(null)} 
              style={{ width: "100%", padding: "12px", borderRadius: 12, background: T.primary, border: "none", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>
              Kapat
            </button>
          </div>
        </div>
      )}
      {/* Borç Hatırlatma */}
      {showBorcHatirla&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={e=>{if(e.target===e.currentTarget)setShowBorcHatirla(false);}}>
          <div style={{background:T.bg,width:"100%",maxWidth:520,borderRadius:"24px 24px 0 0",padding:20,maxHeight:"85vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
            <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"0 auto 16px"}}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <h2 style={{margin:0,fontSize:18,fontWeight:700,color:T.danger}}>💳 Borç Hatırlatma</h2>
              <button onClick={()=>setShowBorcHatirla(false)} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:24}}>✕</button>
            </div>
            <div style={{fontSize:13,color:T.textSec,marginBottom:14}}>Aşağıdaki borçlu müşterilere WA veya SMS ile hatırlatma gönder:</div>
            {musteriler.filter(m=>(m.borc||0)>0).map(m=>(
              <div key={m.id} style={{background:T.card,border:`1px solid ${T.danger}20`,borderRadius:14,padding:14,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontSize:15,fontWeight:700,color:T.text}}>{m.ad}</div>
                    <div style={{fontSize:13,color:T.textSec}}>{m.tel}</div>
                  </div>
                  <div style={{fontSize:16,fontWeight:900,color:T.danger}}>₺{(m.borc||0).toFixed(2)}</div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <button onClick={()=>{
                    const tel=(m.tel||"").replace(/\D/g,"");
                    const waTel=tel.startsWith("0")?"90"+tel.slice(1):tel;
                   linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent("Merhaba " + m.ad + "! 👋\n" + (isletme.ad || kullanici.sirket || "Halı Yıkama") + " olarak bizi tercih ettiğiniz için teşekkür ederiz. Hesabınızda kalan ₺" + (m.borc || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " bakiyenizi hatırlatır, sağlıklı ve mutlu günler dileriz. ✨")}`);
                  }} style={{padding:"10px",borderRadius:11,background:"#25D36615",border:"1px solid #25D36630",color:"#25D366",cursor:"pointer",fontSize:13,fontWeight:700}}>
                    📱 WhatsApp
                  </button>
                  <button onClick={()=>{
                    smsGonder(m.tel,`Sayın ${m.ad}, ${isletme.ad || kullanici.sirket || "Halı Yıkama"} - Hesabınızda ₺${(m.borc||0).toFixed(2)} bakiye bulunmaktadır. Tel: ${isletme.tel||""}`);
                  }} style={{padding:"10px",borderRadius:11,background:T.primary+"15",border:`1px solid ${T.primary}30`,color:T.primary,cursor:"pointer",fontSize:13,fontWeight:700}}>
                    ✉️ SMS
                  </button>
                </div>
              </div>
            ))}
            {musteriler.filter(m=>(m.borc||0)>0).length===0&&(
              <div style={{textAlign:"center",padding:32,color:T.success,fontSize:15}}>✅ Borçlu müşteri yok!</div>
            )}
          </div>
        </div>
      )}

     {/* Rol Seçim Modal */}
      {showRolSecim&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={e=>{if(e.target===e.currentTarget)setShowRolSecim(false);}}>
          <div style={{background:T.bg,width:"100%",maxWidth:480,borderRadius:"24px 24px 0 0",padding:24,boxShadow:"0 -8px 40px rgba(0,0,0,0.4)"}}>
            <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"0 auto 20px"}}/>
            <h2 style={{margin:"0 0 6px",fontSize:18,fontWeight:800,color:T.text}}>Rol Değiştir</h2>
            <p style={{margin:"0 0 20px",fontSize:13,color:T.textSec}}>Geçiş yapmak istediğiniz rolü seçin.</p>
            {[
              {rol:"patron",icon:"👑",renk:T.primary,baslik:"Patron / Yönetici",aciklama:"Tüm modüller: kasa, raporlar, ayarlar, müşteriler"},
              {rol:"sofor",icon:"🚐",renk:"#FB923C",baslik:"Şoför",aciklama:"Saha ve alım/teslim ekranı"},
              {rol:"yikamaci",icon:"🧹",renk:"#8B5CF6",baslik:"Yıkamacı / Personel",aciklama:"İşler ve saha. Kasa gizli."},
            ].map(({rol,icon,renk,baslik,aciklama})=>(
              <button key={rol} onClick={async () => {
            
                const ozelPin = kullanici[`pin_${rol}`];

                if (ozelPin) {
                  const girilenPin = prompt(`${baslik} alanı kilitli. Lütfen giriş şifresini girin:`);
                  if (girilenPin !== ozelPin) {
                    alert("❌ Hatalı Şifre!");
                    return;
                  }
                }
                // PIN yoksa veya doğruysa aşağıdan devam eder...

                const yeniKullanici = { ...kullanici, rol };
                setKullanici(yeniKullanici);
                localStorage.setItem("halici_k", JSON.stringify(yeniKullanici));
                setSayfa(rol === "sofor" ? "saha" : "anaSayfa");
                setAltSayfa(null);
                setShowRolSecim(false);
              }} style={{width:"100%",padding:"16px",borderRadius:16,background:kullanici.rol===rol?renk+"18":T.card,
                border:`2px solid ${kullanici.rol===rol?renk:T.border}`,cursor:"pointer",textAlign:"left",
                display:"flex",alignItems:"center",gap:14,marginBottom:10}}>
                <div style={{width:48,height:48,borderRadius:14,background:renk,display:"flex",alignItems:"center",
                  justifyContent:"center",fontSize:24,flexShrink:0}}>{icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:15,fontWeight:700,color:kullanici.rol===rol?renk:T.text}}>{baslik}</div>
                  <div style={{fontSize:12,color:T.textSec,marginTop:2}}>{aciklama}</div>
                </div>
                {kullanici.rol===rol&&<span style={{fontSize:20,color:renk}}>✓</span>}
              </button>
            ))}
            <button onClick={()=>setShowRolSecim(false)}
              style={{width:"100%",padding:"14px",borderRadius:12,background:"transparent",border:`1.5px solid ${T.border}`,
                color:T.textSec,cursor:"pointer",fontWeight:600,fontSize:15,marginTop:4}}>
              İptal
            </button>
          </div>
        </div>
      )}
{/* 🛠️ MODALLER */}
      
      {/* 👥 BİRDEN FAZLA PERSONEL VARSA İSİM SEÇME EKRANI */}
      {personelSecimModal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:T.bg,width:"100%",maxWidth:400,borderRadius:20,padding:20}}>
            <h3 style={{marginTop:0,color:T.text,textAlign:"center",fontSize:18}}>Kim Giriş Yapıyor?</h3>
            <div style={{fontSize:13,color:T.textSec,textAlign:"center",marginBottom:16}}>{personelSecimModal.rol.ad} Personelleri</div>
            
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {personelSecimModal.kisiler.map(kisi => (
                <button key={kisi.id} onClick={() => {
                  const sorulacakPin = kisi.pin || personelSecimModal.genelPin;
                  if (sorulacakPin) {
                    const girilen = prompt(`🔒 ${kisi.ad} şifrenizi girin:`);
                    if (girilen !== sorulacakPin) return alert("❌ Hatalı Şifre!");
                  }

                  const guncelUser = {
                    ...kullanici,
                    rol: personelSecimModal.rol.id,
                    aktifPersonel: { ad: kisi.ad, id: kisi.id }
                  };
                  setKullanici(guncelUser);
                  localStorage.setItem("halici_k", JSON.stringify(guncelUser));
                  setPersonelSecimModal(null);
                }} style={{padding:16,borderRadius:12,background:T.input,border:`1.5px solid ${T.inputBorder}`,color:T.text,fontSize:16,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:20}}>👤</span> {kisi.ad}
                </button>
              ))}
            </div>
            
            <button onClick={()=>setPersonelSecimModal(null)} style={{width:"100%",padding:14,marginTop:16,borderRadius:12,background:T.danger+"15",color:T.danger,border:"none",fontWeight:600,cursor:"pointer",fontSize:15}}>
              Geri Dön
            </button>
          </div>
        </div>
      )}

      {showFis && (
        <FisModal 
          onKapat={() => { setShowFis(false); setDuzenlenenFis(null); }}
          onKaydet={isEkle}
          musteriler={musteriler} 
          personeller={personeller} 
          onYeniMusteri={musteriEkle} 
          T={T} 
          t={t}
          showMusteriForm={showMusteriForm}
          setShowMusteriForm={setShowMusteriForm}
          formatTel={formatTel}
          yeniFisNo={yeniFisNo} 
          duzenlenenFis={duzenlenenFis}
          kullanici={kullanici} // 👈 İŞTE HAYAT KURTARAN KABLO BURADA!
        />
      )}

      {showHaliAl && (
        <HaliAlModal 
          fis={showHaliAl} 
          urunler={urunler}
          onKaydet={haliAlKaydet} 
          onKapat={() => setShowHaliAl(null)} 
          T={T} 
          t={t}
        />
      )}

      {showTahsilat && (
        <TahsilatModal 
          fis={showTahsilat}
          musteri={musteriler.find(m => m.id === showTahsilat.musteriId) || null}
          personeller={personeller}
          onKaydet={th => tahsilatKaydet(showTahsilat.id, th)}
          onKapat={() => setShowTahsilat(null)} 
          T={T} 
          t={t}
        />
      )}

      {showIade && (
        <IadeModal 
          fis={showIade} 
          onKaydet={iadeKaydet}
          onKapat={() => setShowIade(null)} 
          T={T} 
          t={t}
        />
      )}

 {showMusteriForm !== null && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:400,
          display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={e => { e.stopPropagation(); }}>
          <div style={{background:T.bg,width:"100%",maxWidth:520,borderRadius:"24px 24px 0 0",
            padding:20,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
            <div style={{width:40,height:4,borderRadius:2,background:T.border,margin:"0 auto 16px"}}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <h2 style={{margin:0,fontSize:18,fontWeight:700,color:T.text}}>
                {showMusteriForm?.id ? "✏️ Düzenle" : "👤 Yeni Müşteri"}
              </h2>
              <button onClick={() => setShowMusteriForm(null)} style={{background:"none",border:"none",color:T.textSec,cursor:"pointer",fontSize:26}}>✕</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <button onClick={async () => {
                const c = await rehberdenSec();
                if(c) {
                  // 📒 Rehberden gelirken akıllı parçalama (Son kelime Soyad, gerisi Ad)
                  const p = (c.ad || "").trim().split(/\s+/);
                  const s = p.length > 1 ? p.pop().toUpperCase() : "";
                  const a = p.map(isim => isim.charAt(0).toUpperCase() + isim.slice(1).toLowerCase()).join(" ");
                  setShowMusteriForm(prev => ({ 
                    ...prev, 
                    ad_ham: a, ad_formatli: a,
                    soyad_ham: s, soyad_formatli: s,
                    ad: `${a} ${s}`.trim(), 
                    tel: formatTel(c.tel || prev.tel) 
                  }));
                } else alert("Rehber erişimi desteklenmiyor, manuel girin.");
              }}
                style={{padding:"12px",borderRadius:12,background:T.primary+"12",border:`1px solid ${T.primary}30`,
                  color:T.primary,cursor:"pointer",fontSize:14,fontWeight:600,display:"flex",alignItems:"center",gap:6,justifyContent:"center"}}>
                📒 Rehberden Al
              </button>
             {/* 🏷️ AD VE SOYAD AYRI KUTULAR */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                <Inp 
                  label="Ad(lar) *" 
                  value={showMusteriForm.ad_ham || ""} 
                  onChange={v => {
                    const f = v.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(' ');
                    setShowMusteriForm(p => ({ ...p, ad_ham: v, ad_formatli: f, ad: `${f} ${p.soyad_formatli || ""}`.trim() }));
                  }} 
                  T={T} 
                  placeholder="İsim" 
                />
                <Inp 
                  label="Soyad *" 
                  value={showMusteriForm.soyad_ham || ""} 
                  onChange={v => {
                    const f = v.toUpperCase();
                    setShowMusteriForm(p => ({ ...p, soyad_ham: f, soyad_formatli: f, ad: `${p.ad_formatli || ""} ${f}`.trim() }));
                  }} 
                  T={T} 
                  placeholder="SOYİSİM" 
                  style={{ textTransform: "uppercase" }} 
                />
              </div>

              {/* 🏷️ TELEFONLAR */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                <Inp label="Telefon *" value={showMusteriForm.tel || "+90 "} onChange={v => setShowMusteriForm(p => ({ ...p, tel: formatTel(v) }))} placeholder="+90 5xx..." T={T} />
                <Inp label="2. Telefon" value={showMusteriForm.tel2 || "+90 "} onChange={v => setShowMusteriForm(p => ({ ...p, tel2: formatTel(v) }))} placeholder="+90 5xx..." T={T} />
              </div>

              {/* 📍 HİBRİT AKILLI ADRES BLOĞU (Arama + Detaylı Giriş) */}
<div style={{ background: T.statCard, borderRadius: 14, padding: 14, border: `1px solid ${T.border}`, marginBottom: 12 }}>
  <div style={{ fontSize: 13, fontWeight: 700, color: T.textSec, marginBottom: 10 }}>📍 Müşteri Adresi</div>
  
  {/* 🔍 1. ADIM: AKILLI ARAMA (Hızlı Doldurucu) */}
  <div style={{ position: 'relative', marginBottom: 12 }}>
    <Inp 
      label="🔍 Hızlı Adres Ara" 
      value={showMusteriForm.aramaMetni || ""}
      onChange={async (v) => {
        setShowMusteriForm(p => ({ ...p, aramaMetni: v }));
        if (v.length > 3) {
          const resp = await fetch(`https://nominatim.openstreetmap.org/search?format=jsonv2&q=${encodeURIComponent(v)}&limit=5&addressdetails=1&countrycodes=tr`, {
            headers: { "Accept-Language": "tr" }
          });
          const data = await resp.json();
          setShowMusteriForm(p => ({ ...p, oneriler: data }));
        } else {
          setShowMusteriForm(p => ({ ...p, oneriler: [] }));
        }
      }}
      T={T} 
      placeholder="Örn: Ergani Bagür..." 
    />
    
    {showMusteriForm.oneriler?.length > 0 && (
      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: T.card, zIndex: 100, borderRadius: 12, border: `1px solid ${T.border}`, boxShadow: "0 10px 25px rgba(0,0,0,0.2)", marginTop: 4 }}>
        {showMusteriForm.oneriler.map((item, i) => (
          <div 
            key={i}
            onClick={() => {
              const a = item.address;
              setShowMusteriForm(p => ({
                ...p,
                mahalle: a.neighbourhood || a.suburb || a.village || "",
                sokak: a.road || "",
                ilce: a.town || a.district || a.county || "",
                il: a.province || a.city || "",
                konum: { lat: parseFloat(item.lat), lng: parseFloat(item.lon) },
                koordinat: `${item.lat}, ${item.lon}`,
                aramaMetni: item.display_name,
                oneriler: []
              }));
            }}
            style={{ padding: '10px 14px', fontSize: 12, color: T.text, borderBottom: `1px solid ${T.border}`, cursor: 'pointer' }}>
            📍 {item.display_name}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* ✍️ 2. ADIM: MANUEL DÜZENLEME VE DETAYLAR */}
  <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 8, marginBottom: 8 }}>
    <Inp label="Mahalle*" value={showMusteriForm.mahalle || ""}
      onChange={v => setShowMusteriForm(p => ({ ...p, mahalle: v }))}
      T={T} placeholder="Mahalle" />
    <Inp label="Cadde / Sokak *" value={showMusteriForm.sokak || ""}
      onChange={v => setShowMusteriForm(p => ({ ...p, sokak: v }))}
      T={T} placeholder="Sokak" />
  </div>

  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 8 }}>
    <Inp label="Bina No *" value={showMusteriForm.binaNo || ""} onChange={v => setShowMusteriForm(p => ({ ...p, binaNo: v }))} T={T} placeholder="No" />
    <Inp label="Daire No" value={showMusteriForm.daireNo || ""} onChange={v => setShowMusteriForm(p => ({ ...p, daireNo: v }))} T={T} placeholder="D" />
    <Inp label="Kat" value={showMusteriForm.kat || ""} onChange={v => setShowMusteriForm(p => ({ ...p, kat: v }))} T={T} placeholder="Kat" />
  </div>

  <div style={{ marginBottom: 8 }}>
    <Inp label="Apartman Adı (Opsiyonel)" value={showMusteriForm.apartman || ""} onChange={v => setShowMusteriForm(p => ({ ...p, apartman: v }))} T={T} placeholder="Apartman" />
  </div>

  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
    <Inp label="İlçe *" value={showMusteriForm.ilce || ""}
      onChange={v => setShowMusteriForm(p => ({ ...p, ilce: v }))}
      onBlur={async () => {
        const tam = [showMusteriForm.mahalle, showMusteriForm.sokak, showMusteriForm.ilce, showMusteriForm.il].filter(Boolean).join(", ");
        const sonuc = await adresdenKonumBul(tam);
        if (sonuc) setShowMusteriForm(p => ({ ...p, konum: sonuc, koordinat: `${sonuc.lat}, ${sonuc.lng}` }));
      }}
      T={T} placeholder="İlçe" />
    <Inp label="İl *" value={showMusteriForm.il || ""}
      onChange={v => setShowMusteriForm(p => ({ ...p, il: v }))}
      onBlur={async () => {
        const tam = [showMusteriForm.mahalle, showMusteriForm.sokak, showMusteriForm.ilce, showMusteriForm.il].filter(Boolean).join(", ");
        const sonuc = await adresdenKonumBul(tam);
        if (sonuc) setShowMusteriForm(p => ({ ...p, konum: sonuc, koordinat: `${sonuc.lat}, ${sonuc.lng}` }));
      }}
      T={T} placeholder="İl" />
  </div>

  {/* 🌍 3. ADIM: KOORDİNAT TEYİT VE WHATSAPP GİRİŞİ */}
  <div style={{ marginBottom: 12 }}>
    <Inp 
      label="🌍 Koordinat (Teyit / WhatsApp Konumu)" 
      value={showMusteriForm.koordinat || (showMusteriForm.konum?.lat ? `${showMusteriForm.konum.lat}, ${showMusteriForm.konum.lng}` : "")} 
      onChange={async (v) => {
        const parcalar = v.split(",");
        if (parcalar.length === 2 && !isNaN(parcalar[0].trim()) && !isNaN(parcalar[1].trim())) {
          const lat = parseFloat(parcalar[0].trim());
          const lng = parseFloat(parcalar[1].trim());
          try {
            const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&addressdetails=1`, {
              headers: { "Accept-Language": "tr" }
            });
            const data = await resp.json();
            const a = data.address || {};
            setShowMusteriForm(p => ({ 
              ...p, 
              koordinat: v, 
              konum: { lat, lng },
              mahalle: a.neighbourhood || a.suburb || p.mahalle,
              ilce: a.town || a.district || p.ilce,
              il: a.province || p.il
            }));
          } catch {
            setShowMusteriForm(p => ({ ...p, koordinat: v, konum: { lat, lng } }));
          }
        } else {
          setShowMusteriForm(p => ({ ...p, koordinat: v }));
        }
      }} 
      T={T} 
      placeholder="Koordinat yapıştırınca her şey dolar..." 
    />
  </div>

  {/* 🚀 4. ADIM: ŞU ANKİ KONUM BUTONU */}
  <button type="button" onClick={async () => {
    try {
      const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { enableHighAccuracy: true }));
      const lat = pos.coords.latitude, lng = pos.coords.longitude;
      const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&addressdetails=1`, {
        headers: { "Accept-Language": "tr" }
      });
      const data = await resp.json();
      const a = data.address || {};
      setShowMusteriForm(p => ({ 
        ...p, 
        mahalle: a.neighbourhood || a.suburb || "", 
        sokak: a.road || "", 
        ilce: a.town || a.district || "", 
        il: a.province || "", 
        koordinat: `${lat}, ${lng}`,
        konum: { lat, lng } 
      }));
    } catch { alert("❌ Konum alınamadı."); }
  }} style={{ width: "100%", padding: "11px", borderRadius: 12, background: T.success+"15", border: `1.5px dashed ${T.success}`, color: T.success, cursor: "pointer", fontSize: 13, fontWeight: 700 }}>
    📍 Şu Anki Konumdan Doldur
  </button>
</div>
              <Inp label="Müşteri Notu" value={showMusteriForm.notlar || ""} onChange={v => setShowMusteriForm(p => ({ ...p, notlar: v }))} T={T} placeholder="VIP, alerjisi var..." />
              {/* 🏷️ Müşteri Fişleme / Grup Seçimi */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: T.textSec, display: "block", marginBottom: 8 }}>Müşteri Grubu (Fişleme)</label>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {musteriGruplari.map(g => (
                    <button
                      key={g.id}
                      type="button"
                      onClick={() => setShowMusteriForm(p => ({ ...p, grup: g.id }))}
                      style={{
                        padding: "10px 14px", borderRadius: 12,
                        border: `2px solid ${showMusteriForm.grup === g.id ? g.renk : T.border}`,
                        background: showMusteriForm.grup === g.id ? g.renk + "15" : T.card,
                        color: showMusteriForm.grup === g.id ? g.renk : T.textSec,
                        cursor: "pointer", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, transition: "all 0.2s"
                      }}
                    >
                      <span style={{fontSize: 16}}>{g.icon}</span> {g.ad}
                    </button>
                  ))}
                </div>
              </div>
              
              <Inp label="Notlar" value={showMusteriForm.notlar || ""} onChange={v => setShowMusteriForm(p => ({ ...p, notlar: v }))} placeholder="VIP, özel not..." T={T}/>

             {/* 🚀 MANUEL BORÇ EKLEME */}
              <div style={{ background: T.danger + "10", border: `1px solid ${T.danger}30`, borderRadius: 14, padding: 16, marginTop: 8 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: T.danger, marginBottom: 12 }}>
                  {showMusteriForm?.id ? "💳 Eski / Ekstra Borcu Varsa Ekle" : "💳 Eski / Ekstra Borcu Varsa Ekle"}
                </div>
                
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <Inp 
                    label="Eklenecek Tutar (+₺)" 
                    value={showMusteriForm.ekBorc || ""} 
                    onChange={v => setShowMusteriForm(p => ({ ...p, ekBorc: v }))} 
                    type="number" 
                    min="0" 
                    T={T} 
                    placeholder="Örn: 250"
                  />
                  
                  <DatePicker 
                    label="Borç Tarihi (Zorunlu değil)" 
                    value={showMusteriForm.ekBorcTarih || ""} 
                    onChange={v => setShowMusteriForm(p => ({ ...p, ekBorcTarih: v }))} 
                    T={T}
                  />
                  
                  <Inp 
                    label="Borç Notu (Zorunlu değil)" 
                    value={showMusteriForm.ekBorcNot || ""} 
                    onChange={v => setShowMusteriForm(p => ({ ...p, ekBorcNot: v }))} 
                    T={T} 
                    placeholder={showMusteriForm?.id ? "Geçen seneden kalan..." : "Geçmişten gelen bakiye..."}
                  />
                </div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10,marginTop:16}}>
              <button onClick={() => setShowMusteriForm(null)}
                style={{padding:"14px",borderRadius:12,background:"transparent",border:`1.5px solid ${T.border}`,
                  color:T.textSec,cursor:"pointer",fontWeight:600,fontSize:15}}>{t("iptal")}</button>
              <button onClick={() => {
                // 🚀 AD VE SOYADIN BİRLEŞTİRİLMİŞ HALİYLE KONTROL (ad state'i zaten onChange'de güncelleniyor)
                if(!showMusteriForm.ad || !showMusteriForm.tel){
                  alert("⚠️ İsim ve Telefon alanları zorunludur!");
                  return;
                }

                let data = { ...showMusteriForm };

                if (data.ekBorc && parseFloat(data.ekBorc) > 0) {
                   const eklenecek = parseFloat(data.ekBorc);
                   data.borc = (data.borc || 0) + eklenecek;
                   
                   const tarihBilgisi = data.ekBorcTarih ? `Tarih: ${data.ekBorcTarih}` : "";
                   const notBilgisi = data.ekBorcNot ? `Nedeni: ${data.ekBorcNot}` : "";
                   const ekBilgi = [tarihBilgisi, notBilgisi].filter(Boolean).join(" | ");
                   
                   const borcLogu = `[+${eklenecek}₺ Ek Borç Eklendi] ${ekBilgi}`;
                   data.notlar = data.notlar ? `${data.notlar}\n💳 ${borcLogu}` : `💳 ${borcLogu}`;
                }

                delete data.ekBorc;
                delete data.ekBorcTarih;
                delete data.ekBorcNot;

                const kayitId = data.docId || data.id;
if (kayitId) musteriGunc(kayitId, data);
else musteriEkle(data);
                
                setShowMusteriForm(null);
              }} style={{padding:"14px",borderRadius:12,background:T.primary,border:"none",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:700}}>
                ✅ {t("kaydet")}
              </button>
            </div>
          </div>
        </div>
      )}
      {showMusteriProfil&&(
        <div style={{position:"fixed",inset:0,zIndex:400}}>
          <div onClick={()=>setShowMusteriProfil(null)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.5)"}}/>
          <div style={{position:"absolute",top:0,right:0,bottom:0,width:Math.min(480,window.innerWidth),
            background:T.bg,boxShadow:"-4px 0 24px rgba(0,0,0,0.2)",overflowY:"auto",
            animation:"slideInRight 0.3s ease",zIndex:1}}>
            <div style={{background:T.header,padding:"16px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:44,height:44,borderRadius:12,background:T.primary,display:"flex",
                  alignItems:"center",justifyContent:"center",fontSize:20,fontWeight:800,color:"#fff"}}>
                  {(showMusteriProfil?.ad||"?")[0]}
                </div>
                <div>
                  <div style={{fontSize:16,fontWeight:700,color:"#fff"}}>{showMusteriProfil?.ad}</div>
                  <div style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{showMusteriProfil?.tel}</div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                {/* Sadece patron profilin içinden de kalıcı olarak silebilir */}
                {kullanici?.rol === "patron" && (
                  <button onClick={() => {
                    musteriSil(showMusteriProfil.id, showMusteriProfil.docId);
                    setShowMusteriProfil(null);
                  }}
                  style={{padding:"8px 14px",borderRadius:9,background:"rgba(239,68,68,0.15)",border:`1px solid rgba(239,68,68,0.3)`,color:"#EF4444",cursor:"pointer",fontSize:13,fontWeight:600}}>🗑️ Sil</button>
                )}
                
                <button onClick={()=>{setShowMusteriForm(showMusteriProfil);setShowMusteriProfil(null);}}
                  style={{padding:"8px 14px",borderRadius:9,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:600}}>✏️ Düzenle</button>
                <button onClick={()=>setShowMusteriProfil(null)}
                  style={{padding:"8px 12px",borderRadius:9,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",cursor:"pointer",fontSize:18}}>✕</button>
              </div>
            </div>
            <div style={{padding:16}}>
              {/* İstatistikler */}
              {(()=>{
                const mIs=isler.filter(is=>is.musteriId===showMusteriProfil?.id);
                const ciro=mIs.reduce((s,is)=>s+(is.tahsilat?.kasayaGiren||0),0);
                const m2=mIs.reduce((s,is)=>s+(is.satirlar||[]).reduce((ss,satir)=>{
                  const tip=urunler.find(u=>u.id===satir?.tipId);
                  return ss+(tip?.birim==="m2"?parseFloat(satir?.miktar||0)||0:0);
                },0),0);
                const sonIs=mIs.reduce((son,is)=>!son||gunFarki(is.alisTarihi)<gunFarki(son.alisTarihi)?is:son,null);
                return (
                  <>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:14}}>
                      {[{l:"İş",v:mIs.length,c:T.primary},{l:"m²",v:m2.toFixed(0),c:T.warning},{l:"Ciro",v:"₺"+ciro.toFixed(0),c:T.success}].map(s=>(
                        <div key={s.l} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:12,textAlign:"center"}}>
                          <div style={{fontSize:11,color:T.textSec,marginBottom:2}}>{s.l}</div>
                          <div style={{fontSize:17,fontWeight:700,color:s.c}}>{s.v}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:12}}>
                      <Yildiz puan={showMusteriProfil?.yildiz||0} onChange={y=>yildizGunc(showMusteriProfil.id,y)} boyut={22}/>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:10}}>
                        {[["Semt",showMusteriProfil?.semt||"—"],["Şehir",showMusteriProfil?.sehir||"—"],["Grup",showMusteriProfil?.grup||"Normal"]].map(([k,v])=>(
                          <div key={k}><div style={{fontSize:11,color:T.textSec}}>{k}</div><div style={{fontSize:14,fontWeight:500,color:T.text}}>{v}</div></div>
                        ))}
                      </div>
                      {showMusteriProfil?.adres&&<div style={{marginTop:8,fontSize:13,color:T.textSec}}>📍 {showMusteriProfil.adres}</div>}
                      {showMusteriProfil?.notlar && (
  <div style={{
    marginTop: 8, 
    padding: "12px", 
    background: T.warning + "15", 
    borderRadius: 8, 
    fontSize: 13, 
    color: T.warning,
    whiteSpace: "pre-wrap", /* 🚀 BEYİN: YAZIYI ALT ALTA İNDİREN SİHİRLİ KOD */
    lineHeight: 1.6
  }}>
    {showMusteriProfil.notlar}
  </div>
)}
                    </div>
                   {/* 💰 VEZNE PANELİ: BORÇ TAHSİLAT KISMI */}
                    {yetkiVarMi("tahsilat_al") && (showMusteriProfil?.borc || 0) > 0 && (
                      <div style={{
                        marginTop: 16, marginBottom: 20, padding: "16px", background: T.card,
                        borderRadius: 20, border: `2px dashed ${T.danger}50`, boxShadow: "0 10px 20px rgba(0,0,0,0.05)"
                      }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: T.textSec, textTransform: "uppercase" }}>📌 Müşteri Bakiyesi</span>
                          <span style={{ fontSize: 20, fontWeight: 900, color: T.danger }}>₺{formatPara(showMusteriProfil.borc)}</span>
                        </div>

                        {!showBorcTahsilatForm ? (
                          <button onClick={() => setShowBorcTahsilatForm(true)}
                            style={{
                              width: "100%", padding: "14px", borderRadius: 14, 
                              background: `linear-gradient(135deg, ${T.success}, #059669)`, 
                              border: "none", color: "#fff", fontSize: 15, fontWeight: 800, 
                              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                              boxShadow: `0 8px 15px ${T.success}40`
                            }}>
                            <span>💵</span> BORÇ TAHSİLAT YAP
                          </button>
                        ) : (
                          <div style={{ animation: "fadeIn 0.3s ease" }}>
                            <div style={{ height: 1, background: T.border, margin: "12px 0" }} />
                            <Inp 
                              label="Alınan Tutar (₺)" 
                              value={borcTahsilatMiktar} 
                              onChange={setBorcTahsilatMiktar} 
                              type="number" 
                              placeholder="Miktarı girin..."
                              T={T}
                            />
                            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                              <button onClick={() => { setShowBorcTahsilatForm(false); setBorcTahsilatMiktar(""); }}
                                style={{ flex: 1, padding: "12px", borderRadius: 12, background: T.bg, border: `1px solid ${T.border}`, color: T.textSec, fontWeight: 700 }}>
                                İptal
                              </button>
                              <button onClick={async () => {
                                const miktar = parseFloat(borcTahsilatMiktar) || 0;
                                if (miktar <= 0) { alert("Geçerli tutar girin"); return; }
                                if (miktar > showMusteriProfil.borc) { alert("Tahsilat tutarı borçtan büyük olamaz!"); return; }
                                
                                const yeniBorc = Math.max(0, (showMusteriProfil.borc || 0) - miktar);
                                await musteriGunc(showMusteriProfil.docId || showMusteriProfil.id, { borc: yeniBorc });
                                setShowMusteriProfil(p => ({ ...p, borc: yeniBorc }));
                                
                                setGiderler(prev => [...prev, {
                                  id: "tahsilat_" + Date.now(),
                                  kategori: "Borç Tahsilatı",
                                  aciklama: `${showMusteriProfil.ad} - Eski Borç Ödemesi`,
                                  tutar: miktar,
                                  tarih: bugun(),
                                  tip: "tahsilat",
                                  personel: kullanici.ad || "Sistem"
                                }]);
                                
                                setShowBorcTahsilatForm(false); 
                                setBorcTahsilatMiktar("");
                                alert(`✅ ₺${formatPara(miktar)} tahsil edildi.`);
                              }} style={{ 
                                flex: 2, padding: "12px", borderRadius: 12, 
                                background: T.success, border: "none", color: "#fff", 
                                fontWeight: 800, cursor: "pointer" 
                              }}>
                                ✅ Onayla
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* ⏰ HATIRLATICI PANELİ */}
                    {sonIs && gunFarki(sonIs.alisTarihi) > 180 && (
                      <div style={{ background: T.warning + "15", border: `1px solid ${T.warning}30`, borderRadius: 12, padding: "12px 14px", marginBottom: 12 }}>
                        <div style={{ fontSize: 13, color: T.warning, fontWeight: 600, marginBottom: 8 }}>⏰ {gunFarki(sonIs.alisTarihi)} gündür gelmiyor!</div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                          <button onClick={() => {
                            const tel = (showMusteriProfil?.tel || "").replace(/\D/g, "");
                            const waTel = tel.startsWith("0") ? "90" + tel.slice(1) : tel;
                            linkAc(`https://wa.me/${waTel}?text=${encodeURIComponent("Merhaba " + (showMusteriProfil?.ad || "") + " 🧹 Sizi uzun süredir göremedik!")}`);
                          }} style={{ padding: "11px", borderRadius: 10, background: T.success, border: "none", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>
                            📱 WhatsApp
                          </button>
                          <button onClick={() => smsGonder(showMusteriProfil?.tel || "", `Sayın ${showMusteriProfil?.ad || ""}, halılarınızı yıkama zamanı geldi!`)}
                            style={{ padding: "11px", borderRadius: 10, background: T.primary + "15", border: `1px solid ${T.primary}30`, color: T.primary, cursor: "pointer", fontSize: 13, fontWeight: 700 }}>
                            ✉️ SMS
                          </button>
                        </div>
                      </div>
                    )}

                    {/* 📷 SON FİŞ QR BUTONU */}
                    {sonIs && (
                      <button onClick={() => setShowQRGoster(sonIs)}
                        style={{ width: "100%", padding: "10px", borderRadius: 12, background: T.statCard, border: `1px solid ${T.border}`, color: T.textSec, cursor: "pointer", fontSize: 13, fontWeight: 600, marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                        QR 📷 Son Fiş QR Kodunu Göster
                      </button>
                    )}

                    {/* 📋 İŞ GEÇMİŞİ LİSTESİ */}
                    <h3 style={{ fontSize: 15, fontWeight: 700, color: T.textSec, margin: "10px 0" }}>📋 İş Geçmişi ({mIs.length})</h3>
                    {mIs.length === 0 ? (
                      <div style={{ textAlign: "center", padding: 24, color: T.textSec }}>Henüz iş kaydı yok</div>
                    ) : (
                      [...mIs].sort((a, b) => (b.id || 0) - (a.id || 0)).map(is => {
                        const meta = STATÜLER_META[is?.status || "beklemede"];
                        return (
                          <div key={is.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: "12px 14px", marginBottom: 8 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                <span style={{ fontSize: 12, fontWeight: 600, color: T.primary }}>{is.fisNo?.split("—")[0]?.trim()}</span>
                                <span style={{ fontSize: 12, color: meta?.renk }}>{meta?.icon} {t("k_" + (is.status || "beklemede"))}</span>
                              </div>
                              <span style={{ fontSize: 14, fontWeight: 800, color: T.warning }}>₺{formatPara(is.hesaplama?.genelToplam || 0)}</span>
                            </div>
                            <div style={{ fontSize: 12, color: T.textSec }}>📅 {is.alisTarihi} → {is.teslimTarihi}</div>
                            <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
                              <button onClick={() => whatsappGonder(is)} style={{ padding: "5px 10px", borderRadius: 7, background: "#25D36615", border: "1px solid #25D36630", color: "#25D366", cursor: "pointer", fontSize: 11 }}>📱 WA</button>
                              <button onClick={() => setShowQRGoster(is)} style={{ padding: "5px 10px", borderRadius: 7, background: T.statCard, border: `1px solid ${T.border}`, color: T.textSec, cursor: "pointer", fontSize: 11 }}>QR</button>
                              <button onClick={() => { const w = window.open("", "_blank"); w.document.write(faturaHTML(is, isletme, urunler)); w.document.close(); }} style={{ padding: "5px 10px", borderRadius: 7, background: T.warning + "15", border: `1px solid ${T.warning}30`, color: T.warning, cursor: "pointer", fontSize: 11 }}>📄 Fatura</button>
                              
                              {/* 🛡️ SİLME BUTONU: YETKİ KONTROLLÜ */}
                              {yetkiVarMi("buton_sil") && (
                                <button onClick={() => isSil(is.id, is.docId)} 
                                  style={{ 
                                    padding: "5px 10px", borderRadius: 7, background: T.danger + "15", 
                                    border: `1px solid ${T.danger}30`, color: T.danger, cursor: "pointer", fontSize: 11 
                                  }}>
                                  🗑️ Sil
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


// ═══════════════════════════════════════════════════════════
// ROL SEÇİM EKRANI (Dinamik Personel Listesi & PIN Sistemi)
// ═══════════════════════════════════════════════════════════
function RolSecimEkrani({ bekleyenUser, onRolSec, T, personelRolleri, personeller }) {
  const [secilenRol, setSecilenRol] = useState(null);
  const [adim, setAdim] = useState("rol"); 
  const [secilenPersonel, setSecilenPersonel] = useState(null);
  const [pinGirisi, setPinGirisi] = useState("");
  const [pinHata, setPinHata] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  
  const liste = Array.isArray(personelRolleri) ? personelRolleri : [];
  const rolPersonelleri = secilenRol 
    ? (personeller || []).filter(p => p.rol === secilenRol.ad && p.aktif !== false)
    : [];

  // 📧 PIN HATIRLATMA MOTORU (FIREBASE'DE SATIR YOKSA İÇERİ ALIR)
  const pinKoduHatirlat = async () => {
    // 1. Önce personelin özel PIN'i var mı bak, yoksa bekleyenUser dökümanındaki alana bak
    let ozelPin = secilenPersonel?.pin || bekleyenUser[`pin_${secilenRol?.id}`];

    // 🚀 FIREBASE ZIRHI: Eğer ozelPin 'undefined' ise veya boşsa (Senin dökümanındaki durum)
    if (ozelPin === undefined || ozelPin === null || ozelPin.toString().trim() === "") {
      const onay = window.confirm(
        "Sistemde bu rol için kayıtlı bir PIN bulunamadı. Ayarlar > Roller kısmından PIN oluşturmak için şifresiz giriş yapılsın mı?"
      );
      if (onay) {
        onRolSec(secilenRol.id, secilenPersonel); 
      }
      return;
    }

    // 2. Şifre varsa mail atma süreci
    setYukleniyor(true);
    try {
      emailjs.init("I5OckH63W0nXISCAI");
      const templateParams = {
        to_email: bekleyenUser.email, 
        to_name: bekleyenUser.ad,
        from_name: "HalıPro Güvenlik",
        message: `${secilenPersonel ? secilenPersonel.ad : secilenRol?.ad} yetkisi için PIN kodunuz: ${ozelPin}`,
      };
      await emailjs.send('service_evp34yi', 'template_rnj6d3r', templateParams);
      alert(`✅ Güvenlik Gereği; PIN kodu ${bekleyenUser.email} adresine gönderildi!`);
    } catch (err) {
      alert("❌ PIN gönderilemedi.");
    } finally {
      setYukleniyor(false);
    }
  };

  const rolSec = (rol) => {
    setSecilenRol(rol);
    if ((personeller || []).some(p => p.rol === rol.ad && p.aktif !== false)) {
      setAdim("isim");
    } else {
      setAdim("sifre");
    }
  };
  
  const isimSec = (personel) => {
    setSecilenPersonel(personel);
    const ozelPin = personel.pin || bekleyenUser[`pin_${secilenRol.id}`];
    // Eğer PIN satırı hiç yoksa direkt dükkana al (Zorluk çıkarma)
    if (!ozelPin) {
      onRolSec(secilenRol.id, personel);
    } else {
      setAdim("sifre");
    }
  };
  
  // 🔑 ŞİFRE DOĞRULAMA (FIREBASE SATIRI YOKSA TOLERANS GÖSTERİR)
  const sifreDogrula = () => {
    let ozelPin = secilenPersonel?.pin || bekleyenUser[`pin_${secilenRol?.id}`];

    // 🚀 FIREBASE SATIRI HİÇ YOKSA: Direkt içeri al
    if (ozelPin === undefined || ozelPin === null || ozelPin.toString().trim() === "") {
        onRolSec(secilenRol.id, secilenPersonel);
        return;
    }

    if (pinGirisi === ozelPin.toString()) {
      onRolSec(secilenRol.id, secilenPersonel);
    } else {
      setPinHata(true);
      setTimeout(() => { setPinHata(false); setPinGirisi(""); }, 1500);
    }
  };
  
  return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20 }}>
      {adim === "rol" && (
        <>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <div style={{ fontSize: 54, marginBottom: 12 }}>🧹</div>
            <h2 style={{ fontSize: 26, fontWeight: 900, color: T.text, margin: 0 }}>Rol Seç</h2>
            <p style={{ color: T.textSec, fontSize: 14, marginTop: 8 }}>Lütfen devam etmek için bir yetki seçin:</p>
          </div>
          <div style={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: 12 }}>
            {liste.map(rol => (
              <button key={rol.id} onClick={() => rolSec(rol)}
                style={{ display: "flex", alignItems: "center", gap: 18, padding: "20px", background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 24, cursor: "pointer" }}>
                <div style={{ width: 52, height: 52, borderRadius: 16, background: (rol.renk || T.primary) + "15", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28 }}>{rol.icon}</div>
                <div style={{ flex: 1, textAlign: "left" }}>
                  <div style={{ fontSize: 18, fontWeight: 800, color: T.text }}>{rol.ad}</div>
                </div>
                <span style={{ fontSize: 20, color: T.border }}>›</span>
              </button>
            ))}
          </div>
        </>
      )}
      
      {adim === "isim" && secilenRol && (
        <>
          <button onClick={() => { setAdim("rol"); setSecilenRol(null); }} 
            style={{ alignSelf: "flex-start", background: "none", border: "none", color: T.primary, cursor: "pointer", fontSize: 16, marginBottom: 20 }}>← Geri</button>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{ fontSize: 40 }}>{secilenRol.icon}</div>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: T.text }}>{secilenRol.ad} — Kim Giriyorsunuz?</h2>
          </div>
          <div style={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: 10 }}>
            {rolPersonelleri.map(p => (
              <button key={p.id} onClick={() => isimSec(p)}
                style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 20px", background: T.card, border: `1.5px solid ${T.border}`, borderRadius: 18, cursor: "pointer" }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: T.primary, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 800, color: "#fff" }}>{(p.ad || "?")[0]}</div>
                <div style={{ flex: 1, textAlign: "left" }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: T.text }}>{p.ad}</div>
                </div>
                <span style={{ fontSize: 18, color: T.border }}>›</span>
              </button>
            ))}
            <button onClick={() => { setSecilenPersonel(null); setAdim("sifre"); }}
              style={{ padding: "14px", background: T.statCard, border: `1px dashed ${T.border}`, borderRadius: 14, color: T.textSec, cursor: "pointer", fontSize: 14 }}>
              Diğer / {secilenRol.ad} olarak devam et
            </button>
          </div>
        </>
      )}
      
      {adim === "sifre" && (
        <>
          <button onClick={() => setAdim(rolPersonelleri.length > 0 ? "isim" : "rol")} 
            style={{ alignSelf: "flex-start", background: "none", border: "none", color: T.primary, cursor: "pointer", fontSize: 16, marginBottom: 20 }}>← Geri</button>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🔐</div>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: T.text }}>
              {secilenPersonel ? secilenPersonel.ad : secilenRol?.ad} — Şifre
            </h2>
          </div>
          <div style={{ width: "100%", maxWidth: 300 }}>
            <input type="password" value={pinGirisi} onChange={e => setPinGirisi(e.target.value)}
              onKeyDown={e => e.key === "Enter" && sifreDogrula()}
              placeholder="PIN kodunu girin"
              autoFocus
              style={{ width: "100%", padding: "16px", borderRadius: 14, border: `2px solid ${pinHata ? "#EF4444" : T.inputBorder}`, background: T.input, color: T.text, fontSize: 18, textAlign: "center", outline: "none", boxSizing: "border-box" }} />
            
            <div style={{ textAlign: "right", marginTop: 10 }}>
              <button type="button" onClick={pinKoduHatirlat} disabled={yukleniyor}
                style={{ background: "none", border: "none", color: T.primary, cursor: "pointer", fontSize: 13, fontWeight: 700, textDecoration: "underline" }}>
                {yukleniyor ? "Gönderiliyor..." : "PIN Kodumu Unuttum?"}
              </button>
            </div>

            {pinHata && <div style={{ color: "#EF4444", textAlign: "center", marginTop: 8, fontWeight: 600 }}>❌ PIN Kodu Hatalı!</div>}
            
            <button onClick={sifreDogrula}
              style={{ width: "100%", marginTop: 16, padding: "15px", borderRadius: 14, background: T.primary, color: "#fff", border: "none", fontSize: 16, fontWeight: 700, cursor: "pointer" }}>
              Dükkana Giriş Yap
            </button>
          </div>
        </>
      )}
      
      <p style={{ marginTop: 32, fontSize: 12, color: T.textSec }}>
        {bekleyenUser?.ad} olarak oturum açıyorsunuz
      </p>
    </div>
  );
}

function App() {
  const { tema, T, toggleTema } = useTheme();
  const { dil, t, dilDegistir } = useDil();

  return (
    <BrowserRouter basename="/halipro">
       <HaliCi /> 
    </BrowserRouter>
  );
}

export default App;